/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		188: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".build-" + "38f03f3e11541238801c" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeQueryString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeQueryStringDync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorServeiceHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeQueryFormDataDyn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventBus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(12);



var makeQueryString = function makeQueryString(dataObj) {
  var queryStr = "?";
  dataObj.forEach(function (data) {
    queryStr += data.key + "=" + data.value + "&";
  });
  queryStr = queryStr.substring(0, queryStr.length - 1);
  return queryStr;
};
var makeQueryStringDync = function makeQueryStringDync(dataObj) {
  if (!Object.keys(dataObj).length) return false;

  var queryStr = "?";
  for (var item in dataObj) {
    queryStr += item + "=" + dataObj[item] + "&";
  }
  queryStr = queryStr.substring(0, queryStr.length - 1);
  return queryStr;
};
var errorServeiceHandler = function errorServeiceHandler(response) {
  if ((response.status == 200 || response.status == 201) && response.ok) {
    return response;
  } else {
    if (response.status == 401 && __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].getters.getMode != "development") {
      localStorage.removeItem("newNXTSelfcareUser");
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$emit("snackBarMessage-app", "Valid session doesn't exist.  Please login again.");
      // return;
    }
    // else {

    throw response;
    // }
  }
};
var makeQueryFormDataDyn = function makeQueryFormDataDyn(dataObj) {
  if (!Object.keys(dataObj).length) return false;
  var obj = new FormData();
  for (var data in dataObj) {
    obj.append(data, dataObj[data]);
  }
  return obj;
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/* unused harmony export EffectScope */
/* unused harmony export computed */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Vue; });
/* unused harmony export defineAsyncComponent */
/* unused harmony export defineComponent */
/* unused harmony export del */
/* unused harmony export effectScope */
/* unused harmony export getCurrentInstance */
/* unused harmony export getCurrentScope */
/* unused harmony export h */
/* unused harmony export inject */
/* unused harmony export isProxy */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* unused harmony export isRef */
/* unused harmony export isShallow */
/* unused harmony export markRaw */
/* unused harmony export mergeDefaults */
/* unused harmony export nextTick */
/* unused harmony export onActivated */
/* unused harmony export onBeforeMount */
/* unused harmony export onBeforeUnmount */
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* unused harmony export onMounted */
/* unused harmony export onRenderTracked */
/* unused harmony export onRenderTriggered */
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* unused harmony export onUnmounted */
/* unused harmony export onUpdated */
/* unused harmony export provide */
/* unused harmony export proxyRefs */
/* unused harmony export reactive */
/* unused harmony export readonly */
/* unused harmony export ref */
/* unused harmony export set */
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* unused harmony export toRef */
/* unused harmony export toRefs */
/* unused harmony export triggerRef */
/* unused harmony export unref */
/* unused harmony export useAttrs */
/* unused harmony export useCssModule */
/* unused harmony export useCssVars */
/* unused harmony export useListeners */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export watch */
/* unused harmony export watchEffect */
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/*!
 * Vue.js v2.7.16
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return (isDef(val) &&
        typeof val.then === 'function' &&
        typeof val.catch === 'function');
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null
        ? ''
        : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
            ? JSON.stringify(val, replacer, 2)
            : String(val);
}
function replacer(_key, val) {
    // avoid circular deps from v3
    if (val && val.__v_isRef) {
        return val.value;
    }
    return val;
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) { return map[val.toLowerCase()]; } : function (val) { return map[val]; };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    var len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l
            ? l > 1
                ? fn.apply(ctx, arguments)
                : fn.call(ctx, a)
            : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) { }
/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function (_) { return _; };
/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys$1(modules) {
    return modules
        .reduce(function (keys, m) { return keys.concat(m.staticKeys || []); }, [])
        .join(',');
}
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b)
        return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (a.length === b.length &&
                    a.every(function (e, i) {
                        return looseEqual(e, b[i]);
                    }));
            }
            else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            }
            else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return (keysA.length === keysB.length &&
                    keysA.every(function (key) {
                        return looseEqual(a[key], b[key]);
                    }));
            }
            else {
                /* istanbul ignore next */
                return false;
            }
        }
        catch (e) {
            /* istanbul ignore next */
            return false;
        }
    }
    else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    }
    else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val))
            return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    }
    else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch',
    'renderTracked',
    'renderTriggered'
];

var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: "production" !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: "production" !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj)
                return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function () {
                /* istanbul ignore next */
                supportsPassive = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    }
    catch (e) { }
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer =
                global['process'] && global['process'].env.VUE_ENV === 'server';
        }
        else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
}
else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */ (function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }());
}

var currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function getCurrentInstance() {
    return currentInstance && { proxy: currentInstance };
}
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) { vm = null; }
    if (!vm)
        currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */ (function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function () {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}());
var createEmptyVNode = function (text) {
    if (text === void 0) { text = ''; }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, 
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (false) {
    var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' +
        'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
        'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
        'require' // for Webpack/Browserify
    );
    var warnNonPresent_1 = function (target, key) {
        warn$2("Property or method \"".concat(key, "\" is not defined on the instance but ") +
            'referenced during render. Make sure that this property is reactive, ' +
            'either in the data option, or for class-based components, by ' +
            'initializing the property. ' +
            'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    var warnReservedPrefix_1 = function (target, key) {
        warn$2("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") +
            'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
            'prevent conflicts with Vue internals. ' +
            'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
    if (hasProxy_1) {
        var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        config.keyCodes = new Proxy(config.keyCodes, {
            set: function (target, key, value) {
                if (isBuiltInModifier_1(key)) {
                    warn$2("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                    return false;
                }
                else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    var hasHandler_1 = {
        has: function (target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals_1(key) ||
                (typeof key === 'string' &&
                    key.charAt(0) === '_' &&
                    !(key in target.$data));
            if (!has && !isAllowed) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return has || !isAllowed;
        }
    };
    var getHandler_1 = {
        get: function (target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return target[key];
        }
    };
    initProxy = function initProxy(vm) {
        if (hasProxy_1) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
            vm._renderProxy = new Proxy(vm, handlers);
        }
        else {
            vm._renderProxy = vm;
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var uid$2 = 0;
var pendingCleanupDeps = [];
var cleanupDeps = function () {
    for (var i = 0; i < pendingCleanupDeps.length; i++) {
        var dep = pendingCleanupDeps[i];
        dep.subs = dep.subs.filter(function (s) { return s; });
        dep._pending = false;
    }
    pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */ (function () {
    function Dep() {
        // pending subs cleanup
        this._pending = false;
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            pendingCleanupDeps.push(this);
        }
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (false) {
                Dep.target.onTrack(__assign({ effect: Dep.target }, info));
            }
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.filter(function (s) { return s; });
        if (false) {
            // subs aren't sorted in scheduler if not running async
            // we need to sort them now to make sure they fire in correct
            // order
            subs.sort(function (a, b) { return a.id - b.id; });
        }
        for (var i = 0, l = subs.length; i < l; i++) {
            var sub = subs[i];
            if (false) {
                sub.onTrigger &&
                    sub.onTrigger(__assign({ effect: subs[i] }, info));
            }
            sub.update();
        }
    };
    return Dep;
}());
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted)
            ob.observeArray(inserted);
        // notify change
        if (false) {
            ob.dep.notify({
                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
                target: this,
                key: method
            });
        }
        else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */ (function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                }
                else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        }
        else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}());
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (value && hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        return value.__ob__;
    }
    if (shouldObserve &&
        (ssrMockReactivity || !isServerRendering()) &&
        (isArray(value) || isPlainObject(value)) &&
        Object.isExtensible(value) &&
        !value.__v_skip /* ReactiveFlags.SKIP */ &&
        !isRef(value) &&
        !(value instanceof VNode)) {
        return new Observer(value, shallow, ssrMockReactivity);
    }
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock, observeEvenIfShallow) {
    if (observeEvenIfShallow === void 0) { observeEvenIfShallow = false; }
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) &&
        (val === NO_INITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = shallow ? val && val.__ob__ : observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (false) {
                    dep.depend({
                        target: obj,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (false) {
                customSetter();
            }
            if (setter) {
                setter.call(obj, newVal);
            }
            else if (getter) {
                // #7981: for accessor properties without setter
                return;
            }
            else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            }
            else {
                val = newVal;
            }
            childOb = shallow ? newVal && newVal.__ob__ : observe(newVal, false, mock);
            if (false) {
                dep.notify({
                    type: "set" /* TriggerOpTypes.SET */,
                    target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value
                });
            }
            else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (false) {
        warn$2("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (false) {
        ob.dep.notify({
            type: "add" /* TriggerOpTypes.ADD */,
            target: target,
            key: key,
            newValue: val,
            oldValue: undefined
        });
    }
    else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (false) {
        warn$2("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (isReadonly(target)) {
        "production" !== 'production' &&
            warn$2("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (false) {
        ob.dep.notify({
            type: "delete" /* TriggerOpTypes.DELETE */,
            target: target,
            key: key
        });
    }
    else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}

function reactive(target) {
    makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
            }
            var existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) {
                warn$2("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
            }
        }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (false) {
            if (target == null || isPrimitive(target)) {
                warn$2("value cannot be made reactive: ".concat(String(target)));
            }
            if (isCollectionType(target)) {
                warn$2("Vue 2 does not support reactive collection types such as Map or Set.");
            }
        }
    }
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
    }
    return !!(value && value.__ob__);
}
function isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) {
        def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
    }
    return value;
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
}

/**
 * @internal
 */
var RefFlag = "__v_isRef";
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref$1(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    var ref = {};
    def(ref, RefFlag, true);
    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
    return ref;
}
function triggerRef(ref) {
    if (false) {
        warn$2("received object is not a triggerable ref.");
    }
    if (false) {
        ref.dep &&
            ref.dep.notify({
                type: "set" /* TriggerOpTypes.SET */,
                target: ref,
                key: 'value'
            });
    }
    else {
        ref.dep && ref.dep.notify();
    }
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function proxyRefs(objectWithRefs) {
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for (var i = 0; i < keys.length; i++) {
        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    }
    return proxy;
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            }
            else {
                var ob = val && val.__ob__;
                if (ob)
                    ob.dep.depend();
                return val;
            }
        },
        set: function (value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            }
            else {
                source[key] = value;
            }
        }
    });
}
function customRef(factory) {
    var dep = new Dep();
    var _a = factory(function () {
        if (false) {
            dep.depend({
                target: ref,
                type: "get" /* TrackOpTypes.GET */,
                key: 'value'
            });
        }
        else {
            dep.depend();
        }
    }, function () {
        if (false) {
            dep.notify({
                target: ref,
                type: "set" /* TriggerOpTypes.SET */,
                key: 'value'
            });
        }
        else {
            dep.notify();
        }
    }), get = _a.get, set = _a.set;
    var ref = {
        get value() {
            return get();
        },
        set value(newVal) {
            set(newVal);
        }
    };
    def(ref, RefFlag, true);
    return ref;
}
function toRefs(object) {
    if (false) {
        warn$2("toRefs() expects a reactive object but received a plain one.");
    }
    var ret = isArray(object) ? new Array(object.length) : {};
    for (var key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
function toRef(object, key, defaultValue) {
    var val = object[key];
    if (isRef(val)) {
        return val;
    }
    var ref = {
        get value() {
            var val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value(newVal) {
            object[key] = newVal;
        }
    };
    def(ref, RefFlag, true);
    return ref;
}

var rawToReadonlyFlag = "__v_rawToReadonly";
var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function readonly(target) {
    return createReadonly(target, false);
}
function createReadonly(target, shallow) {
    if (!isPlainObject(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Vue 2 does not support readonly arrays.");
            }
            else if (isCollectionType(target)) {
                warn$2("Vue 2 does not support readonly collection types such as Map or Set.");
            }
            else {
                warn$2("value cannot be made readonly: ".concat(typeof target));
            }
        }
        return target;
    }
    if (false) {
        warn$2("Vue 2 does not support creating readonly proxy for non-extensible object.");
    }
    // already a readonly object
    if (isReadonly(target)) {
        return target;
    }
    // already has a readonly proxy
    var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) {
        return existingProxy;
    }
    var proxy = Object.create(Object.getPrototypeOf(target));
    def(target, existingFlag, proxy);
    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
    if (isRef(target)) {
        def(proxy, RefFlag, true);
    }
    if (shallow || isShallow(target)) {
        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineReadonlyProperty(proxy, target, keys[i], shallow);
    }
    return proxy;
}
function defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = target[key];
            return shallow || !isPlainObject(val) ? val : readonly(val);
        },
        set: function () {
            "production" !== 'production' &&
                warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReadonly(target, true);
}

function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter =  false
            ? function () {
                warn$2('Write operation failed: computed value is readonly');
            }
            : noop;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = isServerRendering()
        ? null
        : new Watcher(currentInstance, getter, noop, { lazy: true });
    if (false) {
        watcher.onTrack = debugOptions.onTrack;
        watcher.onTrigger = debugOptions.onTrigger;
    }
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value() {
            if (watcher) {
                if (watcher.dirty) {
                    watcher.evaluate();
                }
                if (Dep.target) {
                    if (false) {
                        Dep.target.onTrack({
                            effect: Dep.target,
                            target: ref,
                            type: "get" /* TrackOpTypes.GET */,
                            key: 'value'
                        });
                    }
                    watcher.depend();
                }
                return watcher.value;
            }
            else {
                return getter();
            }
        },
        set value(newVal) {
            setter(newVal);
        }
    };
    def(ref, RefFlag, true);
    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
    return ref;
}

var mark;
var measure;
if (false) {
    var perf_1 = inBrowser && window.performance;
    /* istanbul ignore if */
    if (perf_1 &&
        // @ts-ignore
        perf_1.mark &&
        // @ts-ignore
        perf_1.measure &&
        // @ts-ignore
        perf_1.clearMarks &&
        // @ts-ignore
        perf_1.clearMeasures) {
        mark = function (tag) { return perf_1.mark(tag); };
        measure = function (name, startTag, endTag) {
            perf_1.measure(name, startTag, endTag);
            perf_1.clearMarks(startTag);
            perf_1.clearMarks(endTag);
            // perf.clearMeasures(name)
        };
    }
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        }
        else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
            "production" !== 'production' &&
                warn$2("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
        }
        else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        }
        else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    }
    else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        }
        else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs, props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (false) {
                var keyInLowerCase = key.toLowerCase();
                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                    tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") +
                        "".concat(formatComponentName(
                        // @ts-expect-error tag is string
                        tag || Ctor), ", but the declared prop name is") +
                        " \"".concat(key, "\". ") +
                        "Note that HTML attributes are case-insensitive and camelCased " +
                        "props need to use their kebab-case equivalents when using in-DOM " +
                        "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                }
            }
            checkProp(res, props, key, altKey, true) ||
                checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        }
        else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children)
        ? [createTextVNode(children)]
        : isArray(children)
            ? normalizeArrayChildren(children)
            : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean')
            continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        }
        else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            }
            else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        }
        else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            }
            else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) &&
                    isDef(c.tag) &&
                    isUndef(c.key) &&
                    isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
        "production" !== 'production' &&
            warn$2("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (false) {
        warn$2('Avoid using non-primitive value as key, ' +
            'use string/number value instead.', context);
    }
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    }
    else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
            // platform built-in elements
            if (false) {
                warn$2("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
            }
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        }
        else if ((!data || !data.pre) &&
            isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        }
        else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    }
    else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    }
    else if (isDef(vnode)) {
        if (isDef(ns))
            applyNS(vnode, ns);
        if (isDef(data))
            registerDeepBindings(data);
        return vnode;
    }
    else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) &&
                (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null, i, l, keys, key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    }
    else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    }
    else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        }
        else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (false) {
                warn$2('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
        }
        nodes =
            scopedSlotFn(props) ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    else {
        nodes =
            this.$slots[name] ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    }
    else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    }
    else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    }
    else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    }
    else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
            "production" !== 'production' &&
                warn$2('v-bind without argument expects an Object or Array value', this);
        }
        else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function (key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                }
                else {
                    var type = data.attrs && data.attrs.type;
                    hash =
                        asProp || config.mustUseProp(tag, type, key)
                            ? data.domProps || (data.domProps = {})
                            : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic$1(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic$1(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic$1(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    }
    else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
            "production" !== 'production' && warn$2('v-on without argument expects an Object value', this);
        }
        else {
            var on = (data.on = data.on ? extend({}, data.on) : {});
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res, 
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        }
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        }
        else if (false) {
            // null is a special value for explicitly removing a binding
            warn$2("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
        }
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) &&
            data &&
            data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            }
            else {
                slot.push(child);
            }
        }
        else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    }
    else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    }
    else if (isStable &&
        prevScopedSlots &&
        prevScopedSlots !== emptyObject &&
        key === prevScopedSlots.$key &&
        !hasNormalSlots &&
        !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    }
    else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function () {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res =
            res && typeof res === 'object' && !isArray(res)
                ? [res] // single vnode
                : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res &&
            (!vnode ||
                (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
            ? undefined
            : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () { return slots[key]; };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = (vm._setupContext = createSetupContext(vm));
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        }
        else if (isObject(setupResult)) {
            // bindings
            if (false) {
                warn$2("setup() should not return VNodes directly - " +
                    "return a render function instead.");
            }
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    }
                    else if (false) {
                        warn$2("Avoid using variables that start with _ or $ in setup().");
                    }
                }
            }
            else {
                // exposed for compiled render fn
                var proxy = (vm._setupProxy = {});
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        }
        else if (false) {
            warn$2("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult));
        }
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = (vm._attrsProxy = {});
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = (vm._listenersProxy = {});
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind$1(vm.$emit, vm),
        expose: function (exposed) {
            if (false) {
                if (exposeCalled) {
                    warn$2("expose() should be called only once per setup().", vm);
                }
                exposeCalled = true;
            }
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        }
        else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useSlots() {
    return getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useAttrs() {
    return getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useListeners() {
    return getContext().listeners;
}
function getContext() {
    if (false) {
        warn$2("useContext() called without active instance.");
    }
    var vm = currentInstance;
    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    var props = isArray(raw)
        ? raw.reduce(function (normalized, p) { return ((normalized[p] = {}), normalized); }, {})
        : raw;
    for (var key in defaults) {
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            }
            else {
                opt.default = defaults[key];
            }
        }
        else if (opt === null) {
            props[key] = { default: defaults[key] };
        }
        else if (false) {
            warn$2("props default key \"".concat(key, "\" has no corresponding declaration."));
        }
    }
    return props;
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode
        ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
        : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, true); };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (false) {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$attrs is readonly.", vm);
        }, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$listeners is readonly.", vm);
        }, true);
    }
    else {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var prevInst = currentInstance;
        var prevRenderInst = currentRenderingInstance;
        var vnode;
        try {
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        }
        catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (false) {
                try {
                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                }
                catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                }
            }
            else {
                vnode = vm._vnode;
            }
        }
        finally {
            currentRenderingInstance = prevRenderInst;
            setCurrentInstance(prevInst);
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (false) {
                warn$2('Multiple root nodes returned from render function. Render function ' +
                    'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = (factory.owners = [owner]);
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () { return remove$2(owners_1, owner); });
        var forceRender_1 = function (renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            }
            else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
            "production" !== 'production' &&
                warn$2("Failed to resolve async component: ".concat(String(factory)) +
                    (reason ? "\nReason: ".concat(reason) : ''));
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            }
            else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    }
                    else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1( false ? "timeout (".concat(res_1.timeout, "ms)") : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        }
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") +
                    "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") +
                    "Note that HTML attributes are case-insensitive and you cannot use " +
                    "v-on to listen to camelCase events when using in-DOM templates. " +
                    "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
            }
        }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeEffectScope;
var EffectScope = /** @class */ (function () {
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        this.detached = detached;
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) {
            this.index =
                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            }
            finally {
                activeEffectScope = currentEffectScope;
            }
        }
        else if (false) {
            warn$2("cannot run an inactive effect scope.");
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0, l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    };
    return EffectScope;
}());
function effectScope(detached) {
    return new EffectScope(detached);
}
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) { scope = activeEffectScope; }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if (false) {
        warn$2("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        }
        else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper &&
            wrapper.$vnode &&
            wrapper.$parent &&
            wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (false) {
            /* istanbul ignore if */
            if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
                vm.$options.el ||
                el) {
                warn$2('You are using the runtime-only build of Vue where the template ' +
                    'compiler is not available. Either pre-compile the templates into ' +
                    'render functions, or use the compiler-included build.', vm);
            }
            else {
                warn$2('Failed to mount component: template or render function not defined.', vm);
            }
        }
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (false) {
        updateComponent = function () {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:".concat(id);
            var endTag = "vue-perf-end:".concat(id);
            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue ".concat(name, " render"), startTag, endTag);
            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue ".concat(name, " patch"), startTag, endTag);
        };
    }
    else {
        updateComponent = function () {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function () {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (false) {
        watcherOptions.onTrack = function (e) { return callHook$1(vm, 'renderTracked', [e]); };
        watcherOptions.onTrigger = function (e) { return callHook$1(vm, 'renderTriggered', [e]); };
    }
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (false) {
        isUpdatingChildComponent = true;
    }
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
        (!newScopedSlots && vm.$scopedSlots.$key));
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (false) {
        isUpdatingChildComponent = false;
    }
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive)
            return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) { setContext = true; }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prevInst = currentInstance;
    var prevScope = getCurrentScope();
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    if (setContext) {
        setCurrentInstance(prevInst);
        prevScope && prevScope.on();
    }
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index$1 = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index$1 = queue.length = activatedChildren.length = 0;
    has = {};
    if (false) {
        circular = {};
    }
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
    var performance_1 = window.performance;
    if (performance_1 &&
        typeof performance_1.now === 'function' &&
        getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function () { return performance_1.now(); };
    }
}
var sortCompareFn = function (a, b) {
    if (a.post) {
        if (!b.post)
            return 1;
    }
    else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index$1 = 0; index$1 < queue.length; index$1++) {
        watcher = queue[index$1];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
                warn$2('You may have an infinite update loop ' +
                    (watcher.user
                        ? "in watcher with expression \"".concat(watcher.expression, "\"")
                        : "in a component render function."), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    cleanupDeps();
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    }
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index$1 && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (false) {
            flushSchedulerQueue();
            return;
        }
        nextTick(flushSchedulerQueue);
    }
}

var WATCHER = "watcher";
var WATCHER_CB = "".concat(WATCHER, " callback");
var WATCHER_GETTER = "".concat(WATCHER, " getter");
var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'post' }) : { flush: 'post' }));
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'sync' }) : { flush: 'sync' }));
}
// initial value for watchers to trigger on undefined initial values
var INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {
        warn$2("`watch(fn, options?)` signature has been moved to a separate API. " +
            "Use `watchEffect(fn, options?)` instead. `watch` now only " +
            "supports `watch(source, cb, options?) signature.");
    }
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? emptyObject : _a, immediate = _b.immediate, deep = _b.deep, _c = _b.flush, flush = _c === void 0 ? 'pre' : _c, onTrack = _b.onTrack, onTrigger = _b.onTrigger;
    if (false) {
        if (immediate !== undefined) {
            warn$2("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (deep !== undefined) {
            warn$2("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var warnInvalidSource = function (s) {
        warn$2("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") +
            "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var call = function (fn, type, args) {
        if (args === void 0) { args = null; }
        var res = invokeWithErrorHandling(fn, null, args, instance, type);
        if (deep && res && res.__ob__)
            res.__ob__.dep.depend();
        return res;
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function () { return source.value; };
        forceTrigger = isShallow(source);
    }
    else if (isReactive(source)) {
        getter = function () {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) { return isReactive(s) || isShallow(s); });
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    s.__ob__.dep.depend();
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                }
                else {
                    "production" !== 'production' && warnInvalidSource(s);
                }
            });
        };
    }
    else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function () { return call(source, WATCHER_GETTER); };
        }
        else {
            // no cb -> simple effect
            getter = function () {
                if (instance && instance._isDestroyed) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return call(source, WATCHER, [onCleanup]);
            };
        }
    }
    else {
        getter = noop;
        "production" !== 'production' && warnInvalidSource(source);
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var cleanup;
    var onCleanup = function (fn) {
        cleanup = watcher.onStop = function () {
            call(fn, WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = noop;
        if (!cb) {
            getter();
        }
        else if (immediate) {
            call(cb, WATCHER_CB, [
                getter(),
                isMultiSource ? [] : undefined,
                onCleanup
            ]);
        }
        return noop;
    }
    var watcher = new Watcher(currentInstance, getter, noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function () {
        if (!watcher.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep ||
                forceTrigger ||
                (isMultiSource
                    ? newValue.some(function (v, i) {
                        return hasChanged(v, oldValue[i]);
                    })
                    : hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                call(cb, WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        }
        else {
            // watchEffect
            watcher.get();
        }
    };
    if (flush === 'sync') {
        watcher.update = watcher.run;
    }
    else if (flush === 'post') {
        watcher.post = true;
        watcher.update = function () { return queueWatcher(watcher); };
    }
    else {
        // pre
        watcher.update = function () {
            if (instance && instance === currentInstance && !instance._isMounted) {
                // pre-watcher triggered before
                var buffer = instance._preWatchers || (instance._preWatchers = []);
                if (buffer.indexOf(watcher) < 0)
                    buffer.push(watcher);
            }
            else {
                queueWatcher(watcher);
            }
        };
    }
    if (false) {
        watcher.onTrack = onTrack;
        watcher.onTrigger = onTrigger;
    }
    // initial run
    if (cb) {
        if (immediate) {
            watcher.run();
        }
        else {
            oldValue = watcher.get();
        }
    }
    else if (flush === 'post' && instance) {
        instance.$once('hook:mounted', function () { return watcher.get(); });
    }
    else {
        watcher.get();
    }
    return function () {
        watcher.teardown();
    };
}

function provide(key, value) {
    if (!currentInstance) {
        if (false) {
            warn$2("provide() can only be used inside setup().");
        }
    }
    else {
        // TS doesn't allow symbol as index type
        resolveProvided(currentInstance)[key] = value;
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return (vm._provided = Object.create(parentProvides));
    }
    else {
        return existing;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        }
        else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue)
                ? defaultValue.call(instance)
                : defaultValue;
        }
        else if (false) {
            warn$2("injection \"".concat(String(key), "\" not found."));
        }
    }
    else if (false) {
        warn$2("inject() can only be used inside setup() or functional components.");
    }
}

/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function h(type, props, children) {
    if (!currentInstance) {
        "production" !== 'production' &&
            warn$2("globally imported h() can only be invoked when there is an active " +
                "component instance, e.g. synchronously in a component's render or setup function.");
    }
    return createElement$1(currentInstance, type, props, children, 2, true);
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while ((cur = cur.$parent)) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture)
                                return;
                        }
                        catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    }
    finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
            res._handled = true;
        }
    }
    catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
        try {
            return config.errorHandler.call(null, err, vm, info);
        }
        catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (false) {
        warn$2("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function () {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS)
            setTimeout(noop);
    };
    isUsingMicroTask = true;
}
else if (!isIE &&
    typeof MutationObserver !== 'undefined' &&
    (isNative(MutationObserver) ||
        // PhantomJS and iOS 7.x
        MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function () {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
}
else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
        setImmediate(flushCallbacks);
    };
}
else {
    // Fallback to setTimeout.
    timerFunc = function () {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            }
            catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        }
        else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

function useCssModule(name) {
    if (name === void 0) { name = '$style'; }
    /* istanbul ignore else */
    {
        if (!currentInstance) {
            "production" !== 'production' && warn$2("useCssModule must be called inside setup()");
            return emptyObject;
        }
        var mod = currentInstance[name];
        if (!mod) {
            "production" !== 'production' &&
                warn$2("Current instance does not have CSS module named \"".concat(name, "\"."));
            return emptyObject;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    if (!inBrowser && !false)
        return;
    var instance = currentInstance;
    if (!instance) {
        "production" !== 'production' &&
            warn$2("useCssVars is called without current active component instance.");
        return;
    }
    watchPostEffect(function () {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for (var key in vars) {
                style.setProperty("--".concat(key), vars[key]);
            }
        }
    });
}

/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn$2("The suspensible option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn$2("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}

function createLifeCycle(hookName) {
    return function (fn, target) {
        if (target === void 0) { target = currentInstance; }
        if (!target) {
            "production" !== 'production' &&
                warn$2("".concat(formatName(hookName), " is called when there is no active component instance to be ") +
                    "associated with. " +
                    "Lifecycle injection APIs can only be used during execution of setup().");
            return;
        }
        return injectHook(target, hookName, fn);
    };
}
function formatName(name) {
    if (name === 'beforeDestroy') {
        name = 'beforeUnmount';
    }
    else if (name === 'destroyed') {
        name = 'unmounted';
    }
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = mergeLifecycleHook(options[hookName], fn);
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');
var onRenderTracked = createLifeCycle('renderTracked');
var onRenderTriggered = createLifeCycle('renderTriggered');
var injectErrorCapturedHook = createLifeCycle('errorCaptured');
function onErrorCaptured(hook, target) {
    if (target === void 0) { target = currentInstance; }
    injectErrorCapturedHook(hook, target);
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.16';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */
function defineComponent(options) {
    return options;
}

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if ((!isA && !isObject(val)) ||
        val.__v_skip /* ReactiveFlags.SKIP */ ||
        Object.isFrozen(val) ||
        val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--)
            _traverse(val[i], seen);
    }
    else if (isRef(val)) {
        _traverse(val.value, seen);
    }
    else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--)
            _traverse(val[keys[i]], seen);
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */ (function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this, 
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm
            ? activeEffectScope
            : vm
                ? vm._scope
                : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (false) {
                this.onTrack = options.onTrack;
                this.onTrigger = options.onTrigger;
            }
        }
        else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression =  false ? expOrFn.toString() : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        }
        else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                "production" !== 'production' &&
                    warn$2("Failed watching path: \"".concat(expOrFn, "\" ") +
                        'Watcher only accepts simple dot-delimited paths. ' +
                        'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        }
        catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            }
            else {
                throw e;
            }
        }
        finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        }
        else if (this.sync) {
            this.run();
        }
        else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
                // Deep watchers and watchers on Object/Arrays should fire even
                // when the value is the same, because the value may
                // have mutated.
                isObject(value) ||
                this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                }
                else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}());

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props)
        initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods)
        initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    }
    else {
        var ob = observe((vm._data = {}));
        ob && ob.vmCount++;
    }
    if (opts.computed)
        initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = (vm._props = shallowReactive({}));
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = (vm.$options._propKeys = []);
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function (key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) ||
                config.isReservedAttr(hyphenatedKey)) {
                warn$2("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
            }
            defineReactive(props, key, value, function () {
                if (!isRoot && !isUpdatingChildComponent) {
                    warn$2("Avoid mutating a prop directly since the value will be " +
                        "overwritten whenever the parent component re-renders. " +
                        "Instead, use a data or computed property based on the prop's " +
                        "value. Prop being mutated: \"".concat(key, "\""), vm);
                }
            }, true /* shallow */);
        }
        else {
            defineReactive(props, key, value, undefined, true /* shallow */);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
        "production" !== 'production' &&
            warn$2('data functions should return an object:\n' +
                'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (false) {
            if (methods && hasOwn(methods, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a data property."), vm);
            }
        }
        if (props && hasOwn(props, key)) {
            "production" !== 'production' &&
                warn$2("The data property \"".concat(key, "\" is already declared as a prop. ") +
                    "Use prop default value instead.", vm);
        }
        else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    }
    catch (e) {
        handleError(e, vm, "data()");
        return {};
    }
    finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = (vm._computedWatchers = Object.create(null));
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (false) {
            warn$2("Getter is missing for computed property \"".concat(key, "\"."), vm);
        }
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        }
        else if (false) {
            if (key in vm.$data) {
                warn$2("The computed property \"".concat(key, "\" is already defined in data."), vm);
            }
            else if (vm.$options.props && key in vm.$options.props) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
            }
            else if (vm.$options.methods && key in vm.$options.methods) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a method."), vm);
            }
        }
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache
            ? createComputedGetter(key)
            : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    }
    else {
        sharedPropertyDefinition.get = userDef.get
            ? shouldCache && userDef.cache !== false
                ? createComputedGetter(key)
                : createGetterInvoker(userDef.get)
            : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (false) {
        sharedPropertyDefinition.set = function () {
            warn$2("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
        };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (false) {
                    Dep.target.onTrack({
                        effect: Dep.target,
                        target: this,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (false) {
            if (typeof methods[key] !== 'function') {
                warn$2("Method \"".concat(key, "\" has type \"").concat(typeof methods[key], "\" in the component definition. ") +
                    "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a prop."), vm);
            }
            if (key in vm && isReserved(key)) {
                warn$2("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") +
                    "Avoid defining component methods that start with _ or $.");
            }
        }
        vm[key] = typeof methods[key] !== 'function' ? noop : bind$1(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        }
        else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (false) {
        dataDef.set = function () {
            warn$2('Avoid replacing instance root $data. ' +
                'Use nested data properties instead.', this);
        };
        propsDef.set = function () {
            warn$2("$props is readonly.", this);
        };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption)
            ? provideOption.call(vm)
            : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (false) {
                defineReactive(vm, key, result[key], function () {
                    warn$2("Avoid mutating an injected value directly since the changes will be " +
                        "overwritten whenever the provided component re-renders. " +
                        "injection being mutated: \"".concat(key, "\""), vm);
                });
            }
            else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__')
                continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            }
            else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault)
                    ? provideDefault.call(vm)
                    : provideDefault;
            }
            else if (false) {
                warn$2("Injection \"".concat(key, "\" not found"), vm);
            }
        }
        return result;
    }
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {
            startTag = "vue-perf-start:".concat(vm._uid);
            endTag = "vue-perf-end:".concat(vm._uid);
            mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        // #13134 edge case where a child component is manually created during the
        // render of a parent component
        vm._scope.parent = undefined;
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        }
        else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (false) {
            initProxy(vm);
        }
        else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (false) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue ".concat(vm._name, " init"), startTag, endTag);
        }
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = (vm.$options = Object.create(vm.constructor.options));
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified)
                modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    }
    else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, (_this.$slots = resolveSlots(children, parent)));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function () {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    }
    else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    }
    else {
        if (isDef(data.attrs))
            mergeProps(props, data.attrs);
        if (isDef(data.props))
            mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    }
    else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (false) {
        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
            renderContext;
    }
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function (vnode, hydrating) {
        if (vnode.componentInstance &&
            !vnode.componentInstance._isDestroyed &&
            vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        }
        else {
            var child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function (oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = (vnode.componentInstance = oldVnode.componentInstance);
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function (vnode) {
        var context = vnode.context, componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            }
            else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function (vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            }
            else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (false) {
            warn$2("Invalid Component definition: ".concat(String(Ctor)), context);
        }
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context, 
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode, 
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function (a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing)
            ? existing.indexOf(callback) === -1
            : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    }
    else {
        on[event] = callback;
    }
}

var warn$2 = noop;
var tip = noop;
var generateComponentTrace; // work around flow check
var formatComponentName;
if (false) {
    var hasConsole_1 = typeof console !== 'undefined';
    var classifyRE_1 = /(?:^|[-_])(\w)/g;
    var classify_1 = function (str) {
        return str.replace(classifyRE_1, function (c) { return c.toUpperCase(); }).replace(/[-_]/g, '');
    };
    warn$2 = function (msg, vm) {
        if (vm === void 0) { vm = currentInstance; }
        var trace = vm ? generateComponentTrace(vm) : '';
        if (config.warnHandler) {
            config.warnHandler.call(null, msg, vm, trace);
        }
        else if (hasConsole_1 && !config.silent) {
            console.error("[Vue warn]: ".concat(msg).concat(trace));
        }
    };
    tip = function (msg, vm) {
        if (hasConsole_1 && !config.silent) {
            console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
        }
    };
    formatComponentName = function (vm, includeFile) {
        if (vm.$root === vm) {
            return '<Root>';
        }
        var options = isFunction(vm) && vm.cid != null
            ? vm.options
            : vm._isVue
                ? vm.$options || vm.constructor.options
                : vm;
        var name = getComponentName(options);
        var file = options.__file;
        if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return ((name ? "<".concat(classify_1(name), ">") : "<Anonymous>") +
            (file && includeFile !== false ? " at ".concat(file) : ''));
    };
    var repeat_1 = function (str, n) {
        var res = '';
        while (n) {
            if (n % 2 === 1)
                res += str;
            if (n > 1)
                str += str;
            n >>= 1;
        }
        return res;
    };
    generateComponentTrace = function (vm) {
        if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
                if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    }
                    else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [last, currentRecursiveSequence];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return ('\n\nfound in\n\n' +
                tree
                    .map(function (vm, i) {
                    return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm)
                        ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)")
                        : formatComponentName(vm));
                })
                    .join('\n'));
        }
        else {
            return "\n\n(found in ".concat(formatComponentName(vm), ")");
        }
    };
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (false) {
    strats.el = strats.propsData = function (parent, child, vm, key) {
        if (!vm) {
            warn$2("option \"".concat(key, "\" can only be used during instance ") +
                'creation with the `new` keyword.');
        }
        return defaultStrat(parent, child);
    };
}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from, recursive) {
    if (recursive === void 0) { recursive = true; }
    if (!from)
        return to;
    var key, toVal, fromVal;
    var keys = hasSymbol
        ? Reflect.ownKeys(from)
        : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !hasOwn(to, key)) {
            set(to, key, fromVal);
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    }
    else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal)
                ? childVal.call(vm, vm)
                : childVal;
            var defaultData = isFunction(parentVal)
                ? parentVal.call(vm, vm)
                : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            }
            else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            "production" !== 'production' &&
                warn$2('The "data" option should be a function ' +
                    'that returns a per-instance value in component ' +
                    'definitions.', vm);
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal
        ? parentVal
            ? parentVal.concat(childVal)
            : isArray(childVal)
                ? childVal
                : [childVal]
        : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
        "production" !== 'production' && assertObjectType(key, childVal, vm);
        return extend(res, childVal);
    }
    else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch)
        parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch)
        childVal = undefined;
    /* istanbul ignore if */
    if (!childVal)
        return Object.create(parentVal || null);
    if (false) {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal)
        return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props =
    strats.methods =
        strats.inject =
            strats.computed =
                function (parentVal, childVal, vm, key) {
                    if (childVal && "production" !== 'production') {
                        assertObjectType(key, childVal, vm);
                    }
                    if (!parentVal)
                        return childVal;
                    var ret = Object.create(null);
                    extend(ret, parentVal);
                    if (childVal)
                        extend(ret, childVal);
                    return ret;
                };
strats.provide = function (parentVal, childVal) {
    if (!parentVal)
        return childVal;
    return function () {
        var ret = Object.create(null);
        mergeData(ret, isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) {
            mergeData(ret, isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
            );
        }
        return ret;
    };
};
/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn$2('Invalid component name: "' +
            name +
            '". Component names ' +
            'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn$2('Do not use built-in or reserved HTML elements as component ' +
            'id: ' +
            name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props)
        return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            }
            else if (false) {
                warn$2('props must be strings when using array syntax.');
            }
        }
    }
    else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"props\": expected an Array or an Object, " +
            "but got ".concat(toRawType(props), "."), vm);
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject)
        return;
    var normalized = (options.inject = {});
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    }
    else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val)
                ? extend({ from: key }, val)
                : { from: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"inject\": expected an Array or an Object, " +
            "but got ".concat(toRawType(inject), "."), vm);
    }
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn$2("Invalid value for option \"".concat(name, "\": expected an Object, ") +
            "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (false) {
        checkComponents(child);
    }
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id))
        return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId))
        return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId))
        return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (false) {
        warn$2('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    }
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        }
        else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (false) {
        assertProp(prop, key, value, vm, absent);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (false) {
        warn$2('Invalid default value for prop "' +
            key +
            '": ' +
            'Props with type Object/Array must use a factory function ' +
            'to return the default value.', vm);
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm &&
        vm.$options.propsData &&
        vm.$options.propsData[key] === undefined &&
        vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function'
        ? def.call(vm)
        : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn$2('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
    if (!valid && haveExpectedTypes) {
        warn$2(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn$2('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else {
        try {
            valid = value instanceof type;
        }
        catch (e) {
            warn$2('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") +
        " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        isExplicable(typeof value) &&
        !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    }
    else if (type === 'Number') {
        return "".concat(Number(value));
    }
    else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; });
}

function Vue(options) {
    if (false) {
        warn$2('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        }
        else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (false) {
            validateComponentName(name);
        }
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            }
            else {
                /* istanbul ignore if */
                if (false) {
                    validateComponentName(id);
                }
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    }
    else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    }
    else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode, $vnode = keepAliveInstance.$vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
    $vnode.componentOptions.children = undefined;
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function () {
            var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function () {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function () {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function () {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) { return matches(val, name); });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) { return !matches(val, name); });
        });
    },
    updated: function () {
        this.cacheVNode();
    },
    render: function () {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this, include = _a.include, exclude = _a.exclude;
            if (
            // not included
            (include && (!name_2 || !matches(include, name_2))) ||
                // excluded
                (exclude && name_2 && matches(exclude, name_2))) {
                return vnode;
            }
            var _b = this, cache = _b.cache, keys = _b.keys;
            var key = vnode.key == null
                ? // same constructor may get registered as different local components
                    // so cid alone is not enough (#3269)
                    componentOptions.Ctor.cid +
                        (componentOptions.tag ? "::".concat(componentOptions.tag) : '')
                : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            }
            else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config; };
    if (false) {
        configDef.set = function () {
            warn$2('Do not replace the Vue.config object, set individual fields instead.');
        };
    }
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn$2,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function () {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
    return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
        (attr === 'selected' && tag === 'option') ||
        (attr === 'checked' && tag === 'input') ||
        (attr === 'muted' && tag === 'video'));
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false'
        ? 'false'
        : // allow arbitrary string value for contenteditable
            key === 'contenteditable' && isValidContentEditableValue(value)
                ? value
                : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,' +
    'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function (val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef((parentNode = parentNode.parent))) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? (b ? a + ' ' + b : a) : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
            if (res)
                res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res)
                res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isPreTag = function (tag) { return tag === 'pre'; };
var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // https://stackoverflow.com/a/28210364/1070244
        return (unknownElementCache[tag] =
            el.constructor === window.HTMLUnknownElement ||
                el.constructor === window.HTMLElement);
    }
    else {
        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
            "production" !== 'production' && warn$2('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    }
    else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data &&
        vnode.data.attrs &&
        vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createElement: createElement,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

var ref = {
    create: function (_, vnode) {
        registerRef(vnode);
    },
    update: function (oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function (vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref))
        return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            }
            else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    }
                    else {
                        ref.value = [refValue];
                    }
                }
                else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        }
        else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        }
        else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        }
        else if (false) {
            warn$2("Invalid template ref type: ".concat(typeof ref));
        }
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        }
        else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return (a.key === b.key &&
        a.asyncFactory === b.asyncFactory &&
        ((a.tag === b.tag &&
            a.isComment === b.isComment &&
            isDef(a.data) === isDef(b.data) &&
            sameInputType(a, b)) ||
            (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
}
function sameInputType(a, b) {
    if (a.tag !== 'input')
        return true;
    var i;
    var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
    var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
    return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key))
            map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules, nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return (!inVPre &&
            !vnode.ns &&
            !(config.ignoredElements.length &&
                config.ignoredElements.some(function (ignore) {
                    return isRegExp(ignore)
                        ? ignore.test(vnode.tag)
                        : ignore === vnode.tag;
                })) &&
            config.isUnknownElement(vnode.tag));
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (false) {
                if (data && data.pre) {
                    creatingElmInVPre++;
                }
                if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn$2('Unknown custom element: <' +
                        tag +
                        '> - did you ' +
                        'register the component correctly? For recursive components, ' +
                        'make sure to provide the "name" option.', vnode.context);
                }
            }
            vnode.elm = vnode.ns
                ? nodeOps.createElementNS(vnode.ns, tag)
                : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (false) {
                creatingElmInVPre--;
            }
        }
        else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
        else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef((i = i.hook)) && isDef((i = i.init))) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        }
        else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            }
            else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (false) {
                checkDuplicateKeys(children);
            }
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        }
        else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create))
                i.create(emptyNode, vnode);
            if (isDef(i.insert))
                insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef((i = vnode.fnScopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
        else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef((i = activeInstance)) &&
            i !== vnode.context &&
            i !== vnode.fnContext &&
            isDef((i = i.$options._scopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.destroy)))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
        }
        if (isDef((i = vnode.children))) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                }
                else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            }
            else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef((i_3 = vnode.componentInstance)) &&
                isDef((i_3 = i_3._vnode)) &&
                isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef((i_3 = vnode.data.hook)) && isDef((i_3 = i_3.remove))) {
                i_3(vnode, rm);
            }
            else {
                rm();
            }
        }
        else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (false) {
            checkDuplicateKeys(newCh);
        }
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            }
            else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (isUndef(oldKeyToIdx))
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key)
                    ? oldKeyToIdx[newStartVnode.key]
                    : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove &&
                            nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    }
                    else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn$2("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                }
                else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c))
                return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = (vnode.elm = oldVnode.elm);
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            }
            else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) &&
            isTrue(oldVnode.isStatic) &&
            vnode.key === oldVnode.key &&
            (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            if (isDef((i = data.hook)) && isDef((i = i.update)))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            }
            else if (isDef(ch)) {
                if (false) {
                    checkDuplicateKeys(ch);
                }
                if (isDef(oldVnode.text))
                    nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        }
        else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag, data = vnode.data, children = vnode.children;
        inVPre = inVPre || (data && data.pre);
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (false) {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
                return false;
            }
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.init)))
                i(vnode, true /* hydrating */);
            if (isDef((i = vnode.componentInstance))) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                }
                else {
                    // v-html and domProps: innerHTML
                    if (isDef((i = data)) &&
                        isDef((i = i.domProps)) &&
                        isDef((i = i.innerHTML))) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    }
                    else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode ||
                                !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        }
        else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return (vnode.tag.indexOf('vue-component') === 0 ||
                (!isUnknownElement(vnode, inVPre) &&
                    vnode.tag.toLowerCase() ===
                        (node.tagName && node.tagName.toLowerCase())));
        }
        else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode))
                invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        }
        else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            }
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        }
                        else if (false) {
                            warn$2('The client-side rendered virtual DOM tree is not matching ' +
                                'server-rendered content. This is likely caused by incorrect ' +
                                'HTML markup, for example nesting block-level elements inside ' +
                                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                                'full client-side render.');
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, 
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                // clone insert hooks to avoid being mutated during iteration.
                                // e.g. for customed directives under transition group.
                                var cloned = insert_1.fns.slice(1);
                                for (var i_10 = 0; i_10 < cloned.length; i_10++) {
                                    cloned[i_10]();
                                }
                            }
                        }
                        else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                }
                else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives$1 = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        }
        else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function () {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        }
        else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef,
                };
            }
            else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return (dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.')));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        }
        catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives$1];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            }
            else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    }
    else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        }
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    }
    else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    }
    else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    }
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE &&
            !isIE9 &&
            el.tagName === 'TEXTAREA' &&
            key === 'placeholder' &&
            value !== '' &&
            !el.__ieph) {
            var blocker_1 = function (e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) &&
        isUndef(data.class) &&
        (isUndef(oldData) ||
            (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass$1 = {
    create: updateClass,
    update: updateClass
};

var validDivisionCharRE = /[\w).+\-_$\]]/;
function parseFilters(exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;
    for (i = 0; i < exp.length; i++) {
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c)
                inSingle = false;
        }
        else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c)
                inDouble = false;
        }
        else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c)
                inTemplateString = false;
        }
        else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c)
                inRegex = false;
        }
        else if (c === 0x7c && // pipe
            exp.charCodeAt(i + 1) !== 0x7c &&
            exp.charCodeAt(i - 1) !== 0x7c &&
            !curly &&
            !square &&
            !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            }
            else {
                pushFilter();
            }
        }
        else {
            switch (c) {
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                var j = i - 1;
                var p 
                // find first non-whitespace prev char
                = void 0;
                // find first non-whitespace prev char
                for (; j >= 0; j--) {
                    p = exp.charAt(j);
                    if (p !== ' ')
                        break;
                }
                if (!p || !validDivisionCharRE.test(p)) {
                    inRegex = true;
                }
            }
        }
    }
    if (expression === undefined) {
        expression = exp.slice(0, i).trim();
    }
    else if (lastFilterIndex !== 0) {
        pushFilter();
    }
    function pushFilter() {
        (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters) {
        for (i = 0; i < filters.length; i++) {
            expression = wrapFilter(expression, filters[i]);
        }
    }
    return expression;
}
function wrapFilter(exp, filter) {
    var i = filter.indexOf('(');
    if (i < 0) {
        // _f: resolveFilter
        return "_f(\"".concat(filter, "\")(").concat(exp, ")");
    }
    else {
        var name_1 = filter.slice(0, i);
        var args = filter.slice(i + 1);
        return "_f(\"".concat(name_1, "\")(").concat(exp).concat(args !== ')' ? ',' + args : args);
    }
}

/* eslint-disable no-unused-vars */
function baseWarn(msg, range) {
    console.error("[Vue compiler]: ".concat(msg));
}
/* eslint-enable no-unused-vars */
function pluckModuleFunction(modules, key) {
    return modules ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; }) : [];
}
function addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
function addAttr(el, name, value, range, dynamic) {
    var attrs = dynamic
        ? el.dynamicAttrs || (el.dynamicAttrs = [])
        : el.attrs || (el.attrs = []);
    attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
// add a raw attr (use this in preTransforms)
function addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}
function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
        name: name,
        rawName: rawName,
        value: value,
        arg: arg,
        isDynamicArg: isDynamicArg,
        modifiers: modifiers
    }, range));
    el.plain = false;
}
function prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? "_p(".concat(name, ",\"").concat(symbol, "\")") : symbol + name; // mark the event as captured
}
function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || emptyObject;
    // warn prevent and passive modifier
    /* istanbul ignore if */
    if (false) {
        warn("passive and prevent can't be used together. " +
            "Passive handler can't prevent default event.", range);
    }
    // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.
    if (modifiers.right) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'contextmenu':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'contextmenu';
            delete modifiers.right;
        }
    }
    else if (modifiers.middle) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'mouseup':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'mouseup';
        }
    }
    // check capture modifier
    if (modifiers.capture) {
        delete modifiers.capture;
        name = prependModifierMarker('!', name, dynamic);
    }
    if (modifiers.once) {
        delete modifiers.once;
        name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */
    if (modifiers.passive) {
        delete modifiers.passive;
        name = prependModifierMarker('&', name, dynamic);
    }
    var events;
    if (modifiers.native) {
        delete modifiers.native;
        events = el.nativeEvents || (el.nativeEvents = {});
    }
    else {
        events = el.events || (el.events = {});
    }
    var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
    if (modifiers !== emptyObject) {
        newHandler.modifiers = modifiers;
    }
    var handlers = events[name];
    /* istanbul ignore if */
    if (Array.isArray(handlers)) {
        important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    }
    else if (handlers) {
        events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    }
    else {
        events[name] = newHandler;
    }
    el.plain = false;
}
function getRawBindingAttr(el, name) {
    return (el.rawAttrsMap[':' + name] ||
        el.rawAttrsMap['v-bind:' + name] ||
        el.rawAttrsMap[name]);
}
function getBindingAttr(el, name, getStatic) {
    var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
    if (dynamicValue != null) {
        return parseFilters(dynamicValue);
    }
    else if (getStatic !== false) {
        var staticValue = getAndRemoveAttr(el, name);
        if (staticValue != null) {
            return JSON.stringify(staticValue);
        }
    }
}
// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr(el, name, removeFromMap) {
    var val;
    if ((val = el.attrsMap[name]) != null) {
        var list = el.attrsList;
        for (var i = 0, l = list.length; i < l; i++) {
            if (list[i].name === name) {
                list.splice(i, 1);
                break;
            }
        }
    }
    if (removeFromMap) {
        delete el.attrsMap[name];
    }
    return val;
}
function getAndRemoveAttrByRegex(el, name) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
        var attr = list[i];
        if (name.test(attr.name)) {
            list.splice(i, 1);
            return attr;
        }
    }
}
function rangeSetItem(item, range) {
    if (range) {
        if (range.start != null) {
            item.start = range.start;
        }
        if (range.end != null) {
            item.end = range.end;
        }
    }
    return item;
}

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel(el, value, modifiers) {
    var _a = modifiers || {}, number = _a.number, trim = _a.trim;
    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;
    if (trim) {
        valueExpression =
            "(typeof ".concat(baseValueExpression, " === 'string'") +
                "? ".concat(baseValueExpression, ".trim()") +
                ": ".concat(baseValueExpression, ")");
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var assignment = genAssignmentCode(value, valueExpression);
    el.model = {
        value: "(".concat(value, ")"),
        expression: JSON.stringify(value),
        callback: "function (".concat(baseValueExpression, ") {").concat(assignment, "}")
    };
}
/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode(value, assignment) {
    var res = parseModel(value);
    if (res.key === null) {
        return "".concat(value, "=").concat(assignment);
    }
    else {
        return "$set(".concat(res.exp, ", ").concat(res.key, ", ").concat(assignment, ")");
    }
}
/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */
var len, str, chr, index, expressionPos, expressionEndPos;
function parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;
    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
        index = val.lastIndexOf('.');
        if (index > -1) {
            return {
                exp: val.slice(0, index),
                key: '"' + val.slice(index + 1) + '"'
            };
        }
        else {
            return {
                exp: val,
                key: null
            };
        }
    }
    str = val;
    index = expressionPos = expressionEndPos = 0;
    while (!eof()) {
        chr = next();
        /* istanbul ignore if */
        if (isStringStart(chr)) {
            parseString(chr);
        }
        else if (chr === 0x5b) {
            parseBracket(chr);
        }
    }
    return {
        exp: val.slice(0, expressionPos),
        key: val.slice(expressionPos + 1, expressionEndPos)
    };
}
function next() {
    return str.charCodeAt(++index);
}
function eof() {
    return index >= len;
}
function isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
}
function parseBracket(chr) {
    var inBracket = 1;
    expressionPos = index;
    while (!eof()) {
        chr = next();
        if (isStringStart(chr)) {
            parseString(chr);
            continue;
        }
        if (chr === 0x5b)
            inBracket++;
        if (chr === 0x5d)
            inBracket--;
        if (inBracket === 0) {
            expressionEndPos = index;
            break;
        }
    }
}
function parseString(chr) {
    var stringQuote = chr;
    while (!eof()) {
        chr = next();
        if (chr === stringQuote) {
            break;
        }
    }
}

var warn$1;
// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';
function model$1(el, dir, _warn) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;
    if (false) {
        // inputs with type="file" are read only and setting the input's
        // value will throw an error.
        if (tag === 'input' && type === 'file') {
            warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\" type=\"file\">:\n") +
                "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
        }
    }
    if (el.component) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (tag === 'select') {
        genSelect(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'checkbox') {
        genCheckboxModel(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'radio') {
        genRadioModel(el, value, modifiers);
    }
    else if (tag === 'input' || tag === 'textarea') {
        genDefaultModel(el, value, modifiers);
    }
    else if (!config.isReservedTag(tag)) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (false) {
        warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
            "v-model is not supported on this element type. " +
            "If you are working with contenteditable, it's recommended to " +
            'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    }
    // ensure runtime directive metadata
    return true;
}
function genCheckboxModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked', "Array.isArray(".concat(value, ")") +
        "?_i(".concat(value, ",").concat(valueBinding, ")>-1") +
        (trueValueBinding === 'true'
            ? ":(".concat(value, ")")
            : ":_q(".concat(value, ",").concat(trueValueBinding, ")")));
    addHandler(el, 'change', "var $$a=".concat(value, ",") +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(".concat(trueValueBinding, "):(").concat(falseValueBinding, ");") +
        'if(Array.isArray($$a)){' +
        "var $$v=".concat(number ? '_n(' + valueBinding + ')' : valueBinding, ",") +
        '$$i=_i($$a,$$v);' +
        "if($$el.checked){$$i<0&&(".concat(genAssignmentCode(value, '$$a.concat([$$v])'), ")}") +
        "else{$$i>-1&&(".concat(genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))'), ")}") +
        "}else{".concat(genAssignmentCode(value, '$$c'), "}"), null, true);
}
function genRadioModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? "_n(".concat(valueBinding, ")") : valueBinding;
    addProp(el, 'checked', "_q(".concat(value, ",").concat(valueBinding, ")"));
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}
function genSelect(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" +
        ".call($event.target.options,function(o){return o.selected})" +
        ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
        "return ".concat(number ? '_n(val)' : 'val', "})");
    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = ".concat(selectedVal, ";");
    code = "".concat(code, " ").concat(genAssignmentCode(value, assignment));
    addHandler(el, 'change', code, null, true);
}
function genDefaultModel(el, value, modifiers) {
    var type = el.attrsMap.type;
    // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type
    if (false) {
        var value_1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
        var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
        if (value_1 && !typeBinding) {
            var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
            warn$1("".concat(binding, "=\"").concat(value_1, "\" conflicts with v-model on the same element ") +
                'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
        }
    }
    var _a = modifiers || {}, lazy = _a.lazy, number = _a.number, trim = _a.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
    var valueExpression = '$event.target.value';
    if (trim) {
        valueExpression = "$event.target.value.trim()";
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var code = genAssignmentCode(value, valueExpression);
    if (needCompositionGuard) {
        code = "if($event.target.composing)return;".concat(code);
    }
    addProp(el, 'value', "(".concat(value, ")"));
    addHandler(el, event, code, null, true);
    if (trim || number) {
        addHandler(el, 'blur', '$forceUpdate()');
    }
}

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
                // event is fired after handler attachment
                e.timeStamp >= attachedTimestamp_1 ||
                // bail for environments that have buggy event.timeStamp implementations
                // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                // #9681 QtWebEngine event.timeStamp is negative value
                e.timeStamp <= 0 ||
                // #9448 bail if event is fired in another document in a multi-page
                // electron/nw.js app, since event.timeStamp will be using a different
                // starting reference
                e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name, 
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function (vnode) { return updateDOMListeners(vnode, emptyNode); }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children)
                vnode.children.length = 0;
            if (cur === oldProps[key])
                continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        }
        else if (key === 'innerHTML' &&
            isSVG(elm.tagName) &&
            isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        }
        else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            }
            catch (e) { }
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
    //@ts-expect-error
    !elm.composing &&
        (elm.tagName === 'OPTION' ||
            isNotInFocusAndDirty(elm, checkVal) ||
            isDirtyWithModifiers(elm, checkVal)));
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    }
    catch (e) { }
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode &&
                childNode.data &&
                (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if ((styleData = normalizeStyleData(vnode.data))) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while ((parentNode = parentNode.parent)) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    }
    else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    }
    else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        }
        else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) &&
        isUndef(data.style) &&
        isUndef(oldData.staticStyle) &&
        isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        // ie9 setting to null has no effect, must use empty string
        setProp(el, name, cur == null ? '' : cur);
    }
}
var style$1 = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE$1 = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.add(c); });
        }
        else {
            el.classList.add(cls);
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.remove(c); });
        }
        else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        }
        else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if (typeof def === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    }
    else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
        window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
        window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
    ? window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : setTimeout
    : /* istanbul ignore next */ function (/* istanbul ignore next */ fn) { return fn(); };
function nextFrame(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type)
        return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function () {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function (e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
            timeout > 0
                ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                : null;
        propCount = type
            ? type === TRANSITION
                ? transitionDurations.length
                : animationDurations.length
            : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear
        ? appearCancelled || enterCancelled
        : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (false) {
        checkDuration(explicitEnterDuration, 'enter', vnode);
    }
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = (el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        }
        else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    }));
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode &&
                pendingNode.tag === vnode.tag &&
                pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    }
                    else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (false) {
        checkDuration(explicitLeaveDuration, 'leave', vnode);
    }
    var cb = (el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        }
        else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    }));
    if (delayLeave) {
        delayLeave(performLeave);
    }
    else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
                vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        }
                        else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn$2("<transition> explicit ".concat(name, " duration is not a valid number - ") +
            "got ".concat(JSON.stringify(val), "."), vnode.context);
    }
    else if (isNaN(val)) {
        warn$2("<transition> explicit ".concat(name, " duration is NaN - ") +
            'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    }
    else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser
    ? {
        create: _enter,
        activate: _enter,
        remove: function (vnode, rm) {
            /* istanbul ignore else */
            if (vnode.data.show !== true) {
                // @ts-expect-error
                leave(vnode, rm);
            }
            else {
                rm();
            }
        }
    }
    : {};

var platformModules = [attrs, klass$1, events, domProps, style$1, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules$1 = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules$1 });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function (el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            }
            else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        }
        else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function (el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = (el._vOptions = [].map.call(el.options, getValue));
            if (curOptions_1.some(function (o, i) { return !looseEqual(o, prevOptions_1[i]); })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple
                    ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions_1); })
                    : binding.value !== binding.oldValue &&
                        hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        "production" !== 'production' &&
            warn$2("<select multiple v-model=\"".concat(binding.expression, "\"> ") +
                "expects an Array value for its binding, but got ".concat(Object.prototype.toString
                    .call(value)
                    .slice(8, -1)), vm);
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        }
        else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) { return !looseEqual(o, value); });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing)
        return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode;
}
var show = {
    bind: function (el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = (el.__vOriginalDisplay =
            el.style.display === 'none' ? '' : el.style.display);
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        }
        else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function (el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue)
            return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            }
            else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        }
        else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function (el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    }
    else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while ((vnode = vnode.parent)) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
var isVShowDirective = function (d) { return d.name === 'show'; };
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function (h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (false) {
            warn$2('<transition> can only be used on a single element. Use ' +
                '<transition-group> for lists.', this.$parent);
        }
        var mode = this.mode;
        // warn invalid mode
        if (false) {
            warn$2('invalid <transition> mode: ' + mode, this.$parent);
        }
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key =
            child.key == null
                ? child.isComment
                    ? id + 'comment'
                    : id + child.tag
                : isPrimitive(child.key)
                    ? String(child.key).indexOf(id) === 0
                        ? child.key
                        : id + child.key
                    : child.key;
        var data = ((child.data || (child.data = {})).transition =
            extractTransitionData(this));
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild &&
            oldChild.data &&
            !isSameChild(child, oldChild) &&
            !isAsyncPlaceholder(oldChild) &&
            // #6687 component root is a comment node
            !(oldChild.componentInstance &&
                oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = (oldChild.data.transition = extend({}, data));
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            }
            else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function () {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function () {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function (h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = (this.prevChildren = this.children);
        var rawChildren = this.$slots.default || [];
        var children = (this.children = []);
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                }
                else if (false) {
                    var opts = c.componentOptions;
                    var name_1 = opts
                        ? getComponentName(opts.Ctor.options) || opts.tag || ''
                        : c.tag;
                    warn$2("<transition-group> children must be keyed: <".concat(name_1, ">"));
                }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                }
                else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function () {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, (el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                }));
            }
        });
    },
    methods: {
        hasMove: function (el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return (this._hasMove = info.hasTransform);
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            }
            else if (false) {
                // @ts-expect-error
                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' +
                    'https://github.com/vuejs/vue-devtools');
            }
        }
        if (false) {
            // @ts-expect-error
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" +
                "Make sure to turn on production mode when deploying for production.\n" +
                "See more tips at https://vuejs.org/guide/deployment.html");
        }
    }, 0);
}

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});
function parseText(text, delimiters) {
    //@ts-expect-error
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
    if (!tagRE.test(text)) {
        return;
    }
    var tokens = [];
    var rawTokens = [];
    var lastIndex = (tagRE.lastIndex = 0);
    var match, index, tokenValue;
    while ((match = tagRE.exec(text))) {
        index = match.index;
        // push text token
        if (index > lastIndex) {
            rawTokens.push((tokenValue = text.slice(lastIndex, index)));
            tokens.push(JSON.stringify(tokenValue));
        }
        // tag token
        var exp = parseFilters(match[1].trim());
        tokens.push("_s(".concat(exp, ")"));
        rawTokens.push({ '@binding': exp });
        lastIndex = index + match[0].length;
    }
    if (lastIndex < text.length) {
        rawTokens.push((tokenValue = text.slice(lastIndex)));
        tokens.push(JSON.stringify(tokenValue));
    }
    return {
        expression: tokens.join('+'),
        tokens: rawTokens
    };
}

function transformNode$1(el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');
    if (false) {
        var res = parseText(staticClass, options.delimiters);
        if (res) {
            warn("class=\"".concat(staticClass, "\": ") +
                'Interpolation inside attributes has been removed. ' +
                'Use v-bind or the colon shorthand instead. For example, ' +
                'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
        }
    }
    if (staticClass) {
        el.staticClass = JSON.stringify(staticClass.replace(/\s+/g, ' ').trim());
    }
    var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
    if (classBinding) {
        el.classBinding = classBinding;
    }
}
function genData$2(el) {
    var data = '';
    if (el.staticClass) {
        data += "staticClass:".concat(el.staticClass, ",");
    }
    if (el.classBinding) {
        data += "class:".concat(el.classBinding, ",");
    }
    return data;
}
var klass = {
    staticKeys: ['staticClass'],
    transformNode: transformNode$1,
    genData: genData$2
};

function transformNode(el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');
    if (staticStyle) {
        /* istanbul ignore if */
        if (false) {
            var res = parseText(staticStyle, options.delimiters);
            if (res) {
                warn("style=\"".concat(staticStyle, "\": ") +
                    'Interpolation inside attributes has been removed. ' +
                    'Use v-bind or the colon shorthand instead. For example, ' +
                    'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
            }
        }
        el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }
    var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
    if (styleBinding) {
        el.styleBinding = styleBinding;
    }
}
function genData$1(el) {
    var data = '';
    if (el.staticStyle) {
        data += "staticStyle:".concat(el.staticStyle, ",");
    }
    if (el.styleBinding) {
        data += "style:(".concat(el.styleBinding, "),");
    }
    return data;
}
var style = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode,
    genData: genData$1
};

var decoder;
var he = {
    decode: function (html) {
        decoder = decoder || document.createElement('div');
        decoder.innerHTML = html;
        return decoder.textContent;
    }
};

var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
    'link,meta,param,source,track,wbr');
// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');
// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
    'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
    'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
    'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
    'title,tr,track');

/**
 * Not type-checking this file because it's mostly vendor code.
 */
// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(unicodeRegExp.source, "]*");
var qnameCapture = "((?:".concat(ncname, "\\:)?").concat(ncname, ")");
var startTagOpen = new RegExp("^<".concat(qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp("^<\\/".concat(qnameCapture, "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;
// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};
var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) {
    return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
};
function decodeAttr(value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) { return decodingMap[match]; });
}
function parseHTML(html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag = options.isUnaryTag || no;
    var canBeLeftOpenTag = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;
    var _loop_1 = function () {
        last = html;
        // Make sure we're not in a plaintext content element like script/style
        if (!lastTag || !isPlainTextElement(lastTag)) {
            var textEnd = html.indexOf('<');
            if (textEnd === 0) {
                // Comment:
                if (comment.test(html)) {
                    var commentEnd = html.indexOf('-->');
                    if (commentEnd >= 0) {
                        if (options.shouldKeepComment && options.comment) {
                            options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                        }
                        advance(commentEnd + 3);
                        return "continue";
                    }
                }
                // https://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                if (conditionalComment.test(html)) {
                    var conditionalEnd = html.indexOf(']>');
                    if (conditionalEnd >= 0) {
                        advance(conditionalEnd + 2);
                        return "continue";
                    }
                }
                // Doctype:
                var doctypeMatch = html.match(doctype);
                if (doctypeMatch) {
                    advance(doctypeMatch[0].length);
                    return "continue";
                }
                // End tag:
                var endTagMatch = html.match(endTag);
                if (endTagMatch) {
                    var curIndex = index;
                    advance(endTagMatch[0].length);
                    parseEndTag(endTagMatch[1], curIndex, index);
                    return "continue";
                }
                // Start tag:
                var startTagMatch = parseStartTag();
                if (startTagMatch) {
                    handleStartTag(startTagMatch);
                    if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                        advance(1);
                    }
                    return "continue";
                }
            }
            var text = void 0, rest = void 0, next = void 0;
            if (textEnd >= 0) {
                rest = html.slice(textEnd);
                while (!endTag.test(rest) &&
                    !startTagOpen.test(rest) &&
                    !comment.test(rest) &&
                    !conditionalComment.test(rest)) {
                    // < in plain text, be forgiving and treat it as text
                    next = rest.indexOf('<', 1);
                    if (next < 0)
                        break;
                    textEnd += next;
                    rest = html.slice(textEnd);
                }
                text = html.substring(0, textEnd);
            }
            if (textEnd < 0) {
                text = html;
            }
            if (text) {
                advance(text.length);
            }
            if (options.chars && text) {
                options.chars(text, index - text.length, index);
            }
        }
        else {
            var endTagLength_1 = 0;
            var stackedTag_1 = lastTag.toLowerCase();
            var reStackedTag = reCache[stackedTag_1] ||
                (reCache[stackedTag_1] = new RegExp('([\\s\\S]*?)(</' + stackedTag_1 + '[^>]*>)', 'i'));
            var rest = html.replace(reStackedTag, function (all, text, endTag) {
                endTagLength_1 = endTag.length;
                if (!isPlainTextElement(stackedTag_1) && stackedTag_1 !== 'noscript') {
                    text = text
                        .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                        .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
                }
                if (shouldIgnoreFirstNewline(stackedTag_1, text)) {
                    text = text.slice(1);
                }
                if (options.chars) {
                    options.chars(text);
                }
                return '';
            });
            index += html.length - rest.length;
            html = rest;
            parseEndTag(stackedTag_1, index - endTagLength_1, index);
        }
        if (html === last) {
            options.chars && options.chars(html);
            if (false) {
                options.warn("Mal-formatted tag at end of template: \"".concat(html, "\""), {
                    start: index + html.length
                });
            }
            return "break";
        }
    };
    while (html) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    // Clean up any remaining tags
    parseEndTag();
    function advance(n) {
        index += n;
        html = html.substring(n);
    }
    function parseStartTag() {
        var start = html.match(startTagOpen);
        if (start) {
            var match = {
                tagName: start[1],
                attrs: [],
                start: index
            };
            advance(start[0].length);
            var end = void 0, attr = void 0;
            while (!(end = html.match(startTagClose)) &&
                (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
                attr.start = index;
                advance(attr[0].length);
                attr.end = index;
                match.attrs.push(attr);
            }
            if (end) {
                match.unarySlash = end[1];
                advance(end[0].length);
                match.end = index;
                return match;
            }
        }
    }
    function handleStartTag(match) {
        var tagName = match.tagName;
        var unarySlash = match.unarySlash;
        if (expectHTML) {
            if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
                parseEndTag(lastTag);
            }
            if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
                parseEndTag(tagName);
            }
        }
        var unary = isUnaryTag(tagName) || !!unarySlash;
        var l = match.attrs.length;
        var attrs = new Array(l);
        for (var i = 0; i < l; i++) {
            var args = match.attrs[i];
            var value = args[3] || args[4] || args[5] || '';
            var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
                ? options.shouldDecodeNewlinesForHref
                : options.shouldDecodeNewlines;
            attrs[i] = {
                name: args[1],
                value: decodeAttr(value, shouldDecodeNewlines)
            };
            if (false) {
                attrs[i].start = args.start + args[0].match(/^\s*/).length;
                attrs[i].end = args.end;
            }
        }
        if (!unary) {
            stack.push({
                tag: tagName,
                lowerCasedTag: tagName.toLowerCase(),
                attrs: attrs,
                start: match.start,
                end: match.end
            });
            lastTag = tagName;
        }
        if (options.start) {
            options.start(tagName, attrs, unary, match.start, match.end);
        }
    }
    function parseEndTag(tagName, start, end) {
        var pos, lowerCasedTagName;
        if (start == null)
            start = index;
        if (end == null)
            end = index;
        // Find the closest opened tag of the same type
        if (tagName) {
            lowerCasedTagName = tagName.toLowerCase();
            for (pos = stack.length - 1; pos >= 0; pos--) {
                if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                    break;
                }
            }
        }
        else {
            // If no tag name is provided, clean shop
            pos = 0;
        }
        if (pos >= 0) {
            // Close all the open elements, up the stack
            for (var i = stack.length - 1; i >= pos; i--) {
                if (false) {
                    options.warn("tag <".concat(stack[i].tag, "> has no matching end tag."), {
                        start: stack[i].start,
                        end: stack[i].end
                    });
                }
                if (options.end) {
                    options.end(stack[i].tag, start, end);
                }
            }
            // Remove the open elements from the stack
            stack.length = pos;
            lastTag = pos && stack[pos - 1].tag;
        }
        else if (lowerCasedTagName === 'br') {
            if (options.start) {
                options.start(tagName, [], true, start, end);
            }
        }
        else if (lowerCasedTagName === 'p') {
            if (options.start) {
                options.start(tagName, [], false, start, end);
            }
            if (options.end) {
                options.end(tagName, start, end);
            }
        }
    }
}

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;
var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
var slotRE = /^v-slot(:|$)|^#/;
var lineBreakRE = /[\r\n]/;
var whitespaceRE = /[ \f\t\r\n]+/g;
var invalidAttributeRE = /[\s"'<>\/=]/;
var decodeHTMLCached = cached(he.decode);
var emptySlotScopeToken = "_empty_";
// configurable state
var warn;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;
function createASTElement(tag, attrs, parent) {
    return {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        rawAttrsMap: {},
        parent: parent,
        children: []
    };
}
/**
 * Convert HTML string to AST.
 */
function parse(template, options) {
    warn = options.warn || baseWarn;
    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;
    maybeComponent = function (el) {
        return !!(el.component ||
            el.attrsMap[':is'] ||
            el.attrsMap['v-bind:is'] ||
            !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    };
    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
    delimiters = options.delimiters;
    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;
    function warnOnce(msg, range) {
        if (!warned) {
            warned = true;
            warn(msg, range);
        }
    }
    function closeElement(element) {
        trimEndingWhitespace(element);
        if (!inVPre && !element.processed) {
            element = processElement(element, options);
        }
        // tree management
        if (!stack.length && element !== root) {
            // allow root elements with v-if, v-else-if and v-else
            if (root.if && (element.elseif || element.else)) {
                if (false) {
                    checkRootConstraints(element);
                }
                addIfCondition(root, {
                    exp: element.elseif,
                    block: element
                });
            }
            else if (false) {
                warnOnce("Component template should contain exactly one root element. " +
                    "If you are using v-if on multiple elements, " +
                    "use v-else-if to chain them instead.", { start: element.start });
            }
        }
        if (currentParent && !element.forbidden) {
            if (element.elseif || element.else) {
                processIfConditions(element, currentParent);
            }
            else {
                if (element.slotScope) {
                    // scoped slot
                    // keep it in the children list so that v-else(-if) conditions can
                    // find it as the prev node.
                    var name_1 = element.slotTarget || '"default"';
                    (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name_1] = element;
                }
                currentParent.children.push(element);
                element.parent = currentParent;
            }
        }
        // final children cleanup
        // filter out scoped slots
        element.children = element.children.filter(function (c) { return !c.slotScope; });
        // remove trailing whitespace node again
        trimEndingWhitespace(element);
        // check pre state
        if (element.pre) {
            inVPre = false;
        }
        if (platformIsPreTag(element.tag)) {
            inPre = false;
        }
        // apply post-transforms
        for (var i = 0; i < postTransforms.length; i++) {
            postTransforms[i](element, options);
        }
    }
    function trimEndingWhitespace(el) {
        // remove trailing whitespace node
        if (!inPre) {
            var lastNode = void 0;
            while ((lastNode = el.children[el.children.length - 1]) &&
                lastNode.type === 3 &&
                lastNode.text === ' ') {
                el.children.pop();
            }
        }
    }
    function checkRootConstraints(el) {
        if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce("Cannot use <".concat(el.tag, "> as component root element because it may ") +
                'contain multiple nodes.', { start: el.start });
        }
        if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce('Cannot use v-for on stateful component root element because ' +
                'it renders multiple elements.', el.rawAttrsMap['v-for']);
        }
    }
    parseHTML(template, {
        warn: warn,
        expectHTML: options.expectHTML,
        isUnaryTag: options.isUnaryTag,
        canBeLeftOpenTag: options.canBeLeftOpenTag,
        shouldDecodeNewlines: options.shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
        shouldKeepComment: options.comments,
        outputSourceRange: options.outputSourceRange,
        start: function (tag, attrs, unary, start, end) {
            // check namespace.
            // inherit parent ns if there is one
            var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
            // handle IE svg bug
            /* istanbul ignore if */
            if (isIE && ns === 'svg') {
                attrs = guardIESVGBug(attrs);
            }
            var element = createASTElement(tag, attrs, currentParent);
            if (ns) {
                element.ns = ns;
            }
            if (false) {
                if (options.outputSourceRange) {
                    element.start = start;
                    element.end = end;
                    element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
                        cumulated[attr.name] = attr;
                        return cumulated;
                    }, {});
                }
                attrs.forEach(function (attr) {
                    if (invalidAttributeRE.test(attr.name)) {
                        warn("Invalid dynamic argument expression: attribute names cannot contain " +
                            "spaces, quotes, <, >, / or =.", options.outputSourceRange
                            ? {
                                start: attr.start + attr.name.indexOf("["),
                                end: attr.start + attr.name.length
                            }
                            : undefined);
                    }
                });
            }
            if (isForbiddenTag(element) && !isServerRendering()) {
                element.forbidden = true;
                "production" !== 'production' &&
                    warn('Templates should only be responsible for mapping the state to the ' +
                        'UI. Avoid placing tags with side-effects in your templates, such as ' +
                        "<".concat(tag, ">") +
                        ', as they will not be parsed.', { start: element.start });
            }
            // apply pre-transforms
            for (var i = 0; i < preTransforms.length; i++) {
                element = preTransforms[i](element, options) || element;
            }
            if (!inVPre) {
                processPre(element);
                if (element.pre) {
                    inVPre = true;
                }
            }
            if (platformIsPreTag(element.tag)) {
                inPre = true;
            }
            if (inVPre) {
                processRawAttrs(element);
            }
            else if (!element.processed) {
                // structural directives
                processFor(element);
                processIf(element);
                processOnce(element);
            }
            if (!root) {
                root = element;
                if (false) {
                    checkRootConstraints(root);
                }
            }
            if (!unary) {
                currentParent = element;
                stack.push(element);
            }
            else {
                closeElement(element);
            }
        },
        end: function (tag, start, end) {
            var element = stack[stack.length - 1];
            // pop stack
            stack.length -= 1;
            currentParent = stack[stack.length - 1];
            if (false) {
                element.end = end;
            }
            closeElement(element);
        },
        chars: function (text, start, end) {
            if (!currentParent) {
                if (false) {
                    if (text === template) {
                        warnOnce('Component template requires a root element, rather than just text.', { start: start });
                    }
                    else if ((text = text.trim())) {
                        warnOnce("text \"".concat(text, "\" outside root element will be ignored."), {
                            start: start
                        });
                    }
                }
                return;
            }
            // IE textarea placeholder bug
            /* istanbul ignore if */
            if (isIE &&
                currentParent.tag === 'textarea' &&
                currentParent.attrsMap.placeholder === text) {
                return;
            }
            var children = currentParent.children;
            if (inPre || text.trim()) {
                text = isTextTag(currentParent)
                    ? text
                    : decodeHTMLCached(text);
            }
            else if (!children.length) {
                // remove the whitespace-only node right after an opening tag
                text = '';
            }
            else if (whitespaceOption) {
                if (whitespaceOption === 'condense') {
                    // in condense mode, remove the whitespace node if it contains
                    // line break, otherwise condense to a single space
                    text = lineBreakRE.test(text) ? '' : ' ';
                }
                else {
                    text = ' ';
                }
            }
            else {
                text = preserveWhitespace ? ' ' : '';
            }
            if (text) {
                if (!inPre && whitespaceOption === 'condense') {
                    // condense consecutive whitespaces into single space
                    text = text.replace(whitespaceRE, ' ');
                }
                var res = void 0;
                var child = void 0;
                if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
                    child = {
                        type: 2,
                        expression: res.expression,
                        tokens: res.tokens,
                        text: text
                    };
                }
                else if (text !== ' ' ||
                    !children.length ||
                    children[children.length - 1].text !== ' ') {
                    child = {
                        type: 3,
                        text: text
                    };
                }
                if (child) {
                    if (false) {
                        child.start = start;
                        child.end = end;
                    }
                    children.push(child);
                }
            }
        },
        comment: function (text, start, end) {
            // adding anything as a sibling to the root node is forbidden
            // comments should still be allowed, but ignored
            if (currentParent) {
                var child = {
                    type: 3,
                    text: text,
                    isComment: true
                };
                if (false) {
                    child.start = start;
                    child.end = end;
                }
                currentParent.children.push(child);
            }
        }
    });
    return root;
}
function processPre(el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
        el.pre = true;
    }
}
function processRawAttrs(el) {
    var list = el.attrsList;
    var len = list.length;
    if (len) {
        var attrs = (el.attrs = new Array(len));
        for (var i = 0; i < len; i++) {
            attrs[i] = {
                name: list[i].name,
                value: JSON.stringify(list[i].value)
            };
            if (list[i].start != null) {
                attrs[i].start = list[i].start;
                attrs[i].end = list[i].end;
            }
        }
    }
    else if (!el.pre) {
        // non root node in pre blocks with no attributes
        el.plain = true;
    }
}
function processElement(element, options) {
    processKey(element);
    // determine whether this is a plain element after
    // removing structural attributes
    element.plain =
        !element.key && !element.scopedSlots && !element.attrsList.length;
    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);
    for (var i = 0; i < transforms.length; i++) {
        element = transforms[i](element, options) || element;
    }
    processAttrs(element);
    return element;
}
function processKey(el) {
    var exp = getBindingAttr(el, 'key');
    if (exp) {
        if (false) {
            if (el.tag === 'template') {
                warn("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
            }
            if (el.for) {
                var iterator = el.iterator2 || el.iterator1;
                var parent_1 = el.parent;
                if (iterator &&
                    iterator === exp &&
                    parent_1 &&
                    parent_1.tag === 'transition-group') {
                    warn("Do not use v-for index as key on <transition-group> children, " +
                        "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true /* tip */);
                }
            }
        }
        el.key = exp;
    }
}
function processRef(el) {
    var ref = getBindingAttr(el, 'ref');
    if (ref) {
        el.ref = ref;
        el.refInFor = checkInFor(el);
    }
}
function processFor(el) {
    var exp;
    if ((exp = getAndRemoveAttr(el, 'v-for'))) {
        var res = parseFor(exp);
        if (res) {
            extend(el, res);
        }
        else if (false) {
            warn("Invalid v-for expression: ".concat(exp), el.rawAttrsMap['v-for']);
        }
    }
}
function parseFor(exp) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch)
        return;
    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
        res.alias = alias.replace(forIteratorRE, '').trim();
        res.iterator1 = iteratorMatch[1].trim();
        if (iteratorMatch[2]) {
            res.iterator2 = iteratorMatch[2].trim();
        }
    }
    else {
        res.alias = alias;
    }
    return res;
}
function processIf(el) {
    var exp = getAndRemoveAttr(el, 'v-if');
    if (exp) {
        el.if = exp;
        addIfCondition(el, {
            exp: exp,
            block: el
        });
    }
    else {
        if (getAndRemoveAttr(el, 'v-else') != null) {
            el.else = true;
        }
        var elseif = getAndRemoveAttr(el, 'v-else-if');
        if (elseif) {
            el.elseif = elseif;
        }
    }
}
function processIfConditions(el, parent) {
    var prev = findPrevElement(parent.children);
    if (prev && prev.if) {
        addIfCondition(prev, {
            exp: el.elseif,
            block: el
        });
    }
    else if (false) {
        warn("v-".concat(el.elseif ? 'else-if="' + el.elseif + '"' : 'else', " ") +
            "used on element <".concat(el.tag, "> without corresponding v-if."), el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
    }
}
function findPrevElement(children) {
    var i = children.length;
    while (i--) {
        if (children[i].type === 1) {
            return children[i];
        }
        else {
            if (false) {
                warn("text \"".concat(children[i].text.trim(), "\" between v-if and v-else(-if) ") +
                    "will be ignored.", children[i]);
            }
            children.pop();
        }
    }
}
function addIfCondition(el, condition) {
    if (!el.ifConditions) {
        el.ifConditions = [];
    }
    el.ifConditions.push(condition);
}
function processOnce(el) {
    var once = getAndRemoveAttr(el, 'v-once');
    if (once != null) {
        el.once = true;
    }
}
// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent(el) {
    var slotScope;
    if (el.tag === 'template') {
        slotScope = getAndRemoveAttr(el, 'scope');
        /* istanbul ignore if */
        if (false) {
            warn("the \"scope\" attribute for scoped slots have been deprecated and " +
                "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
                "can also be used on plain elements in addition to <template> to " +
                "denote scoped slots.", el.rawAttrsMap['scope'], true);
        }
        el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    }
    else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
        /* istanbul ignore if */
        if (false) {
            warn("Ambiguous combined usage of slot-scope and v-for on <".concat(el.tag, "> ") +
                "(v-for takes higher priority). Use a wrapper <template> for the " +
                "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
        }
        el.slotScope = slotScope;
    }
    // slot="xxx"
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
        el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
        el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
        // preserve slot as an attribute for native shadow DOM compat
        // only for non-scoped slots.
        if (el.tag !== 'template' && !el.slotScope) {
            addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
        }
    }
    // 2.6 v-slot syntax
    {
        if (el.tag === 'template') {
            // v-slot on <template>
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (el.slotTarget || el.slotScope) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.parent && !maybeComponent(el.parent)) {
                        warn("<template v-slot> can only appear at the root level inside " +
                            "the receiving component", el);
                    }
                }
                var _a = getSlotName(slotBinding), name_2 = _a.name, dynamic = _a.dynamic;
                el.slotTarget = name_2;
                el.slotTargetDynamic = dynamic;
                el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
            }
        }
        else {
            // v-slot on component, denotes default slot
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (!maybeComponent(el)) {
                        warn("v-slot can only be used on components or <template>.", slotBinding);
                    }
                    if (el.slotScope || el.slotTarget) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.scopedSlots) {
                        warn("To avoid scope ambiguity, the default slot should also use " +
                            "<template> syntax when there are other named slots.", slotBinding);
                    }
                }
                // add the component's children to its default slot
                var slots = el.scopedSlots || (el.scopedSlots = {});
                var _b = getSlotName(slotBinding), name_3 = _b.name, dynamic = _b.dynamic;
                var slotContainer_1 = (slots[name_3] = createASTElement('template', [], el));
                slotContainer_1.slotTarget = name_3;
                slotContainer_1.slotTargetDynamic = dynamic;
                slotContainer_1.children = el.children.filter(function (c) {
                    if (!c.slotScope) {
                        c.parent = slotContainer_1;
                        return true;
                    }
                });
                slotContainer_1.slotScope = slotBinding.value || emptySlotScopeToken;
                // remove children as they are returned from scopedSlots now
                el.children = [];
                // mark el non-plain so data gets generated
                el.plain = false;
            }
        }
    }
}
function getSlotName(binding) {
    var name = binding.name.replace(slotRE, '');
    if (!name) {
        if (binding.name[0] !== '#') {
            name = 'default';
        }
        else if (false) {
            warn("v-slot shorthand syntax requires a slot name.", binding);
        }
    }
    return dynamicArgRE.test(name)
        ? // dynamic [name]
            { name: name.slice(1, -1), dynamic: true }
        : // static name
            { name: "\"".concat(name, "\""), dynamic: false };
}
// handle <slot/> outlets
function processSlotOutlet(el) {
    if (el.tag === 'slot') {
        el.slotName = getBindingAttr(el, 'name');
        if (false) {
            warn("`key` does not work on <slot> because slots are abstract outlets " +
                "and can possibly expand into multiple elements. " +
                "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
        }
    }
}
function processComponent(el) {
    var binding;
    if ((binding = getBindingAttr(el, 'is'))) {
        el.component = binding;
    }
    if (getAndRemoveAttr(el, 'inline-template') != null) {
        el.inlineTemplate = true;
    }
}
function processAttrs(el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
    for (i = 0, l = list.length; i < l; i++) {
        name = rawName = list[i].name;
        value = list[i].value;
        if (dirRE.test(name)) {
            // mark element as dynamic
            el.hasBindings = true;
            // modifiers
            modifiers = parseModifiers(name.replace(dirRE, ''));
            // support .foo shorthand syntax for the .prop modifier
            if (modifiers) {
                name = name.replace(modifierRE, '');
            }
            if (bindRE.test(name)) {
                // v-bind
                name = name.replace(bindRE, '');
                value = parseFilters(value);
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                if (false) {
                    warn("The value for a v-bind expression cannot be empty. Found in \"v-bind:".concat(name, "\""));
                }
                if (modifiers) {
                    if (modifiers.prop && !isDynamic) {
                        name = camelize(name);
                        if (name === 'innerHtml')
                            name = 'innerHTML';
                    }
                    if (modifiers.camel && !isDynamic) {
                        name = camelize(name);
                    }
                    if (modifiers.sync) {
                        syncGen = genAssignmentCode(value, "$event");
                        if (!isDynamic) {
                            addHandler(el, "update:".concat(camelize(name)), syncGen, null, false, warn, list[i]);
                            if (hyphenate(name) !== camelize(name)) {
                                addHandler(el, "update:".concat(hyphenate(name)), syncGen, null, false, warn, list[i]);
                            }
                        }
                        else {
                            // handler w/ dynamic event name
                            addHandler(el, "\"update:\"+(".concat(name, ")"), syncGen, null, false, warn, list[i], true // dynamic
                            );
                        }
                    }
                }
                if ((modifiers && modifiers.prop) ||
                    (!el.component && platformMustUseProp(el.tag, el.attrsMap.type, name))) {
                    addProp(el, name, value, list[i], isDynamic);
                }
                else {
                    addAttr(el, name, value, list[i], isDynamic);
                }
            }
            else if (onRE.test(name)) {
                // v-on
                name = name.replace(onRE, '');
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                addHandler(el, name, value, modifiers, false, warn, list[i], isDynamic);
            }
            else {
                // normal directives
                name = name.replace(dirRE, '');
                // parse arg
                var argMatch = name.match(argRE);
                var arg = argMatch && argMatch[1];
                isDynamic = false;
                if (arg) {
                    name = name.slice(0, -(arg.length + 1));
                    if (dynamicArgRE.test(arg)) {
                        arg = arg.slice(1, -1);
                        isDynamic = true;
                    }
                }
                addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
                if (false) {
                    checkForAliasModel(el, value);
                }
            }
        }
        else {
            // literal attribute
            if (false) {
                var res = parseText(value, delimiters);
                if (res) {
                    warn("".concat(name, "=\"").concat(value, "\": ") +
                        'Interpolation inside attributes has been removed. ' +
                        'Use v-bind or the colon shorthand instead. For example, ' +
                        'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
                }
            }
            addAttr(el, name, JSON.stringify(value), list[i]);
            // #6887 firefox doesn't update muted state if set via attribute
            // even immediately after element creation
            if (!el.component &&
                name === 'muted' &&
                platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                addProp(el, name, 'true', list[i]);
            }
        }
    }
}
function checkInFor(el) {
    var parent = el;
    while (parent) {
        if (parent.for !== undefined) {
            return true;
        }
        parent = parent.parent;
    }
    return false;
}
function parseModifiers(name) {
    var match = name.match(modifierRE);
    if (match) {
        var ret_1 = {};
        match.forEach(function (m) {
            ret_1[m.slice(1)] = true;
        });
        return ret_1;
    }
}
function makeAttrsMap(attrs) {
    var map = {};
    for (var i = 0, l = attrs.length; i < l; i++) {
        if (false) {
            warn('duplicate attribute: ' + attrs[i].name, attrs[i]);
        }
        map[attrs[i].name] = attrs[i].value;
    }
    return map;
}
// for script (e.g. type="x/template") or style, do not decode content
function isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
}
function isForbiddenTag(el) {
    return (el.tag === 'style' ||
        (el.tag === 'script' &&
            (!el.attrsMap.type || el.attrsMap.type === 'text/javascript')));
}
var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;
/* istanbul ignore next */
function guardIESVGBug(attrs) {
    var res = [];
    for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (!ieNSBug.test(attr.name)) {
            attr.name = attr.name.replace(ieNSPrefix, '');
            res.push(attr);
        }
    }
    return res;
}
function checkForAliasModel(el, value) {
    var _el = el;
    while (_el) {
        if (_el.for && _el.alias === value) {
            warn("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
                "You are binding v-model directly to a v-for iteration alias. " +
                "This will not be able to modify the v-for source array because " +
                "writing to the alias is like modifying a function local variable. " +
                "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
        }
        _el = _el.parent;
    }
}

/**
 * Expand input[v-model] with dynamic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */
function preTransformNode(el, options) {
    if (el.tag === 'input') {
        var map = el.attrsMap;
        if (!map['v-model']) {
            return;
        }
        var typeBinding = void 0;
        if (map[':type'] || map['v-bind:type']) {
            typeBinding = getBindingAttr(el, 'type');
        }
        if (!map.type && !typeBinding && map['v-bind']) {
            typeBinding = "(".concat(map['v-bind'], ").type");
        }
        if (typeBinding) {
            var ifCondition = getAndRemoveAttr(el, 'v-if', true);
            var ifConditionExtra = ifCondition ? "&&(".concat(ifCondition, ")") : "";
            var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
            var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
            // 1. checkbox
            var branch0 = cloneASTElement(el);
            // process for on the main node
            processFor(branch0);
            addRawAttr(branch0, 'type', 'checkbox');
            processElement(branch0, options);
            branch0.processed = true; // prevent it from double-processed
            branch0.if = "(".concat(typeBinding, ")==='checkbox'") + ifConditionExtra;
            addIfCondition(branch0, {
                exp: branch0.if,
                block: branch0
            });
            // 2. add radio else-if condition
            var branch1 = cloneASTElement(el);
            getAndRemoveAttr(branch1, 'v-for', true);
            addRawAttr(branch1, 'type', 'radio');
            processElement(branch1, options);
            addIfCondition(branch0, {
                exp: "(".concat(typeBinding, ")==='radio'") + ifConditionExtra,
                block: branch1
            });
            // 3. other
            var branch2 = cloneASTElement(el);
            getAndRemoveAttr(branch2, 'v-for', true);
            addRawAttr(branch2, ':type', typeBinding);
            processElement(branch2, options);
            addIfCondition(branch0, {
                exp: ifCondition,
                block: branch2
            });
            if (hasElse) {
                branch0.else = true;
            }
            else if (elseIfCondition) {
                branch0.elseif = elseIfCondition;
            }
            return branch0;
        }
    }
}
function cloneASTElement(el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent);
}
var model = {
    preTransformNode: preTransformNode
};

var modules = [klass, style, model];

function text(el, dir) {
    if (dir.value) {
        addProp(el, 'textContent', "_s(".concat(dir.value, ")"), dir);
    }
}

function html(el, dir) {
    if (dir.value) {
        addProp(el, 'innerHTML', "_s(".concat(dir.value, ")"), dir);
    }
}

var directives = {
    model: model$1,
    text: text,
    html: html
};

var baseOptions = {
    expectHTML: true,
    modules: modules,
    directives: directives,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys$1(modules)
};

var isStaticKey;
var isPlatformReservedTag;
var genStaticKeysCached = cached(genStaticKeys);
/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize(root, options) {
    if (!root)
        return;
    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no;
    // first pass: mark all non-static nodes.
    markStatic(root);
    // second pass: mark static roots.
    markStaticRoots(root, false);
}
function genStaticKeys(keys) {
    return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
        (keys ? ',' + keys : ''));
}
function markStatic(node) {
    node.static = isStatic(node);
    if (node.type === 1) {
        // do not make component slot content static. this avoids
        // 1. components not able to mutate slot nodes
        // 2. static slot content fails for hot-reloading
        if (!isPlatformReservedTag(node.tag) &&
            node.tag !== 'slot' &&
            node.attrsMap['inline-template'] == null) {
            return;
        }
        for (var i = 0, l = node.children.length; i < l; i++) {
            var child = node.children[i];
            markStatic(child);
            if (!child.static) {
                node.static = false;
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                var block = node.ifConditions[i].block;
                markStatic(block);
                if (!block.static) {
                    node.static = false;
                }
            }
        }
    }
}
function markStaticRoots(node, isInFor) {
    if (node.type === 1) {
        if (node.static || node.once) {
            node.staticInFor = isInFor;
        }
        // For a node to qualify as a static root, it should have children that
        // are not just static text. Otherwise the cost of hoisting out will
        // outweigh the benefits and it's better off to just always render it fresh.
        if (node.static &&
            node.children.length &&
            !(node.children.length === 1 && node.children[0].type === 3)) {
            node.staticRoot = true;
            return;
        }
        else {
            node.staticRoot = false;
        }
        if (node.children) {
            for (var i = 0, l = node.children.length; i < l; i++) {
                markStaticRoots(node.children[i], isInFor || !!node.for);
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                markStaticRoots(node.ifConditions[i].block, isInFor);
            }
        }
    }
}
function isStatic(node) {
    if (node.type === 2) {
        // expression
        return false;
    }
    if (node.type === 3) {
        // text
        return true;
    }
    return !!(node.pre ||
        (!node.hasBindings && // no dynamic bindings
            !node.if &&
            !node.for && // not v-if or v-for or v-else
            !isBuiltInTag(node.tag) && // not a built-in
            isPlatformReservedTag(node.tag) && // not a component
            !isDirectChildOfTemplateFor(node) &&
            Object.keys(node).every(isStaticKey)));
}
function isDirectChildOfTemplateFor(node) {
    while (node.parent) {
        node = node.parent;
        if (node.tag !== 'template') {
            return false;
        }
        if (node.for) {
            return true;
        }
    }
    return false;
}

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
// KeyboardEvent.keyCode aliases
var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [8, 46]
};
// KeyboardEvent.key aliases
var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    delete: ['Backspace', 'Delete', 'Del']
};
// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return "if(".concat(condition, ")return null;"); };
var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
};
function genHandlers(events, isNative) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";
    for (var name_1 in events) {
        var handlerCode = genHandler(events[name_1]);
        //@ts-expect-error
        if (events[name_1] && events[name_1].dynamic) {
            dynamicHandlers += "".concat(name_1, ",").concat(handlerCode, ",");
        }
        else {
            staticHandlers += "\"".concat(name_1, "\":").concat(handlerCode, ",");
        }
    }
    staticHandlers = "{".concat(staticHandlers.slice(0, -1), "}");
    if (dynamicHandlers) {
        return prefix + "_d(".concat(staticHandlers, ",[").concat(dynamicHandlers.slice(0, -1), "])");
    }
    else {
        return prefix + staticHandlers;
    }
}
function genHandler(handler) {
    if (!handler) {
        return 'function(){}';
    }
    if (Array.isArray(handler)) {
        return "[".concat(handler.map(function (handler) { return genHandler(handler); }).join(','), "]");
    }
    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
    if (!handler.modifiers) {
        if (isMethodPath || isFunctionExpression) {
            return handler.value;
        }
        return "function($event){".concat(isFunctionInvocation ? "return ".concat(handler.value) : handler.value, "}"); // inline statement
    }
    else {
        var code = '';
        var genModifierCode = '';
        var keys = [];
        var _loop_1 = function (key) {
            if (modifierCode[key]) {
                genModifierCode += modifierCode[key];
                // left/right
                if (keyCodes[key]) {
                    keys.push(key);
                }
            }
            else if (key === 'exact') {
                var modifiers_1 = handler.modifiers;
                genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta']
                    .filter(function (keyModifier) { return !modifiers_1[keyModifier]; })
                    .map(function (keyModifier) { return "$event.".concat(keyModifier, "Key"); })
                    .join('||'));
            }
            else {
                keys.push(key);
            }
        };
        for (var key in handler.modifiers) {
            _loop_1(key);
        }
        if (keys.length) {
            code += genKeyFilter(keys);
        }
        // Make sure modifiers like prevent and stop get executed after key filtering
        if (genModifierCode) {
            code += genModifierCode;
        }
        var handlerCode = isMethodPath
            ? "return ".concat(handler.value, ".apply(null, arguments)")
            : isFunctionExpression
                ? "return (".concat(handler.value, ").apply(null, arguments)")
                : isFunctionInvocation
                    ? "return ".concat(handler.value)
                    : handler.value;
        return "function($event){".concat(code).concat(handlerCode, "}");
    }
}
function genKeyFilter(keys) {
    return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
        "".concat(keys.map(genFilterCode).join('&&'), ")return null;"));
}
function genFilterCode(key) {
    var keyVal = parseInt(key, 10);
    if (keyVal) {
        return "$event.keyCode!==".concat(keyVal);
    }
    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return ("_k($event.keyCode," +
        "".concat(JSON.stringify(key), ",") +
        "".concat(JSON.stringify(keyCode), ",") +
        "$event.key," +
        "".concat(JSON.stringify(keyName)) +
        ")");
}

function on(el, dir) {
    if (false) {
        warn$2("v-on without argument does not support modifiers.");
    }
    el.wrapListeners = function (code) { return "_g(".concat(code, ",").concat(dir.value, ")"); };
}

function bind(el, dir) {
    el.wrapData = function (code) {
        return "_b(".concat(code, ",'").concat(el.tag, "',").concat(dir.value, ",").concat(dir.modifiers && dir.modifiers.prop ? 'true' : 'false').concat(dir.modifiers && dir.modifiers.sync ? ',true' : '', ")");
    };
}

var baseDirectives = {
    on: on,
    bind: bind,
    cloak: noop
};

var CodegenState = /** @class */ (function () {
    function CodegenState(options) {
        this.options = options;
        this.warn = options.warn || baseWarn;
        this.transforms = pluckModuleFunction(options.modules, 'transformCode');
        this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
        this.directives = extend(extend({}, baseDirectives), options.directives);
        var isReservedTag = options.isReservedTag || no;
        this.maybeComponent = function (el) {
            return !!el.component || !isReservedTag(el.tag);
        };
        this.onceId = 0;
        this.staticRenderFns = [];
        this.pre = false;
    }
    return CodegenState;
}());
function generate(ast, options) {
    var state = new CodegenState(options);
    // fix #11483, Root level <script> tags should not be rendered.
    var code = ast
        ? ast.tag === 'script'
            ? 'null'
            : genElement(ast, state)
        : '_c("div")';
    return {
        render: "with(this){return ".concat(code, "}"),
        staticRenderFns: state.staticRenderFns
    };
}
function genElement(el, state) {
    if (el.parent) {
        el.pre = el.pre || el.parent.pre;
    }
    if (el.staticRoot && !el.staticProcessed) {
        return genStatic(el, state);
    }
    else if (el.once && !el.onceProcessed) {
        return genOnce(el, state);
    }
    else if (el.for && !el.forProcessed) {
        return genFor(el, state);
    }
    else if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
        return genChildren(el, state) || 'void 0';
    }
    else if (el.tag === 'slot') {
        return genSlot(el, state);
    }
    else {
        // component or element
        var code = void 0;
        if (el.component) {
            code = genComponent(el.component, el, state);
        }
        else {
            var data = void 0;
            var maybeComponent = state.maybeComponent(el);
            if (!el.plain || (el.pre && maybeComponent)) {
                data = genData(el, state);
            }
            var tag 
            // check if this is a component in <script setup>
            = void 0;
            // check if this is a component in <script setup>
            var bindings = state.options.bindings;
            if (maybeComponent && bindings && bindings.__isScriptSetup !== false) {
                tag = checkBindingType(bindings, el.tag);
            }
            if (!tag)
                tag = "'".concat(el.tag, "'");
            var children = el.inlineTemplate ? null : genChildren(el, state, true);
            code = "_c(".concat(tag).concat(data ? ",".concat(data) : '' // data
            ).concat(children ? ",".concat(children) : '' // children
            , ")");
        }
        // module transforms
        for (var i = 0; i < state.transforms.length; i++) {
            code = state.transforms[i](el, code);
        }
        return code;
    }
}
function checkBindingType(bindings, key) {
    var camelName = camelize(key);
    var PascalName = capitalize(camelName);
    var checkType = function (type) {
        if (bindings[key] === type) {
            return key;
        }
        if (bindings[camelName] === type) {
            return camelName;
        }
        if (bindings[PascalName] === type) {
            return PascalName;
        }
    };
    var fromConst = checkType("setup-const" /* BindingTypes.SETUP_CONST */) ||
        checkType("setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */);
    if (fromConst) {
        return fromConst;
    }
    var fromMaybeRef = checkType("setup-let" /* BindingTypes.SETUP_LET */) ||
        checkType("setup-ref" /* BindingTypes.SETUP_REF */) ||
        checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */);
    if (fromMaybeRef) {
        return fromMaybeRef;
    }
}
// hoist static sub-trees out
function genStatic(el, state) {
    el.staticProcessed = true;
    // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.
    var originalPreState = state.pre;
    if (el.pre) {
        state.pre = el.pre;
    }
    state.staticRenderFns.push("with(this){return ".concat(genElement(el, state), "}"));
    state.pre = originalPreState;
    return "_m(".concat(state.staticRenderFns.length - 1).concat(el.staticInFor ? ',true' : '', ")");
}
// v-once
function genOnce(el, state) {
    el.onceProcessed = true;
    if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.staticInFor) {
        var key = '';
        var parent_1 = el.parent;
        while (parent_1) {
            if (parent_1.for) {
                key = parent_1.key;
                break;
            }
            parent_1 = parent_1.parent;
        }
        if (!key) {
            "production" !== 'production' &&
                state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
            return genElement(el, state);
        }
        return "_o(".concat(genElement(el, state), ",").concat(state.onceId++, ",").concat(key, ")");
    }
    else {
        return genStatic(el, state);
    }
}
function genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion
    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}
function genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) {
        return altEmpty || '_e()';
    }
    var condition = conditions.shift();
    if (condition.exp) {
        return "(".concat(condition.exp, ")?").concat(genTernaryExp(condition.block), ":").concat(genIfConditions(conditions, state, altGen, altEmpty));
    }
    else {
        return "".concat(genTernaryExp(condition.block));
    }
    // v-if with v-once should generate code like (a)?_m(0):_m(1)
    function genTernaryExp(el) {
        return altGen
            ? altGen(el, state)
            : el.once
                ? genOnce(el, state)
                : genElement(el, state);
    }
}
function genFor(el, state, altGen, altHelper) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? ",".concat(el.iterator1) : '';
    var iterator2 = el.iterator2 ? ",".concat(el.iterator2) : '';
    if (false) {
        state.warn("<".concat(el.tag, " v-for=\"").concat(alias, " in ").concat(exp, "\">: component lists rendered with ") +
            "v-for should have explicit keys. " +
            "See https://v2.vuejs.org/v2/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true /* tip */);
    }
    el.forProcessed = true; // avoid recursion
    return ("".concat(altHelper || '_l', "((").concat(exp, "),") +
        "function(".concat(alias).concat(iterator1).concat(iterator2, "){") +
        "return ".concat((altGen || genElement)(el, state)) +
        '})');
}
function genData(el, state) {
    var data = '{';
    // directives first.
    // directives may mutate the el's other properties before they are generated.
    var dirs = genDirectives(el, state);
    if (dirs)
        data += dirs + ',';
    // key
    if (el.key) {
        data += "key:".concat(el.key, ",");
    }
    // ref
    if (el.ref) {
        data += "ref:".concat(el.ref, ",");
    }
    if (el.refInFor) {
        data += "refInFor:true,";
    }
    // pre
    if (el.pre) {
        data += "pre:true,";
    }
    // record original tag name for components using "is" attribute
    if (el.component) {
        data += "tag:\"".concat(el.tag, "\",");
    }
    // module data generation functions
    for (var i = 0; i < state.dataGenFns.length; i++) {
        data += state.dataGenFns[i](el);
    }
    // attributes
    if (el.attrs) {
        data += "attrs:".concat(genProps(el.attrs), ",");
    }
    // DOM props
    if (el.props) {
        data += "domProps:".concat(genProps(el.props), ",");
    }
    // event handlers
    if (el.events) {
        data += "".concat(genHandlers(el.events, false), ",");
    }
    if (el.nativeEvents) {
        data += "".concat(genHandlers(el.nativeEvents, true), ",");
    }
    // slot target
    // only for non-scoped slots
    if (el.slotTarget && !el.slotScope) {
        data += "slot:".concat(el.slotTarget, ",");
    }
    // scoped slots
    if (el.scopedSlots) {
        data += "".concat(genScopedSlots(el, el.scopedSlots, state), ",");
    }
    // component v-model
    if (el.model) {
        data += "model:{value:".concat(el.model.value, ",callback:").concat(el.model.callback, ",expression:").concat(el.model.expression, "},");
    }
    // inline-template
    if (el.inlineTemplate) {
        var inlineTemplate = genInlineTemplate(el, state);
        if (inlineTemplate) {
            data += "".concat(inlineTemplate, ",");
        }
    }
    data = data.replace(/,$/, '') + '}';
    // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.
    if (el.dynamicAttrs) {
        data = "_b(".concat(data, ",\"").concat(el.tag, "\",").concat(genProps(el.dynamicAttrs), ")");
    }
    // v-bind data wrap
    if (el.wrapData) {
        data = el.wrapData(data);
    }
    // v-on data wrap
    if (el.wrapListeners) {
        data = el.wrapListeners(data);
    }
    return data;
}
function genDirectives(el, state) {
    var dirs = el.directives;
    if (!dirs)
        return;
    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;
    for (i = 0, l = dirs.length; i < l; i++) {
        dir = dirs[i];
        needRuntime = true;
        var gen = state.directives[dir.name];
        if (gen) {
            // compile-time directive that manipulates AST.
            // returns true if it also needs a runtime counterpart.
            needRuntime = !!gen(el, dir, state.warn);
        }
        if (needRuntime) {
            hasRuntime = true;
            res += "{name:\"".concat(dir.name, "\",rawName:\"").concat(dir.rawName, "\"").concat(dir.value
                ? ",value:(".concat(dir.value, "),expression:").concat(JSON.stringify(dir.value))
                : '').concat(dir.arg ? ",arg:".concat(dir.isDynamicArg ? dir.arg : "\"".concat(dir.arg, "\"")) : '').concat(dir.modifiers ? ",modifiers:".concat(JSON.stringify(dir.modifiers)) : '', "},");
        }
    }
    if (hasRuntime) {
        return res.slice(0, -1) + ']';
    }
}
function genInlineTemplate(el, state) {
    var ast = el.children[0];
    if (false) {
        state.warn('Inline-template components must have exactly one child element.', { start: el.start });
    }
    if (ast && ast.type === 1) {
        var inlineRenderFns = generate(ast, state.options);
        return "inlineTemplate:{render:function(){".concat(inlineRenderFns.render, "},staticRenderFns:[").concat(inlineRenderFns.staticRenderFns
            .map(function (code) { return "function(){".concat(code, "}"); })
            .join(','), "]}");
    }
}
function genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for ||
        Object.keys(slots).some(function (key) {
            var slot = slots[key];
            return (slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
            );
        });
    // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.
    var needsKey = !!el.if;
    // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.
    if (!needsForceUpdate) {
        var parent_2 = el.parent;
        while (parent_2) {
            if ((parent_2.slotScope && parent_2.slotScope !== emptySlotScopeToken) ||
                parent_2.for) {
                needsForceUpdate = true;
                break;
            }
            if (parent_2.if) {
                needsKey = true;
            }
            parent_2 = parent_2.parent;
        }
    }
    var generatedSlots = Object.keys(slots)
        .map(function (key) { return genScopedSlot(slots[key], state); })
        .join(',');
    return "scopedSlots:_u([".concat(generatedSlots, "]").concat(needsForceUpdate ? ",null,true" : "").concat(!needsForceUpdate && needsKey ? ",null,false,".concat(hash(generatedSlots)) : "", ")");
}
function hash(str) {
    var hash = 5381;
    var i = str.length;
    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
}
function containsSlotChild(el) {
    if (el.type === 1) {
        if (el.tag === 'slot') {
            return true;
        }
        return el.children.some(containsSlotChild);
    }
    return false;
}
function genScopedSlot(el, state) {
    var isLegacySyntax = el.attrsMap['slot-scope'];
    if (el.if && !el.ifProcessed && !isLegacySyntax) {
        return genIf(el, state, genScopedSlot, "null");
    }
    if (el.for && !el.forProcessed) {
        return genFor(el, state, genScopedSlot);
    }
    var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
    var fn = "function(".concat(slotScope, "){") +
        "return ".concat(el.tag === 'template'
            ? el.if && isLegacySyntax
                ? "(".concat(el.if, ")?").concat(genChildren(el, state) || 'undefined', ":undefined")
                : genChildren(el, state) || 'undefined'
            : genElement(el, state), "}");
    // reverse proxy v-slot without scope on this.$slots
    var reverseProxy = slotScope ? "" : ",proxy:true";
    return "{key:".concat(el.slotTarget || "\"default\"", ",fn:").concat(fn).concat(reverseProxy, "}");
}
function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    var children = el.children;
    if (children.length) {
        var el_1 = children[0];
        // optimize single v-for
        if (children.length === 1 &&
            el_1.for &&
            el_1.tag !== 'template' &&
            el_1.tag !== 'slot') {
            var normalizationType_1 = checkSkip
                ? state.maybeComponent(el_1)
                    ? ",1"
                    : ",0"
                : "";
            return "".concat((altGenElement || genElement)(el_1, state)).concat(normalizationType_1);
        }
        var normalizationType = checkSkip
            ? getNormalizationType(children, state.maybeComponent)
            : 0;
        var gen_1 = altGenNode || genNode;
        return "[".concat(children.map(function (c) { return gen_1(c, state); }).join(','), "]").concat(normalizationType ? ",".concat(normalizationType) : '');
    }
}
// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType(children, maybeComponent) {
    var res = 0;
    for (var i = 0; i < children.length; i++) {
        var el = children[i];
        if (el.type !== 1) {
            continue;
        }
        if (needsNormalization(el) ||
            (el.ifConditions &&
                el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
            res = 2;
            break;
        }
        if (maybeComponent(el) ||
            (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
            res = 1;
        }
    }
    return res;
}
function needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}
function genNode(node, state) {
    if (node.type === 1) {
        return genElement(node, state);
    }
    else if (node.type === 3 && node.isComment) {
        return genComment(node);
    }
    else {
        return genText(node);
    }
}
function genText(text) {
    return "_v(".concat(text.type === 2
        ? text.expression // no need for () because already wrapped in _s()
        : transformSpecialNewlines(JSON.stringify(text.text)), ")");
}
function genComment(comment) {
    return "_e(".concat(JSON.stringify(comment.text), ")");
}
function genSlot(el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(".concat(slotName).concat(children ? ",function(){return ".concat(children, "}") : '');
    var attrs = el.attrs || el.dynamicAttrs
        ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
            // slot props are camelized
            name: camelize(attr.name),
            value: attr.value,
            dynamic: attr.dynamic
        }); }))
        : null;
    var bind = el.attrsMap['v-bind'];
    if ((attrs || bind) && !children) {
        res += ",null";
    }
    if (attrs) {
        res += ",".concat(attrs);
    }
    if (bind) {
        res += "".concat(attrs ? '' : ',null', ",").concat(bind);
    }
    return res + ')';
}
// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent(componentName, el, state) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return "_c(".concat(componentName, ",").concat(genData(el, state)).concat(children ? ",".concat(children) : '', ")");
}
function genProps(props) {
    var staticProps = "";
    var dynamicProps = "";
    for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        var value = transformSpecialNewlines(prop.value);
        if (prop.dynamic) {
            dynamicProps += "".concat(prop.name, ",").concat(value, ",");
        }
        else {
            staticProps += "\"".concat(prop.name, "\":").concat(value, ",");
        }
    }
    staticProps = "{".concat(staticProps.slice(0, -1), "}");
    if (dynamicProps) {
        return "_d(".concat(staticProps, ",[").concat(dynamicProps.slice(0, -1), "])");
    }
    else {
        return staticProps;
    }
}
// #3895, #4268
function transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' +
    ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
        'super,throw,while,yield,delete,export,import,return,switch,default,' +
        'extends,finally,continue,debugger,function,arguments')
        .split(',')
        .join('\\b|\\b') +
    '\\b');
// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' +
    'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') +
    '\\s*\\([^\\)]*\\)');
// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
// detect problematic expressions in a template
function detectErrors(ast, warn) {
    if (ast) {
        checkNode(ast, warn);
    }
}
function checkNode(node, warn) {
    if (node.type === 1) {
        for (var name_1 in node.attrsMap) {
            if (dirRE.test(name_1)) {
                var value = node.attrsMap[name_1];
                if (value) {
                    var range = node.rawAttrsMap[name_1];
                    if (name_1 === 'v-for') {
                        checkFor(node, "v-for=\"".concat(value, "\""), warn, range);
                    }
                    else if (name_1 === 'v-slot' || name_1[0] === '#') {
                        checkFunctionParameterExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else if (onRE.test(name_1)) {
                        checkEvent(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else {
                        checkExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                }
            }
        }
        if (node.children) {
            for (var i = 0; i < node.children.length; i++) {
                checkNode(node.children[i], warn);
            }
        }
    }
    else if (node.type === 2) {
        checkExpression(node.expression, node.text, warn, node);
    }
}
function checkEvent(exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);
    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
        warn("avoid using JavaScript unary operator as property name: " +
            "\"".concat(keywordMatch[0], "\" in expression ").concat(text.trim()), range);
    }
    checkExpression(exp, text, warn, range);
}
function checkFor(node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}
function checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') {
        try {
            new Function("var ".concat(ident, "=_"));
        }
        catch (e) {
            warn("invalid ".concat(type, " \"").concat(ident, "\" in expression: ").concat(text.trim()), range);
        }
    }
}
function checkExpression(exp, text, warn, range) {
    try {
        new Function("return ".concat(exp));
    }
    catch (e) {
        var keywordMatch = exp
            .replace(stripStringRE, '')
            .match(prohibitedKeywordRE);
        if (keywordMatch) {
            warn("avoid using JavaScript keyword as property name: " +
                "\"".concat(keywordMatch[0], "\"\n  Raw expression: ").concat(text.trim()), range);
        }
        else {
            warn("invalid expression: ".concat(e.message, " in\n\n") +
                "    ".concat(exp, "\n\n") +
                "  Raw expression: ".concat(text.trim(), "\n"), range);
        }
    }
}
function checkFunctionParameterExpression(exp, text, warn, range) {
    try {
        new Function(exp, '');
    }
    catch (e) {
        warn("invalid function parameter expression: ".concat(e.message, " in\n\n") +
            "    ".concat(exp, "\n\n") +
            "  Raw expression: ".concat(text.trim(), "\n"), range);
    }
}

var range = 2;
function generateCodeFrame(source, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = source.length; }
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for (var i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (var j = i - range; j <= i + range || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                res.push("".concat(j + 1).concat(repeat(" ", 3 - String(j + 1).length), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length_1 = end > count ? lineLength - pad : end - start;
                    res.push("   |  " + repeat(" ", pad) + repeat("^", length_1));
                }
                else if (j > i) {
                    if (end > count) {
                        var length_2 = Math.min(end - count, lineLength);
                        res.push("   |  " + repeat("^", length_2));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function repeat(str, n) {
    var result = '';
    if (n > 0) {
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // eslint-disable-line
            if (n & 1)
                result += str;
            n >>>= 1;
            if (n <= 0)
                break;
            str += str;
        }
    }
    return result;
}

function createFunction(code, errors) {
    try {
        return new Function(code);
    }
    catch (err) {
        errors.push({ err: err, code: code });
        return noop;
    }
}
function createCompileToFunctionFn(compile) {
    var cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
        options = extend({}, options);
        var warn = options.warn || warn$2;
        delete options.warn;
        /* istanbul ignore if */
        if (false) {
            // detect possible CSP restriction
            try {
                new Function('return 1');
            }
            catch (e) {
                if (e.toString().match(/unsafe-eval|CSP/)) {
                    warn('It seems you are using the standalone build of Vue.js in an ' +
                        'environment with Content Security Policy that prohibits unsafe-eval. ' +
                        'The template compiler cannot work in this environment. Consider ' +
                        'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
                        'templates into render functions.');
                }
            }
        }
        // check cache
        var key = options.delimiters
            ? String(options.delimiters) + template
            : template;
        if (cache[key]) {
            return cache[key];
        }
        // compile
        var compiled = compile(template, options);
        // check compilation errors/tips
        if (false) {
            if (compiled.errors && compiled.errors.length) {
                if (options.outputSourceRange) {
                    compiled.errors.forEach(function (e) {
                        warn("Error compiling template:\n\n".concat(e.msg, "\n\n") +
                            generateCodeFrame(template, e.start, e.end), vm);
                    });
                }
                else {
                    warn("Error compiling template:\n\n".concat(template, "\n\n") +
                        compiled.errors.map(function (e) { return "- ".concat(e); }).join('\n') +
                        '\n', vm);
                }
            }
            if (compiled.tips && compiled.tips.length) {
                if (options.outputSourceRange) {
                    compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
                }
                else {
                    compiled.tips.forEach(function (msg) { return tip(msg, vm); });
                }
            }
        }
        // turn code into functions
        var res = {};
        var fnGenErrors = [];
        res.render = createFunction(compiled.render, fnGenErrors);
        res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
            return createFunction(code, fnGenErrors);
        });
        // check function generation errors.
        // this should only happen if there is a bug in the compiler itself.
        // mostly for codegen development use
        /* istanbul ignore if */
        if (false) {
            if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
                warn("Failed to generate render function:\n\n" +
                    fnGenErrors
                        .map(function (_a) {
                        var err = _a.err, code = _a.code;
                        return "".concat(err.toString(), " in\n\n").concat(code, "\n");
                    })
                        .join('\n'), vm);
            }
        }
        return (cache[key] = res);
    };
}

function createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
        function compile(template, options) {
            var finalOptions = Object.create(baseOptions);
            var errors = [];
            var tips = [];
            var warn = function (msg, range, tip) {
                (tip ? tips : errors).push(msg);
            };
            if (options) {
                if (false) {
                    // $flow-disable-line
                    var leadingSpaceLength_1 = template.match(/^\s*/)[0].length;
                    warn = function (msg, range, tip) {
                        var data = typeof msg === 'string' ? { msg: msg } : msg;
                        if (range) {
                            if (range.start != null) {
                                data.start = range.start + leadingSpaceLength_1;
                            }
                            if (range.end != null) {
                                data.end = range.end + leadingSpaceLength_1;
                            }
                        }
                        (tip ? tips : errors).push(data);
                    };
                }
                // merge custom modules
                if (options.modules) {
                    finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                }
                // merge custom directives
                if (options.directives) {
                    finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
                }
                // copy other options
                for (var key in options) {
                    if (key !== 'modules' && key !== 'directives') {
                        finalOptions[key] = options[key];
                    }
                }
            }
            finalOptions.warn = warn;
            var compiled = baseCompile(template.trim(), finalOptions);
            if (false) {
                detectErrors(compiled.ast, warn);
            }
            compiled.errors = errors;
            compiled.tips = tips;
            return compiled;
        }
        return {
            compile: compile,
            compileToFunctions: createCompileToFunctionFn(compile)
        };
    };
}

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile(template, options) {
    var ast = parse(template.trim(), options);
    if (options.optimize !== false) {
        optimize(ast, options);
    }
    var code = generate(ast, options);
    return {
        ast: ast,
        render: code.render,
        staticRenderFns: code.staticRenderFns
    };
});

var _a = createCompiler(baseOptions), compileToFunctions = _a.compileToFunctions;

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode(href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0;
}
// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser
    ? getShouldDecode(true)
    : false;

var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML;
});
var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (el, hydrating) {
    el = el && query(el);
    /* istanbul ignore if */
    if (el === document.body || el === document.documentElement) {
        "production" !== 'production' &&
            warn$2("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
        return this;
    }
    var options = this.$options;
    // resolve template/el and convert to render function
    if (!options.render) {
        var template = options.template;
        if (template) {
            if (typeof template === 'string') {
                if (template.charAt(0) === '#') {
                    template = idToTemplate(template);
                    /* istanbul ignore if */
                    if (false) {
                        warn$2("Template element not found or is empty: ".concat(options.template), this);
                    }
                }
            }
            else if (template.nodeType) {
                template = template.innerHTML;
            }
            else {
                if (false) {
                    warn$2('invalid template option:' + template, this);
                }
                return this;
            }
        }
        else if (el) {
            // @ts-expect-error
            template = getOuterHTML(el);
        }
        if (template) {
            /* istanbul ignore if */
            if (false) {
                mark('compile');
            }
            var _a = compileToFunctions(template, {
                outputSourceRange: "production" !== 'production',
                shouldDecodeNewlines: shouldDecodeNewlines,
                shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                delimiters: options.delimiters,
                comments: options.comments
            }, this), render = _a.render, staticRenderFns = _a.staticRenderFns;
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            /* istanbul ignore if */
            if (false) {
                mark('compile end');
                measure("vue ".concat(this._name, " compile"), 'compile', 'compile end');
            }
        }
    }
    return mount.call(this, el, hydrating);
};
/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML(el) {
    if (el.outerHTML) {
        return el.outerHTML;
    }
    else {
        var container = document.createElement('div');
        container.appendChild(el.cloneNode(true));
        return container.innerHTML;
    }
}
Vue.compile = compileToFunctions;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2), __webpack_require__(18).setImmediate))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldGet"] = __classPrivateFieldGet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldSet"] = __classPrivateFieldSet;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(3);

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function (input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, webSafe) {
        this.init_();
        var charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.reject = function () { };
        this.resolve = function () { };
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(global.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    var runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    var ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    return 'indexedDB' in self && indexedDB != null;
}
/**
 * This method validates browser context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 */
function validateIndexedDBOpenable() {
    return new Promise(function (resolve, reject) {
        try {
            var preExist_1 = true;
            var DB_CHECK_NAME_1 = 'validate-browser-context-for-indexeddb-analytics-module';
            var request_1 = window.indexedDB.open(DB_CHECK_NAME_1);
            request_1.onsuccess = function () {
                request_1.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist_1) {
                    window.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
                }
                resolve(true);
            };
            request_1.onupgradeneeded = function () {
                preExist_1 = false;
            };
            request_1.onerror = function () {
                var _a;
                reject(((_a = request_1.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (!navigator || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    tslib.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? String(value) : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    var res = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    var params = [];
    var _loop_1 = function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };
    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, offset) {
        if (!offset) {
            offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
var DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
var DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
var RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis, backoffFactor) {
    if (intervalMillis === void 0) { intervalMillis = DEFAULT_INTERVAL_MILLIS; }
    if (backoffFactor === void 0) { backoffFactor = DEFAULT_BACKOFF_FACTOR; }
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

exports.CONSTANTS = CONSTANTS;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.MAX_VALUE_MILLIS = MAX_VALUE_MILLIS;
exports.RANDOM_FACTOR = RANDOM_FACTOR;
exports.Sha1 = Sha1;
exports.areCookiesEnabled = areCookiesEnabled;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.calculateBackoffMillis = calculateBackoffMillis;
exports.contains = contains;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.errorPrefix = errorPrefix;
exports.getUA = getUA;
exports.isAdmin = isAdmin;
exports.isBrowser = isBrowser;
exports.isBrowserExtension = isBrowserExtension;
exports.isElectron = isElectron;
exports.isEmpty = isEmpty;
exports.isIE = isIE;
exports.isIndexedDBAvailable = isIndexedDBAvailable;
exports.isMobileCordova = isMobileCordova;
exports.isNode = isNode;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.isSafari = isSafari;
exports.isUWP = isUWP;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateIndexedDBOpenable = validateIndexedDBOpenable;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(3);
var util = __webpack_require__(4);
var component = __webpack_require__(7);
var logger$1 = __webpack_require__(62);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {},
    _a["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    _a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */] = 'First argument to `onLog` must be null or a function.',
    _a);
var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);

var name$1 = "@firebase/app";
var version = "0.6.11";

var name$2 = "@firebase/analytics";

var name$3 = "@firebase/auth";

var name$4 = "@firebase/database";

var name$5 = "@firebase/functions";

var name$6 = "@firebase/installations";

var name$7 = "@firebase/messaging";

var name$8 = "@firebase/performance";

var name$9 = "@firebase/remote-config";

var name$a = "@firebase/storage";

var name$b = "@firebase/firestore";

var name$c = "firebase-wrapper";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1;
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
var PLATFORM_LOG_STRING = (_a$1 = {},
    _a$1[name$1] = 'fire-core',
    _a$1[name$2] = 'fire-analytics',
    _a$1[name$3] = 'fire-auth',
    _a$1[name$4] = 'fire-rtdb',
    _a$1[name$5] = 'fire-fn',
    _a$1[name$6] = 'fire-iid',
    _a$1[name$7] = 'fire-fcm',
    _a$1[name$8] = 'fire-perf',
    _a$1[name$9] = 'fire-rc',
    _a$1[name$a] = 'fire-gcs',
    _a$1[name$b] = 'fire-fst',
    _a$1['fire-js'] = 'fire-js',
    _a$1[name$c] = 'fire-js-all',
    _a$1);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new logger$1.Logger('@firebase/app');

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        var e_1, _a;
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.container = new component.ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new component.Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
        try {
            // populate ComponentContainer with existing components
            for (var _b = tslib.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var component$1 = _c.value;
                this._addComponent(component$1);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
        })
            .then(function () {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        // getImmediate will always succeed because _getService is only called for registered components.
        return this.container.getProvider(name).getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */
    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */
    FirebaseAppImpl.prototype._addComponent = function (component) {
        try {
            this.container.addComponent(component);
        }
        catch (e) {
            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
        this.container.addOrOverwriteComponent(component);
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

var version$1 = "7.20.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: logger$1.setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: version$1,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!util.contains(apps, name)) {
            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
                appName: String(name)
            });
        }
        if (util.contains(apps, name)) {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    function registerComponent(component) {
        var e_1, _a;
        var componentName = component.name;
        if (components.has(componentName)) {
            logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */
                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    namespace[componentName]
                : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function (appArg) {
                if (appArg === void 0) { appArg = app(); }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== 'function') {
                    // Invalid argument.
                    // This happens in the following case: firebase.storage('gs:/')
                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
                        appName: componentName
                    });
                }
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) {
                util.deepExtend(serviceNamespace, component.serviceProps);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] =
                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
                // option added to the no-explicit-any rule when ESlint releases it.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var serviceFxn = this._getService.bind(this, componentName);
                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
                };
        }
        try {
            // add the component to existing app instances
            for (var _b = tslib.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var appName = _c.value;
                apps[appName]._addComponent(component);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return component.type === "PUBLIC" /* PUBLIC */
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                namespace[componentName]
            : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) {
            library += "-" + variant;
        }
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
            ];
            if (libraryMismatch) {
                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
            }
            if (libraryMismatch && versionMismatch) {
                warning.push('and');
            }
            if (versionMismatch) {
                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
            }
            logger.warn(warning.join(' '));
            return;
        }
        registerComponent(new component.Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== 'function') {
            throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */, {
                appName: name
            });
        }
        logger$1.setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib.__assign(tslib.__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: util.createSubscribe,
        ErrorFactory: util.ErrorFactory,
        deepExtend: util.deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    return namespace;
}
var firebase = createFirebaseNamespace();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PlatformLoggerService = /** @class */ (function () {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function () {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(function (provider) {
            if (isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            }
            else {
                return null;
            }
        })
            .filter(function (logString) { return logString; })
            .join(' ');
    };
    return PlatformLoggerService;
}());
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new component.Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
    // Register `app` package.
    firebase.registerVersion(name$1, version, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion('fire-js', '');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (util.isBrowser() && self.firebase !== undefined) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var initializeApp = firebase.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
firebase.initializeApp = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (util.isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, args);
};
var firebase$1 = firebase;
registerCoreComponents(firebase$1);

exports.default = firebase$1;
exports.firebase = firebase$1;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(3);
var util = __webpack_require__(4);

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
var Component = /** @class */ (function () {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */;
    }
    Component.prototype.setInstantiationMode = function (mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function (multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function (props) {
        this.serviceProps = props;
        return this;
    };
    return Component;
}());

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
var Provider = /** @class */ (function () {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    Provider.prototype.get = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new util.Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            // If the service instance is available, resolve the promise with it immediately
            try {
                var instance = this.getOrInitializeService(normalizedIdentifier);
                if (instance) {
                    deferred.resolve(instance);
                }
            }
            catch (e) {
                // when the instance factory throws an exception during get(), it should not cause
                // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function (options) {
        var _a = tslib.__assign({ identifier: DEFAULT_ENTRY_NAME, optional: false }, options), identifier = _a.identifier, optional = _a.optional;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        try {
            var instance = this.getOrInitializeService(normalizedIdentifier);
            if (!instance) {
                if (optional) {
                    return null;
                }
                throw Error("Service " + this.name + " is not available");
            }
            return instance;
        }
        catch (e) {
            if (optional) {
                return null;
            }
            else {
                throw e;
            }
        }
    };
    Provider.prototype.getComponent = function () {
        return this.component;
    };
    Provider.prototype.setComponent = function (component) {
        var e_1, _a;
        if (component.name !== this.name) {
            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        }
        if (this.component) {
            throw Error("Component for " + this.name + " has already been provided");
        }
        this.component = component;
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService(DEFAULT_ENTRY_NAME);
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for (var _b = tslib.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService(normalizedIdentifier);
                    instanceDeferred.resolve(instance);
                }
                catch (e) {
                    // when the instance factory throws an exception, it should not cause
                    // a fatal error. We just leave the promise unresolved.
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Provider.prototype.clearInstance = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        this.instancesDeferred.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var services;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        services = Array.from(this.instances.values());
                        return [4 /*yield*/, Promise.all(tslib.__spread(services
                                .filter(function (service) { return 'INTERNAL' in service; }) // legacy services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service.INTERNAL.delete(); }), services
                                .filter(function (service) { return '_delete' in service; }) // modularized services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service._delete(); })))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function () {
        return this.component != null;
    };
    Provider.prototype.getOrInitializeService = function (identifier) {
        var instance = this.instances.get(identifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
            this.instances.set(identifier, instance);
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    };
    return Provider;
}());
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
var ComponentContainer = /** @class */ (function () {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    ComponentContainer.prototype.addComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error("Component " + component.name + " has already been registered with " + this.name);
        }
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    ComponentContainer.prototype.getProvider = function (name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function () {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}());

exports.Component = Component;
exports.ComponentContainer = ComponentContainer;
exports.Provider = Provider;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(24)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);

var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapMutations; });
/* unused harmony export mapState */
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventBus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config_firebaseConfig__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_surveyquestions_firebaseIssue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_surveyquestions_firebaseIssue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_surveyquestions_firebaseIssue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






console.log("=======> firebase", __WEBPACK_IMPORTED_MODULE_3__components_surveyquestions_firebaseIssue___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    var _ref;

    return _ref = {
      isActive: false,
      message: ''
    }, _defineProperty(_ref, "message", ""), _defineProperty(_ref, "backgroundColor", ""), _defineProperty(_ref, "leftalign", 0), _defineProperty(_ref, "minwidth", 0), _defineProperty(_ref, "loader", false), _defineProperty(_ref, "isSnakebar", false), _ref;
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getMode"])),
  methods: {
    messagesSnackbar: function messagesSnackbar(data) {
      var _this = this;

      this.message = data.message;
      console.log(this.message);
      if (!data.status) {
        this.backgroundColor = "#EC4C47";
      } else {
        this.backgroundColor = "#47B881";
      }
      this.isSnakebar = true;
      setTimeout(function () {
        _this.isSnakebar = false;
      }, 3000);
    },
    selfcareLoader: function selfcareLoader(data) {
      this.loader = data;
    },
    eventsOn: function eventsOn() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("nxtdigital-loader", this.selfcareLoader);
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("snackBarMessage-app", function (data) {
        _this2.message = data;
        _this2.backgroundColor = "#EC4C47";
        _this2.isSnakebar = true;
        setTimeout(function () {
          _this2.isSnakebar = false;
          localStorage.removeItem("selfcareUser");
          _this2.$router.push({ name: "login" });
        }, 3000);
      });
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("snackBarFullScreenMessage", function (data) {
        _this2.messagesSnackbar(data);
      });
    },
    eventsOff: function eventsOff() {
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$off("nxtdigital-loader", this.selfcareLoader);
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$off("snackBarMessage-app");
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$off("snackBarFullScreenMessage");
    }
  },
  created: function created() {
    //this.messagesSnackbar();
    // if(this.getMode != "development") {
    //   console.log = function() {}
    // }
    this.eventsOn();
  },
  beforeDestroy: function beforeDestroy() {
    this.eventsOff();
  },

  components: {
    snackbar: function snackbar() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 66));
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_account_forgotPassword__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_account_login__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_account_registration__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_account_otp__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_help_customerSupport__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_help_faq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_myprofile_details__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_myprofile_kyc__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_contactUs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_contactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modules_contactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_logout__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_mypacks_manage__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_mypacks_renew__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_addpacks_addPacks__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_cart__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_myIndigital__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_addpacks_channelList__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_planDetailImg__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_bannerImg__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_payment__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_topUp__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_alert__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_transaction__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_instantPayment__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_ottQuickpay_js__ = __webpack_require__(56);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);





// import registrationModule from './modules/registrationModule'

























// let base_url = getBaseURL(window.location.origin)
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    name: "NXT Digital Selfcare Portal",
    version: "v1.0.5",
    mode: "production",
    server: "live",
    // baseUrl: "https://ccare.incablenet.net/",
    baseUrl: getBaseURL(window.location.origin),
    userInfo: undefined,
    docImage: undefined,
    getCartDetails: {},
    surveyQuestions: [],
    pageNum: 1,
    cartData: [],
    CTAImages: '',
    CartDetails: [],
    bbDetails: false
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  modules: {
    forgotPassword: __WEBPACK_IMPORTED_MODULE_5__modules_account_forgotPassword__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_6__modules_account_login__["a" /* default */],
    registration: __WEBPACK_IMPORTED_MODULE_7__modules_account_registration__["a" /* default */],
    otp: __WEBPACK_IMPORTED_MODULE_8__modules_account_otp__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_10__modules_help_faq__["a" /* default */],
    customerSupport: __WEBPACK_IMPORTED_MODULE_9__modules_help_customerSupport__["a" /* default */],
    details: __WEBPACK_IMPORTED_MODULE_11__modules_myprofile_details__["a" /* default */],
    kyc: __WEBPACK_IMPORTED_MODULE_12__modules_myprofile_kyc__["a" /* default */],
    contactUs: __WEBPACK_IMPORTED_MODULE_13__modules_contactUs___default.a,
    logout: __WEBPACK_IMPORTED_MODULE_14__modules_logout__["a" /* default */],
    manage: __WEBPACK_IMPORTED_MODULE_15__modules_mypacks_manage__["a" /* default */],
    renew: __WEBPACK_IMPORTED_MODULE_16__modules_mypacks_renew__["a" /* default */],
    addpacks: __WEBPACK_IMPORTED_MODULE_17__modules_addpacks_addPacks__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_18__modules_cart__["a" /* default */],
    myIndigital: __WEBPACK_IMPORTED_MODULE_19__modules_myIndigital__["a" /* default */],
    bannerImage: __WEBPACK_IMPORTED_MODULE_22__modules_bannerImg__["a" /* default */],
    channelList: __WEBPACK_IMPORTED_MODULE_20__modules_addpacks_channelList__["a" /* default */],
    channelListDetails: __WEBPACK_IMPORTED_MODULE_21__modules_planDetailImg__["a" /* default */],
    payment: __WEBPACK_IMPORTED_MODULE_23__modules_payment__["a" /* default */],
    topup: __WEBPACK_IMPORTED_MODULE_24__modules_topUp__["a" /* default */],
    alert: __WEBPACK_IMPORTED_MODULE_25__modules_alert__["a" /* default */],
    transaction: __WEBPACK_IMPORTED_MODULE_26__modules_transaction__["a" /* default */],
    instantPayment: __WEBPACK_IMPORTED_MODULE_27__modules_instantPayment__["a" /* default */],
    ottquickpay: __WEBPACK_IMPORTED_MODULE_28__modules_ottQuickpay_js__["a" /* default */]
  }
});
function getBaseURL(data) {
  if (data == 'http://localhost:8080') {
    return 'https://customercare.nxtdigital.in/';
    // return 'https://imclselfcaretest.mobiotics.com'
  }
  return data;
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.idb = {}));
}(this, function (exports) { 'use strict';

  function toArray(arr) {
    return Array.prototype.slice.call(arr);
  }

  function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
      request.onsuccess = function() {
        resolve(request.result);
      };

      request.onerror = function() {
        reject(request.error);
      };
    });
  }

  function promisifyRequestCall(obj, method, args) {
    var request;
    var p = new Promise(function(resolve, reject) {
      request = obj[method].apply(obj, args);
      promisifyRequest(request).then(resolve, reject);
    });

    p.request = request;
    return p;
  }

  function promisifyCursorRequestCall(obj, method, args) {
    var p = promisifyRequestCall(obj, method, args);
    return p.then(function(value) {
      if (!value) return;
      return new Cursor(value, p.request);
    });
  }

  function proxyProperties(ProxyClass, targetProp, properties) {
    properties.forEach(function(prop) {
      Object.defineProperty(ProxyClass.prototype, prop, {
        get: function() {
          return this[targetProp][prop];
        },
        set: function(val) {
          this[targetProp][prop] = val;
        }
      });
    });
  }

  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return this[targetProp][prop].apply(this[targetProp], arguments);
      };
    });
  }

  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function Index(index) {
    this._index = index;
  }

  proxyProperties(Index, '_index', [
    'name',
    'keyPath',
    'multiEntry',
    'unique'
  ]);

  proxyRequestMethods(Index, '_index', IDBIndex, [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
    'openCursor',
    'openKeyCursor'
  ]);

  function Cursor(cursor, request) {
    this._cursor = cursor;
    this._request = request;
  }

  proxyProperties(Cursor, '_cursor', [
    'direction',
    'key',
    'primaryKey',
    'value'
  ]);

  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
    'update',
    'delete'
  ]);

  // proxy 'next' methods
  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
    if (!(methodName in IDBCursor.prototype)) return;
    Cursor.prototype[methodName] = function() {
      var cursor = this;
      var args = arguments;
      return Promise.resolve().then(function() {
        cursor._cursor[methodName].apply(cursor._cursor, args);
        return promisifyRequest(cursor._request).then(function(value) {
          if (!value) return;
          return new Cursor(value, cursor._request);
        });
      });
    };
  });

  function ObjectStore(store) {
    this._store = store;
  }

  ObjectStore.prototype.createIndex = function() {
    return new Index(this._store.createIndex.apply(this._store, arguments));
  };

  ObjectStore.prototype.index = function() {
    return new Index(this._store.index.apply(this._store, arguments));
  };

  proxyProperties(ObjectStore, '_store', [
    'name',
    'keyPath',
    'indexNames',
    'autoIncrement'
  ]);

  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'put',
    'add',
    'delete',
    'clear',
    'get',
    'getAll',
    'getKey',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'openCursor',
    'openKeyCursor'
  ]);

  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
    'deleteIndex'
  ]);

  function Transaction(idbTransaction) {
    this._tx = idbTransaction;
    this.complete = new Promise(function(resolve, reject) {
      idbTransaction.oncomplete = function() {
        resolve();
      };
      idbTransaction.onerror = function() {
        reject(idbTransaction.error);
      };
      idbTransaction.onabort = function() {
        reject(idbTransaction.error);
      };
    });
  }

  Transaction.prototype.objectStore = function() {
    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
  };

  proxyProperties(Transaction, '_tx', [
    'objectStoreNames',
    'mode'
  ]);

  proxyMethods(Transaction, '_tx', IDBTransaction, [
    'abort'
  ]);

  function UpgradeDB(db, oldVersion, transaction) {
    this._db = db;
    this.oldVersion = oldVersion;
    this.transaction = new Transaction(transaction);
  }

  UpgradeDB.prototype.createObjectStore = function() {
    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
  };

  proxyProperties(UpgradeDB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
    'deleteObjectStore',
    'close'
  ]);

  function DB(db) {
    this._db = db;
  }

  DB.prototype.transaction = function() {
    return new Transaction(this._db.transaction.apply(this._db, arguments));
  };

  proxyProperties(DB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(DB, '_db', IDBDatabase, [
    'close'
  ]);

  // Add cursor iterators
  // TODO: remove this once browsers do the right thing with promises
  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
    [ObjectStore, Index].forEach(function(Constructor) {
      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
      if (!(funcName in Constructor.prototype)) return;

      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
        var args = toArray(arguments);
        var callback = args[args.length - 1];
        var nativeObject = this._store || this._index;
        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
        request.onsuccess = function() {
          callback(request.result);
        };
      };
    });
  });

  // polyfill getAll
  [Index, ObjectStore].forEach(function(Constructor) {
    if (Constructor.prototype.getAll) return;
    Constructor.prototype.getAll = function(query, count) {
      var instance = this;
      var items = [];

      return new Promise(function(resolve) {
        instance.iterateCursor(query, function(cursor) {
          if (!cursor) {
            resolve(items);
            return;
          }
          items.push(cursor.value);

          if (count !== undefined && items.length == count) {
            resolve(items);
            return;
          }
          cursor.continue();
        });
      });
    };
  });

  function openDb(name, version, upgradeCallback) {
    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
    var request = p.request;

    if (request) {
      request.onupgradeneeded = function(event) {
        if (upgradeCallback) {
          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        }
      };
    }

    return p.then(function(db) {
      return new DB(db);
    });
  }

  function deleteDb(name) {
    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
  }

  exports.openDb = openDb;
  exports.deleteDb = deleteDb;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configFirebase; });
var configFirebase = {
  apiKey: "AIzaSyCmyYTOZlJeEV4riZSvw7qRciWMQ-buKFQ",
  authDomain: "imcl-selfcare.firebaseapp.com",
  databaseURL: "https://imcl-selfcare.firebaseio.com",
  projectId: "imcl-selfcare",
  storageBucket: "imcl-selfcare.appspot.com",
  messagingSenderId: "361777923362",
  appId: "1:361777923362:web:c60692e610f5db931c117b",
  measurementId: "G-XX8NXVHT2J"
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "loader.svg?98e076eca46c2c2e5073b28c5d17b729";

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_router__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_main_style_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_main_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_main_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__foreGroundMessage__ = __webpack_require__(60);







__WEBPACK_IMPORTED_MODULE_2__router_router__["a" /* router */].beforeEach(function (to, from, next) {

    var user = localStorage.getItem('newNXTSelfcareUser') ? localStorage.getItem('newNXTSelfcareUser') : '';

    if (to.fullPath !== '/' && !to.fullPath.includes('instantpayment') && !to.fullPath.includes('qrscan') && !to.fullPath.includes('ottquickpay') && !to.fullPath.includes('hdupgrade') && !to.fullPath.includes('paymentstatuscheck') && to.fullPath !== "/maintenance" && to.fullPath !== "/maintenancelogin" && !user) next('/');else next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('getStringellips', function (data) {
    if (data) {
        return data;
    }
    return '---';
});

var vueMain = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: "#app",
    router: __WEBPACK_IMPORTED_MODULE_2__router_router__["a" /* router */],
    store: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    }
});

/* harmony default export */ __webpack_exports__["default"] = (vueMain);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(20)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2cd15c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(26);
function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c2cd15c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2cd15c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(23);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("59bb0c5c", content, true, {});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".loader[data-v-6c2cd15c]{width:100%;height:100vh;position:absolute;z-index:999;background:rgba(0,0,0,.5)}.loader-image[data-v-6c2cd15c]{margin:20% auto}.main-loader-div[data-v-6c2cd15c]{width:20%;margin:auto}.loader-div[data-v-6c2cd15c]{width:20%;background-color:#fff;margin:23% auto;padding:40px;border-radius:13px}@media only screen and (min-width:320px){.loader-div[data-v-6c2cd15c]{width:65%;margin:60% auto}}@media only screen and (min-width:768px){.loader-div[data-v-6c2cd15c]{width:40%;margin:40% auto}}@media only screen and (min-width:1024px){.loader-div[data-v-6c2cd15c]{width:30%;margin:30% auto}}@media only screen and (min-width:1200px){.loader-div[data-v-6c2cd15c]{width:20%;margin:21% auto}}", ""]);

// exports


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! @license Firebase v3.3.0
    Build: 3.3.0-rc.7
    Terms: https://developers.google.com/terms */
(function () {
    var aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
        if (c.get || c.set) throw new TypeError("ES3 does not support getters and setters.");a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    },
        h = "undefined" != typeof window && window === this ? this : "undefined" != typeof global ? global : this,
        _l = function l() {
        _l = function l() {};h.Symbol || (h.Symbol = ba);
    },
        ca = 0,
        ba = function ba(a) {
        return "jscomp_symbol_" + (a || "") + ca++;
    },
        _p = function p() {
        _l();var a = h.Symbol.iterator;a || (a = h.Symbol.iterator = h.Symbol("iterator"));
        "function" != typeof Array.prototype[a] && aa(Array.prototype, a, { configurable: !0, writable: !0, value: function value() {
                return m(this);
            } });_p = function p() {};
    },
        m = function m(a) {
        var b = 0;return da(function () {
            return b < a.length ? { done: !1, value: a[b++] } : { done: !0 };
        });
    },
        da = function da(a) {
        _p();a = { next: a };a[h.Symbol.iterator] = function () {
            return this;
        };return a;
    },
        q = this,
        r = function r() {},
        t = function t(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);
                if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    },
        u = function u(a) {
        return "function" == t(a);
    },
        ea = function ea(a, b, c) {
        return a.call.apply(a.bind, arguments);
    },
        fa = function fa(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    },
        _v = function v(a, b, c) {
        _v = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ea : fa;return _v.apply(null, arguments);
    },
        w = function w(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);return function () {
            var b = c.slice();b.push.apply(b, arguments);return a.apply(this, b);
        };
    },
        x = function x(a, b) {
        function c() {}c.prototype = b.prototype;a.ga = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.fa = function (a, c, g) {
            for (var f = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
                f[k - 2] = arguments[k];
            }return b.prototype[c].apply(a, f);
        };
    };var y = "undefined" !== typeof window ? window : global;function __extends(a, b) {
        function c() {
            this.constructor = a;
        }for (var d in b) {
            b.hasOwnProperty(d) && (a[d] = b[d]);
        }a.prototype = null === b ? Object.create(b) : (c.prototype = b.prototype, new c());
    }
    function __decorate(a, b, c, d) {
        var e = arguments.length,
            g = 3 > e ? b : null === d ? d = Object.getOwnPropertyDescriptor(b, c) : d,
            f;f = y.Reflect;if ("object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && "function" === typeof f.decorate) g = f.decorate(a, b, c, d);else for (var k = a.length - 1; 0 <= k; k--) {
            if (f = a[k]) g = (3 > e ? f(g) : 3 < e ? f(b, c, g) : f(b, c)) || g;
        }return 3 < e && g && Object.defineProperty(b, c, g), g;
    }function __metadata(a, b) {
        var c = y.Reflect;if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && "function" === typeof c.metadata) return c.metadata(a, b);
    }
    var __param = function __param(a, b) {
        return function (c, d) {
            b(c, d, a);
        };
    },
        __awaiter = function __awaiter(a, b, c, d) {
        return new (c || (c = Promise))(function (e, g) {
            function f(a) {
                try {
                    n(d.next(a));
                } catch (b) {
                    g(b);
                }
            }function k(a) {
                try {
                    n(d.throw(a));
                } catch (b) {
                    g(b);
                }
            }function n(a) {
                a.done ? e(a.value) : new c(function (b) {
                    b(a.value);
                }).then(f, k);
            }n((d = d.apply(a, b)).next());
        });
    };"undefined" !== typeof y.L && y.L || "undefined" === typeof global || (global.ca = __extends, global.ba = __decorate, global.da = __metadata, global.ea = __param, global.aa = __awaiter);var z = function z(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, z);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    };x(z, Error);z.prototype.name = "CustomError";var ga = function ga(a, b) {
        for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
            d += c.shift() + e.shift();
        }return d + c.join("%s");
    };var A = function A(a, b) {
        b.unshift(a);z.call(this, ga.apply(null, b));b.shift();
    };x(A, z);A.prototype.name = "AssertionError";var ha = function ha(a, b, c, d) {
        var e = "Assertion failed";if (c) var e = e + (": " + c),
            g = d;else a && (e += ": " + a, g = b);throw new A("" + e, g || []);
    },
        B = function B(a, b, c) {
        a || ha("", null, b, Array.prototype.slice.call(arguments, 2));
    },
        C = function C(a, b, c) {
        u(a) || ha("Expected function but got %s: %s.", [t(a), a], b, Array.prototype.slice.call(arguments, 2));
    };var D = function D(a, b, c) {
        this.S = c;this.M = a;this.U = b;this.s = 0;this.o = null;
    };D.prototype.get = function () {
        var a;0 < this.s ? (this.s--, a = this.o, this.o = a.next, a.next = null) : a = this.M();return a;
    };D.prototype.put = function (a) {
        this.U(a);this.s < this.S && (this.s++, a.next = this.o, this.o = a);
    };var E;a: {
        var ia = q.navigator;if (ia) {
            var ja = ia.userAgent;if (ja) {
                E = ja;break a;
            }
        }E = "";
    };var ka = function ka(a) {
        q.setTimeout(function () {
            throw a;
        }, 0);
    },
        F,
        la = function la() {
        var a = q.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && -1 == E.indexOf("Presto") && (a = function a() {
            var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = _v(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && -1 == E.indexOf("Trident") && -1 == E.indexOf("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (void 0 !== c.next) {
                    c = c.next;var a = c.F;c.F = null;a();
                }
            };return function (a) {
                d.next = { F: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
            var b = document.createElement("SCRIPT");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            q.setTimeout(a, 0);
        };
    };var G = function G() {
        this.v = this.f = null;
    },
        ma = new D(function () {
        return new H();
    }, function (a) {
        a.reset();
    }, 100);G.prototype.add = function (a, b) {
        var c = ma.get();c.set(a, b);this.v ? this.v.next = c : (B(!this.f), this.f = c);this.v = c;
    };G.prototype.remove = function () {
        var a = null;this.f && (a = this.f, this.f = this.f.next, this.f || (this.v = null), a.next = null);return a;
    };var H = function H() {
        this.next = this.scope = this.B = null;
    };H.prototype.set = function (a, b) {
        this.B = a;this.scope = b;this.next = null;
    };
    H.prototype.reset = function () {
        this.next = this.scope = this.B = null;
    };var L = function L(a, b) {
        I || na();K || (I(), K = !0);oa.add(a, b);
    },
        I,
        na = function na() {
        if (q.Promise && q.Promise.resolve) {
            var a = q.Promise.resolve(void 0);I = function I() {
                a.then(pa);
            };
        } else I = function I() {
            var a = pa;!u(q.setImmediate) || q.Window && q.Window.prototype && -1 == E.indexOf("Edge") && q.Window.prototype.setImmediate == q.setImmediate ? (F || (F = la()), F(a)) : q.setImmediate(a);
        };
    },
        K = !1,
        oa = new G(),
        pa = function pa() {
        for (var a; a = oa.remove();) {
            try {
                a.B.call(a.scope);
            } catch (b) {
                ka(b);
            }ma.put(a);
        }K = !1;
    };var N = function N(a, b) {
        this.b = 0;this.K = void 0;this.j = this.g = this.u = null;this.m = this.A = !1;if (a != r) try {
            var c = this;a.call(b, function (a) {
                M(c, 2, a);
            }, function (a) {
                try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}M(c, 3, a);
            });
        } catch (d) {
            M(this, 3, d);
        }
    },
        qa = function qa() {
        this.next = this.context = this.h = this.c = this.child = null;this.w = !1;
    };qa.prototype.reset = function () {
        this.context = this.h = this.c = this.child = null;this.w = !1;
    };
    var ra = new D(function () {
        return new qa();
    }, function (a) {
        a.reset();
    }, 100),
        sa = function sa(a, b, c) {
        var d = ra.get();d.c = a;d.h = b;d.context = c;return d;
    },
        ua = function ua(a, b, c) {
        ta(a, b, c, null) || L(w(b, a));
    };N.prototype.then = function (a, b, c) {
        null != a && C(a, "opt_onFulfilled should be a function.");null != b && C(b, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return va(this, u(a) ? a : null, u(b) ? b : null, c);
    };N.prototype.then = N.prototype.then;N.prototype.$goog_Thenable = !0;
    N.prototype.X = function (a, b) {
        return va(this, null, a, b);
    };var xa = function xa(a, b) {
        a.g || 2 != a.b && 3 != a.b || wa(a);B(null != b.c);a.j ? a.j.next = b : a.g = b;a.j = b;
    },
        va = function va(a, b, c, d) {
        var e = sa(null, null, null);e.child = new N(function (a, f) {
            e.c = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (J) {
                    f(J);
                }
            } : a;e.h = c ? function (b) {
                try {
                    var e = c.call(d, b);a(e);
                } catch (J) {
                    f(J);
                }
            } : f;
        });e.child.u = a;xa(a, e);return e.child;
    };N.prototype.Y = function (a) {
        B(1 == this.b);this.b = 0;M(this, 2, a);
    };N.prototype.Z = function (a) {
        B(1 == this.b);this.b = 0;M(this, 3, a);
    };
    var M = function M(a, b, c) {
        0 == a.b && (a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself")), a.b = 1, ta(c, a.Y, a.Z, a) || (a.K = c, a.b = b, a.u = null, wa(a), 3 != b || ya(a, c)));
    },
        ta = function ta(a, b, c, d) {
        if (a instanceof N) return null != b && C(b, "opt_onFulfilled should be a function."), null != c && C(c, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"), xa(a, sa(b || r, c || null, d)), !0;var e;if (a) try {
            e = !!a.$goog_Thenable;
        } catch (f) {
            e = !1;
        } else e = !1;if (e) return a.then(b, c, d), !0;e = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == e && null != a || "function" == e) try {
            var g = a.then;if (u(g)) return za(a, g, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }return !1;
    },
        za = function za(a, b, c, d, e) {
        var g = !1,
            f = function f(a) {
            g || (g = !0, c.call(e, a));
        },
            k = function k(a) {
            g || (g = !0, d.call(e, a));
        };try {
            b.call(a, f, k);
        } catch (n) {
            k(n);
        }
    },
        wa = function wa(a) {
        a.A || (a.A = !0, L(a.O, a));
    },
        Aa = function Aa(a) {
        var b = null;a.g && (b = a.g, a.g = b.next, b.next = null);a.g || (a.j = null);null != b && B(null != b.c);return b;
    };
    N.prototype.O = function () {
        for (var a; a = Aa(this);) {
            var b = this.b,
                c = this.K;if (3 == b && a.h && !a.w) {
                var d;for (d = this; d && d.m; d = d.u) {
                    d.m = !1;
                }
            }if (a.child) a.child.u = null, Ba(a, b, c);else try {
                a.w ? a.c.call(a.context) : Ba(a, b, c);
            } catch (e) {
                Ca.call(null, e);
            }ra.put(a);
        }this.A = !1;
    };var Ba = function Ba(a, b, c) {
        2 == b ? a.c.call(a.context, c) : a.h && a.h.call(a.context, c);
    },
        ya = function ya(a, b) {
        a.m = !0;L(function () {
            a.m && Ca.call(null, b);
        });
    },
        Ca = ka;function O(a, b) {
        if (!(b instanceof Object)) return b;switch (b.constructor) {case Date:
                return new Date(b.getTime());case Object:
                void 0 === a && (a = {});break;case Array:
                a = [];break;default:
                return b;}for (var c in b) {
            b.hasOwnProperty(c) && (a[c] = O(a[c], b[c]));
        }return a;
    };var Da = Error.captureStackTrace,
        Q = function Q(a, b) {
        this.code = a;this.message = b;if (Da) Da(this, P.prototype.create);else {
            var c = Error.apply(this, arguments);this.name = "FirebaseError";Object.defineProperty(this, "stack", { get: function get() {
                    return c.stack;
                } });
        }
    };Q.prototype = Object.create(Error.prototype);Q.prototype.constructor = Q;Q.prototype.name = "FirebaseError";var P = function P(a, b, c) {
        this.V = a;this.W = b;this.N = c;this.pattern = /\{\$([^}]+)}/g;
    };
    P.prototype.create = function (a, b) {
        void 0 === b && (b = {});var c = this.N[a];a = this.V + "/" + a;var c = void 0 === c ? "Error" : c.replace(this.pattern, function (a, c) {
            a = b[c];return void 0 !== a ? a.toString() : "<" + c + "?>";
        }),
            c = this.W + ": " + c + " (" + a + ").",
            c = new Q(a, c),
            d;for (d in b) {
            b.hasOwnProperty(d) && "_" !== d.slice(-1) && (c[d] = b[d]);
        }return c;
    };N.all = function (a) {
        return new N(function (b, c) {
            var d = a.length,
                e = [];if (d) for (var g = function g(a, c) {
                d--;e[a] = c;0 == d && b(e);
            }, f = function f(a) {
                c(a);
            }, k = 0, n; k < a.length; k++) {
                n = a[k], ua(n, w(g, k), f);
            } else b(e);
        });
    };N.resolve = function (a) {
        if (a instanceof N) return a;var b = new N(r);M(b, 2, a);return b;
    };N.reject = function (a) {
        return new N(function (b, c) {
            c(a);
        });
    };N.prototype["catch"] = N.prototype.X;var R = N;"undefined" !== typeof Promise && (R = Promise);var Ea = R;function Fa(a, b) {
        a = new S(a, b);return a.subscribe.bind(a);
    }var S = function S(a, b) {
        var c = this;this.a = [];this.J = 0;this.task = Ea.resolve();this.l = !1;this.D = b;this.task.then(function () {
            a(c);
        }).catch(function (a) {
            c.error(a);
        });
    };S.prototype.next = function (a) {
        T(this, function (b) {
            b.next(a);
        });
    };S.prototype.error = function (a) {
        T(this, function (b) {
            b.error(a);
        });this.close(a);
    };S.prototype.complete = function () {
        T(this, function (a) {
            a.complete();
        });this.close();
    };
    S.prototype.subscribe = function (a, b, c) {
        var d = this,
            e;if (void 0 === a && void 0 === b && void 0 === c) throw Error("Missing Observer.");e = Ga(a) ? a : { next: a, error: b, complete: c };void 0 === e.next && (e.next = U);void 0 === e.error && (e.error = U);void 0 === e.complete && (e.complete = U);a = this.$.bind(this, this.a.length);this.l && this.task.then(function () {
            try {
                d.G ? e.error(d.G) : e.complete();
            } catch (a) {}
        });this.a.push(e);return a;
    };
    S.prototype.$ = function (a) {
        void 0 !== this.a && void 0 !== this.a[a] && (delete this.a[a], --this.J, 0 === this.J && void 0 !== this.D && this.D(this));
    };var T = function T(a, b) {
        if (!a.l) for (var c = 0; c < a.a.length; c++) {
            Ha(a, c, b);
        }
    },
        Ha = function Ha(a, b, c) {
        a.task.then(function () {
            if (void 0 !== a.a && void 0 !== a.a[b]) try {
                c(a.a[b]);
            } catch (d) {}
        });
    };S.prototype.close = function (a) {
        var b = this;this.l || (this.l = !0, void 0 !== a && (this.G = a), this.task.then(function () {
            b.a = void 0;b.D = void 0;
        }));
    };
    function Ga(a) {
        if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a) return !1;var b;b = ["next", "error", "complete"];_p();var c = b[Symbol.iterator];b = c ? c.call(b) : m(b);for (c = b.next(); !c.done; c = b.next()) {
            if (c = c.value, c in a && "function" === typeof a[c]) return !0;
        }return !1;
    }function U() {};var V = R,
        W = function W(a, b, c) {
        var d = this;this.H = c;this.I = !1;this.i = {};this.C = b;this.T = O(void 0, a);Object.keys(c.INTERNAL.factories).forEach(function (a) {
            var b = c.INTERNAL.useAsService(d, a);null !== b && (d[a] = d.R.bind(d, b));
        });
    };W.prototype.delete = function () {
        var a = this;return new V(function (b) {
            X(a);b();
        }).then(function () {
            a.H.INTERNAL.removeApp(a.C);return V.all(Object.keys(a.i).map(function (b) {
                return a.i[b].INTERNAL.delete();
            }));
        }).then(function () {
            a.I = !0;a.i = {};
        });
    };
    W.prototype.R = function (a) {
        X(this);void 0 === this.i[a] && (this.i[a] = this.H.INTERNAL.factories[a](this, this.P.bind(this)));return this.i[a];
    };W.prototype.P = function (a) {
        O(this, a);
    };var X = function X(a) {
        a.I && Y(Ia("deleted", { name: a.C }));
    };h.Object.defineProperties(W.prototype, { name: { configurable: !0, enumerable: !0, get: function get() {
                X(this);return this.C;
            } }, options: { configurable: !0, enumerable: !0, get: function get() {
                X(this);return this.T;
            } } });W.prototype.name && W.prototype.options || W.prototype.delete || console.log("dc");
    function Ja() {
        function a(a) {
            a = a || "[DEFAULT]";var b = d[a];void 0 === b && Y("noApp", { name: a });return b;
        }function b(a, b) {
            Object.keys(e).forEach(function (d) {
                d = c(a, d);if (null !== d && g[d]) g[d](b, a);
            });
        }function c(a, b) {
            if ("serverAuth" === b) return null;var c = b;a = a.options;"auth" === b && (a.serviceAccount || a.credential) && (c = "serverAuth");return c;
        }var d = {},
            e = {},
            g = {},
            f = {
            __esModule: !0, initializeApp: function initializeApp(a, c) {
                void 0 === c ? c = "[DEFAULT]" : "string" === typeof c && "" !== c || Y("bad-app-name", { name: c + "" });void 0 !== d[c] && Y("dupApp", { name: c });a = new W(a, c, f);d[c] = a;b(a, "create");void 0 != a.INTERNAL && void 0 != a.INTERNAL.getToken || O(a, { INTERNAL: { getToken: function getToken() {
                            return V.resolve(null);
                        }, addAuthTokenListener: function addAuthTokenListener() {}, removeAuthTokenListener: function removeAuthTokenListener() {} } });return a;
            }, app: a, apps: null, Promise: V, SDK_VERSION: "0.0.0", INTERNAL: {
                registerService: function registerService(b, c, d, Z) {
                    e[b] && Y("dupService", { name: b });e[b] = c;Z && (g[b] = Z);c = function c(_c) {
                        void 0 === _c && (_c = a());return _c[b]();
                    };void 0 !== d && O(c, d);return f[b] = c;
                }, createFirebaseNamespace: Ja, extendNamespace: function extendNamespace(a) {
                    O(f, a);
                }, createSubscribe: Fa, ErrorFactory: P, removeApp: function removeApp(a) {
                    b(d[a], "delete");delete d[a];
                }, factories: e, useAsService: c, Promise: N, deepExtend: O
            }
        };f["default"] = f;Object.defineProperty(f, "apps", { get: function get() {
                return Object.keys(d).map(function (a) {
                    return d[a];
                });
            } });a.App = W;return f;
    }function Y(a, b) {
        throw Error(Ia(a, b));
    }
    function Ia(a, b) {
        b = b || {};b = { noApp: "No Firebase App '" + b.name + "' has been created - call Firebase App.initializeApp().", "bad-app-name": "Illegal App name: '" + b.name + "'.", dupApp: "Firebase App named '" + b.name + "' already exists.", deleted: "Firebase App named '" + b.name + "' already deleted.", dupService: "Firebase Service named '" + b.name + "' already registered." }[a];return void 0 === b ? "Application Error: (" + a + ")" : b;
    };"undefined" !== typeof window && (window.firebase = Ja());
})();
firebase.SDK_VERSION = "3.3.0";
(function () {
    var h,
        aa = aa || {},
        l = this,
        ba = function ba() {},
        m = function m(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    },
        ca = function ca(a) {
        return null === a;
    },
        da = function da(a) {
        return "array" == m(a);
    },
        ea = function ea(a) {
        var b = m(a);return "array" == b || "object" == b && "number" == typeof a.length;
    },
        n = function n(a) {
        return "string" == typeof a;
    },
        fa = function fa(a) {
        return "number" == typeof a;
    },
        p = function p(a) {
        return "function" == m(a);
    },
        ga = function ga(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && null != a || "function" == b;
    },
        ha = function ha(a, b, c) {
        return a.call.apply(a.bind, arguments);
    },
        ia = function ia(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    },
        _r = function r(a, b, c) {
        _r = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ha : ia;return _r.apply(null, arguments);
    },
        ja = function ja(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);return function () {
            var b = c.slice();b.push.apply(b, arguments);return a.apply(this, b);
        };
    },
        ka = Date.now || function () {
        return +new Date();
    },
        t = function t(a, b) {
        function c() {}c.prototype = b.prototype;a.Pc = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.Ne = function (a, c, f) {
            for (var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
                g[k - 2] = arguments[k];
            }return b.prototype[c].apply(a, g);
        };
    };var u = function u(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, u);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    };t(u, Error);u.prototype.name = "CustomError";var la = function la(a, b) {
        for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
            d += c.shift() + e.shift();
        }return d + c.join("%s");
    },
        ma = String.prototype.trim ? function (a) {
        return a.trim();
    } : function (a) {
        return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
    },
        na = /&/g,
        oa = /</g,
        pa = />/g,
        qa = /"/g,
        sa = /'/g,
        ta = /\x00/g,
        ua = /[\x00&<>"']/,
        v = function v(a, b) {
        return -1 != a.indexOf(b);
    },
        va = function va(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    };var wa = function wa(a, b) {
        b.unshift(a);u.call(this, la.apply(null, b));b.shift();
    };t(wa, u);wa.prototype.name = "AssertionError";
    var xa = function xa(a, b, c, d) {
        var e = "Assertion failed";if (c) var e = e + (": " + c),
            f = d;else a && (e += ": " + a, f = b);throw new wa("" + e, f || []);
    },
        w = function w(a, b, c) {
        a || xa("", null, b, Array.prototype.slice.call(arguments, 2));
    },
        ya = function ya(a, b) {
        throw new wa("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    },
        za = function za(a, b, c) {
        fa(a) || xa("Expected number but got %s: %s.", [m(a), a], b, Array.prototype.slice.call(arguments, 2));return a;
    },
        Aa = function Aa(a, b, c) {
        n(a) || xa("Expected string but got %s: %s.", [m(a), a], b, Array.prototype.slice.call(arguments, 2));
    },
        Ba = function Ba(a, b, c) {
        p(a) || xa("Expected function but got %s: %s.", [m(a), a], b, Array.prototype.slice.call(arguments, 2));
    };var Ca = Array.prototype.indexOf ? function (a, b, c) {
        w(null != a.length);return Array.prototype.indexOf.call(a, b, c);
    } : function (a, b, c) {
        c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (n(a)) return n(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
            if (c in a && a[c] === b) return c;
        }return -1;
    },
        x = Array.prototype.forEach ? function (a, b, c) {
        w(null != a.length);Array.prototype.forEach.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
            f in e && b.call(c, e[f], f, a);
        }
    },
        Da = function Da(a, b) {
        for (var c = n(a) ? a.split("") : a, d = a.length - 1; 0 <= d; --d) {
            d in c && b.call(void 0, c[d], d, a);
        }
    },
        Ea = Array.prototype.map ? function (a, b, c) {
        w(null != a.length);return Array.prototype.map.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = Array(d), f = n(a) ? a.split("") : a, g = 0; g < d; g++) {
            g in f && (e[g] = b.call(c, f[g], g, a));
        }return e;
    },
        Fa = Array.prototype.some ? function (a, b, c) {
        w(null != a.length);return Array.prototype.some.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && b.call(c, e[f], f, a)) return !0;
        }return !1;
    },
        Ha = function Ha(a) {
        var b;a: {
            b = Ga;for (var c = a.length, d = n(a) ? a.split("") : a, e = 0; e < c; e++) {
                if (e in d && b.call(void 0, d[e], e, a)) {
                    b = e;break a;
                }
            }b = -1;
        }return 0 > b ? null : n(a) ? a.charAt(b) : a[b];
    },
        Ia = function Ia(a, b) {
        return 0 <= Ca(a, b);
    },
        Ka = function Ka(a, b) {
        b = Ca(a, b);var c;(c = 0 <= b) && Ja(a, b);return c;
    },
        Ja = function Ja(a, b) {
        w(null != a.length);return 1 == Array.prototype.splice.call(a, b, 1).length;
    },
        La = function La(a, b) {
        var c = 0;Da(a, function (d, e) {
            b.call(void 0, d, e, a) && Ja(a, e) && c++;
        });
    },
        Ma = function Ma(a) {
        return Array.prototype.concat.apply(Array.prototype, arguments);
    },
        Na = function Na(a) {
        return Array.prototype.concat.apply(Array.prototype, arguments);
    },
        Oa = function Oa(a) {
        var b = a.length;if (0 < b) {
            for (var c = Array(b), d = 0; d < b; d++) {
                c[d] = a[d];
            }return c;
        }return [];
    },
        Pa = function Pa(a, b) {
        for (var c = 1; c < arguments.length; c++) {
            var d = arguments[c];if (ea(d)) {
                var e = a.length || 0,
                    f = d.length || 0;a.length = e + f;for (var g = 0; g < f; g++) {
                    a[e + g] = d[g];
                }
            } else a.push(d);
        }
    };var Qa = function Qa(a, b) {
        for (var c in a) {
            b.call(void 0, a[c], c, a);
        }
    },
        Ra = function Ra(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = a[d];
        }return b;
    },
        Sa = function Sa(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = d;
        }return b;
    },
        Ta = function Ta(a) {
        for (var b in a) {
            return !1;
        }return !0;
    },
        Ua = function Ua(a, b) {
        for (var c in a) {
            if (!(c in b) || a[c] !== b[c]) return !1;
        }for (c in b) {
            if (!(c in a)) return !1;
        }return !0;
    },
        Va = function Va(a) {
        var b = {},
            c;for (c in a) {
            b[c] = a[c];
        }return b;
    },
        Wa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
        Xa = function Xa(a, b) {
        for (var c, d, e = 1; e < arguments.length; e++) {
            d = arguments[e];for (c in d) {
                a[c] = d[c];
            }for (var f = 0; f < Wa.length; f++) {
                c = Wa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
            }
        }
    };var Ya;a: {
        var Za = l.navigator;if (Za) {
            var $a = Za.userAgent;if ($a) {
                Ya = $a;break a;
            }
        }Ya = "";
    }var y = function y(a) {
        return v(Ya, a);
    };var ab = function ab(a) {
        ab[" "](a);return a;
    };ab[" "] = ba;var cb = function cb(a, b) {
        var c = bb;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    };var db = y("Opera"),
        z = y("Trident") || y("MSIE"),
        eb = y("Edge"),
        fb = eb || z,
        gb = y("Gecko") && !(v(Ya.toLowerCase(), "webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"),
        hb = v(Ya.toLowerCase(), "webkit") && !y("Edge"),
        ib = function ib() {
        var a = l.document;return a ? a.documentMode : void 0;
    },
        jb;
    a: {
        var kb = "",
            lb = function () {
            var a = Ya;if (gb) return (/rv\:([^\);]+)(\)|;)/.exec(a)
            );if (eb) return (/Edge\/([\d\.]+)/.exec(a)
            );if (z) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
            );if (hb) return (/WebKit\/(\S+)/.exec(a)
            );if (db) return (/(?:Version)[ \/]?(\S+)/.exec(a)
            );
        }();lb && (kb = lb ? lb[1] : "");if (z) {
            var mb = ib();if (null != mb && mb > parseFloat(kb)) {
                jb = String(mb);break a;
            }
        }jb = kb;
    }
    var nb = jb,
        bb = {},
        A = function A(a) {
        return cb(a, function () {
            for (var b = 0, c = ma(String(nb)).split("."), d = ma(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
                var g = c[f] || "",
                    k = d[f] || "";do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];k = /(\d*)(\D*)(.*)/.exec(k) || ["", "", "", ""];if (0 == g[0].length && 0 == k[0].length) break;b = va(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == k[1].length ? 0 : parseInt(k[1], 10)) || va(0 == g[2].length, 0 == k[2].length) || va(g[2], k[2]);g = g[3];k = k[3];
                } while (0 == b);
            }return 0 <= b;
        });
    },
        ob = l.document,
        pb = ob && z ? ib() || ("CSS1Compat" == ob.compatMode ? parseInt(nb, 10) : 5) : void 0;var qb = null,
        rb = null,
        tb = function tb(a) {
        var b = "";sb(a, function (a) {
            b += String.fromCharCode(a);
        });return b;
    },
        sb = function sb(a, b) {
        function c(b) {
            for (; d < a.length;) {
                var c = a.charAt(d++),
                    e = rb[c];if (null != e) return e;if (!/^[\s\xa0]*$/.test(c)) throw Error("Unknown base64 encoding at char: " + c);
            }return b;
        }ub();for (var d = 0;;) {
            var e = c(-1),
                f = c(0),
                g = c(64),
                k = c(64);if (64 === k && -1 === e) break;b(e << 2 | f >> 4);64 != g && (b(f << 4 & 240 | g >> 2), 64 != k && b(g << 6 & 192 | k));
        }
    },
        ub = function ub() {
        if (!qb) {
            qb = {};rb = {};for (var a = 0; 65 > a; a++) {
                qb[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a), rb[qb[a]] = a, 62 <= a && (rb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)] = a);
            }
        }
    };var wb = function wb() {
        this.ec = "";this.Md = vb;
    };wb.prototype.Nb = !0;wb.prototype.Ib = function () {
        return this.ec;
    };wb.prototype.toString = function () {
        return "Const{" + this.ec + "}";
    };var xb = function xb(a) {
        if (a instanceof wb && a.constructor === wb && a.Md === vb) return a.ec;ya("expected object of type Const, got '" + a + "'");return "type_error:Const";
    },
        vb = {};var B = function B() {
        this.ja = "";this.Ld = yb;
    };B.prototype.Nb = !0;B.prototype.Ib = function () {
        return this.ja;
    };B.prototype.toString = function () {
        return "SafeUrl{" + this.ja + "}";
    };
    var zb = function zb(a) {
        if (a instanceof B && a.constructor === B && a.Ld === yb) return a.ja;ya("expected object of type SafeUrl, got '" + a + "' of type " + m(a));return "type_error:SafeUrl";
    },
        Ab = /^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i,
        Cb = function Cb(a) {
        if (a instanceof B) return a;a = a.Nb ? a.Ib() : String(a);Ab.test(a) || (a = "about:invalid#zClosurez");return Bb(a);
    },
        yb = {},
        Bb = function Bb(a) {
        var b = new B();b.ja = a;return b;
    };Bb("about:blank");var Eb = function Eb() {
        this.Vb = "";this.Nd = Db;
    };Eb.prototype.Nb = !0;Eb.prototype.Ib = function () {
        return this.Vb;
    };Eb.prototype.toString = function () {
        return "TrustedResourceUrl{" + this.Vb + "}";
    };var Db = {};var Gb = function Gb() {
        this.ja = "";this.Kd = Fb;
    };Gb.prototype.Nb = !0;Gb.prototype.Ib = function () {
        return this.ja;
    };Gb.prototype.toString = function () {
        return "SafeHtml{" + this.ja + "}";
    };var Hb = function Hb(a) {
        if (a instanceof Gb && a.constructor === Gb && a.Kd === Fb) return a.ja;ya("expected object of type SafeHtml, got '" + a + "' of type " + m(a));return "type_error:SafeHtml";
    },
        Fb = {};Gb.prototype.ne = function (a) {
        this.ja = a;return this;
    };var Ib = function Ib(a, b) {
        b = b instanceof B ? b : Cb(b);a.href = zb(b);
    };var Jb = !z || 9 <= Number(pb),
        Kb = z && !A("9");!hb || A("528");gb && A("1.9b") || z && A("8") || db && A("9.5") || hb && A("528");gb && !A("8") || z && A("9");var Lb = function Lb() {
        this.ya = this.ya;this.Sb = this.Sb;
    };Lb.prototype.ya = !1;Lb.prototype.isDisposed = function () {
        return this.ya;
    };Lb.prototype.Oa = function () {
        if (this.Sb) for (; this.Sb.length;) {
            this.Sb.shift()();
        }
    };var Mb = function Mb(a, b) {
        this.type = a;this.currentTarget = this.target = b;this.defaultPrevented = this.Va = !1;this.ud = !0;
    };Mb.prototype.preventDefault = function () {
        this.defaultPrevented = !0;this.ud = !1;
    };var Nb = function Nb(a, b) {
        Mb.call(this, a ? a.type : "");this.relatedTarget = this.currentTarget = this.target = null;this.charCode = this.keyCode = this.button = this.screenY = this.screenX = this.clientY = this.clientX = this.offsetY = this.offsetX = 0;this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;this.kb = this.state = null;a && this.init(a, b);
    };t(Nb, Mb);
    Nb.prototype.init = function (a, b) {
        var c = this.type = a.type,
            d = a.changedTouches ? a.changedTouches[0] : null;this.target = a.target || a.srcElement;this.currentTarget = b;if (b = a.relatedTarget) {
            if (gb) {
                var e;a: {
                    try {
                        ab(b.nodeName);e = !0;break a;
                    } catch (f) {}e = !1;
                }e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);this.relatedTarget = b;null === d ? (this.offsetX = hb || void 0 !== a.offsetX ? a.offsetX : a.layerX, this.offsetY = hb || void 0 !== a.offsetY ? a.offsetY : a.layerY, this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0) : (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0);this.button = a.button;this.keyCode = a.keyCode || 0;this.charCode = a.charCode || ("keypress" == c ? a.keyCode : 0);this.ctrlKey = a.ctrlKey;this.altKey = a.altKey;this.shiftKey = a.shiftKey;this.metaKey = a.metaKey;this.state = a.state;this.kb = a;a.defaultPrevented && this.preventDefault();
    };Nb.prototype.preventDefault = function () {
        Nb.Pc.preventDefault.call(this);var a = this.kb;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Kb) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };Nb.prototype.ce = function () {
        return this.kb;
    };var Ob = "closure_listenable_" + (1E6 * Math.random() | 0),
        Pb = 0;var Qb = function Qb(a, b, c, d, e) {
        this.listener = a;this.Wb = null;this.src = b;this.type = c;this.Bb = !!d;this.Kb = e;this.key = ++Pb;this.$a = this.Ab = !1;
    },
        Rb = function Rb(a) {
        a.$a = !0;a.listener = null;a.Wb = null;a.src = null;a.Kb = null;
    };var Sb = function Sb(a) {
        this.src = a;this.w = {};this.xb = 0;
    };Sb.prototype.add = function (a, b, c, d, e) {
        var f = a.toString();a = this.w[f];a || (a = this.w[f] = [], this.xb++);var g = Tb(a, b, d, e);-1 < g ? (b = a[g], c || (b.Ab = !1)) : (b = new Qb(b, this.src, f, !!d, e), b.Ab = c, a.push(b));return b;
    };Sb.prototype.remove = function (a, b, c, d) {
        a = a.toString();if (!(a in this.w)) return !1;var e = this.w[a];b = Tb(e, b, c, d);return -1 < b ? (Rb(e[b]), Ja(e, b), 0 == e.length && (delete this.w[a], this.xb--), !0) : !1;
    };
    var Ub = function Ub(a, b) {
        var c = b.type;c in a.w && Ka(a.w[c], b) && (Rb(b), 0 == a.w[c].length && (delete a.w[c], a.xb--));
    };Sb.prototype.tc = function (a, b, c, d) {
        a = this.w[a.toString()];var e = -1;a && (e = Tb(a, b, c, d));return -1 < e ? a[e] : null;
    };var Tb = function Tb(a, b, c, d) {
        for (var e = 0; e < a.length; ++e) {
            var f = a[e];if (!f.$a && f.listener == b && f.Bb == !!c && f.Kb == d) return e;
        }return -1;
    };var Vb = "closure_lm_" + (1E6 * Math.random() | 0),
        Wb = {},
        Xb = 0,
        Yb = function Yb(a, b, c, d, e) {
        if (da(b)) for (var f = 0; f < b.length; f++) {
            Yb(a, b[f], c, d, e);
        } else c = Zb(c), a && a[Ob] ? a.listen(b, c, d, e) : $b(a, b, c, !1, d, e);
    },
        $b = function $b(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");var g = !!e,
            k = ac(a);k || (a[Vb] = k = new Sb(a));c = k.add(b, c, d, e, f);if (c.Wb) return;d = bc();c.Wb = d;d.src = a;d.listener = c;if (a.addEventListener) a.addEventListener(b.toString(), d, g);else if (a.attachEvent) a.attachEvent(cc(b.toString()), d);else throw Error("addEventListener and attachEvent are unavailable.");
        Xb++;
    },
        bc = function bc() {
        var a = dc,
            b = Jb ? function (c) {
            return a.call(b.src, b.listener, c);
        } : function (c) {
            c = a.call(b.src, b.listener, c);if (!c) return c;
        };return b;
    },
        ec = function ec(a, b, c, d, e) {
        if (da(b)) for (var f = 0; f < b.length; f++) {
            ec(a, b[f], c, d, e);
        } else c = Zb(c), a && a[Ob] ? fc(a, b, c, d, e) : $b(a, b, c, !0, d, e);
    },
        gc = function gc(a, b, c, d, e) {
        if (da(b)) for (var f = 0; f < b.length; f++) {
            gc(a, b[f], c, d, e);
        } else c = Zb(c), a && a[Ob] ? a.Y.remove(String(b), c, d, e) : a && (a = ac(a)) && (b = a.tc(b, c, !!d, e)) && hc(b);
    },
        hc = function hc(a) {
        if (!fa(a) && a && !a.$a) {
            var b = a.src;if (b && b[Ob]) Ub(b.Y, a);else {
                var c = a.type,
                    d = a.Wb;b.removeEventListener ? b.removeEventListener(c, d, a.Bb) : b.detachEvent && b.detachEvent(cc(c), d);Xb--;(c = ac(b)) ? (Ub(c, a), 0 == c.xb && (c.src = null, b[Vb] = null)) : Rb(a);
            }
        }
    },
        cc = function cc(a) {
        return a in Wb ? Wb[a] : Wb[a] = "on" + a;
    },
        jc = function jc(a, b, c, d) {
        var e = !0;if (a = ac(a)) if (b = a.w[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
            var f = b[a];f && f.Bb == c && !f.$a && (f = ic(f, d), e = e && !1 !== f);
        }return e;
    },
        ic = function ic(a, b) {
        var c = a.listener,
            d = a.Kb || a.src;a.Ab && hc(a);return c.call(d, b);
    },
        dc = function dc(a, b) {
        if (a.$a) return !0;
        if (!Jb) {
            if (!b) a: {
                b = ["window", "event"];for (var c = l, d; d = b.shift();) {
                    if (null != c[d]) c = c[d];else {
                        b = null;break a;
                    }
                }b = c;
            }d = b;b = new Nb(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;if (0 == d.keyCode) try {
                        d.keyCode = -1;break a;
                    } catch (g) {
                        e = !0;
                    }if (e || void 0 == d.returnValue) d.returnValue = !0;
                }d = [];for (e = b.currentTarget; e; e = e.parentNode) {
                    d.push(e);
                }a = a.type;for (e = d.length - 1; !b.Va && 0 <= e; e--) {
                    b.currentTarget = d[e];var f = jc(d[e], a, !0, b),
                        c = c && f;
                }for (e = 0; !b.Va && e < d.length; e++) {
                    b.currentTarget = d[e], f = jc(d[e], a, !1, b), c = c && f;
                }
            }return c;
        }return ic(a, new Nb(b, this));
    },
        ac = function ac(a) {
        a = a[Vb];return a instanceof Sb ? a : null;
    },
        kc = "__closure_events_fn_" + (1E9 * Math.random() >>> 0),
        Zb = function Zb(a) {
        w(a, "Listener can not be null.");if (p(a)) return a;w(a.handleEvent, "An object listener must have handleEvent method.");a[kc] || (a[kc] = function (b) {
            return a.handleEvent(b);
        });return a[kc];
    };var lc = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var mc = function mc(a) {
        a = String(a);if (/^\s*$/.test(a) ? 0 : /^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g, "@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g, "]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, ""))) try {
            return eval("(" + a + ")");
        } catch (b) {}throw Error("Invalid JSON string: " + a);
    },
        pc = function pc(a) {
        var b = [];nc(new oc(), a, b);return b.join("");
    },
        oc = function oc() {
        this.$b = void 0;
    },
        nc = function nc(a, b, c) {
        if (null == b) c.push("null");else {
            if ("object" == (typeof b === "undefined" ? "undefined" : _typeof(b))) {
                if (da(b)) {
                    var d = b;b = d.length;c.push("[");for (var e = "", f = 0; f < b; f++) {
                        c.push(e), e = d[f], nc(a, a.$b ? a.$b.call(d, String(f), e) : e, c), e = ",";
                    }c.push("]");return;
                }if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
                    c.push("{");f = "";for (d in b) {
                        Object.prototype.hasOwnProperty.call(b, d) && (e = b[d], "function" != typeof e && (c.push(f), qc(d, c), c.push(":"), nc(a, a.$b ? a.$b.call(b, d, e) : e, c), f = ","));
                    }c.push("}");return;
                }
            }switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {
                case "string":
                    qc(b, c);break;case "number":
                    c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");break;case "boolean":
                    c.push(String(b));break;case "function":
                    c.push("null");break;default:
                    throw Error("Unknown type: " + (typeof b === "undefined" ? "undefined" : _typeof(b)));
            }
        }
    },
        rc = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": "\\u000b" },
        sc = /\uffff/.test("\uFFFF") ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g,
        qc = function qc(a, b) {
        b.push('"', a.replace(sc, function (a) {
            var b = rc[a];b || (b = "\\u" + (a.charCodeAt(0) | 65536).toString(16).substr(1), rc[a] = b);return b;
        }), '"');
    };var tc = function tc() {};tc.prototype.Tc = null;var uc = function uc(a) {
        return a.Tc || (a.Tc = a.xc());
    };var vc,
        wc = function wc() {};t(wc, tc);wc.prototype.Cb = function () {
        var a = xc(this);return a ? new ActiveXObject(a) : new XMLHttpRequest();
    };wc.prototype.xc = function () {
        var a = {};xc(this) && (a[0] = !0, a[1] = !0);return a;
    };
    var xc = function xc(a) {
        if (!a.gd && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
                var d = b[c];try {
                    return new ActiveXObject(d), a.gd = d;
                } catch (e) {}
            }throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }return a.gd;
    };vc = new wc();var yc = function yc() {};t(yc, tc);yc.prototype.Cb = function () {
        var a = new XMLHttpRequest();if ("withCredentials" in a) return a;if ("undefined" != typeof XDomainRequest) return new zc();throw Error("Unsupported browser");
    };yc.prototype.xc = function () {
        return {};
    };
    var zc = function zc() {
        this.na = new XDomainRequest();this.readyState = 0;this.onreadystatechange = null;this.responseText = "";this.status = -1;this.statusText = this.responseXML = null;this.na.onload = _r(this.ee, this);this.na.onerror = _r(this.ed, this);this.na.onprogress = _r(this.fe, this);this.na.ontimeout = _r(this.ge, this);
    };h = zc.prototype;h.open = function (a, b, c) {
        if (null != c && !c) throw Error("Only async requests are supported.");this.na.open(a, b);
    };
    h.send = function (a) {
        if (a) {
            if ("string" == typeof a) this.na.send(a);else throw Error("Only string data is supported");
        } else this.na.send();
    };h.abort = function () {
        this.na.abort();
    };h.setRequestHeader = function () {};h.ee = function () {
        this.status = 200;this.responseText = this.na.responseText;Ac(this, 4);
    };h.ed = function () {
        this.status = 500;this.responseText = "";Ac(this, 4);
    };h.ge = function () {
        this.ed();
    };h.fe = function () {
        this.status = 200;Ac(this, 1);
    };var Ac = function Ac(a, b) {
        a.readyState = b;if (a.onreadystatechange) a.onreadystatechange();
    };var C = function C(a, b) {
        this.h = [];this.g = b;for (var c = !0, d = a.length - 1; 0 <= d; d--) {
            var e = a[d] | 0;c && e == b || (this.h[d] = e, c = !1);
        }
    },
        Bc = {},
        Cc = function Cc(a) {
        if (-128 <= a && 128 > a) {
            var b = Bc[a];if (b) return b;
        }b = new C([a | 0], 0 > a ? -1 : 0);-128 <= a && 128 > a && (Bc[a] = b);return b;
    },
        F = function F(a) {
        if (isNaN(a) || !isFinite(a)) return D;if (0 > a) return E(F(-a));for (var b = [], c = 1, d = 0; a >= c; d++) {
            b[d] = a / c | 0, c *= 4294967296;
        }return new C(b, 0);
    },
        Dc = function Dc(a, b) {
        if (0 == a.length) throw Error("number format error: empty string");b = b || 10;if (2 > b || 36 < b) throw Error("radix out of range: " + b);if ("-" == a.charAt(0)) return E(Dc(a.substring(1), b));if (0 <= a.indexOf("-")) throw Error('number format error: interior "-" character');for (var c = F(Math.pow(b, 8)), d = D, e = 0; e < a.length; e += 8) {
            var f = Math.min(8, a.length - e),
                g = parseInt(a.substring(e, e + f), b);8 > f ? (f = F(Math.pow(b, f)), d = d.multiply(f).add(F(g))) : (d = d.multiply(c), d = d.add(F(g)));
        }return d;
    },
        D = Cc(0),
        Ec = Cc(1),
        Fc = Cc(16777216),
        Gc = function Gc(a) {
        if (-1 == a.g) return -Gc(E(a));for (var b = 0, c = 1, d = 0; d < a.h.length; d++) {
            b += Hc(a, d) * c, c *= 4294967296;
        }return b;
    };
    C.prototype.toString = function (a) {
        a = a || 10;if (2 > a || 36 < a) throw Error("radix out of range: " + a);if (G(this)) return "0";if (-1 == this.g) return "-" + E(this).toString(a);for (var b = F(Math.pow(a, 6)), c = this, d = "";;) {
            var e = Ic(c, b),
                c = Jc(c, e.multiply(b)),
                f = ((0 < c.h.length ? c.h[0] : c.g) >>> 0).toString(a),
                c = e;if (G(c)) return f + d;for (; 6 > f.length;) {
                f = "0" + f;
            }d = "" + f + d;
        }
    };
    var H = function H(a, b) {
        return 0 > b ? 0 : b < a.h.length ? a.h[b] : a.g;
    },
        Hc = function Hc(a, b) {
        a = H(a, b);return 0 <= a ? a : 4294967296 + a;
    },
        G = function G(a) {
        if (0 != a.g) return !1;for (var b = 0; b < a.h.length; b++) {
            if (0 != a.h[b]) return !1;
        }return !0;
    };C.prototype.Eb = function (a) {
        if (this.g != a.g) return !1;for (var b = Math.max(this.h.length, a.h.length), c = 0; c < b; c++) {
            if (H(this, c) != H(a, c)) return !1;
        }return !0;
    };C.prototype.compare = function (a) {
        a = Jc(this, a);return -1 == a.g ? -1 : G(a) ? 0 : 1;
    };
    var E = function E(a) {
        for (var b = a.h.length, c = [], d = 0; d < b; d++) {
            c[d] = ~a.h[d];
        }return new C(c, ~a.g).add(Ec);
    };C.prototype.add = function (a) {
        for (var b = Math.max(this.h.length, a.h.length), c = [], d = 0, e = 0; e <= b; e++) {
            var f = d + (H(this, e) & 65535) + (H(a, e) & 65535),
                g = (f >>> 16) + (H(this, e) >>> 16) + (H(a, e) >>> 16),
                d = g >>> 16,
                f = f & 65535,
                g = g & 65535;c[e] = g << 16 | f;
        }return new C(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };var Jc = function Jc(a, b) {
        return a.add(E(b));
    };
    C.prototype.multiply = function (a) {
        if (G(this) || G(a)) return D;if (-1 == this.g) return -1 == a.g ? E(this).multiply(E(a)) : E(E(this).multiply(a));if (-1 == a.g) return E(this.multiply(E(a)));if (0 > this.compare(Fc) && 0 > a.compare(Fc)) return F(Gc(this) * Gc(a));for (var b = this.h.length + a.h.length, c = [], d = 0; d < 2 * b; d++) {
            c[d] = 0;
        }for (d = 0; d < this.h.length; d++) {
            for (var e = 0; e < a.h.length; e++) {
                var f = H(this, d) >>> 16,
                    g = H(this, d) & 65535,
                    k = H(a, e) >>> 16,
                    q = H(a, e) & 65535;c[2 * d + 2 * e] += g * q;Kc(c, 2 * d + 2 * e);c[2 * d + 2 * e + 1] += f * q;Kc(c, 2 * d + 2 * e + 1);c[2 * d + 2 * e + 1] += g * k;Kc(c, 2 * d + 2 * e + 1);c[2 * d + 2 * e + 2] += f * k;Kc(c, 2 * d + 2 * e + 2);
            }
        }for (d = 0; d < b; d++) {
            c[d] = c[2 * d + 1] << 16 | c[2 * d];
        }for (d = b; d < 2 * b; d++) {
            c[d] = 0;
        }return new C(c, 0);
    };
    var Kc = function Kc(a, b) {
        for (; (a[b] & 65535) != a[b];) {
            a[b + 1] += a[b] >>> 16, a[b] &= 65535;
        }
    },
        Ic = function Ic(a, b) {
        if (G(b)) throw Error("division by zero");if (G(a)) return D;if (-1 == a.g) return -1 == b.g ? Ic(E(a), E(b)) : E(Ic(E(a), b));if (-1 == b.g) return E(Ic(a, E(b)));if (30 < a.h.length) {
            if (-1 == a.g || -1 == b.g) throw Error("slowDivide_ only works with positive integers.");for (var c = Ec; 0 >= b.compare(a);) {
                c = c.shiftLeft(1), b = b.shiftLeft(1);
            }var d = Lc(c, 1),
                e = Lc(b, 1),
                f;b = Lc(b, 2);for (c = Lc(c, 2); !G(b);) {
                f = e.add(b), 0 >= f.compare(a) && (d = d.add(c), e = f), b = Lc(b, 1), c = Lc(c, 1);
            }return d;
        }for (c = D; 0 <= a.compare(b);) {
            d = Math.max(1, Math.floor(Gc(a) / Gc(b)));e = Math.ceil(Math.log(d) / Math.LN2);e = 48 >= e ? 1 : Math.pow(2, e - 48);f = F(d);for (var g = f.multiply(b); -1 == g.g || 0 < g.compare(a);) {
                d -= e, f = F(d), g = f.multiply(b);
            }G(f) && (f = Ec);c = c.add(f);a = Jc(a, g);
        }return c;
    },
        Mc = function Mc(a, b) {
        for (var c = Math.max(a.h.length, b.h.length), d = [], e = 0; e < c; e++) {
            d[e] = H(a, e) | H(b, e);
        }return new C(d, a.g | b.g);
    };
    C.prototype.shiftLeft = function (a) {
        var b = a >> 5;a %= 32;for (var c = this.h.length + b + (0 < a ? 1 : 0), d = [], e = 0; e < c; e++) {
            d[e] = 0 < a ? H(this, e - b) << a | H(this, e - b - 1) >>> 32 - a : H(this, e - b);
        }return new C(d, this.g);
    };var Lc = function Lc(a, b) {
        var c = b >> 5;b %= 32;for (var d = a.h.length - c, e = [], f = 0; f < d; f++) {
            e[f] = 0 < b ? H(a, f + c) >>> b | H(a, f + c + 1) << 32 - b : H(a, f + c);
        }return new C(e, a.g);
    };var Nc = function Nc(a, b) {
        this.ob = a;this.ma = b;
    };Nc.prototype.Eb = function (a) {
        return this.ma == a.ma && this.ob.Eb(Va(a.ob));
    };
    var Qc = function Qc(a) {
        try {
            var b;if (b = 0 == a.lastIndexOf("[", 0)) {
                var c = a.length - 1;b = 0 <= c && a.indexOf("]", c) == c;
            }return b ? new Oc(a.substring(1, a.length - 1)) : new Pc(a);
        } catch (d) {
            return null;
        }
    },
        Pc = function Pc(a) {
        var b = D;if (a instanceof C) {
            if (0 != a.g || 0 > a.compare(D) || 0 < a.compare(Rc)) throw Error("The address does not look like an IPv4.");b = Va(a);
        } else {
            if (!Sc.test(a)) throw Error(a + " does not look like an IPv4 address.");var c = a.split(".");if (4 != c.length) throw Error(a + " does not look like an IPv4 address.");for (var d = 0; d < c.length; d++) {
                var e;e = c[d];var f = Number(e);e = 0 == f && /^[\s\xa0]*$/.test(e) ? NaN : f;if (isNaN(e) || 0 > e || 255 < e || 1 != c[d].length && 0 == c[d].lastIndexOf("0", 0)) throw Error("In " + a + ", octet " + d + " is not valid");e = F(e);b = Mc(b.shiftLeft(8), e);
            }
        }Nc.call(this, b, 4);
    };t(Pc, Nc);var Sc = /^[0-9.]*$/,
        Rc = Jc(Ec.shiftLeft(32), Ec);Pc.prototype.toString = function () {
        if (this.Ca) return this.Ca;for (var a = Hc(this.ob, 0), b = [], c = 3; 0 <= c; c--) {
            b[c] = String(a & 255), a >>>= 8;
        }return this.Ca = b.join(".");
    };
    var Oc = function Oc(a) {
        var b = D;if (a instanceof C) {
            if (0 != a.g || 0 > a.compare(D) || 0 < a.compare(Tc)) throw Error("The address does not look like a valid IPv6.");b = Va(a);
        } else {
            if (!Uc.test(a)) throw Error(a + " is not a valid IPv6 address.");var c = a.split(":");if (-1 != c[c.length - 1].indexOf(".")) {
                a = Hc(Va(new Pc(c[c.length - 1]).ob), 0);var d = [];d.push((a >>> 16 & 65535).toString(16));d.push((a & 65535).toString(16));Ja(c, c.length - 1);Pa(c, d);a = c.join(":");
            }d = a.split("::");if (2 < d.length || 1 == d.length && 8 != c.length) throw Error(a + " is not a valid IPv6 address.");if (1 < d.length) {
                c = d[0].split(":");d = d[1].split(":");1 == c.length && "" == c[0] && (c = []);1 == d.length && "" == d[0] && (d = []);var e = 8 - (c.length + d.length);if (1 > e) c = [];else {
                    for (var f = [], g = 0; g < e; g++) {
                        f[g] = "0";
                    }c = Na(c, f, d);
                }
            }if (8 != c.length) throw Error(a + " is not a valid IPv6 address");for (d = 0; d < c.length; d++) {
                e = Dc(c[d], 16);if (0 > e.compare(D) || 0 < e.compare(Vc)) throw Error(c[d] + " in " + a + " is not a valid hextet.");b = Mc(b.shiftLeft(16), e);
            }
        }Nc.call(this, b, 6);
    };t(Oc, Nc);
    var Uc = /^([a-fA-F0-9]*:){2}[a-fA-F0-9:.]*$/,
        Vc = Cc(65535),
        Tc = Jc(Ec.shiftLeft(128), Ec);Oc.prototype.toString = function () {
        if (this.Ca) return this.Ca;for (var a = [], b = 3; 0 <= b; b--) {
            var c = Hc(this.ob, b),
                d = c & 65535;a.push((c >>> 16).toString(16));a.push(d.toString(16));
        }for (var c = b = -1, e = d = 0, f = 0; f < a.length; f++) {
            "0" == a[f] ? (e++, -1 == c && (c = f), e > d && (d = e, b = c)) : (c = -1, e = 0);
        }0 < d && (b + d == a.length && a.push(""), a.splice(b, d, ""), 0 == b && (a = [""].concat(a)));return this.Ca = a.join(":");
    };!gb && !z || z && 9 <= Number(pb) || gb && A("1.9.1");z && A("9");var Xc = function Xc(a, b) {
        Qa(b, function (b, d) {
            "style" == d ? a.style.cssText = b : "class" == d ? a.className = b : "for" == d ? a.htmlFor = b : Wc.hasOwnProperty(d) ? a.setAttribute(Wc[d], b) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, b) : a[d] = b;
        });
    },
        Wc = { cellpadding: "cellPadding", cellspacing: "cellSpacing", colspan: "colSpan", frameborder: "frameBorder", height: "height", maxlength: "maxLength", nonce: "nonce", role: "role", rowspan: "rowSpan", type: "type", usemap: "useMap", valign: "vAlign", width: "width" };var Yc = function Yc(a, b, c) {
        this.pe = c;this.Td = a;this.ye = b;this.Rb = 0;this.Lb = null;
    };Yc.prototype.get = function () {
        var a;0 < this.Rb ? (this.Rb--, a = this.Lb, this.Lb = a.next, a.next = null) : a = this.Td();return a;
    };Yc.prototype.put = function (a) {
        this.ye(a);this.Rb < this.pe && (this.Rb++, a.next = this.Lb, this.Lb = a);
    };var Zc = function Zc(a) {
        l.setTimeout(function () {
            throw a;
        }, 0);
    },
        $c,
        ad = function ad() {
        var a = l.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function a() {
            var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = _r(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (void 0 !== c.next) {
                    c = c.next;var a = c.Xc;c.Xc = null;a();
                }
            };return function (a) {
                d.next = { Xc: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
            var b = document.createElement("SCRIPT");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            l.setTimeout(a, 0);
        };
    };var bd = function bd() {
        this.jc = this.Ja = null;
    },
        dd = new Yc(function () {
        return new cd();
    }, function (a) {
        a.reset();
    }, 100);bd.prototype.add = function (a, b) {
        var c = dd.get();c.set(a, b);this.jc ? this.jc.next = c : (w(!this.Ja), this.Ja = c);this.jc = c;
    };bd.prototype.remove = function () {
        var a = null;this.Ja && (a = this.Ja, this.Ja = this.Ja.next, this.Ja || (this.jc = null), a.next = null);return a;
    };var cd = function cd() {
        this.next = this.scope = this.sc = null;
    };cd.prototype.set = function (a, b) {
        this.sc = a;this.scope = b;this.next = null;
    };
    cd.prototype.reset = function () {
        this.next = this.scope = this.sc = null;
    };var id = function id(a, b) {
        ed || fd();gd || (ed(), gd = !0);hd.add(a, b);
    },
        ed,
        fd = function fd() {
        if (l.Promise && l.Promise.resolve) {
            var a = l.Promise.resolve(void 0);ed = function ed() {
                a.then(jd);
            };
        } else ed = function ed() {
            var a = jd;!p(l.setImmediate) || l.Window && l.Window.prototype && !y("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? ($c || ($c = ad()), $c(a)) : l.setImmediate(a);
        };
    },
        gd = !1,
        hd = new bd(),
        jd = function jd() {
        for (var a; a = hd.remove();) {
            try {
                a.sc.call(a.scope);
            } catch (b) {
                Zc(b);
            }dd.put(a);
        }gd = !1;
    };var kd = function kd(a) {
        a.prototype.then = a.prototype.then;a.prototype.$goog_Thenable = !0;
    },
        ld = function ld(a) {
        if (!a) return !1;try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    };var I = function I(a, b) {
        this.F = 0;this.ka = void 0;this.Ma = this.fa = this.o = null;this.Jb = this.rc = !1;if (a != ba) try {
            var c = this;a.call(b, function (a) {
                md(c, 2, a);
            }, function (a) {
                if (!(a instanceof nd)) try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}md(c, 3, a);
            });
        } catch (d) {
            md(this, 3, d);
        }
    },
        od = function od() {
        this.next = this.context = this.Sa = this.Ea = this.child = null;this.ib = !1;
    };od.prototype.reset = function () {
        this.context = this.Sa = this.Ea = this.child = null;this.ib = !1;
    };
    var pd = new Yc(function () {
        return new od();
    }, function (a) {
        a.reset();
    }, 100),
        qd = function qd(a, b, c) {
        var d = pd.get();d.Ea = a;d.Sa = b;d.context = c;return d;
    },
        J = function J(a) {
        if (a instanceof I) return a;var b = new I(ba);md(b, 2, a);return b;
    },
        K = function K(a) {
        return new I(function (b, c) {
            c(a);
        });
    },
        sd = function sd(a, b, c) {
        rd(a, b, c, null) || id(ja(b, a));
    },
        td = function td(a) {
        return new I(function (b) {
            var c = a.length,
                d = [];if (c) for (var e = function e(a, _e, f) {
                c--;d[a] = _e ? { be: !0, value: f } : { be: !1, reason: f };0 == c && b(d);
            }, f = 0, g; f < a.length; f++) {
                g = a[f], sd(g, ja(e, f, !0), ja(e, f, !1));
            } else b(d);
        });
    };I.prototype.then = function (a, b, c) {
        null != a && Ba(a, "opt_onFulfilled should be a function.");null != b && Ba(b, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return ud(this, p(a) ? a : null, p(b) ? b : null, c);
    };kd(I);var wd = function wd(a, b) {
        b = qd(b, b, void 0);b.ib = !0;vd(a, b);return a;
    };I.prototype.l = function (a, b) {
        return ud(this, null, a, b);
    };I.prototype.cancel = function (a) {
        0 == this.F && id(function () {
            var b = new nd(a);xd(this, b);
        }, this);
    };
    var xd = function xd(a, b) {
        if (0 == a.F) if (a.o) {
            var c = a.o;if (c.fa) {
                for (var d = 0, e = null, f = null, g = c.fa; g && (g.ib || (d++, g.child == a && (e = g), !(e && 1 < d))); g = g.next) {
                    e || (f = g);
                }e && (0 == c.F && 1 == d ? xd(c, b) : (f ? (d = f, w(c.fa), w(null != d), d.next == c.Ma && (c.Ma = d), d.next = d.next.next) : yd(c), zd(c, e, 3, b)));
            }a.o = null;
        } else md(a, 3, b);
    },
        vd = function vd(a, b) {
        a.fa || 2 != a.F && 3 != a.F || Ad(a);w(null != b.Ea);a.Ma ? a.Ma.next = b : a.fa = b;a.Ma = b;
    },
        ud = function ud(a, b, c, d) {
        var e = qd(null, null, null);e.child = new I(function (a, g) {
            e.Ea = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (ra) {
                    g(ra);
                }
            } : a;e.Sa = c ? function (b) {
                try {
                    var e = c.call(d, b);void 0 === e && b instanceof nd ? g(b) : a(e);
                } catch (ra) {
                    g(ra);
                }
            } : g;
        });e.child.o = a;vd(a, e);return e.child;
    };I.prototype.He = function (a) {
        w(1 == this.F);this.F = 0;md(this, 2, a);
    };I.prototype.Ie = function (a) {
        w(1 == this.F);this.F = 0;md(this, 3, a);
    };
    var md = function md(a, b, c) {
        0 == a.F && (a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself")), a.F = 1, rd(c, a.He, a.Ie, a) || (a.ka = c, a.F = b, a.o = null, Ad(a), 3 != b || c instanceof nd || Bd(a, c)));
    },
        rd = function rd(a, b, c, d) {
        if (a instanceof I) return null != b && Ba(b, "opt_onFulfilled should be a function."), null != c && Ba(c, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"), vd(a, qd(b || ba, c || null, d)), !0;if (ld(a)) return a.then(b, c, d), !0;if (ga(a)) try {
            var e = a.then;if (p(e)) return Cd(a, e, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }return !1;
    },
        Cd = function Cd(a, b, c, d, e) {
        var f = !1,
            g = function g(a) {
            f || (f = !0, c.call(e, a));
        },
            k = function k(a) {
            f || (f = !0, d.call(e, a));
        };try {
            b.call(a, g, k);
        } catch (q) {
            k(q);
        }
    },
        Ad = function Ad(a) {
        a.rc || (a.rc = !0, id(a.Xd, a));
    },
        yd = function yd(a) {
        var b = null;a.fa && (b = a.fa, a.fa = b.next, b.next = null);a.fa || (a.Ma = null);null != b && w(null != b.Ea);return b;
    };I.prototype.Xd = function () {
        for (var a; a = yd(this);) {
            zd(this, a, this.F, this.ka);
        }this.rc = !1;
    };
    var zd = function zd(a, b, c, d) {
        if (3 == c && b.Sa && !b.ib) for (; a && a.Jb; a = a.o) {
            a.Jb = !1;
        }if (b.child) b.child.o = null, Dd(b, c, d);else try {
            b.ib ? b.Ea.call(b.context) : Dd(b, c, d);
        } catch (e) {
            Ed.call(null, e);
        }pd.put(b);
    },
        Dd = function Dd(a, b, c) {
        2 == b ? a.Ea.call(a.context, c) : a.Sa && a.Sa.call(a.context, c);
    },
        Bd = function Bd(a, b) {
        a.Jb = !0;id(function () {
            a.Jb && Ed.call(null, b);
        });
    },
        Ed = Zc,
        nd = function nd(a) {
        u.call(this, a);
    };t(nd, u);nd.prototype.name = "cancel"; /*
                                             Portions of this code are from MochiKit, received by
                                             The Closure Authors under the MIT license. All other code is Copyright
                                             2005-2009 The Closure Authors. All Rights Reserved.
                                             */
    var Fd = function Fd(a, b) {
        this.ac = [];this.nd = a;this.Zc = b || null;this.mb = this.Qa = !1;this.ka = void 0;this.Nc = this.Sc = this.mc = !1;this.hc = 0;this.o = null;this.nc = 0;
    };Fd.prototype.cancel = function (a) {
        if (this.Qa) this.ka instanceof Fd && this.ka.cancel();else {
            if (this.o) {
                var b = this.o;delete this.o;a ? b.cancel(a) : (b.nc--, 0 >= b.nc && b.cancel());
            }this.nd ? this.nd.call(this.Zc, this) : this.Nc = !0;this.Qa || Gd(this, new Hd());
        }
    };Fd.prototype.Yc = function (a, b) {
        this.mc = !1;Id(this, a, b);
    };
    var Id = function Id(a, b, c) {
        a.Qa = !0;a.ka = c;a.mb = !b;Jd(a);
    },
        Ld = function Ld(a) {
        if (a.Qa) {
            if (!a.Nc) throw new Kd();a.Nc = !1;
        }
    };Fd.prototype.callback = function (a) {
        Ld(this);Md(a);Id(this, !0, a);
    };
    var Gd = function Gd(a, b) {
        Ld(a);Md(b);Id(a, !1, b);
    },
        Md = function Md(a) {
        w(!(a instanceof Fd), "An execution sequence may not be initiated with a blocking Deferred.");
    },
        Qd = function Qd(a) {
        var b = Nd("https://apis.google.com/js/client.js?onload=" + Od);Pd(b, null, a, void 0);
    },
        Pd = function Pd(a, b, c, d) {
        w(!a.Sc, "Blocking Deferreds can not be re-used");a.ac.push([b, c, d]);a.Qa && Jd(a);
    };Fd.prototype.then = function (a, b, c) {
        var d,
            e,
            f = new I(function (a, b) {
            d = a;e = b;
        });Pd(this, d, function (a) {
            a instanceof Hd ? f.cancel() : e(a);
        });return f.then(a, b, c);
    };
    kd(Fd);
    var Rd = function Rd(a) {
        return Fa(a.ac, function (a) {
            return p(a[1]);
        });
    },
        Jd = function Jd(a) {
        if (a.hc && a.Qa && Rd(a)) {
            var b = a.hc,
                c = Sd[b];c && (l.clearTimeout(c.nb), delete Sd[b]);a.hc = 0;
        }a.o && (a.o.nc--, delete a.o);for (var b = a.ka, d = c = !1; a.ac.length && !a.mc;) {
            var e = a.ac.shift(),
                f = e[0],
                g = e[1],
                e = e[2];if (f = a.mb ? g : f) try {
                var k = f.call(e || a.Zc, b);void 0 !== k && (a.mb = a.mb && (k == b || k instanceof Error), a.ka = b = k);if (ld(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.mc = !0;
            } catch (q) {
                b = q, a.mb = !0, Rd(a) || (c = !0);
            }
        }a.ka = b;d && (k = _r(a.Yc, a, !0), d = _r(a.Yc, a, !1), b instanceof Fd ? (Pd(b, k, d), b.Sc = !0) : b.then(k, d));c && (b = new Td(b), Sd[b.nb] = b, a.hc = b.nb);
    },
        Kd = function Kd() {
        u.call(this);
    };t(Kd, u);Kd.prototype.message = "Deferred has already fired";Kd.prototype.name = "AlreadyCalledError";var Hd = function Hd() {
        u.call(this);
    };t(Hd, u);Hd.prototype.message = "Deferred was canceled";Hd.prototype.name = "CanceledError";var Td = function Td(a) {
        this.nb = l.setTimeout(_r(this.Ge, this), 0);this.J = a;
    };
    Td.prototype.Ge = function () {
        w(Sd[this.nb], "Cannot throw an error that is not scheduled.");delete Sd[this.nb];throw this.J;
    };var Sd = {};var Nd = function Nd(a) {
        var b = new Eb();b.Vb = a;return Ud(b);
    },
        Ud = function Ud(a) {
        var b = {},
            c = b.document || document,
            d;a instanceof Eb && a.constructor === Eb && a.Nd === Db ? d = a.Vb : (ya("expected object of type TrustedResourceUrl, got '" + a + "' of type " + m(a)), d = "type_error:TrustedResourceUrl");var e = document.createElement("SCRIPT");a = { vd: e, wb: void 0 };var f = new Fd(Vd, a),
            g = null,
            k = null != b.timeout ? b.timeout : 5E3;0 < k && (g = window.setTimeout(function () {
            Wd(e, !0);Gd(f, new Xd(1, "Timeout reached for loading script " + d));
        }, k), a.wb = g);e.onload = e.onreadystatechange = function () {
            e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (Wd(e, b.Oe || !1, g), f.callback(null));
        };e.onerror = function () {
            Wd(e, !0, g);Gd(f, new Xd(0, "Error while loading script " + d));
        };a = b.attributes || {};Xa(a, { type: "text/javascript", charset: "UTF-8", src: d });Xc(e, a);Yd(c).appendChild(e);return f;
    },
        Yd = function Yd(a) {
        var b;return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
    },
        Vd = function Vd() {
        if (this && this.vd) {
            var a = this.vd;a && "SCRIPT" == a.tagName && Wd(a, !0, this.wb);
        }
    },
        Wd = function Wd(a, b, c) {
        null != c && l.clearTimeout(c);a.onload = ba;a.onerror = ba;a.onreadystatechange = ba;b && window.setTimeout(function () {
            a && a.parentNode && a.parentNode.removeChild(a);
        }, 0);
    },
        Xd = function Xd(a, b) {
        var c = "Jsloader error (code #" + a + ")";b && (c += ": " + b);u.call(this, c);this.code = a;
    };t(Xd, u);var Zd = function Zd() {
        Lb.call(this);this.Y = new Sb(this);this.Qd = this;this.Cc = null;
    };t(Zd, Lb);Zd.prototype[Ob] = !0;h = Zd.prototype;h.addEventListener = function (a, b, c, d) {
        Yb(this, a, b, c, d);
    };h.removeEventListener = function (a, b, c, d) {
        gc(this, a, b, c, d);
    };
    h.dispatchEvent = function (a) {
        $d(this);var b,
            c = this.Cc;if (c) {
            b = [];for (var d = 1; c; c = c.Cc) {
                b.push(c), w(1E3 > ++d, "infinite loop");
            }
        }c = this.Qd;d = a.type || a;if (n(a)) a = new Mb(a, c);else if (a instanceof Mb) a.target = a.target || c;else {
            var e = a;a = new Mb(d, c);Xa(a, e);
        }var e = !0,
            f;if (b) for (var g = b.length - 1; !a.Va && 0 <= g; g--) {
            f = a.currentTarget = b[g], e = ae(f, d, !0, a) && e;
        }a.Va || (f = a.currentTarget = c, e = ae(f, d, !0, a) && e, a.Va || (e = ae(f, d, !1, a) && e));if (b) for (g = 0; !a.Va && g < b.length; g++) {
            f = a.currentTarget = b[g], e = ae(f, d, !1, a) && e;
        }return e;
    };
    h.Oa = function () {
        Zd.Pc.Oa.call(this);if (this.Y) {
            var a = this.Y,
                b = 0,
                c;for (c in a.w) {
                for (var d = a.w[c], e = 0; e < d.length; e++) {
                    ++b, Rb(d[e]);
                }delete a.w[c];a.xb--;
            }
        }this.Cc = null;
    };h.listen = function (a, b, c, d) {
        $d(this);return this.Y.add(String(a), b, !1, c, d);
    };
    var fc = function fc(a, b, c, d, e) {
        a.Y.add(String(b), c, !0, d, e);
    },
        ae = function ae(a, b, c, d) {
        b = a.Y.w[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
            var g = b[f];if (g && !g.$a && g.Bb == c) {
                var k = g.listener,
                    q = g.Kb || g.src;g.Ab && Ub(a.Y, g);e = !1 !== k.call(q, d) && e;
            }
        }return e && 0 != d.ud;
    };Zd.prototype.tc = function (a, b, c, d) {
        return this.Y.tc(String(a), b, c, d);
    };var $d = function $d(a) {
        w(a.Y, "Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?");
    };var be = "StopIteration" in l ? l.StopIteration : { message: "StopIteration", stack: "" },
        ce = function ce() {};ce.prototype.next = function () {
        throw be;
    };ce.prototype.Pd = function () {
        return this;
    };var de = function de(a, b) {
        this.Z = {};this.s = [];this.ma = this.i = 0;var c = arguments.length;if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
                this.set(arguments[d], arguments[d + 1]);
            }
        } else a && this.addAll(a);
    };h = de.prototype;h.dd = function () {
        return this.i;
    };h.T = function () {
        ee(this);for (var a = [], b = 0; b < this.s.length; b++) {
            a.push(this.Z[this.s[b]]);
        }return a;
    };h.ha = function () {
        ee(this);return this.s.concat();
    };h.jb = function (a) {
        return fe(this.Z, a);
    };
    h.Eb = function (a, b) {
        if (this === a) return !0;if (this.i != a.dd()) return !1;b = b || ge;ee(this);for (var c, d = 0; c = this.s[d]; d++) {
            if (!b(this.get(c), a.get(c))) return !1;
        }return !0;
    };var ge = function ge(a, b) {
        return a === b;
    };de.prototype.remove = function (a) {
        return fe(this.Z, a) ? (delete this.Z[a], this.i--, this.ma++, this.s.length > 2 * this.i && ee(this), !0) : !1;
    };
    var ee = function ee(a) {
        if (a.i != a.s.length) {
            for (var b = 0, c = 0; b < a.s.length;) {
                var d = a.s[b];fe(a.Z, d) && (a.s[c++] = d);b++;
            }a.s.length = c;
        }if (a.i != a.s.length) {
            for (var e = {}, c = b = 0; b < a.s.length;) {
                d = a.s[b], fe(e, d) || (a.s[c++] = d, e[d] = 1), b++;
            }a.s.length = c;
        }
    };h = de.prototype;h.get = function (a, b) {
        return fe(this.Z, a) ? this.Z[a] : b;
    };h.set = function (a, b) {
        fe(this.Z, a) || (this.i++, this.s.push(a), this.ma++);this.Z[a] = b;
    };
    h.addAll = function (a) {
        var b;a instanceof de ? (b = a.ha(), a = a.T()) : (b = Sa(a), a = Ra(a));for (var c = 0; c < b.length; c++) {
            this.set(b[c], a[c]);
        }
    };h.forEach = function (a, b) {
        for (var c = this.ha(), d = 0; d < c.length; d++) {
            var e = c[d],
                f = this.get(e);a.call(b, f, e, this);
        }
    };h.clone = function () {
        return new de(this);
    };h.Pd = function (a) {
        ee(this);var b = 0,
            c = this.ma,
            d = this,
            e = new ce();e.next = function () {
            if (c != d.ma) throw Error("The map has changed since the iterator was created");if (b >= d.s.length) throw be;var e = d.s[b++];return a ? e : d.Z[e];
        };return e;
    };
    var fe = function fe(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    };var he = function he(a) {
        if (a.T && "function" == typeof a.T) return a.T();if (n(a)) return a.split("");if (ea(a)) {
            for (var b = [], c = a.length, d = 0; d < c; d++) {
                b.push(a[d]);
            }return b;
        }return Ra(a);
    },
        ie = function ie(a) {
        if (a.ha && "function" == typeof a.ha) return a.ha();if (!a.T || "function" != typeof a.T) {
            if (ea(a) || n(a)) {
                var b = [];a = a.length;for (var c = 0; c < a; c++) {
                    b.push(c);
                }return b;
            }return Sa(a);
        }
    },
        je = function je(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ea(a) || n(a)) x(a, b, void 0);else for (var c = ie(a), d = he(a), e = d.length, f = 0; f < e; f++) {
            b.call(void 0, d[f], c && c[f], a);
        }
    };var ke = function ke(a, b, c, d, e) {
        this.reset(a, b, c, d, e);
    };ke.prototype.ad = null;var le = 0;ke.prototype.reset = function (a, b, c, d, e) {
        "number" == typeof e || le++;d || ka();this.qb = a;this.re = b;delete this.ad;
    };ke.prototype.yd = function (a) {
        this.qb = a;
    };var me = function me(a) {
        this.se = a;this.fd = this.oc = this.qb = this.o = null;
    },
        ne = function ne(a, b) {
        this.name = a;this.value = b;
    };ne.prototype.toString = function () {
        return this.name;
    };var oe = new ne("SEVERE", 1E3),
        pe = new ne("CONFIG", 700),
        qe = new ne("FINE", 500);me.prototype.getParent = function () {
        return this.o;
    };me.prototype.yd = function (a) {
        this.qb = a;
    };var re = function re(a) {
        if (a.qb) return a.qb;if (a.o) return re(a.o);ya("Root logger has no level set.");return null;
    };
    me.prototype.log = function (a, b, c) {
        if (a.value >= re(this).value) for (p(b) && (b = b()), a = new ke(a, String(b), this.se), c && (a.ad = c), c = "log:" + a.re, l.console && (l.console.timeStamp ? l.console.timeStamp(c) : l.console.markTimeline && l.console.markTimeline(c)), l.msWriteProfilerMark && l.msWriteProfilerMark(c), c = this; c;) {
            b = c;var d = a;if (b.fd) for (var e = 0, f; f = b.fd[e]; e++) {
                f(d);
            }c = c.getParent();
        }
    };
    var se = {},
        te = null,
        ue = function ue(a) {
        te || (te = new me(""), se[""] = te, te.yd(pe));var b;if (!(b = se[a])) {
            b = new me(a);var c = a.lastIndexOf("."),
                d = a.substr(c + 1),
                c = ue(a.substr(0, c));c.oc || (c.oc = {});c.oc[d] = b;b.o = c;se[a] = b;
        }return b;
    };var L = function L(a, b) {
        a && a.log(qe, b, void 0);
    };var ve = function ve(a, b, c) {
        if (p(a)) c && (a = _r(a, c));else if (a && "function" == typeof a.handleEvent) a = _r(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : l.setTimeout(a, b || 0);
    },
        we = function we(a) {
        var b = null;return new I(function (c, d) {
            b = ve(function () {
                c(void 0);
            }, a);-1 == b && d(Error("Failed to schedule timer."));
        }).l(function (a) {
            l.clearTimeout(b);throw a;
        });
    };var xe = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,
        ye = function ye(a, b) {
        if (a) {
            a = a.split("&");for (var c = 0; c < a.length; c++) {
                var d = a[c].indexOf("="),
                    e,
                    f = null;0 <= d ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    };var M = function M(a) {
        Zd.call(this);this.headers = new de();this.lc = a || null;this.oa = !1;this.kc = this.a = null;this.pb = this.ld = this.Qb = "";this.Ba = this.wc = this.Ob = this.qc = !1;this.fb = 0;this.gc = null;this.td = "";this.ic = this.xe = this.Gd = !1;
    };t(M, Zd);var ze = M.prototype,
        Ae = ue("goog.net.XhrIo");ze.P = Ae;var Be = /^https?$/i,
        Ce = ["POST", "PUT"];
    M.prototype.send = function (a, b, c, d) {
        if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.Qb + "; newUri=" + a);b = b ? b.toUpperCase() : "GET";this.Qb = a;this.pb = "";this.ld = b;this.qc = !1;this.oa = !0;this.a = this.lc ? this.lc.Cb() : vc.Cb();this.kc = this.lc ? uc(this.lc) : uc(vc);this.a.onreadystatechange = _r(this.qd, this);this.xe && "onprogress" in this.a && (this.a.onprogress = _r(function (a) {
            this.pd(a, !0);
        }, this), this.a.upload && (this.a.upload.onprogress = _r(this.pd, this)));try {
            L(this.P, De(this, "Opening Xhr")), this.wc = !0, this.a.open(b, String(a), !0), this.wc = !1;
        } catch (f) {
            L(this.P, De(this, "Error opening Xhr: " + f.message));this.J(5, f);return;
        }a = c || "";var e = this.headers.clone();d && je(d, function (a, b) {
            e.set(b, a);
        });d = Ha(e.ha());c = l.FormData && a instanceof l.FormData;!Ia(Ce, b) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");e.forEach(function (a, b) {
            this.a.setRequestHeader(b, a);
        }, this);this.td && (this.a.responseType = this.td);"withCredentials" in this.a && this.a.withCredentials !== this.Gd && (this.a.withCredentials = this.Gd);try {
            Ee(this), 0 < this.fb && (this.ic = Fe(this.a), L(this.P, De(this, "Will abort after " + this.fb + "ms if incomplete, xhr2 " + this.ic)), this.ic ? (this.a.timeout = this.fb, this.a.ontimeout = _r(this.wb, this)) : this.gc = ve(this.wb, this.fb, this)), L(this.P, De(this, "Sending request")), this.Ob = !0, this.a.send(a), this.Ob = !1;
        } catch (f) {
            L(this.P, De(this, "Send error: " + f.message)), this.J(5, f);
        }
    };var Fe = function Fe(a) {
        return z && A(9) && fa(a.timeout) && void 0 !== a.ontimeout;
    },
        Ga = function Ga(a) {
        return "content-type" == a.toLowerCase();
    };
    M.prototype.wb = function () {
        "undefined" != typeof aa && this.a && (this.pb = "Timed out after " + this.fb + "ms, aborting", L(this.P, De(this, this.pb)), this.dispatchEvent("timeout"), this.abort(8));
    };M.prototype.J = function (a, b) {
        this.oa = !1;this.a && (this.Ba = !0, this.a.abort(), this.Ba = !1);this.pb = b;Ge(this);He(this);
    };var Ge = function Ge(a) {
        a.qc || (a.qc = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
    };
    M.prototype.abort = function () {
        this.a && this.oa && (L(this.P, De(this, "Aborting")), this.oa = !1, this.Ba = !0, this.a.abort(), this.Ba = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), He(this));
    };M.prototype.Oa = function () {
        this.a && (this.oa && (this.oa = !1, this.Ba = !0, this.a.abort(), this.Ba = !1), He(this, !0));M.Pc.Oa.call(this);
    };M.prototype.qd = function () {
        this.isDisposed() || (this.wc || this.Ob || this.Ba ? Ie(this) : this.ve());
    };M.prototype.ve = function () {
        Ie(this);
    };
    var Ie = function Ie(a) {
        if (a.oa && "undefined" != typeof aa) if (a.kc[1] && 4 == Je(a) && 2 == Ke(a)) L(a.P, De(a, "Local request error detected and ignored"));else if (a.Ob && 4 == Je(a)) ve(a.qd, 0, a);else if (a.dispatchEvent("readystatechange"), 4 == Je(a)) {
            L(a.P, De(a, "Request complete"));a.oa = !1;try {
                var b = Ke(a),
                    c;a: switch (b) {case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
                        c = !0;break a;default:
                        c = !1;}var d;if (!(d = c)) {
                    var e;if (e = 0 === b) {
                        var f = String(a.Qb).match(xe)[1] || null;if (!f && l.self && l.self.location) var g = l.self.location.protocol,
                            f = g.substr(0, g.length - 1);e = !Be.test(f ? f.toLowerCase() : "");
                    }d = e;
                }if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");else {
                    var k;try {
                        k = 2 < Je(a) ? a.a.statusText : "";
                    } catch (q) {
                        L(a.P, "Can not get status: " + q.message), k = "";
                    }a.pb = k + " [" + Ke(a) + "]";Ge(a);
                }
            } finally {
                He(a);
            }
        }
    };M.prototype.pd = function (a, b) {
        w("progress" === a.type, "goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Le(a, "progress"));this.dispatchEvent(Le(a, b ? "downloadprogress" : "uploadprogress"));
    };
    var Le = function Le(a, b) {
        return { type: b, lengthComputable: a.lengthComputable, loaded: a.loaded, total: a.total };
    },
        He = function He(a, b) {
        if (a.a) {
            Ee(a);var c = a.a,
                d = a.kc[0] ? ba : null;a.a = null;a.kc = null;b || a.dispatchEvent("ready");try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.P) && a.log(oe, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    },
        Ee = function Ee(a) {
        a.a && a.ic && (a.a.ontimeout = null);fa(a.gc) && (l.clearTimeout(a.gc), a.gc = null);
    },
        Je = function Je(a) {
        return a.a ? a.a.readyState : 0;
    },
        Ke = function Ke(a) {
        try {
            return 2 < Je(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    },
        Me = function Me(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return L(a.P, "Can not get responseText: " + b.message), "";
        }
    },
        De = function De(a, b) {
        return b + " [" + a.ld + " " + a.Qb + " " + Ke(a) + "]";
    };var Ne = function Ne(a, b) {
        this.ga = this.Ia = this.la = "";this.Ua = null;this.Aa = this.qa = "";this.M = this.oe = !1;var c;a instanceof Ne ? (this.M = void 0 !== b ? b : a.M, Oe(this, a.la), c = a.Ia, N(this), this.Ia = c, Pe(this, a.ga), Qe(this, a.Ua), Re(this, a.qa), Se(this, a.aa.clone()), a = a.Aa, N(this), this.Aa = a) : a && (c = String(a).match(xe)) ? (this.M = !!b, Oe(this, c[1] || "", !0), a = c[2] || "", N(this), this.Ia = Te(a), Pe(this, c[3] || "", !0), Qe(this, c[4]), Re(this, c[5] || "", !0), Se(this, c[6] || "", !0), a = c[7] || "", N(this), this.Aa = Te(a)) : (this.M = !!b, this.aa = new O(null, 0, this.M));
    };Ne.prototype.toString = function () {
        var a = [],
            b = this.la;b && a.push(Ue(b, Ve, !0), ":");var c = this.ga;if (c || "file" == b) a.push("//"), (b = this.Ia) && a.push(Ue(b, Ve, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.Ua, null != c && a.push(":", String(c));if (c = this.qa) this.ga && "/" != c.charAt(0) && a.push("/"), a.push(Ue(c, "/" == c.charAt(0) ? We : Xe, !0));(c = this.aa.toString()) && a.push("?", c);(c = this.Aa) && a.push("#", Ue(c, Ye));return a.join("");
    };
    Ne.prototype.resolve = function (a) {
        var b = this.clone(),
            c = !!a.la;c ? Oe(b, a.la) : c = !!a.Ia;if (c) {
            var d = a.Ia;N(b);b.Ia = d;
        } else c = !!a.ga;c ? Pe(b, a.ga) : c = null != a.Ua;d = a.qa;if (c) Qe(b, a.Ua);else if (c = !!a.qa) {
            if ("/" != d.charAt(0)) if (this.ga && !this.qa) d = "/" + d;else {
                var e = b.qa.lastIndexOf("/");-1 != e && (d = b.qa.substr(0, e + 1) + d);
            }e = d;if (".." == e || "." == e) d = "";else if (v(e, "./") || v(e, "/.")) {
                for (var d = 0 == e.lastIndexOf("/", 0), e = e.split("/"), f = [], g = 0; g < e.length;) {
                    var k = e[g++];"." == k ? d && g == e.length && f.push("") : ".." == k ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }d = f.join("/");
            } else d = e;
        }c ? Re(b, d) : c = "" !== a.aa.toString();c ? Se(b, Te(a.aa.toString())) : c = !!a.Aa;c && (a = a.Aa, N(b), b.Aa = a);return b;
    };Ne.prototype.clone = function () {
        return new Ne(this);
    };
    var Oe = function Oe(a, b, c) {
        N(a);a.la = c ? Te(b, !0) : b;a.la && (a.la = a.la.replace(/:$/, ""));
    },
        Pe = function Pe(a, b, c) {
        N(a);a.ga = c ? Te(b, !0) : b;
    },
        Qe = function Qe(a, b) {
        N(a);if (b) {
            b = Number(b);if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);a.Ua = b;
        } else a.Ua = null;
    },
        Re = function Re(a, b, c) {
        N(a);a.qa = c ? Te(b, !0) : b;
    },
        Se = function Se(a, b, c) {
        N(a);b instanceof O ? (a.aa = b, a.aa.Mc(a.M)) : (c || (b = Ue(b, Ze)), a.aa = new O(b, 0, a.M));
    },
        P = function P(a, b, c) {
        N(a);a.aa.set(b, c);
    },
        N = function N(a) {
        if (a.oe) throw Error("Tried to modify a read-only Uri");
    };
    Ne.prototype.Mc = function (a) {
        this.M = a;this.aa && this.aa.Mc(a);return this;
    };
    var $e = function $e(a) {
        return a instanceof Ne ? a.clone() : new Ne(a, void 0);
    },
        af = function af(a, b) {
        var c = new Ne(null, void 0);Oe(c, "https");a && Pe(c, a);b && Re(c, b);return c;
    },
        Te = function Te(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    },
        Ue = function Ue(a, b, c) {
        return n(a) ? (a = encodeURI(a).replace(b, bf), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    },
        bf = function bf(a) {
        a = a.charCodeAt(0);return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    },
        Ve = /[#\/\?@]/g,
        Xe = /[\#\?:]/g,
        We = /[\#\?]/g,
        Ze = /[\#\?@]/g,
        Ye = /#/g,
        O = function O(a, b, c) {
        this.i = this.j = null;this.I = a || null;this.M = !!c;
    },
        cf = function cf(a) {
        a.j || (a.j = new de(), a.i = 0, a.I && ye(a.I, function (b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    },
        ef = function ef(a) {
        var b = ie(a);if ("undefined" == typeof b) throw Error("Keys are undefined");var c = new O(null, 0, void 0);a = he(a);for (var d = 0; d < b.length; d++) {
            var e = b[d],
                f = a[d];da(f) ? df(c, e, f) : c.add(e, f);
        }return c;
    };h = O.prototype;h.dd = function () {
        cf(this);return this.i;
    };
    h.add = function (a, b) {
        cf(this);this.I = null;a = this.K(a);var c = this.j.get(a);c || this.j.set(a, c = []);c.push(b);this.i = za(this.i) + 1;return this;
    };h.remove = function (a) {
        cf(this);a = this.K(a);return this.j.jb(a) ? (this.I = null, this.i = za(this.i) - this.j.get(a).length, this.j.remove(a)) : !1;
    };h.jb = function (a) {
        cf(this);a = this.K(a);return this.j.jb(a);
    };h.ha = function () {
        cf(this);for (var a = this.j.T(), b = this.j.ha(), c = [], d = 0; d < b.length; d++) {
            for (var e = a[d], f = 0; f < e.length; f++) {
                c.push(b[d]);
            }
        }return c;
    };
    h.T = function (a) {
        cf(this);var b = [];if (n(a)) this.jb(a) && (b = Ma(b, this.j.get(this.K(a))));else {
            a = this.j.T();for (var c = 0; c < a.length; c++) {
                b = Ma(b, a[c]);
            }
        }return b;
    };h.set = function (a, b) {
        cf(this);this.I = null;a = this.K(a);this.jb(a) && (this.i = za(this.i) - this.j.get(a).length);this.j.set(a, [b]);this.i = za(this.i) + 1;return this;
    };h.get = function (a, b) {
        a = a ? this.T(a) : [];return 0 < a.length ? String(a[0]) : b;
    };var df = function df(a, b, c) {
        a.remove(b);0 < c.length && (a.I = null, a.j.set(a.K(b), Oa(c)), a.i = za(a.i) + c.length);
    };
    O.prototype.toString = function () {
        if (this.I) return this.I;if (!this.j) return "";for (var a = [], b = this.j.ha(), c = 0; c < b.length; c++) {
            for (var d = b[c], e = encodeURIComponent(String(d)), d = this.T(d), f = 0; f < d.length; f++) {
                var g = e;"" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));a.push(g);
            }
        }return this.I = a.join("&");
    };O.prototype.clone = function () {
        var a = new O();a.I = this.I;this.j && (a.j = this.j.clone(), a.i = this.i);return a;
    };O.prototype.K = function (a) {
        a = String(a);this.M && (a = a.toLowerCase());return a;
    };
    O.prototype.Mc = function (a) {
        a && !this.M && (cf(this), this.I = null, this.j.forEach(function (a, c) {
            var d = c.toLowerCase();c != d && (this.remove(c), df(this, d, a));
        }, this));this.M = a;
    };var gf = function gf() {
        var a = ff();return z && !!pb && 11 == pb || /Edge\/\d+/.test(a);
    },
        hf = function hf() {
        return l.window && l.window.location.href || "";
    },
        jf = function jf(a, b) {
        var c = [],
            d;for (d in a) {
            d in b ? _typeof(a[d]) != _typeof(b[d]) ? c.push(d) : da(a[d]) ? Ua(a[d], b[d]) || c.push(d) : "object" == _typeof(a[d]) && null != a[d] && null != b[d] ? 0 < jf(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
        }for (d in b) {
            d in a || c.push(d);
        }return c;
    },
        lf = function lf() {
        var a;a = ff();a = "Chrome" != kf(a) ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;return a && 30 > a ? !1 : !z || !pb || 9 < pb;
    },
        mf = function mf(a) {
        (a || l.window).close();
    },
        nf = function nf(a, b, c) {
        var d = Math.floor(1E9 * Math.random()).toString();b = b || 500;c = c || 600;var e = (window.screen.availHeight - c) / 2,
            f = (window.screen.availWidth - b) / 2;b = { width: b, height: c, top: 0 < e ? e : 0, left: 0 < f ? f : 0, location: !0, resizable: !0, statusbar: !0, toolbar: !1 };d && (b.target = d);"Firefox" == kf(ff()) && (a = a || "http://localhost", b.scrollbars = !0);var g;c = a || "about:blank";(d = b) || (d = {});a = window;b = c instanceof B ? c : Cb("undefined" != typeof c.href ? c.href : String(c));c = d.target || c.target;e = [];for (g in d) {
            switch (g) {case "width":case "height":case "top":case "left":
                    e.push(g + "=" + d[g]);break;case "target":case "noreferrer":
                    break;default:
                    e.push(g + "=" + (d[g] ? 1 : 0));}
        }g = e.join(",");(y("iPhone") && !y("iPod") && !y("iPad") || y("iPad") || y("iPod")) && a.navigator && a.navigator.standalone && c && "_self" != c ? (g = a.document.createElement("A"), b = b instanceof B ? b : Cb(b), g.href = zb(b), g.setAttribute("target", c), d.noreferrer && g.setAttribute("rel", "noreferrer"), d = document.createEvent("MouseEvent"), d.initMouseEvent("click", !0, !0, a, 1), g.dispatchEvent(d), g = {}) : d.noreferrer ? (g = a.open("", c, g), d = zb(b), g && (fb && v(d, ";") && (d = "'" + d.replace(/'/g, "%27") + "'"), g.opener = null, a = new wb(), a.ec = "b/12014412, meta tag with sanitized URL", ua.test(d) && (-1 != d.indexOf("&") && (d = d.replace(na, "&amp;")), -1 != d.indexOf("<") && (d = d.replace(oa, "&lt;")), -1 != d.indexOf(">") && (d = d.replace(pa, "&gt;")), -1 != d.indexOf('"') && (d = d.replace(qa, "&quot;")), -1 != d.indexOf("'") && (d = d.replace(sa, "&#39;")), -1 != d.indexOf("\x00") && (d = d.replace(ta, "&#0;"))), d = '<META HTTP-EQUIV="refresh" content="0; url=' + d + '">', Aa(xb(a), "must provide justification"), w(!/^[\s\xa0]*$/.test(xb(a)), "must provide non-empty justification"), g.document.write(Hb(new Gb().ne(d))), g.document.close())) : g = a.open(zb(b), c, g);if (g) try {
            g.focus();
        } catch (k) {}return g;
    },
        of = function of(a) {
        return new I(function (b) {
            var c = function c() {
                we(2E3).then(function () {
                    if (!a || a.closed) b();else return c();
                });
            };return c();
        });
    },
        pf = function pf() {
        var a = null;return new I(function (b) {
            "complete" == l.document.readyState ? b() : (a = function a() {
                b();
            }, ec(window, "load", a));
        }).l(function (b) {
            gc(window, "load", a);throw b;
        });
    },
        qf = function qf(a) {
        switch (a || l.navigator && l.navigator.product || "") {case "ReactNative":
                return "ReactNative";default:
                return "undefined" !== typeof l.process ? "Node" : "Browser";}
    },
        rf = function rf() {
        var a = qf();return "ReactNative" === a || "Node" === a;
    },
        kf = function kf(a) {
        var b = a.toLowerCase();if (v(b, "opera/") || v(b, "opr/") || v(b, "opios/")) return "Opera";if (v(b, "iemobile")) return "IEMobile";if (v(b, "msie") || v(b, "trident/")) return "IE";if (v(b, "edge/")) return "Edge";if (v(b, "firefox/")) return "Firefox";if (v(b, "silk/")) return "Silk";if (v(b, "blackberry")) return "Blackberry";if (v(b, "webos")) return "Webos";if (!v(b, "safari/") || v(b, "chrome/") || v(b, "crios/") || v(b, "android")) {
            if (!v(b, "chrome/") && !v(b, "crios/") || v(b, "edge/")) {
                if (v(b, "android")) return "Android";if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
            } else return "Chrome";
        } else return "Safari";return "Other";
    },
        sf = function sf(a) {
        var b = qf(void 0);return ("Browser" === b ? kf(ff()) : b) + "/JsCore/" + a;
    },
        ff = function ff() {
        return l.navigator && l.navigator.userAgent || "";
    },
        tf = function tf(a) {
        a = a.split(".");for (var b = l, c = 0; c < a.length && "object" == (typeof b === "undefined" ? "undefined" : _typeof(b)) && null != b; c++) {
            b = b[a[c]];
        }c != a.length && (b = void 0);return b;
    },
        vf = function vf() {
        var a;if (!(a = !l.location || !l.location.protocol || "http:" != l.location.protocol && "https:" != l.location.protocol || rf())) {
            var b;a: {
                try {
                    var c = l.localStorage,
                        d = uf();if (c) {
                        c.setItem(d, "1");c.removeItem(d);b = gf() ? !!l.indexedDB : !0;break a;
                    }
                } catch (e) {}b = !1;
            }a = !b;
        }return !a;
    },
        wf = function wf(a) {
        a = a || ff();var b = (a || ff()).toLowerCase();return b.match(/android/) || b.match(/webos/) || b.match(/iphone|ipad|ipod/) || b.match(/blackberry/) || b.match(/windows phone/) || b.match(/iemobile/) || "Firefox" == kf(a) ? !1 : !0;
    },
        xf = function xf(a) {
        return "undefined" === typeof a ? null : pc(a);
    },
        yf = function yf(a) {
        if (null !== a) {
            var b;try {
                b = mc(a);
            } catch (c) {
                try {
                    b = JSON.parse(a);
                } catch (d) {
                    throw c;
                }
            }return b;
        }
    },
        uf = function uf(a) {
        return a ? a : "" + Math.floor(1E9 * Math.random()).toString();
    },
        zf = function zf() {
        var a = l.___jsl;if (a && a.H) for (var b in a.H) {
            if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for (var c = 0; c < a.CP.length; c++) {
                a.CP[c] = null;
            }
        }
    };var Af;try {
        var Bf = {};Object.defineProperty(Bf, "abcd", { configurable: !0, enumerable: !0, value: 1 });Object.defineProperty(Bf, "abcd", { configurable: !0, enumerable: !0, value: 2 });Af = 2 == Bf.abcd;
    } catch (a) {
        Af = !1;
    }
    var Q = function Q(a, b, c) {
        Af ? Object.defineProperty(a, b, { configurable: !0, enumerable: !0, value: c }) : a[b] = c;
    },
        Cf = function Cf(a, b) {
        if (b) for (var c in b) {
            b.hasOwnProperty(c) && Q(a, c, b[c]);
        }
    },
        Df = function Df(a) {
        var b = {},
            c;for (c in a) {
            a.hasOwnProperty(c) && (b[c] = a[c]);
        }return b;
    },
        Ef = function Ef(a, b) {
        if (!b || !b.length) return !0;if (!a) return !1;for (var c = 0; c < b.length; c++) {
            var d = a[b[c]];if (void 0 === d || null === d || "" === d) return !1;
        }return !0;
    };var Ff = { Hd: { tb: 985, sb: 735, providerId: "facebook.com" }, Id: { tb: 500, sb: 620, providerId: "github.com" }, Jd: { tb: 515, sb: 680, providerId: "google.com" }, Od: { tb: 485, sb: 705, providerId: "twitter.com" } },
        Gf = function Gf(a) {
        for (var b in Ff) {
            if (Ff[b].providerId == a) return Ff[b];
        }return null;
    };var R = function R(a, b) {
        this.code = "auth/" + a;this.message = b || Hf[a] || "";
    };t(R, Error);R.prototype.G = function () {
        return { name: this.code, code: this.code, message: this.message };
    };
    var Hf = {
        "argument-error": "", "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.", "cors-unsupported": "This browser is not supported.", "credential-already-in-use": "This credential is already associated with a different user account.", "custom-token-mismatch": "The custom token corresponds to a different audience.", "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        "email-already-in-use": "The email address is already in use by another account.", "expired-action-code": "The action code has expired. ", "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.", "internal-error": "An internal error has occurred.", "invalid-user-token": "The user's credential is no longer valid. The user must sign in again.", "invalid-auth-event": "An internal error has occurred.", "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
        "invalid-email": "The email address is badly formatted.", "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.", "invalid-credential": "The supplied auth credential is malformed or has expired.", "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.", "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.", "wrong-password": "The password is invalid or the user does not have a password.", "missing-iframe-start": "An internal error has occurred.", "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.", "app-deleted": "This instance of FirebaseApp has been deleted.", "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.", "no-auth-event": "An internal error has occurred.", "no-such-provider": "User was not linked to an account with the given provider.", "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.", "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http or https and web storage must be enabled.',
        "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.", "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.", "provider-already-linked": "User can only be linked to one identity for the given provider.", timeout: "The operation has timed out.", "user-token-expired": "The user's credential is no longer valid. The user must sign in again.", "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
        "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.", "user-disabled": "The user account has been disabled by an administrator.", "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.", "user-signed-out": "", "weak-password": "The password must be 6 characters long or more.", "web-storage-unsupported": "This browser is not supported."
    };var If = function If(a, b, c, d, e) {
        this.ua = a;this.za = b || null;this.hb = c || null;this.bc = d || null;this.J = e || null;if (this.hb || this.J) {
            if (this.hb && this.J) throw new R("invalid-auth-event");if (this.hb && !this.bc) throw new R("invalid-auth-event");
        } else throw new R("invalid-auth-event");
    };If.prototype.getError = function () {
        return this.J;
    };If.prototype.G = function () {
        return { type: this.ua, eventId: this.za, urlResponse: this.hb, sessionId: this.bc, error: this.J && this.J.G() };
    };var Jf = function Jf(a) {
        var b = "unauthorized-domain",
            c = void 0,
            d = $e(a);a = d.ga;d = d.la;"http" != d && "https" != d ? b = "operation-not-supported-in-this-environment" : c = la("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a);R.call(this, b, c);
    };t(Jf, R);var Kf = function Kf(a) {
        this.qe = a.sub;ka();this.Db = a.email || null;
    };var Lf = function Lf(a, b, c, d) {
        var e = {};ga(c) ? e = c : b && n(c) && n(d) ? e = { oauthToken: c, oauthTokenSecret: d } : !b && n(c) && (e = { accessToken: c });if (b || !e.idToken && !e.accessToken) {
            if (b && e.oauthToken && e.oauthTokenSecret) Q(this, "accessToken", e.oauthToken), Q(this, "secret", e.oauthTokenSecret);else {
                if (b) throw new R("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");throw new R("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
            }
        } else e.idToken && Q(this, "idToken", e.idToken), e.accessToken && Q(this, "accessToken", e.accessToken);Q(this, "provider", a);
    };Lf.prototype.Gb = function (a) {
        var b = Mf(this);return S(a, Nf, b);
    };Lf.prototype.md = function (a, b) {
        var c = Mf(this);c.idToken = b;return S(a, Of, c);
    };var Mf = function Mf(a) {
        var b = {};a.idToken && (b.id_token = a.idToken);a.accessToken && (b.access_token = a.accessToken);a.secret && (b.oauth_token_secret = a.secret);b.providerId = a.provider;return { postBody: ef(b).toString(), requestUri: vf() ? hf() : "http://localhost" };
    };
    Lf.prototype.G = function () {
        var a = { provider: this.provider };this.idToken && (a.oauthIdToken = this.idToken);this.accessToken && (a.oauthAccessToken = this.accessToken);this.secret && (a.oauthTokenSecret = this.secret);return a;
    };
    var Pf = function Pf(a, b) {
        var c = !!b;b = function b() {
            Cf(this, { providerId: a, isOAuthProvider: !0 });this.Lc = [];"google.com" == a && this.addScope("profile");
        };c || (b.prototype.addScope = function (a) {
            Ia(this.Lc, a) || this.Lc.push(a);
        });b.prototype.Hb = function () {
            return Oa(this.Lc);
        };b.credential = function (b, e) {
            return new Lf(a, c, b, e);
        };Cf(b, { PROVIDER_ID: a });return b;
    },
        Qf = Pf("facebook.com");Qf.prototype.addScope = Qf.prototype.addScope || void 0;var Rf = Pf("github.com");Rf.prototype.addScope = Rf.prototype.addScope || void 0;var Sf = Pf("google.com");
    Sf.prototype.addScope = Sf.prototype.addScope || void 0;Sf.credential = function (a, b) {
        if (!a && !b) throw new R("argument-error", "credential failed: must provide the ID token and/or the access token.");return new Lf("google.com", !1, ga(a) ? a : { idToken: a || null, accessToken: b || null });
    };var Tf = Pf("twitter.com", !0),
        Uf = function Uf(a, b) {
        this.Db = a;this.Dc = b;Q(this, "provider", "password");
    };Uf.prototype.Gb = function (a) {
        return S(a, Vf, { email: this.Db, password: this.Dc });
    };
    Uf.prototype.md = function (a, b) {
        return S(a, Wf, { idToken: b, email: this.Db, password: this.Dc });
    };Uf.prototype.G = function () {
        return { email: this.Db, password: this.Dc };
    };var Xf = function Xf() {
        Cf(this, { providerId: "password", isOAuthProvider: !1 });
    };Cf(Xf, { PROVIDER_ID: "password" });
    var Yf = { Me: Xf, Hd: Qf, Jd: Sf, Id: Rf, Od: Tf },
        Zf = function Zf(a) {
        var b = a && a.providerId;if (!b) return null;var c = a && a.oauthAccessToken,
            d = a && a.oauthTokenSecret;a = a && a.oauthIdToken;for (var e in Yf) {
            if (Yf[e].PROVIDER_ID == b) try {
                return Yf[e].credential({ accessToken: c, idToken: a, oauthToken: c, oauthTokenSecret: d });
            } catch (f) {
                break;
            }
        }return null;
    };var $f = function $f(a, b, c) {
        R.call(this, "account-exists-with-different-credential", c);Q(this, "email", a);Q(this, "credential", b);
    };t($f, R);$f.prototype.G = function () {
        var a = { code: this.code, message: this.message, email: this.email },
            b = this.credential && this.credential.G();b && (Xa(a, b), a.providerId = b.provider, delete a.provider);return a;
    };var ag = function ag(a) {
        this.Le = a;
    };t(ag, tc);ag.prototype.Cb = function () {
        return new this.Le();
    };ag.prototype.xc = function () {
        return {};
    };
    var T = function T(a, b, c) {
        var d;d = "Node" == qf();d = l.XMLHttpRequest || d && firebase.INTERNAL.node && firebase.INTERNAL.node.XMLHttpRequest;if (!d) throw new R("internal-error", "The XMLHttpRequest compatibility library was not found.");this.v = a;a = b || {};this.Ae = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";this.Be = a.secureTokenTimeout || 1E4;this.wd = Va(a.secureTokenHeaders || bg);this.$d = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.ae = a.firebaseTimeout || 1E4;this.cd = Va(a.firebaseHeaders || cg);c && (this.cd["X-Client-Version"] = c, this.wd["X-Client-Version"] = c);this.Sd = new yc();this.Ke = new ag(d);
    },
        dg,
        bg = { "Content-Type": "application/x-www-form-urlencoded" },
        cg = { "Content-Type": "application/json" },
        fg = function fg(a, b, c, d, e, f, g) {
        lf() ? a = _r(a.De, a) : (dg || (dg = new I(function (a, b) {
            eg(a, b);
        })), a = _r(a.Ce, a));a(b, c, d, e, f, g);
    };
    T.prototype.De = function (a, b, c, d, e, f) {
        var g = "Node" == qf(),
            k = rf() ? g ? new M(this.Ke) : new M() : new M(this.Sd),
            q;f && (k.fb = Math.max(0, f), q = setTimeout(function () {
            k.dispatchEvent("timeout");
        }, f));k.listen("complete", function () {
            q && clearTimeout(q);var a = null;try {
                var c;c = this.a ? mc(this.a.responseText) : void 0;a = c || null;
            } catch (d) {
                try {
                    a = JSON.parse(Me(this)) || null;
                } catch (e) {
                    a = null;
                }
            }b && b(a);
        });fc(k, "ready", function () {
            q && clearTimeout(q);this.ya || (this.ya = !0, this.Oa());
        });fc(k, "timeout", function () {
            q && clearTimeout(q);this.ya || (this.ya = !0, this.Oa());b && b(null);
        });k.send(a, c, d, e);
    };var Od = "__fcb" + Math.floor(1E6 * Math.random()).toString(),
        eg = function eg(a, b) {
        ((window.gapi || {}).client || {}).request ? a() : (l[Od] = function () {
            ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
        }, Qd(function () {
            b(Error("CORS_UNSUPPORTED"));
        }));
    };
    T.prototype.Ce = function (a, b, c, d, e) {
        var f = this;dg.then(function () {
            window.gapi.client.setApiKey(f.v);var g = window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({ path: a, method: c, body: d, headers: e, authType: "none", callback: function callback(a) {
                    window.gapi.auth.setToken(g);b && b(a);
                } });
        }).l(function (a) {
            b && b({ error: { message: a && a.message || "CORS_UNSUPPORTED" } });
        });
    };
    var hg = function hg(a, b) {
        return new I(function (c, d) {
            "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? fg(a, a.Ae + "?key=" + encodeURIComponent(a.v), function (a) {
                a ? a.error ? d(gg(a)) : a.access_token && a.refresh_token ? c(a) : d(new R("internal-error")) : d(new R("network-request-failed"));
            }, "POST", ef(b).toString(), a.wd, a.Be) : d(new R("internal-error"));
        });
    },
        ig = function ig(a) {
        var b = {},
            c;for (c in a) {
            null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
        }return pc(b);
    },
        jg = function jg(a, b, c, d, e) {
        var f = a.$d + b + "?key=" + encodeURIComponent(a.v);e && (f += "&cb=" + ka().toString());return new I(function (b, e) {
            fg(a, f, function (a) {
                a ? a.error ? e(gg(a)) : b(a) : e(new R("network-request-failed"));
            }, c, ig(d), a.cd, a.ae);
        });
    },
        kg = function kg(a) {
        if (!lc.test(a.email)) throw new R("invalid-email");
    },
        lg = function lg(a) {
        "email" in a && kg(a);
    },
        ng = function ng(a, b) {
        var c = vf() ? hf() : "http://localhost";return S(a, mg, { identifier: b, continueUri: c }).then(function (a) {
            return a.allProviders || [];
        });
    },
        pg = function pg(a) {
        return S(a, og, {}).then(function (a) {
            return a.authorizedDomains || [];
        });
    },
        qg = function qg(a) {
        if (!a.idToken) throw new R("internal-error");
    };T.prototype.signInAnonymously = function () {
        return S(this, rg, {});
    };T.prototype.updateEmail = function (a, b) {
        return S(this, sg, { idToken: a, email: b });
    };T.prototype.updatePassword = function (a, b) {
        return S(this, Wf, { idToken: a, password: b });
    };var tg = { displayName: "DISPLAY_NAME", photoUrl: "PHOTO_URL" };
    T.prototype.updateProfile = function (a, b) {
        var c = { idToken: a },
            d = [];Qa(tg, function (a, f) {
            var g = b[f];null === g ? d.push(a) : f in b && (c[f] = g);
        });d.length && (c.deleteAttribute = d);return S(this, sg, c);
    };T.prototype.sendPasswordResetEmail = function (a) {
        return S(this, ug, { requestType: "PASSWORD_RESET", email: a });
    };T.prototype.sendEmailVerification = function (a) {
        return S(this, vg, { requestType: "VERIFY_EMAIL", idToken: a });
    };
    var xg = function xg(a, b, c) {
        return S(a, wg, { idToken: b, deleteProvider: c });
    },
        yg = function yg(a) {
        if (!a.requestUri || !a.sessionId && !a.postBody) throw new R("internal-error");
    },
        zg = function zg(a) {
        if (a.needConfirmation) throw (a && a.email ? new $f(a.email, Zf(a), a.message) : null) || new R("account-exists-with-different-credential");if (!a.idToken) throw new R("internal-error");
    },
        Ag = function Ag(a) {
        if (!a.oobCode) throw new R("invalid-action-code");
    };T.prototype.confirmPasswordReset = function (a, b) {
        return S(this, Bg, { oobCode: a, newPassword: b });
    };
    T.prototype.checkActionCode = function (a) {
        return S(this, Cg, { oobCode: a });
    };T.prototype.applyActionCode = function (a) {
        return S(this, Dg, { oobCode: a });
    };
    var Dg = { endpoint: "setAccountInfo", D: Ag, cb: "email" },
        Cg = { endpoint: "resetPassword", D: Ag, sa: function sa(a) {
            if (!lc.test(a.email)) throw new R("internal-error");
        } },
        Eg = { endpoint: "signupNewUser", D: function D(a) {
            kg(a);if (!a.password) throw new R("weak-password");
        }, sa: qg, ta: !0 },
        mg = { endpoint: "createAuthUri" },
        Fg = { endpoint: "deleteAccount", ab: ["idToken"] },
        wg = { endpoint: "setAccountInfo", ab: ["idToken", "deleteProvider"], D: function D(a) {
            if (!da(a.deleteProvider)) throw new R("internal-error");
        } },
        Gg = { endpoint: "getAccountInfo" },
        vg = { endpoint: "getOobConfirmationCode", ab: ["idToken", "requestType"], D: function D(a) {
            if ("VERIFY_EMAIL" != a.requestType) throw new R("internal-error");
        }, cb: "email" },
        ug = { endpoint: "getOobConfirmationCode", ab: ["requestType"], D: function D(a) {
            if ("PASSWORD_RESET" != a.requestType) throw new R("internal-error");kg(a);
        }, cb: "email" },
        og = { Rd: !0, endpoint: "getProjectConfig", je: "GET" },
        Bg = { endpoint: "resetPassword", D: Ag, cb: "email" },
        sg = { endpoint: "setAccountInfo", ab: ["idToken"], D: lg, ta: !0 },
        Wf = {
        endpoint: "setAccountInfo", ab: ["idToken"],
        D: function D(a) {
            lg(a);if (!a.password) throw new R("weak-password");
        }, sa: qg, ta: !0
    },
        rg = { endpoint: "signupNewUser", sa: qg, ta: !0 },
        Nf = { endpoint: "verifyAssertion", D: yg, sa: zg, ta: !0 },
        Of = { endpoint: "verifyAssertion", D: function D(a) {
            yg(a);if (!a.idToken) throw new R("internal-error");
        }, sa: zg, ta: !0 },
        Hg = { endpoint: "verifyCustomToken", D: function D(a) {
            if (!a.token) throw new R("invalid-custom-token");
        }, sa: qg, ta: !0 },
        Vf = { endpoint: "verifyPassword", D: function D(a) {
            kg(a);if (!a.password) throw new R("wrong-password");
        }, sa: qg, ta: !0 },
        S = function S(a, b, c) {
        if (!Ef(c, b.ab)) return K(new R("internal-error"));var d = b.je || "POST",
            e;return J(c).then(b.D).then(function () {
            b.ta && (c.returnSecureToken = !0);return jg(a, b.endpoint, d, c, b.Rd || !1);
        }).then(function (a) {
            return e = a;
        }).then(b.sa).then(function () {
            if (!b.cb) return e;if (!(b.cb in e)) throw new R("internal-error");return e[b.cb];
        });
    },
        gg = function gg(a) {
        var b, c;c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";var d = { keyInvalid: "invalid-api-key", ipRefererBlocked: "app-not-authorized" };if (c = d[c] ? new R(d[c]) : null) return c;c = a.error && a.error.message || "";d = {
            INVALID_CUSTOM_TOKEN: "invalid-custom-token", CREDENTIAL_MISMATCH: "custom-token-mismatch", MISSING_CUSTOM_TOKEN: "internal-error", INVALID_IDENTIFIER: "invalid-email", MISSING_CONTINUE_URI: "internal-error", INVALID_EMAIL: "invalid-email", INVALID_PASSWORD: "wrong-password", USER_DISABLED: "user-disabled", MISSING_PASSWORD: "internal-error", EMAIL_EXISTS: "email-already-in-use", PASSWORD_LOGIN_DISABLED: "operation-not-allowed", INVALID_IDP_RESPONSE: "invalid-credential",
            FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use", EMAIL_NOT_FOUND: "user-not-found", EXPIRED_OOB_CODE: "expired-action-code", INVALID_OOB_CODE: "invalid-action-code", MISSING_OOB_CODE: "internal-error", CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login", INVALID_ID_TOKEN: "invalid-user-token", TOKEN_EXPIRED: "user-token-expired", USER_NOT_FOUND: "user-token-expired", CORS_UNSUPPORTED: "cors-unsupported", TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests", WEAK_PASSWORD: "weak-password", OPERATION_NOT_ALLOWED: "operation-not-allowed"
        };
        b = (b = c.match(/:\s*(.*)$/)) && 1 < b.length ? b[1] : void 0;for (var e in d) {
            if (0 === c.indexOf(e)) return new R(d[e], b);
        }!b && a && (b = xf(a));return new R("internal-error", b);
    };var Ig = function Ig(a) {
        this.R = a;
    };Ig.prototype.value = function () {
        return this.R;
    };Ig.prototype.zd = function (a) {
        this.R.style = a;return this;
    };var Jg = function Jg(a) {
        this.R = a || {};
    };Jg.prototype.value = function () {
        return this.R;
    };Jg.prototype.zd = function (a) {
        this.R.style = a;return this;
    };var Lg = function Lg(a) {
        this.Je = a;this.vc = null;this.od = Kg(this);
    };Lg.prototype.Bc = function () {
        return this.od;
    };
    var Mg = function Mg(a) {
        var b = new Jg();b.R.where = document.body;b.R.url = a.Je;b.R.messageHandlersFilter = tf("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.R.attributes = b.R.attributes || {};new Ig(b.R.attributes).zd({ position: "absolute", top: "-100px", width: "1px", height: "1px" });b.R.dontclear = !0;return b;
    },
        Kg = function Kg(a) {
        return Ng().then(function () {
            return new I(function (b, c) {
                tf("gapi.iframes.getContext")().open(Mg(a).value(), function (d) {
                    a.vc = d;a.vc.restyle({ setHideOnLeave: !1 });var e = setTimeout(function () {
                        c(Error("Network Error"));
                    }, 5E3),
                        f = function f() {
                        clearTimeout(e);b();
                    };d.ping(f).then(f, function () {
                        c(Error("Network Error"));
                    });
                });
            });
        });
    },
        Og = function Og(a, b) {
        a.od.then(function () {
            a.vc.register("authEvent", b, tf("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
        });
    },
        Pg = "__iframefcb" + Math.floor(1E6 * Math.random()).toString(),
        Ng = function Ng() {
        return new I(function (a, b) {
            var c = function c() {
                zf();tf("gapi.load")("gapi.iframes", { callback: a, ontimeout: function ontimeout() {
                        zf();b(Error("Network Error"));
                    }, timeout: 3E3 });
            };tf("gapi.iframes.Iframe") ? a() : tf("gapi.load") ? c() : (l[Pg] = function () {
                tf("gapi.load") ? c() : b(Error("Network Error"));
            }, J(Nd("https://apis.google.com/js/api.js?onload=" + Pg)).l(function () {
                b(Error("Network Error"));
            }));
        });
    };var Rg = function Rg(a, b, c, d) {
        this.X = a;this.v = b;this.ea = c;d = this.xa = d || null;a = af(a, "/__/auth/iframe");P(a, "apiKey", b);P(a, "appName", c);d && P(a, "v", d);this.ke = a.toString();this.hd = new Lg(this.ke);this.yb = [];Qg(this);
    };Rg.prototype.Bc = function () {
        return this.hd.Bc();
    };
    var Sg = function Sg(a, b, c, d, e, f, g, k, q) {
        a = af(a, "/__/auth/handler");P(a, "apiKey", b);P(a, "appName", c);P(a, "authType", d);P(a, "providerId", e);f && f.length && P(a, "scopes", f.join(","));g && P(a, "redirectUrl", g);k && P(a, "eventId", k);q && P(a, "v", q);return a.toString();
    },
        Qg = function Qg(a) {
        Og(a.hd, function (b) {
            var c = {};if (b && b.authEvent) {
                var d = !1;b = b.authEvent || {};if (b.type) {
                    if (c = b.error) var e = (c = b.error) && (c.name || c.code),
                        c = e ? new R(e.substring(5), c.message) : null;b = new If(b.type, b.eventId, b.urlResponse, b.sessionId, c);
                } else b = null;for (c = 0; c < a.yb.length; c++) {
                    d = a.yb[c](b) || d;
                }c = {};c.status = d ? "ACK" : "ERROR";return J(c);
            }c.status = "ERROR";return J(c);
        });
    },
        Tg = function Tg(a, b) {
        La(a.yb, function (a) {
            return a == b;
        });
    };var Ug = function Ug(a) {
        this.u = a || firebase.INTERNAL.reactNative && firebase.INTERNAL.reactNative.AsyncStorage;if (!this.u) throw new R("internal-error", "The React Native compatibility library was not found.");
    };h = Ug.prototype;h.get = function (a) {
        return J(this.u.getItem(a)).then(function (a) {
            return a && yf(a);
        });
    };h.set = function (a, b) {
        return J(this.u.setItem(a, xf(b)));
    };h.remove = function (a) {
        return J(this.u.removeItem(a));
    };h.Ka = function () {};h.Za = function () {};var Vg = function Vg() {
        this.u = {};
    };h = Vg.prototype;h.get = function (a) {
        return J(this.u[a]);
    };h.set = function (a, b) {
        this.u[a] = b;return J();
    };h.remove = function (a) {
        delete this.u[a];return J();
    };h.Ka = function () {};h.Za = function () {};var Xg = function Xg() {
        if (!Wg()) {
            if ("Node" == qf()) throw new R("internal-error", "The LocalStorage compatibility library was not found.");throw new R("web-storage-unsupported");
        }this.u = l.localStorage || firebase.INTERNAL.node.localStorage;
    },
        Wg = function Wg() {
        var a = "Node" == qf(),
            a = l.localStorage || a && firebase.INTERNAL.node && firebase.INTERNAL.node.localStorage;if (!a) return !1;try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    };h = Xg.prototype;
    h.get = function (a) {
        var b = this;return J().then(function () {
            var c = b.u.getItem(a);return yf(c);
        });
    };h.set = function (a, b) {
        var c = this;return J().then(function () {
            var d = xf(b);null === d ? c.remove(a) : c.u.setItem(a, d);
        });
    };h.remove = function (a) {
        var b = this;return J().then(function () {
            b.u.removeItem(a);
        });
    };h.Ka = function (a) {
        l.window && Yb(l.window, "storage", a);
    };h.Za = function (a) {
        l.window && gc(l.window, "storage", a);
    };var Yg = function Yg() {
        this.u = {};
    };h = Yg.prototype;h.get = function () {
        return J(null);
    };h.set = function () {
        return J();
    };h.remove = function () {
        return J();
    };h.Ka = function () {};h.Za = function () {};var $g = function $g() {
        if (!Zg()) {
            if ("Node" == qf()) throw new R("internal-error", "The SessionStorage compatibility library was not found.");throw new R("web-storage-unsupported");
        }this.u = l.sessionStorage || firebase.INTERNAL.node.sessionStorage;
    },
        Zg = function Zg() {
        var a = "Node" == qf(),
            a = l.sessionStorage || a && firebase.INTERNAL.node && firebase.INTERNAL.node.sessionStorage;if (!a) return !1;try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    };h = $g.prototype;
    h.get = function (a) {
        var b = this;return J().then(function () {
            var c = b.u.getItem(a);return yf(c);
        });
    };h.set = function (a, b) {
        var c = this;return J().then(function () {
            var d = xf(b);null === d ? c.remove(a) : c.u.setItem(a, d);
        });
    };h.remove = function (a) {
        var b = this;return J().then(function () {
            b.u.removeItem(a);
        });
    };h.Ka = function () {};h.Za = function () {};var ah = function ah(a, b, c, d, e, f) {
        if (!window.indexedDB) throw new R("web-storage-unsupported");this.Ud = a;this.Ac = b;this.pc = c;this.Fd = d;this.ma = e;this.O = {};this.ub = [];this.rb = 0;this.le = f || l.indexedDB;
    },
        bh,
        ch = function ch(a) {
        return new I(function (b, c) {
            var d = a.le.open(a.Ud, a.ma);d.onerror = function (a) {
                c(Error(a.target.errorCode));
            };d.onupgradeneeded = function (b) {
                b = b.target.result;try {
                    b.createObjectStore(a.Ac, { keyPath: a.pc });
                } catch (d) {
                    c(d);
                }
            };d.onsuccess = function (a) {
                b(a.target.result);
            };
        });
    },
        dh = function dh(a) {
        a.jd || (a.jd = ch(a));return a.jd;
    },
        eh = function eh(a, b) {
        return b.objectStore(a.Ac);
    },
        fh = function fh(a, b, c) {
        return b.transaction([a.Ac], c ? "readwrite" : "readonly");
    },
        gh = function gh(a) {
        return new I(function (b, c) {
            a.onsuccess = function (a) {
                a && a.target ? b(a.target.result) : b();
            };a.onerror = function (a) {
                c(Error(a.target.errorCode));
            };
        });
    };h = ah.prototype;
    h.set = function (a, b) {
        var c = !1,
            d,
            e = this;return wd(dh(this).then(function (b) {
            d = b;b = eh(e, fh(e, d, !0));return gh(b.get(a));
        }).then(function (f) {
            var g = eh(e, fh(e, d, !0));if (f) return f.value = b, gh(g.put(f));e.rb++;c = !0;f = {};f[e.pc] = a;f[e.Fd] = b;return gh(g.add(f));
        }).then(function () {
            e.O[a] = b;
        }), function () {
            c && e.rb--;
        });
    };h.get = function (a) {
        var b = this;return dh(this).then(function (c) {
            return gh(eh(b, fh(b, c, !1)).get(a));
        }).then(function (a) {
            return a && a.value;
        });
    };
    h.remove = function (a) {
        var b = !1,
            c = this;return wd(dh(this).then(function (d) {
            b = !0;c.rb++;return gh(eh(c, fh(c, d, !0))["delete"](a));
        }).then(function () {
            delete c.O[a];
        }), function () {
            b && c.rb--;
        });
    };
    h.Fe = function () {
        var a = this;return dh(this).then(function (b) {
            var c = eh(a, fh(a, b, !1));return c.getAll ? gh(c.getAll()) : new I(function (a, b) {
                var f = [],
                    g = c.openCursor();g.onsuccess = function (b) {
                    (b = b.target.result) ? (f.push(b.value), b["continue"]()) : a(f);
                };g.onerror = function (a) {
                    b(Error(a.target.errorCode));
                };
            });
        }).then(function (b) {
            var c = {},
                d = [];if (0 == a.rb) {
                for (d = 0; d < b.length; d++) {
                    c[b[d][a.pc]] = b[d][a.Fd];
                }d = jf(a.O, c);a.O = c;
            }return d;
        });
    };h.Ka = function (a) {
        0 == this.ub.length && this.Oc();this.ub.push(a);
    };
    h.Za = function (a) {
        La(this.ub, function (b) {
            return b == a;
        });0 == this.ub.length && this.dc();
    };h.Oc = function () {
        var a = this;this.dc();var b = function b() {
            a.Fc = we(800).then(_r(a.Fe, a)).then(function (b) {
                0 < b.length && x(a.ub, function (a) {
                    a(b);
                });
            }).then(b).l(function (a) {
                "STOP_EVENT" != a.message && b();
            });return a.Fc;
        };b();
    };h.dc = function () {
        this.Fc && this.Fc.cancel("STOP_EVENT");
    };var kh = function kh() {
        this.$c = { Browser: hh, Node: ih, ReactNative: jh }[qf()];
    },
        lh,
        hh = { V: Xg, Qc: $g },
        ih = { V: Xg, Qc: $g },
        jh = { V: Ug, Qc: Yg };var mh = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),
        U = function U(a, b) {
        return { name: a || "", ca: "a valid string", optional: !!b, da: n };
    },
        nh = function nh(a) {
        return { name: a || "", ca: "a valid object", optional: !1, da: ga };
    },
        oh = function oh(a, b) {
        return { name: a || "", ca: "a function", optional: !!b, da: p };
    },
        ph = function ph() {
        return { name: "", ca: "null", optional: !1, da: ca };
    },
        qh = function qh() {
        return { name: "credential", ca: "a valid credential", optional: !1, da: function da(a) {
                return !(!a || !a.Gb);
            } };
    },
        rh = function rh() {
        return {
            name: "authProvider",
            ca: "a valid Auth provider", optional: !1, da: function da(a) {
                return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
            }
        };
    },
        sh = function sh(a, b, c, d) {
        return { name: c || "", ca: a.ca + " or " + b.ca, optional: !!d, da: function da(c) {
                return a.da(c) || b.da(c);
            } };
    };var uh = function uh(a, b) {
        for (var c in b) {
            var d = b[c].name;a[d] = th(d, a[c], b[c].b);
        }
    },
        V = function V(a, b, c, d) {
        a[b] = th(b, c, d);
    },
        th = function th(a, b, c) {
        if (!c) return b;var d = vh(a);a = function a() {
            var a = Array.prototype.slice.call(arguments),
                e;a: {
                e = Array.prototype.slice.call(a);var k;k = 0;for (var q = !1, ra = 0; ra < c.length; ra++) {
                    if (c[ra].optional) q = !0;else {
                        if (q) throw new R("internal-error", "Argument validator encountered a required argument after an optional argument.");k++;
                    }
                }q = c.length;if (e.length < k || q < e.length) e = "Expected " + (k == q ? 1 == k ? "1 argument" : k + " arguments" : k + "-" + q + " arguments") + " but got " + e.length + ".";else {
                    for (k = 0; k < e.length; k++) {
                        if (q = c[k].optional && void 0 === e[k], !c[k].da(e[k]) && !q) {
                            e = c[k];if (0 > k || k >= mh.length) throw new R("internal-error", "Argument validator received an unsupported number of arguments.");e = mh[k] + " argument " + (e.name ? '"' + e.name + '" ' : "") + "must be " + e.ca + ".";break a;
                        }
                    }e = null;
                }
            }if (e) throw new R("argument-error", d + " failed: " + e);return b.apply(this, a);
        };for (var e in b) {
            a[e] = b[e];
        }for (e in b.prototype) {
            a.prototype[e] = b.prototype[e];
        }return a;
    },
        vh = function vh(a) {
        a = a.split(".");return a[a.length - 1];
    };var wh = function wh(a, b, c, d) {
        this.te = a;this.xd = b;this.ze = c;this.eb = d;this.N = {};lh || (lh = new kh());a = lh;try {
            var e;gf() ? (bh || (bh = new ah("firebaseLocalStorageDb", "firebaseLocalStorage", "fbase_key", "value", 1)), e = bh) : e = new a.$c.V();this.Ta = e;
        } catch (f) {
            this.Ta = new Vg(), this.eb = !0;
        }try {
            this.fc = new a.$c.Qc();
        } catch (f) {
            this.fc = new Vg();
        }this.Ad = _r(this.Bd, this);this.O = {};
    },
        xh,
        yh = function yh() {
        xh || (xh = new wh("firebase", ":", "Safari" == kf(ff()) && l.window && l.window != l.window.top ? !0 : !1, wf()));return xh;
    };h = wh.prototype;
    h.K = function (a, b) {
        return this.te + this.xd + a.name + (b ? this.xd + b : "");
    };h.get = function (a, b) {
        return (a.V ? this.Ta : this.fc).get(this.K(a, b));
    };h.remove = function (a, b) {
        b = this.K(a, b);a.V && !this.eb && (this.O[b] = null);return (a.V ? this.Ta : this.fc).remove(b);
    };h.set = function (a, b, c) {
        var d = this.K(a, c),
            e = this,
            f = a.V ? this.Ta : this.fc;return f.set(d, b).then(function () {
            return f.get(d);
        }).then(function (b) {
            a.V && !this.eb && (e.O[d] = b);
        });
    };
    h.addListener = function (a, b, c) {
        a = this.K(a, b);this.eb || (this.O[a] = l.localStorage.getItem(a));Ta(this.N) && this.Oc();this.N[a] || (this.N[a] = []);this.N[a].push(c);
    };h.removeListener = function (a, b, c) {
        a = this.K(a, b);this.N[a] && (La(this.N[a], function (a) {
            return a == c;
        }), 0 == this.N[a].length && delete this.N[a]);Ta(this.N) && this.dc();
    };h.Oc = function () {
        this.Ta.Ka(this.Ad);this.eb || zh(this);
    };
    var zh = function zh(a) {
        Ah(a);a.zc = setInterval(function () {
            for (var b in a.N) {
                var c = l.localStorage.getItem(b);c != a.O[b] && (a.O[b] = c, c = new Nb({ type: "storage", key: b, target: window, oldValue: a.O[b], newValue: c }), a.Bd(c));
            }
        }, 1E3);
    },
        Ah = function Ah(a) {
        a.zc && (clearInterval(a.zc), a.zc = null);
    };wh.prototype.dc = function () {
        this.Ta.Za(this.Ad);this.eb || Ah(this);
    };
    wh.prototype.Bd = function (a) {
        if (a && a.ce) {
            var b = a.kb.key;if (this.ze) {
                var c = l.localStorage.getItem(b);a = a.kb.newValue;a != c && (a ? l.localStorage.setItem(b, a) : a || l.localStorage.removeItem(b));
            }this.O[b] = l.localStorage.getItem(b);this.Vc(b);
        } else x(a, _r(this.Vc, this));
    };wh.prototype.Vc = function (a) {
        this.N[a] && x(this.N[a], function (a) {
            a();
        });
    };var Bh = function Bh(a) {
        this.B = a;this.A = yh();
    },
        Ch = { name: "pendingRedirect", V: !1 },
        Dh = function Dh(a) {
        return a.A.set(Ch, "pending", a.B);
    },
        Eh = function Eh(a) {
        return a.A.remove(Ch, a.B);
    },
        Fh = function Fh(a) {
        return a.A.get(Ch, a.B).then(function (a) {
            return "pending" == a;
        });
    };var Ih = function Ih(a, b, c) {
        var d = this,
            e = (this.xa = firebase.SDK_VERSION || null) ? sf(this.xa) : null;this.f = new T(b, null, e);this.pa = null;this.X = a;this.v = b;this.ea = c;this.vb = [];this.Pb = !1;this.Rc = _r(this.de, this);this.Wa = new Gh(this);this.rd = new Hh(this);this.Ec = new Bh(this.v + ":" + this.ea);this.gb = {};this.gb.unknown = this.Wa;this.gb.signInViaRedirect = this.Wa;this.gb.linkViaRedirect = this.Wa;this.gb.signInViaPopup = this.rd;this.gb.linkViaPopup = this.rd;this.Zb = this.bb = null;this.Tb = new I(function (a, b) {
            d.bb = a;d.Zb = b;
        });
    };
    Ih.prototype.reset = function () {
        var a = this;this.pa = null;this.Tb.cancel();this.Pb = !1;this.Zb = this.bb = null;this.Mb && Tg(this.Mb, this.Rc);this.Tb = new I(function (b, c) {
            a.bb = b;a.Zb = c;
        });
    };
    var Jh = function Jh(a) {
        var b = hf();return pg(a).then(function (a) {
            a: {
                for (var d = $e(b).ga, e = 0; e < a.length; e++) {
                    var f;var g = a[e];f = d;var k = Qc(g);k ? f = (f = Qc(f)) ? k.Eb(f) : !1 : (k = g.split(".").join("\\."), f = new RegExp("^(.+\\." + k + "|" + k + ")$", "i").test(f));if (f) {
                        a = !0;break a;
                    }
                }a = !1;
            }if (!a) throw new Jf(hf());
        });
    },
        Kh = function Kh(a) {
        a.Pb || (a.Pb = !0, pf().then(function () {
            a.Mb = new Rg(a.X, a.v, a.ea, a.xa);a.Mb.Bc().l(function () {
                a.Zb(new R("network-request-failed"));a.reset();
            });a.Mb.yb.push(a.Rc);
        }));return a.Tb;
    };
    Ih.prototype.subscribe = function (a) {
        Ia(this.vb, a) || this.vb.push(a);if (!this.Pb) {
            var b = this,
                c = function c() {
                var a = ff(),
                    c;(c = wf(a)) || (a = a || ff(), c = "Safari" == kf(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0);c ? Lh(b.Wa) : Kh(b);
            };Fh(this.Ec).then(function (a) {
                a ? Eh(b.Ec).then(function () {
                    Kh(b);
                }) : c();
            }).l(function () {
                c();
            });
        }
    };Ih.prototype.unsubscribe = function (a) {
        La(this.vb, function (b) {
            return b == a;
        });
    };
    Ih.prototype.de = function (a) {
        if (!a) throw new R("invalid-auth-event");this.bb && (this.bb(), this.bb = null);for (var b = !1, c = 0; c < this.vb.length; c++) {
            var d = this.vb[c];if (d.Wc(a.ua, a.za)) {
                (b = this.gb[a.ua]) && b.sd(a, d);b = !0;break;
            }
        }Lh(this.Wa);return b;
    };Ih.prototype.getRedirectResult = function () {
        return this.Wa.getRedirectResult();
    };
    var Nh = function Nh(a, b, c, d, e, f) {
        if (!b) return K(new R("popup-blocked"));if (f) return Kh(a), J();a.pa || (a.pa = Jh(a.f));return a.pa.then(function () {
            return Kh(a);
        }).then(function () {
            Mh(d);var f = Sg(a.X, a.v, a.ea, c, d.providerId, d.Hb(), null, e, a.xa);Ib((b || l.window).location, f);
        }).l(function (b) {
            "auth/network-request-failed" == b.code && (a.pa = null);throw b;
        });
    },
        Oh = function Oh(a, b, c, d) {
        a.pa || (a.pa = Jh(a.f));return a.pa.then(function () {
            Mh(c);var e = Sg(a.X, a.v, a.ea, b, c.providerId, c.Hb(), hf(), d, a.xa);Dh(a.Ec).then(function () {
                Ib(l.window.location, e);
            });
        });
    },
        Ph = function Ph(a, b, c, d, e) {
        var f = new R("popup-closed-by-user");return a.Tb.l(function () {}).then(function () {
            return of(d);
        }).then(function () {
            return we(2E3).then(function () {
                b.Ha(c, null, f, e);
            });
        });
    },
        Mh = function Mh(a) {
        if (!a.isOAuthProvider) throw new R("invalid-oauth-provider");
    },
        Qh = {},
        Rh = function Rh(a, b, c) {
        var d = b + ":" + c;Qh[d] || (Qh[d] = new Ih(a, b, c));return Qh[d];
    },
        Gh = function Gh(a) {
        this.A = a;this.Jc = this.Yb = this.Xa = this.W = null;this.Ic = !1;
    };
    Gh.prototype.sd = function (a, b) {
        if (!a) return K(new R("invalid-auth-event"));this.Ic = !0;var c = a.ua,
            d = a.za;"unknown" == c ? (this.W || Sh(this, !1, null, null), a = J()) : a = a.J ? this.Gc(a, b) : b.lb(c, d) ? this.Hc(a, b) : K(new R("invalid-auth-event"));return a;
    };var Lh = function Lh(a) {
        a.Ic || (a.Ic = !0, Sh(a, !1, null, null));
    };Gh.prototype.Gc = function (a) {
        this.W || Sh(this, !0, null, a.getError());return J();
    };
    Gh.prototype.Hc = function (a, b) {
        var c = this,
            d = a.ua;b = b.lb(d, a.za);var e = a.hb;a = a.bc;var f = "signInViaRedirect" == d || "linkViaRedirect" == d;return this.W ? J() : b(e, a).then(function (a) {
            c.W || Sh(c, f, a, null);
        }).l(function (a) {
            c.W || Sh(c, f, null, a);
        });
    };var Sh = function Sh(a, b, c, d) {
        b ? d ? (a.W = function () {
            return K(d);
        }, a.Yb && a.Yb(d)) : (a.W = function () {
            return J(c);
        }, a.Xa && a.Xa(c)) : (a.W = function () {
            return J({ user: null });
        }, a.Xa && a.Xa({ user: null }));a.Xa = null;a.Yb = null;
    };
    Gh.prototype.getRedirectResult = function () {
        var a = this;this.Uc || (this.Uc = new I(function (b, c) {
            a.W ? a.W().then(b, c) : (a.Xa = b, a.Yb = c, Th(a));
        }));return this.Uc;
    };var Th = function Th(a) {
        var b = new R("timeout");a.Jc && a.Jc.cancel();a.Jc = we(1E4).then(function () {
            a.W || Sh(a, !0, null, b);
        });
    },
        Hh = function Hh(a) {
        this.A = a;
    };Hh.prototype.sd = function (a, b) {
        if (!a) return K(new R("invalid-auth-event"));var c = a.ua,
            d = a.za;return a.J ? this.Gc(a, b) : b.lb(c, d) ? this.Hc(a, b) : K(new R("invalid-auth-event"));
    };
    Hh.prototype.Gc = function (a, b) {
        b.Ha(a.ua, null, a.getError(), a.za);return J();
    };Hh.prototype.Hc = function (a, b) {
        var c = a.za,
            d = a.ua;return b.lb(d, c)(a.hb, a.bc).then(function (a) {
            b.Ha(d, a, null, c);
        }).l(function (a) {
            b.Ha(d, null, a, c);
        });
    };var Uh = function Uh(a) {
        this.f = a;this.wa = this.S = null;this.Pa = 0;
    };Uh.prototype.G = function () {
        return { apiKey: this.f.v, refreshToken: this.S, accessToken: this.wa, expirationTime: this.Pa };
    };
    var Wh = function Wh(a, b) {
        var c = b.idToken,
            d = b.refreshToken;b = Vh(b.expiresIn);a.wa = c;a.Pa = b;a.S = d;
    },
        Vh = function Vh(a) {
        return ka() + 1E3 * parseInt(a, 10);
    },
        Xh = function Xh(a, b) {
        return hg(a.f, b).then(function (b) {
            a.wa = b.access_token;a.Pa = Vh(b.expires_in);a.S = b.refresh_token;return { accessToken: a.wa, expirationTime: a.Pa, refreshToken: a.S };
        }).l(function (b) {
            "auth/user-token-expired" == b.code && (a.S = null);throw b;
        });
    },
        Yh = function Yh(a) {
        return !(!a.wa || a.S);
    };
    Uh.prototype.getToken = function (a) {
        a = !!a;return Yh(this) ? K(new R("user-token-expired")) : a || !this.wa || ka() > this.Pa - 3E4 ? this.S ? Xh(this, { grant_type: "refresh_token", refresh_token: this.S }) : J(null) : J({ accessToken: this.wa, expirationTime: this.Pa, refreshToken: this.S });
    };var Zh = function Zh(a, b, c, d, e) {
        Cf(this, { uid: a, displayName: d || null, photoURL: e || null, email: c || null, providerId: b });
    },
        $h = function $h(a, b) {
        Mb.call(this, a);for (var c in b) {
            this[c] = b[c];
        }
    };t($h, Mb);
    var W = function W(a, b, c) {
        this.U = [];this.v = a.apiKey;this.ea = a.appName;this.X = a.authDomain || null;a = firebase.SDK_VERSION ? sf(firebase.SDK_VERSION) : null;this.f = new T(this.v, null, a);this.ba = new Uh(this.f);ai(this, b.idToken);Wh(this.ba, b);Q(this, "refreshToken", this.ba.S);bi(this, c || {});Zd.call(this);this.Ub = !1;this.X && vf() && (this.m = Rh(this.X, this.v, this.ea));this.cc = [];
    };t(W, Zd);
    var ai = function ai(a, b) {
        a.kd = b;Q(a, "_lat", b);
    },
        ci = function ci(a, b) {
        La(a.cc, function (a) {
            return a == b;
        });
    },
        di = function di(a) {
        for (var b = [], c = 0; c < a.cc.length; c++) {
            b.push(a.cc[c](a));
        }return td(b).then(function () {
            return a;
        });
    },
        ei = function ei(a) {
        a.m && !a.Ub && (a.Ub = !0, a.m.subscribe(a));
    },
        bi = function bi(a, b) {
        Cf(a, { uid: b.uid, displayName: b.displayName || null, photoURL: b.photoURL || null, email: b.email || null, emailVerified: b.emailVerified || !1, isAnonymous: b.isAnonymous || !1, providerData: [] });
    };Q(W.prototype, "providerId", "firebase");
    var fi = function fi() {},
        gi = function gi(a) {
        return J().then(function () {
            if (a.Vd) throw new R("app-deleted");
        });
    },
        hi = function hi(a) {
        return Ea(a.providerData, function (a) {
            return a.providerId;
        });
    },
        ji = function ji(a, b) {
        b && (ii(a, b.providerId), a.providerData.push(b));
    },
        ii = function ii(a, b) {
        La(a.providerData, function (a) {
            return a.providerId == b;
        });
    },
        ki = function ki(a, b, c) {
        ("uid" != b || c) && a.hasOwnProperty(b) && Q(a, b, c);
    };
    W.prototype.copy = function (a) {
        var b = this;b != a && (Cf(this, { uid: a.uid, displayName: a.displayName, photoURL: a.photoURL, email: a.email, emailVerified: a.emailVerified, isAnonymous: a.isAnonymous, providerData: [] }), x(a.providerData, function (a) {
            ji(b, a);
        }), this.ba = a.ba, Q(this, "refreshToken", this.ba.S));
    };W.prototype.reload = function () {
        var a = this;return gi(this).then(function () {
            return li(a).then(function () {
                return di(a);
            }).then(fi);
        });
    };
    var li = function li(a) {
        return a.getToken().then(function (b) {
            var c = a.isAnonymous;return mi(a, b).then(function () {
                c || ki(a, "isAnonymous", !1);return b;
            }).l(function (b) {
                "auth/user-token-expired" == b.code && (a.dispatchEvent(new $h("userDeleted")), ni(a));throw b;
            });
        });
    };
    W.prototype.getToken = function (a) {
        var b = this,
            c = Yh(this.ba);return gi(this).then(function () {
            return b.ba.getToken(a);
        }).then(function (a) {
            if (!a) throw new R("internal-error");a.accessToken != b.kd && (ai(b, a.accessToken), b.Da());ki(b, "refreshToken", a.refreshToken);return a.accessToken;
        }).l(function (a) {
            if ("auth/user-token-expired" == a.code && !c) return di(b).then(function () {
                ki(b, "refreshToken", null);throw a;
            });throw a;
        });
    };
    var oi = function oi(a, b) {
        b.idToken && a.kd != b.idToken && (Wh(a.ba, b), a.Da(), ai(a, b.idToken), ki(a, "refreshToken", a.ba.S));
    };W.prototype.Da = function () {
        this.dispatchEvent(new $h("tokenChanged"));
    };var mi = function mi(a, b) {
        return S(a.f, Gg, { idToken: b }).then(_r(a.we, a));
    };
    W.prototype.we = function (a) {
        a = a.users;if (!a || !a.length) throw new R("internal-error");a = a[0];bi(this, { uid: a.localId, displayName: a.displayName, photoURL: a.photoUrl, email: a.email, emailVerified: !!a.emailVerified });for (var b = pi(a), c = 0; c < b.length; c++) {
            ji(this, b[c]);
        }ki(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
    };
    var pi = function pi(a) {
        return (a = a.providerUserInfo) && a.length ? Ea(a, function (a) {
            return new Zh(a.rawId, a.providerId, a.email, a.displayName, a.photoUrl);
        }) : [];
    };W.prototype.reauthenticate = function (a) {
        var b = this;return this.c(a.Gb(this.f).then(function (a) {
            var d;a: {
                var e = a.idToken.split(".");if (3 == e.length) {
                    for (var e = e[1], f = (4 - e.length % 4) % 4, g = 0; g < f; g++) {
                        e += ".";
                    }try {
                        var k = mc(tb(e));if (k.sub && k.iss && k.aud && k.exp) {
                            d = new Kf(k);break a;
                        }
                    } catch (q) {}
                }d = null;
            }if (!d || b.uid != d.qe) throw new R("user-mismatch");oi(b, a);return b.reload();
        }));
    };
    var qi = function qi(a, b) {
        return li(a).then(function () {
            if (Ia(hi(a), b)) return di(a).then(function () {
                throw new R("provider-already-linked");
            });
        });
    };h = W.prototype;h.link = function (a) {
        var b = this;return this.c(qi(this, a.provider).then(function () {
            return b.getToken();
        }).then(function (c) {
            return a.md(b.f, c);
        }).then(_r(this.bd, this)));
    };h.bd = function (a) {
        oi(this, a);var b = this;return this.reload().then(function () {
            return b;
        });
    };
    h.updateEmail = function (a) {
        var b = this;return this.c(this.getToken().then(function (c) {
            return b.f.updateEmail(c, a);
        }).then(function (a) {
            oi(b, a);return b.reload();
        }));
    };h.updatePassword = function (a) {
        var b = this;return this.c(this.getToken().then(function (c) {
            return b.f.updatePassword(c, a);
        }).then(function (a) {
            oi(b, a);return b.reload();
        }));
    };
    h.updateProfile = function (a) {
        if (void 0 === a.displayName && void 0 === a.photoURL) return gi(this);var b = this;return this.c(this.getToken().then(function (c) {
            return b.f.updateProfile(c, { displayName: a.displayName, photoUrl: a.photoURL });
        }).then(function (a) {
            oi(b, a);ki(b, "displayName", a.displayName || null);ki(b, "photoURL", a.photoUrl || null);return di(b);
        }).then(fi));
    };
    h.unlink = function (a) {
        var b = this;return this.c(li(this).then(function (c) {
            return Ia(hi(b), a) ? xg(b.f, c, [a]).then(function (a) {
                var c = {};x(a.providerUserInfo || [], function (a) {
                    c[a.providerId] = !0;
                });x(hi(b), function (a) {
                    c[a] || ii(b, a);
                });return di(b);
            }) : di(b).then(function () {
                throw new R("no-such-provider");
            });
        }));
    };h.delete = function () {
        var a = this;return this.c(this.getToken().then(function (b) {
            return S(a.f, Fg, { idToken: b });
        }).then(function () {
            a.dispatchEvent(new $h("userDeleted"));
        })).then(function () {
            ni(a);
        });
    };
    h.Wc = function (a, b) {
        return "linkViaPopup" == a && (this.ia || null) == b && this.$ || "linkViaRedirect" == a && (this.Xb || null) == b ? !0 : !1;
    };h.Ha = function (a, b, c, d) {
        "linkViaPopup" == a && d == (this.ia || null) && (c && this.Fa ? this.Fa(c) : b && !c && this.$ && this.$(b), this.C && (this.C.cancel(), this.C = null), delete this.$, delete this.Fa);
    };h.lb = function (a, b) {
        return "linkViaPopup" == a && b == (this.ia || null) || "linkViaRedirect" == a && (this.Xb || null) == b ? _r(this.Yd, this) : null;
    };h.Fb = function () {
        return uf(this.uid + ":::");
    };
    h.linkWithPopup = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = Gf(a.providerId),
            d = this.Fb(),
            e = null;!wf() && this.X && a.isOAuthProvider && (e = Sg(this.X, this.v, this.ea, "linkViaPopup", a.providerId, a.Hb(), null, d, firebase.SDK_VERSION || null));var f = nf(e, c && c.tb, c && c.sb),
            c = qi(this, a.providerId).then(function () {
            return di(b);
        }).then(function () {
            ri(b);return b.getToken();
        }).then(function () {
            return Nh(b.m, f, "linkViaPopup", a, d, !!e);
        }).then(function () {
            return new I(function (a, c) {
                b.Ha("linkViaPopup", null, new R("cancelled-popup-request"), b.ia || null);b.$ = a;b.Fa = c;b.ia = d;b.C = Ph(b.m, b, "linkViaPopup", f, d);
            });
        }).then(function (a) {
            f && mf(f);return a;
        }).l(function (a) {
            f && mf(f);throw a;
        });return this.c(c);
    };
    h.linkWithRedirect = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = null,
            d = this.Fb(),
            e = qi(this, a.providerId).then(function () {
            ri(b);return b.getToken();
        }).then(function () {
            b.Xb = d;return di(b);
        }).then(function (a) {
            b.Ga && (a = b.Ga, a = a.A.set(si, b.G(), a.B));return a;
        }).then(function () {
            return Oh(b.m, "linkViaRedirect", a, d);
        }).l(function (a) {
            c = a;if (b.Ga) return ti(b.Ga);throw c;
        }).then(function () {
            if (c) throw c;
        });return this.c(e);
    };
    var ri = function ri(a) {
        if (a.m && a.Ub) return;if (a.m && !a.Ub) throw new R("internal-error");throw new R("auth-domain-config-required");
    };W.prototype.Yd = function (a, b) {
        var c = this;this.C && (this.C.cancel(), this.C = null);var d = null,
            e = this.getToken().then(function (d) {
            return S(c.f, Of, { requestUri: a, sessionId: b, idToken: d });
        }).then(function (a) {
            d = Zf(a);return c.bd(a);
        }).then(function (a) {
            return { user: a, credential: d };
        });return this.c(e);
    };
    W.prototype.sendEmailVerification = function () {
        var a = this;return this.c(this.getToken().then(function (b) {
            return a.f.sendEmailVerification(b);
        }).then(function (b) {
            if (a.email != b) return a.reload();
        }).then(function () {}));
    };var ni = function ni(a) {
        for (var b = 0; b < a.U.length; b++) {
            a.U[b].cancel("app-deleted");
        }a.U = [];a.Vd = !0;Q(a, "refreshToken", null);a.m && a.m.unsubscribe(a);
    };W.prototype.c = function (a) {
        var b = this;this.U.push(a);wd(a, function () {
            Ka(b.U, a);
        });return a;
    };W.prototype.toJSON = function () {
        return this.G();
    };
    W.prototype.G = function () {
        var a = { uid: this.uid, displayName: this.displayName, photoURL: this.photoURL, email: this.email, emailVerified: this.emailVerified, isAnonymous: this.isAnonymous, providerData: [], apiKey: this.v, appName: this.ea, authDomain: this.X, stsTokenManager: this.ba.G(), redirectEventId: this.Xb || null };x(this.providerData, function (b) {
            a.providerData.push(Df(b));
        });return a;
    };
    var ui = function ui(a) {
        if (!a.apiKey) return null;var b = { apiKey: a.apiKey, authDomain: a.authDomain, appName: a.appName },
            c = {};if (a.stsTokenManager && a.stsTokenManager.accessToken && a.stsTokenManager.expirationTime) c.idToken = a.stsTokenManager.accessToken, c.refreshToken = a.stsTokenManager.refreshToken || null, c.expiresIn = (a.stsTokenManager.expirationTime - ka()) / 1E3;else return null;var d = new W(b, c, a);a.providerData && x(a.providerData, function (a) {
            if (a) {
                var b = {};Cf(b, a);ji(d, b);
            }
        });a.redirectEventId && (d.Xb = a.redirectEventId);
        return d;
    },
        vi = function vi(a, b, c) {
        var d = new W(a, b);c && (d.Ga = c);return d.reload().then(function () {
            return d;
        });
    };var wi = function wi(a) {
        this.B = a;this.A = yh();
    },
        si = { name: "redirectUser", V: !1 },
        ti = function ti(a) {
        return a.A.remove(si, a.B);
    },
        xi = function xi(a, b) {
        return a.A.get(si, a.B).then(function (a) {
            a && b && (a.authDomain = b);return ui(a || {});
        });
    };var yi = function yi(a) {
        this.B = a;this.A = yh();
    },
        zi = { name: "authUser", V: !0 },
        Ai = function Ai(a) {
        return a.A.remove(zi, a.B);
    },
        Bi = function Bi(a, b) {
        return a.A.get(zi, a.B).then(function (a) {
            a && b && (a.authDomain = b);return ui(a || {});
        });
    };var Y = function Y(a) {
        this.Na = !1;Q(this, "app", a);if (X(this).options && X(this).options.apiKey) a = firebase.SDK_VERSION ? sf(firebase.SDK_VERSION) : null, this.f = new T(X(this).options && X(this).options.apiKey, null, a);else throw new R("invalid-api-key");this.U = [];this.La = [];this.ue = firebase.INTERNAL.createSubscribe(_r(this.me, this));Ci(this, null);this.va = new yi(X(this).options.apiKey + ":" + X(this).name);this.Ya = new wi(X(this).options.apiKey + ":" + X(this).name);this.zb = this.c(Di(this));this.ra = this.c(Ei(this));this.yc = !1;this.uc = _r(this.Ee, this);this.Dd = _r(this.Ra, this);this.Ed = _r(this.ie, this);this.Cd = _r(this.he, this);Fi(this);this.INTERNAL = {};this.INTERNAL.delete = _r(this.delete, this);
    };Y.prototype.toJSON = function () {
        return { apiKey: X(this).options.apiKey, authDomain: X(this).options.authDomain, appName: X(this).name, currentUser: Z(this) && Z(this).G() };
    };
    var Gi = function Gi(a) {
        return a.Wd || K(new R("auth-domain-config-required"));
    },
        Fi = function Fi(a) {
        var b = X(a).options.authDomain,
            c = X(a).options.apiKey;b && vf() && (a.Wd = a.zb.then(function () {
            if (!a.Na) return a.m = Rh(b, c, X(a).name), a.m.subscribe(a), Z(a) && ei(Z(a)), a.Kc && (ei(a.Kc), a.Kc = null), a.m;
        }));
    };h = Y.prototype;h.Wc = function (a, b) {
        switch (a) {case "unknown":case "signInViaRedirect":
                return !0;case "signInViaPopup":
                return this.ia == b && !!this.$;default:
                return !1;}
    };
    h.Ha = function (a, b, c, d) {
        "signInViaPopup" == a && this.ia == d && (c && this.Fa ? this.Fa(c) : b && !c && this.$ && this.$(b), this.C && (this.C.cancel(), this.C = null), delete this.$, delete this.Fa);
    };h.lb = function (a, b) {
        return "signInViaRedirect" == a || "signInViaPopup" == a && this.ia == b && this.$ ? _r(this.Zd, this) : null;
    };
    h.Zd = function (a, b) {
        var c = this;a = { requestUri: a, sessionId: b };this.C && (this.C.cancel(), this.C = null);var d = null,
            e = S(c.f, Nf, a).then(function (a) {
            d = Zf(a);return a;
        });a = c.zb.then(function () {
            return e;
        }).then(function (a) {
            return Hi(c, a);
        }).then(function () {
            return { user: Z(c), credential: d };
        });return this.c(a);
    };h.Fb = function () {
        return uf();
    };
    h.signInWithPopup = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = Gf(a.providerId),
            d = this.Fb(),
            e = null;!wf() && X(this).options.authDomain && a.isOAuthProvider && (e = Sg(X(this).options.authDomain, X(this).options.apiKey, X(this).name, "signInViaPopup", a.providerId, a.Hb(), null, d, firebase.SDK_VERSION || null));var f = nf(e, c && c.tb, c && c.sb),
            c = Gi(this).then(function (b) {
            return Nh(b, f, "signInViaPopup", a, d, !!e);
        }).then(function () {
            return new I(function (a, c) {
                b.Ha("signInViaPopup", null, new R("cancelled-popup-request"), b.ia);b.$ = a;b.Fa = c;b.ia = d;b.C = Ph(b.m, b, "signInViaPopup", f, d);
            });
        }).then(function (a) {
            f && mf(f);return a;
        }).l(function (a) {
            f && mf(f);throw a;
        });return this.c(c);
    };h.signInWithRedirect = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = Gi(this).then(function () {
            return Oh(b.m, "signInViaRedirect", a);
        });return this.c(c);
    };
    h.getRedirectResult = function () {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var a = this,
            b = Gi(this).then(function () {
            return a.m.getRedirectResult();
        });return this.c(b);
    };
    var Hi = function Hi(a, b) {
        var c = {};c.apiKey = X(a).options.apiKey;c.authDomain = X(a).options.authDomain;c.appName = X(a).name;return a.zb.then(function () {
            return vi(c, b, a.Ya);
        }).then(function (b) {
            if (Z(a) && b.uid == Z(a).uid) return Z(a).copy(b), a.Ra(b);Ci(a, b);ei(b);return a.Ra(b);
        }).then(function () {
            a.Da();
        });
    },
        Ci = function Ci(a, b) {
        Z(a) && (ci(Z(a), a.Dd), gc(Z(a), "tokenChanged", a.Ed), gc(Z(a), "userDeleted", a.Cd));b && (b.cc.push(a.Dd), Yb(b, "tokenChanged", a.Ed), Yb(b, "userDeleted", a.Cd));Q(a, "currentUser", b);
    };
    Y.prototype.signOut = function () {
        var a = this,
            b = this.ra.then(function () {
            if (!Z(a)) return J();Ci(a, null);return Ai(a.va).then(function () {
                a.Da();
            });
        });return this.c(b);
    };
    var Ii = function Ii(a) {
        var b = xi(a.Ya, X(a).options.authDomain).then(function (b) {
            if (a.Kc = b) b.Ga = a.Ya;return ti(a.Ya);
        });return a.c(b);
    },
        Di = function Di(a) {
        var b = X(a).options.authDomain,
            c = Ii(a).then(function () {
            return Bi(a.va, b);
        }).then(function (b) {
            return b ? (b.Ga = a.Ya, b.reload().then(function () {
                return b;
            }).l(function (c) {
                return "auth/network-request-failed" == c.code ? b : Ai(a.va);
            })) : null;
        }).then(function (b) {
            Ci(a, b || null);
        });return a.c(c);
    },
        Ei = function Ei(a) {
        return a.zb.then(function () {
            return a.getRedirectResult();
        }).l(function () {}).then(function () {
            if (!a.Na) return a.uc();
        }).l(function () {}).then(function () {
            if (!a.Na) {
                a.yc = !0;var b = a.va;b.A.addListener(zi, b.B, a.uc);
            }
        });
    };Y.prototype.Ee = function () {
        var a = this;return Bi(this.va, X(this).options.authDomain).then(function (b) {
            if (!a.Na) {
                var c;if (c = Z(a) && b) {
                    c = Z(a).uid;var d = b.uid;c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
                }if (c) return Z(a).copy(b), Z(a).getToken();if (Z(a) || b) Ci(a, b), b && (ei(b), b.Ga = a.Ya), a.m && a.m.subscribe(a), a.Da();
            }
        });
    };Y.prototype.Ra = function (a) {
        var b = this.va;return b.A.set(zi, a.G(), b.B);
    };Y.prototype.ie = function () {
        this.Da();this.Ra(Z(this));
    };
    Y.prototype.he = function () {
        this.signOut();
    };var Ji = function Ji(a, b) {
        return a.c(b.then(function (b) {
            return Hi(a, b);
        }).then(function () {
            return Z(a);
        }));
    };h = Y.prototype;h.me = function (a) {
        var b = this;this.addAuthTokenListener(function () {
            a.next(Z(b));
        });
    };h.onAuthStateChanged = function (a, b, c) {
        var d = this;this.yc && firebase.Promise.resolve().then(function () {
            p(a) ? a(Z(d)) : p(a.next) && a.next(Z(d));
        });return this.ue(a, b, c);
    };
    h.getToken = function (a) {
        var b = this,
            c = this.ra.then(function () {
            return Z(b) ? Z(b).getToken(a).then(function (a) {
                return { accessToken: a };
            }) : null;
        });return this.c(c);
    };h.signInWithCustomToken = function (a) {
        var b = this;return this.ra.then(function () {
            return Ji(b, S(b.f, Hg, { token: a }));
        }).then(function (a) {
            ki(a, "isAnonymous", !1);return b.Ra(a);
        }).then(function () {
            return Z(b);
        });
    };h.signInWithEmailAndPassword = function (a, b) {
        var c = this;return this.ra.then(function () {
            return Ji(c, S(c.f, Vf, { email: a, password: b }));
        });
    };
    h.createUserWithEmailAndPassword = function (a, b) {
        var c = this;return this.ra.then(function () {
            return Ji(c, S(c.f, Eg, { email: a, password: b }));
        });
    };h.signInWithCredential = function (a) {
        var b = this;return this.ra.then(function () {
            return Ji(b, a.Gb(b.f));
        });
    };h.signInAnonymously = function () {
        var a = Z(this),
            b = this;return a && a.isAnonymous ? J(a) : this.ra.then(function () {
            return Ji(b, b.f.signInAnonymously());
        }).then(function (a) {
            ki(a, "isAnonymous", !0);return b.Ra(a);
        }).then(function () {
            return Z(b);
        });
    };
    var X = function X(a) {
        return a.app;
    },
        Z = function Z(a) {
        return a.currentUser;
    };h = Y.prototype;h.Da = function () {
        if (this.yc) for (var a = 0; a < this.La.length; a++) {
            if (this.La[a]) this.La[a](Z(this) && Z(this)._lat || null);
        }
    };h.addAuthTokenListener = function (a) {
        var b = this;this.La.push(a);this.c(this.ra.then(function () {
            b.Na || Ia(b.La, a) && a(Z(b) && Z(b)._lat || null);
        }));
    };h.removeAuthTokenListener = function (a) {
        La(this.La, function (b) {
            return b == a;
        });
    };
    h.delete = function () {
        this.Na = !0;for (var a = 0; a < this.U.length; a++) {
            this.U[a].cancel("app-deleted");
        }this.U = [];this.va && (a = this.va, a.A.removeListener(zi, a.B, this.uc));this.m && this.m.unsubscribe(this);return firebase.Promise.resolve();
    };h.c = function (a) {
        var b = this;this.U.push(a);wd(a, function () {
            Ka(b.U, a);
        });return a;
    };h.fetchProvidersForEmail = function (a) {
        return this.c(ng(this.f, a));
    };h.verifyPasswordResetCode = function (a) {
        return this.checkActionCode(a).then(function (a) {
            return a.data.email;
        });
    };
    h.confirmPasswordReset = function (a, b) {
        return this.c(this.f.confirmPasswordReset(a, b).then(function () {}));
    };h.checkActionCode = function (a) {
        return this.c(this.f.checkActionCode(a).then(function (a) {
            return { data: { email: a.email } };
        }));
    };h.applyActionCode = function (a) {
        return this.c(this.f.applyActionCode(a).then(function () {}));
    };h.sendPasswordResetEmail = function (a) {
        return this.c(this.f.sendPasswordResetEmail(a).then(function () {}));
    };uh(Y.prototype, {
        applyActionCode: { name: "applyActionCode", b: [U("code")] }, checkActionCode: { name: "checkActionCode", b: [U("code")] }, confirmPasswordReset: { name: "confirmPasswordReset", b: [U("code"), U("newPassword")] }, createUserWithEmailAndPassword: { name: "createUserWithEmailAndPassword", b: [U("email"), U("password")] }, fetchProvidersForEmail: { name: "fetchProvidersForEmail", b: [U("email")] }, getRedirectResult: { name: "getRedirectResult", b: [] }, onAuthStateChanged: {
            name: "onAuthStateChanged", b: [sh(nh(), oh(), "nextOrObserver"), oh("opt_error", !0), oh("opt_completed", !0)]
        }, sendPasswordResetEmail: { name: "sendPasswordResetEmail", b: [U("email")] }, signInAnonymously: { name: "signInAnonymously", b: [] }, signInWithCredential: { name: "signInWithCredential", b: [qh()] }, signInWithCustomToken: { name: "signInWithCustomToken", b: [U("token")] }, signInWithEmailAndPassword: { name: "signInWithEmailAndPassword", b: [U("email"), U("password")] }, signInWithPopup: { name: "signInWithPopup", b: [rh()] }, signInWithRedirect: { name: "signInWithRedirect", b: [rh()] }, signOut: {
            name: "signOut",
            b: []
        }, toJSON: { name: "toJSON", b: [U(null, !0)] }, verifyPasswordResetCode: { name: "verifyPasswordResetCode", b: [U("code")] }
    });
    uh(W.prototype, {
        "delete": { name: "delete", b: [] }, getToken: { name: "getToken", b: [{ name: "opt_forceRefresh", ca: "a boolean", optional: !0, da: function da(a) {
                    return "boolean" == typeof a;
                } }] }, link: { name: "link", b: [qh()] }, linkWithPopup: { name: "linkWithPopup", b: [rh()] }, linkWithRedirect: { name: "linkWithRedirect", b: [rh()] }, reauthenticate: { name: "reauthenticate", b: [qh()] }, reload: { name: "reload", b: [] }, sendEmailVerification: { name: "sendEmailVerification", b: [] }, toJSON: { name: "toJSON", b: [U(null, !0)] }, unlink: { name: "unlink", b: [U("provider")] },
        updateEmail: { name: "updateEmail", b: [U("email")] }, updatePassword: { name: "updatePassword", b: [U("password")] }, updateProfile: { name: "updateProfile", b: [nh("profile")] }
    });uh(I.prototype, { l: { name: "catch" }, then: { name: "then" } });V(Xf, "credential", function (a, b) {
        return new Uf(a, b);
    }, [U("email"), U("password")]);uh(Qf.prototype, { addScope: { name: "addScope", b: [U("scope")] } });V(Qf, "credential", Qf.credential, [sh(U(), nh(), "token")]);uh(Rf.prototype, { addScope: { name: "addScope", b: [U("scope")] } });
    V(Rf, "credential", Rf.credential, [sh(U(), nh(), "token")]);uh(Sf.prototype, { addScope: { name: "addScope", b: [U("scope")] } });V(Sf, "credential", Sf.credential, [sh(U(), sh(nh(), ph()), "idToken"), sh(U(), ph(), "accessToken", !0)]);V(Tf, "credential", Tf.credential, [sh(U(), nh(), "token"), U("secret", !0)]);
    (function () {
        if ("undefined" !== typeof firebase && firebase.INTERNAL && firebase.INTERNAL.registerService) {
            var a = { Auth: Y, Error: R };V(a, "EmailAuthProvider", Xf, []);V(a, "FacebookAuthProvider", Qf, []);V(a, "GithubAuthProvider", Rf, []);V(a, "GoogleAuthProvider", Sf, []);V(a, "TwitterAuthProvider", Tf, []);firebase.INTERNAL.registerService("auth", function (a, c) {
                a = new Y(a);c({ INTERNAL: { getToken: _r(a.getToken, a), addAuthTokenListener: _r(a.addAuthTokenListener, a), removeAuthTokenListener: _r(a.removeAuthTokenListener, a) } });return a;
            }, a, function (a, c) {
                if ("create" === a) try {
                    c.auth();
                } catch (d) {}
            });firebase.INTERNAL.extendNamespace({ User: W });
        } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
    })();
})();
(function () {
    var h,
        n = this;function p(a) {
        return void 0 !== a;
    }function aa() {}function ba(a) {
        a.Wb = function () {
            return a.bf ? a.bf : a.bf = new a();
        };
    }
    function ca(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    }function da(a) {
        return "array" == ca(a);
    }function ea(a) {
        var b = ca(a);return "array" == b || "object" == b && "number" == typeof a.length;
    }function q(a) {
        return "string" == typeof a;
    }function fa(a) {
        return "number" == typeof a;
    }function ga(a) {
        return "function" == ca(a);
    }function ha(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && null != a || "function" == b;
    }function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    }function r(a, b, c) {
        r = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;return r.apply(null, arguments);
    }
    function ka(a, b) {
        function c() {}c.prototype = b.prototype;a.Ig = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.Eg = function (a, c, f) {
            for (var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
                g[k - 2] = arguments[k];
            }return b.prototype[c].apply(a, g);
        };
    };function la() {
        this.Ya = -1;
    };function ma() {
        this.Ya = -1;this.Ya = 64;this.N = [];this.Wd = [];this.Jf = [];this.zd = [];this.zd[0] = 128;for (var a = 1; a < this.Ya; ++a) {
            this.zd[a] = 0;
        }this.Pd = this.ac = 0;this.reset();
    }ka(ma, la);ma.prototype.reset = function () {
        this.N[0] = 1732584193;this.N[1] = 4023233417;this.N[2] = 2562383102;this.N[3] = 271733878;this.N[4] = 3285377520;this.Pd = this.ac = 0;
    };
    function na(a, b, c) {
        c || (c = 0);var d = a.Jf;if (q(b)) for (var e = 0; 16 > e; e++) {
            d[e] = b.charCodeAt(c) << 24 | b.charCodeAt(c + 1) << 16 | b.charCodeAt(c + 2) << 8 | b.charCodeAt(c + 3), c += 4;
        } else for (e = 0; 16 > e; e++) {
            d[e] = b[c] << 24 | b[c + 1] << 16 | b[c + 2] << 8 | b[c + 3], c += 4;
        }for (e = 16; 80 > e; e++) {
            var f = d[e - 3] ^ d[e - 8] ^ d[e - 14] ^ d[e - 16];d[e] = (f << 1 | f >>> 31) & 4294967295;
        }b = a.N[0];c = a.N[1];for (var g = a.N[2], k = a.N[3], m = a.N[4], l, e = 0; 80 > e; e++) {
            40 > e ? 20 > e ? (f = k ^ c & (g ^ k), l = 1518500249) : (f = c ^ g ^ k, l = 1859775393) : 60 > e ? (f = c & g | k & (c | g), l = 2400959708) : (f = c ^ g ^ k, l = 3395469782), f = (b << 5 | b >>> 27) + f + m + l + d[e] & 4294967295, m = k, k = g, g = (c << 30 | c >>> 2) & 4294967295, c = b, b = f;
        }a.N[0] = a.N[0] + b & 4294967295;a.N[1] = a.N[1] + c & 4294967295;a.N[2] = a.N[2] + g & 4294967295;a.N[3] = a.N[3] + k & 4294967295;a.N[4] = a.N[4] + m & 4294967295;
    }
    ma.prototype.update = function (a, b) {
        if (null != a) {
            p(b) || (b = a.length);for (var c = b - this.Ya, d = 0, e = this.Wd, f = this.ac; d < b;) {
                if (0 == f) for (; d <= c;) {
                    na(this, a, d), d += this.Ya;
                }if (q(a)) for (; d < b;) {
                    if (e[f] = a.charCodeAt(d), ++f, ++d, f == this.Ya) {
                        na(this, e);f = 0;break;
                    }
                } else for (; d < b;) {
                    if (e[f] = a[d], ++f, ++d, f == this.Ya) {
                        na(this, e);f = 0;break;
                    }
                }
            }this.ac = f;this.Pd += b;
        }
    };function t(a, b) {
        for (var c in a) {
            b.call(void 0, a[c], c, a);
        }
    }function oa(a, b) {
        var c = {},
            d;for (d in a) {
            c[d] = b.call(void 0, a[d], d, a);
        }return c;
    }function pa(a, b) {
        for (var c in a) {
            if (!b.call(void 0, a[c], c, a)) return !1;
        }return !0;
    }function qa(a) {
        var b = 0,
            c;for (c in a) {
            b++;
        }return b;
    }function ra(a) {
        for (var b in a) {
            return b;
        }
    }function sa(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = a[d];
        }return b;
    }function ta(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = d;
        }return b;
    }function ua(a, b) {
        for (var c in a) {
            if (a[c] == b) return !0;
        }return !1;
    }
    function va(a, b, c) {
        for (var d in a) {
            if (b.call(c, a[d], d, a)) return d;
        }
    }function wa(a, b) {
        var c = va(a, b, void 0);return c && a[c];
    }function xa(a) {
        for (var b in a) {
            return !1;
        }return !0;
    }function ya(a) {
        var b = {},
            c;for (c in a) {
            b[c] = a[c];
        }return b;
    };function za(a) {
        a = String(a);if (/^\s*$/.test(a) ? 0 : /^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g, "@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, ""))) try {
            return eval("(" + a + ")");
        } catch (b) {}throw Error("Invalid JSON string: " + a);
    }function Aa() {
        this.Fd = void 0;
    }
    function Ba(a, b, c) {
        switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {
            case "string":
                Ca(b, c);break;case "number":
                c.push(isFinite(b) && !isNaN(b) ? b : "null");break;case "boolean":
                c.push(b);break;case "undefined":
                c.push("null");break;case "object":
                if (null == b) {
                    c.push("null");break;
                }if (da(b)) {
                    var d = b.length;c.push("[");for (var e = "", f = 0; f < d; f++) {
                        c.push(e), e = b[f], Ba(a, a.Fd ? a.Fd.call(b, String(f), e) : e, c), e = ",";
                    }c.push("]");break;
                }c.push("{");d = "";for (f in b) {
                    Object.prototype.hasOwnProperty.call(b, f) && (e = b[f], "function" != typeof e && (c.push(d), Ca(f, c), c.push(":"), Ba(a, a.Fd ? a.Fd.call(b, f, e) : e, c), d = ","));
                }c.push("}");break;case "function":
                break;default:
                throw Error("Unknown type: " + (typeof b === "undefined" ? "undefined" : _typeof(b)));
        }
    }var Da = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": "\\u000b" },
        Ea = /\uffff/.test("\uFFFF") ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g;
    function Ca(a, b) {
        b.push('"', a.replace(Ea, function (a) {
            if (a in Da) return Da[a];var b = a.charCodeAt(0),
                e = "\\u";16 > b ? e += "000" : 256 > b ? e += "00" : 4096 > b && (e += "0");return Da[a] = e + b.toString(16);
        }), '"');
    };var v;a: {
        var Fa = n.navigator;if (Fa) {
            var Ga = Fa.userAgent;if (Ga) {
                v = Ga;break a;
            }
        }v = "";
    };function Ha(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, Ha);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    }ka(Ha, Error);Ha.prototype.name = "CustomError";var w = Array.prototype,
        Ia = w.indexOf ? function (a, b, c) {
        return w.indexOf.call(a, b, c);
    } : function (a, b, c) {
        c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (q(a)) return q(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
            if (c in a && a[c] === b) return c;
        }return -1;
    },
        Ja = w.forEach ? function (a, b, c) {
        w.forEach.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            f in e && b.call(c, e[f], f, a);
        }
    },
        Ka = w.filter ? function (a, b, c) {
        return w.filter.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = [], f = 0, g = q(a) ? a.split("") : a, k = 0; k < d; k++) {
            if (k in g) {
                var m = g[k];b.call(c, m, k, a) && (e[f++] = m);
            }
        }return e;
    },
        La = w.map ? function (a, b, c) {
        return w.map.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = Array(d), f = q(a) ? a.split("") : a, g = 0; g < d; g++) {
            g in f && (e[g] = b.call(c, f[g], g, a));
        }return e;
    },
        Ma = w.reduce ? function (a, b, c, d) {
        for (var e = [], f = 1, g = arguments.length; f < g; f++) {
            e.push(arguments[f]);
        }d && (e[0] = r(b, d));return w.reduce.apply(a, e);
    } : function (a, b, c, d) {
        var e = c;Ja(a, function (c, g) {
            e = b.call(d, e, c, g, a);
        });return e;
    },
        Na = w.every ? function (a, b, c) {
        return w.every.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && !b.call(c, e[f], f, a)) return !1;
        }return !0;
    };function Oa(a, b) {
        var c = Pa(a, b, void 0);return 0 > c ? null : q(a) ? a.charAt(c) : a[c];
    }function Pa(a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && b.call(c, e[f], f, a)) return f;
        }return -1;
    }function Qa(a, b) {
        var c = Ia(a, b);0 <= c && w.splice.call(a, c, 1);
    }function Ra(a, b, c) {
        return 2 >= arguments.length ? w.slice.call(a, b) : w.slice.call(a, b, c);
    }
    function Sa(a, b) {
        a.sort(b || Ta);
    }function Ta(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    };var Ua = -1 != v.indexOf("Opera") || -1 != v.indexOf("OPR"),
        Va = -1 != v.indexOf("Trident") || -1 != v.indexOf("MSIE"),
        Wa = -1 != v.indexOf("Gecko") && -1 == v.toLowerCase().indexOf("webkit") && !(-1 != v.indexOf("Trident") || -1 != v.indexOf("MSIE")),
        Xa = -1 != v.toLowerCase().indexOf("webkit");
    (function () {
        var a = "",
            b;if (Ua && n.opera) return a = n.opera.version, ga(a) ? a() : a;Wa ? b = /rv\:([^\);]+)(\)|;)/ : Va ? b = /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/ : Xa && (b = /WebKit\/(\S+)/);b && (a = (a = b.exec(v)) ? a[1] : "");return Va && (b = (b = n.document) ? b.documentMode : void 0, b > parseFloat(a)) ? String(b) : a;
    })();var Ya = null,
        Za = null,
        $a = null;function ab(a, b) {
        if (!ea(a)) throw Error("encodeByteArray takes an array as a parameter");bb();for (var c = b ? Za : Ya, d = [], e = 0; e < a.length; e += 3) {
            var f = a[e],
                g = e + 1 < a.length,
                k = g ? a[e + 1] : 0,
                m = e + 2 < a.length,
                l = m ? a[e + 2] : 0,
                u = f >> 2,
                f = (f & 3) << 4 | k >> 4,
                k = (k & 15) << 2 | l >> 6,
                l = l & 63;m || (l = 64, g || (k = 64));d.push(c[u], c[f], c[k], c[l]);
        }return d.join("");
    }
    function bb() {
        if (!Ya) {
            Ya = {};Za = {};$a = {};for (var a = 0; 65 > a; a++) {
                Ya[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a), Za[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a), $a[Za[a]] = a, 62 <= a && ($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)] = a);
            }
        }
    };function cb(a) {
        n.setTimeout(function () {
            throw a;
        }, 0);
    }var db;
    function eb() {
        var a = n.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && -1 == v.indexOf("Presto") && (a = function a() {
            var a = document.createElement("iframe");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = r(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && -1 == v.indexOf("Trident") && -1 == v.indexOf("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (p(c.next)) {
                    c = c.next;var a = c.Le;c.Le = null;a();
                }
            };return function (a) {
                d.next = { Le: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("script") ? function (a) {
            var b = document.createElement("script");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            n.setTimeout(a, 0);
        };
    };function fb(a, b) {
        gb || hb();ib || (gb(), ib = !0);jb.push(new kb(a, b));
    }var gb;function hb() {
        if (n.Promise && n.Promise.resolve) {
            var a = n.Promise.resolve();gb = function gb() {
                a.then(lb);
            };
        } else gb = function gb() {
            var a = lb;!ga(n.setImmediate) || n.Window && n.Window.prototype && n.Window.prototype.setImmediate == n.setImmediate ? (db || (db = eb()), db(a)) : n.setImmediate(a);
        };
    }var ib = !1,
        jb = [];[].push(function () {
        ib = !1;jb = [];
    });
    function lb() {
        for (; jb.length;) {
            var a = jb;jb = [];for (var b = 0; b < a.length; b++) {
                var c = a[b];try {
                    c.Wf.call(c.scope);
                } catch (d) {
                    cb(d);
                }
            }
        }ib = !1;
    }function kb(a, b) {
        this.Wf = a;this.scope = b;
    };function mb(a, b) {
        this.L = nb;this.uf = void 0;this.Ca = this.Ha = null;this.jd = this.be = !1;if (a == ob) pb(this, qb, b);else try {
            var c = this;a.call(b, function (a) {
                pb(c, qb, a);
            }, function (a) {
                if (!(a instanceof rb)) try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}pb(c, sb, a);
            });
        } catch (d) {
            pb(this, sb, d);
        }
    }var nb = 0,
        qb = 2,
        sb = 3;function ob() {}mb.prototype.then = function (a, b, c) {
        return tb(this, ga(a) ? a : null, ga(b) ? b : null, c);
    };mb.prototype.then = mb.prototype.then;mb.prototype.$goog_Thenable = !0;h = mb.prototype;
    h.Ag = function (a, b) {
        return tb(this, null, a, b);
    };h.cancel = function (a) {
        this.L == nb && fb(function () {
            var b = new rb(a);ub(this, b);
        }, this);
    };function ub(a, b) {
        if (a.L == nb) if (a.Ha) {
            var c = a.Ha;if (c.Ca) {
                for (var d = 0, e = -1, f = 0, g; g = c.Ca[f]; f++) {
                    if (g = g.m) if (d++, g == a && (e = f), 0 <= e && 1 < d) break;
                }0 <= e && (c.L == nb && 1 == d ? ub(c, b) : (d = c.Ca.splice(e, 1)[0], vb(c, d, sb, b)));
            }a.Ha = null;
        } else pb(a, sb, b);
    }function wb(a, b) {
        a.Ca && a.Ca.length || a.L != qb && a.L != sb || xb(a);a.Ca || (a.Ca = []);a.Ca.push(b);
    }
    function tb(a, b, c, d) {
        var e = { m: null, hf: null, kf: null };e.m = new mb(function (a, g) {
            e.hf = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (l) {
                    g(l);
                }
            } : a;e.kf = c ? function (b) {
                try {
                    var e = c.call(d, b);!p(e) && b instanceof rb ? g(b) : a(e);
                } catch (l) {
                    g(l);
                }
            } : g;
        });e.m.Ha = a;wb(a, e);return e.m;
    }h.Cf = function (a) {
        this.L = nb;pb(this, qb, a);
    };h.Df = function (a) {
        this.L = nb;pb(this, sb, a);
    };
    function pb(a, b, c) {
        if (a.L == nb) {
            if (a == c) b = sb, c = new TypeError("Promise cannot resolve to itself");else {
                var d;if (c) try {
                    d = !!c.$goog_Thenable;
                } catch (e) {
                    d = !1;
                } else d = !1;if (d) {
                    a.L = 1;c.then(a.Cf, a.Df, a);return;
                }if (ha(c)) try {
                    var f = c.then;if (ga(f)) {
                        yb(a, c, f);return;
                    }
                } catch (g) {
                    b = sb, c = g;
                }
            }a.uf = c;a.L = b;a.Ha = null;xb(a);b != sb || c instanceof rb || zb(a, c);
        }
    }function yb(a, b, c) {
        function d(b) {
            f || (f = !0, a.Df(b));
        }function e(b) {
            f || (f = !0, a.Cf(b));
        }a.L = 1;var f = !1;try {
            c.call(b, e, d);
        } catch (g) {
            d(g);
        }
    }
    function xb(a) {
        a.be || (a.be = !0, fb(a.Uf, a));
    }h.Uf = function () {
        for (; this.Ca && this.Ca.length;) {
            var a = this.Ca;this.Ca = null;for (var b = 0; b < a.length; b++) {
                vb(this, a[b], this.L, this.uf);
            }
        }this.be = !1;
    };function vb(a, b, c, d) {
        if (c == qb) b.hf(d);else {
            if (b.m) for (; a && a.jd; a = a.Ha) {
                a.jd = !1;
            }b.kf(d);
        }
    }function zb(a, b) {
        a.jd = !0;fb(function () {
            a.jd && Ab.call(null, b);
        });
    }var Ab = cb;function rb(a) {
        Ha.call(this, a);
    }ka(rb, Ha);rb.prototype.name = "cancel";function Bb(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }function x(a, b) {
        if (Object.prototype.hasOwnProperty.call(a, b)) return a[b];
    }function Cb(a, b) {
        for (var c in a) {
            Object.prototype.hasOwnProperty.call(a, c) && b(c, a[c]);
        }
    };function y(a, b, c, d) {
        var e;d < b ? e = "at least " + b : d > c && (e = 0 === c ? "none" : "no more than " + c);if (e) throw Error(a + " failed: Was called with " + d + (1 === d ? " argument." : " arguments.") + " Expects " + e + ".");
    }function Db(a, b, c) {
        var d = "";switch (b) {case 1:
                d = c ? "first" : "First";break;case 2:
                d = c ? "second" : "Second";break;case 3:
                d = c ? "third" : "Third";break;case 4:
                d = c ? "fourth" : "Fourth";break;default:
                throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a = a + " failed: " + (d + " argument ");
    }
    function A(a, b, c, d) {
        if ((!d || p(c)) && !ga(c)) throw Error(Db(a, b, d) + "must be a valid function.");
    }function Eb(a, b, c) {
        if (p(c) && (!ha(c) || null === c)) throw Error(Db(a, b, !0) + "must be a valid context object.");
    };function Fb(a) {
        var b = [];Cb(a, function (a, d) {
            da(d) ? Ja(d, function (d) {
                b.push(encodeURIComponent(a) + "=" + encodeURIComponent(d));
            }) : b.push(encodeURIComponent(a) + "=" + encodeURIComponent(d));
        });return b.length ? "&" + b.join("&") : "";
    };var Gb = n.Promise || mb;mb.prototype["catch"] = mb.prototype.Ag;function Hb() {
        var a = this;this.reject = this.resolve = null;this.ra = new Gb(function (b, c) {
            a.resolve = b;a.reject = c;
        });
    }function Ib(a, b) {
        return function (c, d) {
            c ? a.reject(c) : a.resolve(d);ga(b) && (Jb(a.ra), 1 === b.length ? b(c) : b(c, d));
        };
    }function Jb(a) {
        a.then(void 0, aa);
    };function Kb(a, b) {
        if (!a) throw Lb(b);
    }function Lb(a) {
        return Error("Firebase Database (" + firebase.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + a);
    };function Mb(a) {
        for (var b = [], c = 0, d = 0; d < a.length; d++) {
            var e = a.charCodeAt(d);55296 <= e && 56319 >= e && (e -= 55296, d++, Kb(d < a.length, "Surrogate pair missing trail surrogate."), e = 65536 + (e << 10) + (a.charCodeAt(d) - 56320));128 > e ? b[c++] = e : (2048 > e ? b[c++] = e >> 6 | 192 : (65536 > e ? b[c++] = e >> 12 | 224 : (b[c++] = e >> 18 | 240, b[c++] = e >> 12 & 63 | 128), b[c++] = e >> 6 & 63 | 128), b[c++] = e & 63 | 128);
        }return b;
    }function Nb(a) {
        for (var b = 0, c = 0; c < a.length; c++) {
            var d = a.charCodeAt(c);128 > d ? b++ : 2048 > d ? b += 2 : 55296 <= d && 56319 >= d ? (b += 4, c++) : b += 3;
        }return b;
    };function Ob(a) {
        return "undefined" !== typeof JSON && p(JSON.parse) ? JSON.parse(a) : za(a);
    }function B(a) {
        if ("undefined" !== typeof JSON && p(JSON.stringify)) a = JSON.stringify(a);else {
            var b = [];Ba(new Aa(), a, b);a = b.join("");
        }return a;
    };function Pb(a, b) {
        this.committed = a;this.snapshot = b;
    };function Qb() {
        return "undefined" !== typeof window && !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined" !== typeof navigator && "string" === typeof navigator.userAgent ? navigator.userAgent : "");
    };function Rb(a) {
        this.te = a;this.Bd = [];this.Rb = 0;this.Yd = -1;this.Gb = null;
    }function Sb(a, b, c) {
        a.Yd = b;a.Gb = c;a.Yd < a.Rb && (a.Gb(), a.Gb = null);
    }function Tb(a, b, c) {
        for (a.Bd[b] = c; a.Bd[a.Rb];) {
            var d = a.Bd[a.Rb];delete a.Bd[a.Rb];for (var e = 0; e < d.length; ++e) {
                if (d[e]) {
                    var f = a;Ub(function () {
                        f.te(d[e]);
                    });
                }
            }if (a.Rb === a.Yd) {
                a.Gb && (clearTimeout(a.Gb), a.Gb(), a.Gb = null);break;
            }a.Rb++;
        }
    };function Vb() {
        this.qc = {};
    }Vb.prototype.set = function (a, b) {
        null == b ? delete this.qc[a] : this.qc[a] = b;
    };Vb.prototype.get = function (a) {
        return Bb(this.qc, a) ? this.qc[a] : null;
    };Vb.prototype.remove = function (a) {
        delete this.qc[a];
    };Vb.prototype.cf = !0;function Wb(a) {
        this.vc = a;this.Cd = "firebase:";
    }h = Wb.prototype;h.set = function (a, b) {
        null == b ? this.vc.removeItem(this.Cd + a) : this.vc.setItem(this.Cd + a, B(b));
    };h.get = function (a) {
        a = this.vc.getItem(this.Cd + a);return null == a ? null : Ob(a);
    };h.remove = function (a) {
        this.vc.removeItem(this.Cd + a);
    };h.cf = !1;h.toString = function () {
        return this.vc.toString();
    };function Xb(a) {
        try {
            if ("undefined" !== typeof window && "undefined" !== typeof window[a]) {
                var b = window[a];b.setItem("firebase:sentinel", "cache");b.removeItem("firebase:sentinel");return new Wb(b);
            }
        } catch (c) {}return new Vb();
    }var Yb = Xb("localStorage"),
        Zb = Xb("sessionStorage");function $b(a, b, c) {
        this.type = ac;this.source = a;this.path = b;this.Ja = c;
    }$b.prototype.Nc = function (a) {
        return this.path.e() ? new $b(this.source, C, this.Ja.R(a)) : new $b(this.source, D(this.path), this.Ja);
    };$b.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " overwrite: " + this.Ja.toString() + ")";
    };function bc(a, b) {
        this.type = cc;this.source = a;this.path = b;
    }bc.prototype.Nc = function () {
        return this.path.e() ? new bc(this.source, C) : new bc(this.source, D(this.path));
    };bc.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " listen_complete)";
    };function dc(a) {
        this.He = a;
    }dc.prototype.getToken = function (a) {
        return this.He.INTERNAL.getToken(a).then(null, function (a) {
            return a && "auth/token-not-initialized" === a.code ? (E("Got auth/token-not-initialized error.  Treating as null token."), null) : Promise.reject(a);
        });
    };function ec(a, b) {
        a.He.INTERNAL.addAuthTokenListener(b);
    };function fc() {
        this.Jd = F;
    }fc.prototype.j = function (a) {
        return this.Jd.Q(a);
    };fc.prototype.toString = function () {
        return this.Jd.toString();
    };function gc(a, b, c, d, e) {
        this.host = a.toLowerCase();this.domain = this.host.substr(this.host.indexOf(".") + 1);this.Sc = b;this.pe = c;this.Cg = d;this.nf = e || "";this.bb = Yb.get("host:" + a) || this.host;
    }function hc(a, b) {
        b !== a.bb && (a.bb = b, "s-" === a.bb.substr(0, 2) && Yb.set("host:" + a.host, a.bb));
    }
    function ic(a, b, c) {
        H("string" === typeof b, "typeof type must == string");H("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)), "typeof params must == object");if ("websocket" === b) b = (a.Sc ? "wss://" : "ws://") + a.bb + "/.ws?";else if ("long_polling" === b) b = (a.Sc ? "https://" : "http://") + a.bb + "/.lp?";else throw Error("Unknown connection type: " + b);a.host !== a.bb && (c.ns = a.pe);var d = [];t(c, function (a, b) {
            d.push(b + "=" + a);
        });return b + d.join("&");
    }
    gc.prototype.toString = function () {
        var a = (this.Sc ? "https://" : "http://") + this.host;this.nf && (a += "<" + this.nf + ">");return a;
    };function jc(a, b) {
        this.zf = {};this.Vc = new kc(a);this.va = b;var c = 1E4 + 2E4 * Math.random();setTimeout(r(this.rf, this), Math.floor(c));
    }jc.prototype.rf = function () {
        var a = this.Vc.get(),
            b = {},
            c = !1,
            d;for (d in a) {
            0 < a[d] && Bb(this.zf, d) && (b[d] = a[d], c = !0);
        }c && this.va.ye(b);setTimeout(r(this.rf, this), Math.floor(6E5 * Math.random()));
    };function lc() {
        this.uc = {};
    }function mc(a, b, c) {
        p(c) || (c = 1);Bb(a.uc, b) || (a.uc[b] = 0);a.uc[b] += c;
    }lc.prototype.get = function () {
        return ya(this.uc);
    };function kc(a) {
        this.Nf = a;this.rd = null;
    }kc.prototype.get = function () {
        var a = this.Nf.get(),
            b = ya(a);if (this.rd) for (var c in this.rd) {
            b[c] -= this.rd[c];
        }this.rd = a;return b;
    };var nc = {},
        oc = {};function pc(a) {
        a = a.toString();nc[a] || (nc[a] = new lc());return nc[a];
    }function qc(a, b) {
        var c = a.toString();oc[c] || (oc[c] = b());return oc[c];
    };function rc() {
        this.wb = [];
    }function sc(a, b) {
        for (var c = null, d = 0; d < b.length; d++) {
            var e = b[d],
                f = e.Zb();null === c || f.ca(c.Zb()) || (a.wb.push(c), c = null);null === c && (c = new tc(f));c.add(e);
        }c && a.wb.push(c);
    }function uc(a, b, c) {
        sc(a, c);vc(a, function (a) {
            return a.ca(b);
        });
    }function wc(a, b, c) {
        sc(a, c);vc(a, function (a) {
            return a.contains(b) || b.contains(a);
        });
    }
    function vc(a, b) {
        for (var c = !0, d = 0; d < a.wb.length; d++) {
            var e = a.wb[d];if (e) if (e = e.Zb(), b(e)) {
                for (var e = a.wb[d], f = 0; f < e.hd.length; f++) {
                    var g = e.hd[f];if (null !== g) {
                        e.hd[f] = null;var k = g.Ub();xc && E("event: " + g.toString());Ub(k);
                    }
                }a.wb[d] = null;
            } else c = !1;
        }c && (a.wb = []);
    }function tc(a) {
        this.qa = a;this.hd = [];
    }tc.prototype.add = function (a) {
        this.hd.push(a);
    };tc.prototype.Zb = function () {
        return this.qa;
    };function yc(a, b, c, d) {
        this.ae = b;this.Md = c;this.Dd = d;this.gd = a;
    }yc.prototype.Zb = function () {
        var a = this.Md.xb();return "value" === this.gd ? a.path : a.getParent().path;
    };yc.prototype.ge = function () {
        return this.gd;
    };yc.prototype.Ub = function () {
        return this.ae.Ub(this);
    };yc.prototype.toString = function () {
        return this.Zb().toString() + ":" + this.gd + ":" + B(this.Md.Ue());
    };function zc(a, b, c) {
        this.ae = a;this.error = b;this.path = c;
    }zc.prototype.Zb = function () {
        return this.path;
    };zc.prototype.ge = function () {
        return "cancel";
    };
    zc.prototype.Ub = function () {
        return this.ae.Ub(this);
    };zc.prototype.toString = function () {
        return this.path.toString() + ":cancel";
    };function Ac() {}Ac.prototype.Xe = function () {
        return null;
    };Ac.prototype.fe = function () {
        return null;
    };var Bc = new Ac();function Cc(a, b, c) {
        this.Gf = a;this.Na = b;this.yd = c;
    }Cc.prototype.Xe = function (a) {
        var b = this.Na.O;if (Dc(b, a)) return b.j().R(a);b = null != this.yd ? new Ec(this.yd, !0, !1) : this.Na.u();return this.Gf.rc(a, b);
    };Cc.prototype.fe = function (a, b, c) {
        var d = null != this.yd ? this.yd : Fc(this.Na);a = this.Gf.Xd(d, b, 1, c, a);return 0 === a.length ? null : a[0];
    };function I(a, b, c, d) {
        this.type = a;this.Ma = b;this.Za = c;this.qe = d;this.Dd = void 0;
    }function Gc(a) {
        return new I(Hc, a);
    }var Hc = "value";function Ec(a, b, c) {
        this.A = a;this.ea = b;this.Tb = c;
    }function Ic(a) {
        return a.ea;
    }function Jc(a) {
        return a.Tb;
    }function Kc(a, b) {
        return b.e() ? a.ea && !a.Tb : Dc(a, J(b));
    }function Dc(a, b) {
        return a.ea && !a.Tb || a.A.Fa(b);
    }Ec.prototype.j = function () {
        return this.A;
    };function Lc(a, b) {
        return Mc(a.name, b.name);
    }function Nc(a, b) {
        return Mc(a, b);
    };function K(a, b) {
        this.name = a;this.S = b;
    }function Oc(a, b) {
        return new K(a, b);
    };function Pc(a, b) {
        return a && "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) ? (H(".sv" in a, "Unexpected leaf node or priority contents"), b[a[".sv"]]) : a;
    }function Qc(a, b) {
        var c = new Rc();Sc(a, new L(""), function (a, e) {
            Tc(c, a, Uc(e, b));
        });return c;
    }function Uc(a, b) {
        var c = a.C().H(),
            c = Pc(c, b),
            d;if (a.J()) {
            var e = Pc(a.Ea(), b);return e !== a.Ea() || c !== a.C().H() ? new Vc(e, M(c)) : a;
        }d = a;c !== a.C().H() && (d = d.ga(new Vc(c)));a.P(N, function (a, c) {
            var e = Uc(c, b);e !== c && (d = d.U(a, e));
        });return d;
    };var Wc = function () {
        var a = 1;return function () {
            return a++;
        };
    }(),
        H = Kb,
        Xc = Lb;
    function Yc(a) {
        try {
            var b;bb();for (var c = $a, d = [], e = 0; e < a.length;) {
                var f = c[a.charAt(e++)],
                    g = e < a.length ? c[a.charAt(e)] : 0;++e;var k = e < a.length ? c[a.charAt(e)] : 64;++e;var m = e < a.length ? c[a.charAt(e)] : 64;++e;if (null == f || null == g || null == k || null == m) throw Error();d.push(f << 2 | g >> 4);64 != k && (d.push(g << 4 & 240 | k >> 2), 64 != m && d.push(k << 6 & 192 | m));
            }if (8192 > d.length) b = String.fromCharCode.apply(null, d);else {
                a = "";for (c = 0; c < d.length; c += 8192) {
                    a += String.fromCharCode.apply(null, Ra(d, c, c + 8192));
                }b = a;
            }return b;
        } catch (l) {
            E("base64Decode failed: ", l);
        }return null;
    }function Zc(a) {
        var b = Mb(a);a = new ma();a.update(b);var b = [],
            c = 8 * a.Pd;56 > a.ac ? a.update(a.zd, 56 - a.ac) : a.update(a.zd, a.Ya - (a.ac - 56));for (var d = a.Ya - 1; 56 <= d; d--) {
            a.Wd[d] = c & 255, c /= 256;
        }na(a, a.Wd);for (d = c = 0; 5 > d; d++) {
            for (var e = 24; 0 <= e; e -= 8) {
                b[c] = a.N[d] >> e & 255, ++c;
            }
        }return ab(b);
    }function $c(a) {
        for (var b = "", c = 0; c < arguments.length; c++) {
            b = ea(arguments[c]) ? b + $c.apply(null, arguments[c]) : "object" === _typeof(arguments[c]) ? b + B(arguments[c]) : b + arguments[c], b += " ";
        }return b;
    }var xc = null,
        ad = !0;
    function bd(a, b) {
        Kb(!b || !0 === a || !1 === a, "Can't turn on custom loggers persistently.");!0 === a ? ("undefined" !== typeof console && ("function" === typeof console.log ? xc = r(console.log, console) : "object" === _typeof(console.log) && (xc = function xc(a) {
            console.log(a);
        })), b && Zb.set("logging_enabled", !0)) : ga(a) ? xc = a : (xc = null, Zb.remove("logging_enabled"));
    }function E(a) {
        !0 === ad && (ad = !1, null === xc && !0 === Zb.get("logging_enabled") && bd(!0));if (xc) {
            var b = $c.apply(null, arguments);xc(b);
        }
    }
    function cd(a) {
        return function () {
            E(a, arguments);
        };
    }function dd(a) {
        if ("undefined" !== typeof console) {
            var b = "FIREBASE INTERNAL ERROR: " + $c.apply(null, arguments);"undefined" !== typeof console.error ? console.error(b) : console.log(b);
        }
    }function ed(a) {
        var b = $c.apply(null, arguments);throw Error("FIREBASE FATAL ERROR: " + b);
    }function O(a) {
        if ("undefined" !== typeof console) {
            var b = "FIREBASE WARNING: " + $c.apply(null, arguments);"undefined" !== typeof console.warn ? console.warn(b) : console.log(b);
        }
    }
    function fd(a) {
        var b,
            c,
            d,
            e,
            f,
            g = a;f = c = a = b = "";d = !0;e = "https";if (q(g)) {
            var k = g.indexOf("//");0 <= k && (e = g.substring(0, k - 1), g = g.substring(k + 2));k = g.indexOf("/");-1 === k && (k = g.length);b = g.substring(0, k);f = "";g = g.substring(k).split("/");for (k = 0; k < g.length; k++) {
                if (0 < g[k].length) {
                    var m = g[k];try {
                        m = decodeURIComponent(m.replace(/\+/g, " "));
                    } catch (l) {}f += "/" + m;
                }
            }g = b.split(".");3 === g.length ? (a = g[1], c = g[0].toLowerCase()) : 2 === g.length && (a = g[0]);k = b.indexOf(":");0 <= k && (d = "https" === e || "wss" === e);
        }"firebase" === a && ed(b + " is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
        c && "undefined" != c || ed("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d || "undefined" !== typeof window && window.location && window.location.protocol && -1 !== window.location.protocol.indexOf("https:") && O("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return { kc: new gc(b, d, c, "ws" === e || "wss" === e), path: new L(f) };
    }function gd(a) {
        return fa(a) && (a != a || a == Number.POSITIVE_INFINITY || a == Number.NEGATIVE_INFINITY);
    }
    function hd(a) {
        if ("complete" === document.readyState) a();else {
            var b = !1,
                c = function c() {
                document.body ? b || (b = !0, a()) : setTimeout(c, Math.floor(10));
            };document.addEventListener ? (document.addEventListener("DOMContentLoaded", c, !1), window.addEventListener("load", c, !1)) : document.attachEvent && (document.attachEvent("onreadystatechange", function () {
                "complete" === document.readyState && c();
            }), window.attachEvent("onload", c));
        }
    }
    function Mc(a, b) {
        if (a === b) return 0;if ("[MIN_NAME]" === a || "[MAX_NAME]" === b) return -1;if ("[MIN_NAME]" === b || "[MAX_NAME]" === a) return 1;var c = id(a),
            d = id(b);return null !== c ? null !== d ? 0 == c - d ? a.length - b.length : c - d : -1 : null !== d ? 1 : a < b ? -1 : 1;
    }function jd(a, b) {
        if (b && a in b) return b[a];throw Error("Missing required key (" + a + ") in object: " + B(b));
    }
    function kd(a) {
        if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a) return B(a);var b = [],
            c;for (c in a) {
            b.push(c);
        }b.sort();c = "{";for (var d = 0; d < b.length; d++) {
            0 !== d && (c += ","), c += B(b[d]), c += ":", c += kd(a[b[d]]);
        }return c + "}";
    }function ld(a, b) {
        if (a.length <= b) return [a];for (var c = [], d = 0; d < a.length; d += b) {
            d + b > a ? c.push(a.substring(d, a.length)) : c.push(a.substring(d, d + b));
        }return c;
    }function md(a, b) {
        if (da(a)) for (var c = 0; c < a.length; ++c) {
            b(c, a[c]);
        } else t(a, b);
    }
    function nd(a) {
        H(!gd(a), "Invalid JSON number");var b, c, d, e;0 === a ? (d = c = 0, b = -Infinity === 1 / a ? 1 : 0) : (b = 0 > a, a = Math.abs(a), a >= Math.pow(2, -1022) ? (d = Math.min(Math.floor(Math.log(a) / Math.LN2), 1023), c = d + 1023, d = Math.round(a * Math.pow(2, 52 - d) - Math.pow(2, 52))) : (c = 0, d = Math.round(a / Math.pow(2, -1074))));e = [];for (a = 52; a; --a) {
            e.push(d % 2 ? 1 : 0), d = Math.floor(d / 2);
        }for (a = 11; a; --a) {
            e.push(c % 2 ? 1 : 0), c = Math.floor(c / 2);
        }e.push(b ? 1 : 0);e.reverse();b = e.join("");c = "";for (a = 0; 64 > a; a += 8) {
            d = parseInt(b.substr(a, 8), 2).toString(16), 1 === d.length && (d = "0" + d), c += d;
        }return c.toLowerCase();
    }var od = /^-?\d{1,10}$/;function id(a) {
        return od.test(a) && (a = Number(a), -2147483648 <= a && 2147483647 >= a) ? a : null;
    }function Ub(a) {
        try {
            a();
        } catch (b) {
            setTimeout(function () {
                O("Exception was thrown by user callback.", b.stack || "");throw b;
            }, Math.floor(0));
        }
    }function pd(a, b, c) {
        Object.defineProperty(a, b, { get: c });
    };function qd(a) {
        var b = {},
            c = {},
            d = {},
            e = "";try {
            var f = a.split("."),
                b = Ob(Yc(f[0]) || ""),
                c = Ob(Yc(f[1]) || ""),
                e = f[2],
                d = c.d || {};delete c.d;
        } catch (g) {}return { Fg: b, Me: c, data: d, xg: e };
    }function rd(a) {
        a = qd(a);var b = a.Me;return !!a.xg && !!b && "object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && b.hasOwnProperty("iat");
    }function sd(a) {
        a = qd(a).Me;return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && !0 === x(a, "admin");
    };var ud = null;"undefined" !== typeof MozWebSocket ? ud = MozWebSocket : "undefined" !== typeof WebSocket && (ud = WebSocket);function vd(a, b, c, d) {
        this.Zd = a;this.f = cd(this.Zd);this.frames = this.Ac = null;this.qb = this.rb = this.Fe = 0;this.Xa = pc(b);a = { v: "5" };"undefined" !== typeof location && location.href && -1 !== location.href.indexOf("firebaseio.com") && (a.r = "f");c && (a.s = c);d && (a.ls = d);this.Ne = ic(b, "websocket", a);
    }var wd;
    vd.prototype.open = function (a, b) {
        this.kb = b;this.hg = a;this.f("Websocket connecting to " + this.Ne);this.xc = !1;Yb.set("previous_websocket_failure", !0);try {
            this.La = new ud(this.Ne);
        } catch (c) {
            this.f("Error instantiating WebSocket.");var d = c.message || c.data;d && this.f(d);this.fb();return;
        }var e = this;this.La.onopen = function () {
            e.f("Websocket connected.");e.xc = !0;
        };this.La.onclose = function () {
            e.f("Websocket connection was disconnected.");e.La = null;e.fb();
        };this.La.onmessage = function (a) {
            if (null !== e.La) if (a = a.data, e.qb += a.length, mc(e.Xa, "bytes_received", a.length), xd(e), null !== e.frames) yd(e, a);else {
                a: {
                    H(null === e.frames, "We already have a frame buffer");if (6 >= a.length) {
                        var b = Number(a);if (!isNaN(b)) {
                            e.Fe = b;e.frames = [];a = null;break a;
                        }
                    }e.Fe = 1;e.frames = [];
                }null !== a && yd(e, a);
            }
        };this.La.onerror = function (a) {
            e.f("WebSocket error.  Closing connection.");(a = a.message || a.data) && e.f(a);e.fb();
        };
    };vd.prototype.start = function () {};
    vd.isAvailable = function () {
        var a = !1;if ("undefined" !== typeof navigator && navigator.userAgent) {
            var b = navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b && 1 < b.length && 4.4 > parseFloat(b[1]) && (a = !0);
        }return !a && null !== ud && !wd;
    };vd.responsesRequiredToBeHealthy = 2;vd.healthyTimeout = 3E4;h = vd.prototype;h.sd = function () {
        Yb.remove("previous_websocket_failure");
    };function yd(a, b) {
        a.frames.push(b);if (a.frames.length == a.Fe) {
            var c = a.frames.join("");a.frames = null;c = Ob(c);a.hg(c);
        }
    }
    h.send = function (a) {
        xd(this);a = B(a);this.rb += a.length;mc(this.Xa, "bytes_sent", a.length);a = ld(a, 16384);1 < a.length && zd(this, String(a.length));for (var b = 0; b < a.length; b++) {
            zd(this, a[b]);
        }
    };h.Tc = function () {
        this.Bb = !0;this.Ac && (clearInterval(this.Ac), this.Ac = null);this.La && (this.La.close(), this.La = null);
    };h.fb = function () {
        this.Bb || (this.f("WebSocket is closing itself"), this.Tc(), this.kb && (this.kb(this.xc), this.kb = null));
    };h.close = function () {
        this.Bb || (this.f("WebSocket is being closed"), this.Tc());
    };
    function xd(a) {
        clearInterval(a.Ac);a.Ac = setInterval(function () {
            a.La && zd(a, "0");xd(a);
        }, Math.floor(45E3));
    }function zd(a, b) {
        try {
            a.La.send(b);
        } catch (c) {
            a.f("Exception thrown from WebSocket.send():", c.message || c.data, "Closing connection."), setTimeout(r(a.fb, a), 0);
        }
    };function Ad(a, b, c) {
        this.f = cd("p:rest:");this.M = a;this.Hb = b;this.Vd = c;this.$ = {};
    }function Bd(a, b) {
        if (p(b)) return "tag$" + b;H(Cd(a.n), "should have a tag if it's not a default query.");return a.path.toString();
    }h = Ad.prototype;
    h.df = function (a, b, c, d) {
        var e = a.path.toString();this.f("Listen called for " + e + " " + a.ya());var f = Bd(a, c),
            g = {};this.$[f] = g;a = Dd(a.n);var k = this;Ed(this, e + ".json", a, function (a, b) {
            var u = b;404 === a && (a = u = null);null === a && k.Hb(e, u, !1, c);x(k.$, f) === g && d(a ? 401 == a ? "permission_denied" : "rest_error:" + a : "ok", null);
        });
    };h.Ef = function (a, b) {
        var c = Bd(a, b);delete this.$[c];
    };h.qf = function () {};h.re = function () {};h.gf = function () {};h.xd = function () {};h.put = function () {};h.ef = function () {};h.ye = function () {};
    function Ed(a, b, c, d) {
        c = c || {};c.format = "export";a.Vd.getToken(!1).then(function (e) {
            (e = e && e.accessToken) && (c.auth = e);var f = (a.M.Sc ? "https://" : "http://") + a.M.host + b + "?" + Fb(c);a.f("Sending REST request for " + f);var g = new XMLHttpRequest();g.onreadystatechange = function () {
                if (d && 4 === g.readyState) {
                    a.f("REST Response for " + f + " received. status:", g.status, "response:", g.responseText);var b = null;if (200 <= g.status && 300 > g.status) {
                        try {
                            b = Ob(g.responseText);
                        } catch (c) {
                            O("Failed to parse JSON response for " + f + ": " + g.responseText);
                        }d(null, b);
                    } else 401 !== g.status && 404 !== g.status && O("Got unsuccessful REST response for " + f + " Status: " + g.status), d(g.status);d = null;
                }
            };g.open("GET", f, !0);g.send();
        });
    };function Fd(a, b, c) {
        this.type = Gd;this.source = a;this.path = b;this.children = c;
    }Fd.prototype.Nc = function (a) {
        if (this.path.e()) return a = this.children.subtree(new L(a)), a.e() ? null : a.value ? new $b(this.source, C, a.value) : new Fd(this.source, C, a);H(J(this.path) === a, "Can't get a merge for a child not on the path of the operation");return new Fd(this.source, D(this.path), this.children);
    };Fd.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
    };function Hd() {
        this.hb = {};
    }
    function Id(a, b) {
        var c = b.type,
            d = b.Za;H("child_added" == c || "child_changed" == c || "child_removed" == c, "Only child changes supported for tracking");H(".priority" !== d, "Only non-priority child changes can be tracked.");var e = x(a.hb, d);if (e) {
            var f = e.type;if ("child_added" == c && "child_removed" == f) a.hb[d] = new I("child_changed", b.Ma, d, e.Ma);else if ("child_removed" == c && "child_added" == f) delete a.hb[d];else if ("child_removed" == c && "child_changed" == f) a.hb[d] = new I("child_removed", e.qe, d);else if ("child_changed" == c && "child_added" == f) a.hb[d] = new I("child_added", b.Ma, d);else if ("child_changed" == c && "child_changed" == f) a.hb[d] = new I("child_changed", b.Ma, d, e.qe);else throw Xc("Illegal combination of changes: " + b + " occurred after " + e);
        } else a.hb[d] = b;
    };function Jd(a) {
        this.W = a;this.g = a.n.g;
    }function Kd(a, b, c, d) {
        var e = [],
            f = [];Ja(b, function (b) {
            "child_changed" === b.type && a.g.nd(b.qe, b.Ma) && f.push(new I("child_moved", b.Ma, b.Za));
        });Ld(a, e, "child_removed", b, d, c);Ld(a, e, "child_added", b, d, c);Ld(a, e, "child_moved", f, d, c);Ld(a, e, "child_changed", b, d, c);Ld(a, e, Hc, b, d, c);return e;
    }function Ld(a, b, c, d, e, f) {
        d = Ka(d, function (a) {
            return a.type === c;
        });Sa(d, r(a.Of, a));Ja(d, function (c) {
            var d = Md(a, c, f);Ja(e, function (e) {
                e.tf(c.type) && b.push(e.createEvent(d, a.W));
            });
        });
    }
    function Md(a, b, c) {
        "value" !== b.type && "child_removed" !== b.type && (b.Dd = c.Ze(b.Za, b.Ma, a.g));return b;
    }Jd.prototype.Of = function (a, b) {
        if (null == a.Za || null == b.Za) throw Xc("Should only compare child_ events.");return this.g.compare(new K(a.Za, a.Ma), new K(b.Za, b.Ma));
    };function Nd(a, b) {
        this.Sd = a;this.Mf = b;
    }function Od(a) {
        this.V = a;
    }
    Od.prototype.gb = function (a, b, c, d) {
        var e = new Hd(),
            f;if (b.type === ac) b.source.ee ? c = Pd(this, a, b.path, b.Ja, c, d, e) : (H(b.source.We, "Unknown source."), f = b.source.Ee || Jc(a.u()) && !b.path.e(), c = Qd(this, a, b.path, b.Ja, c, d, f, e));else if (b.type === Gd) b.source.ee ? c = Rd(this, a, b.path, b.children, c, d, e) : (H(b.source.We, "Unknown source."), f = b.source.Ee || Jc(a.u()), c = Sd(this, a, b.path, b.children, c, d, f, e));else if (b.type === Td) {
            if (b.Id) {
                if (b = b.path, null != c.mc(b)) c = a;else {
                    f = new Cc(c, a, d);d = a.O.j();if (b.e() || ".priority" === J(b)) Ic(a.u()) ? b = c.Ba(Fc(a)) : (b = a.u().j(), H(b instanceof P, "serverChildren would be complete if leaf node"), b = c.sc(b)), b = this.V.za(d, b, e);else {
                        var g = J(b),
                            k = c.rc(g, a.u());null == k && Dc(a.u(), g) && (k = d.R(g));b = null != k ? this.V.F(d, g, k, D(b), f, e) : a.O.j().Fa(g) ? this.V.F(d, g, F, D(b), f, e) : d;b.e() && Ic(a.u()) && (d = c.Ba(Fc(a)), d.J() && (b = this.V.za(b, d, e)));
                    }d = Ic(a.u()) || null != c.mc(C);c = Ud(a, b, d, this.V.Qa());
                }
            } else c = Vd(this, a, b.path, b.Pb, c, d, e);
        } else if (b.type === cc) d = b.path, b = a.u(), f = b.j(), g = b.ea || d.e(), c = Wd(this, new Xd(a.O, new Ec(f, g, b.Tb)), d, c, Bc, e);else throw Xc("Unknown operation type: " + b.type);e = sa(e.hb);d = c;b = d.O;b.ea && (f = b.j().J() || b.j().e(), g = Yd(a), (0 < e.length || !a.O.ea || f && !b.j().ca(g) || !b.j().C().ca(g.C())) && e.push(Gc(Yd(d))));return new Nd(c, e);
    };
    function Wd(a, b, c, d, e, f) {
        var g = b.O;if (null != d.mc(c)) return b;var k;if (c.e()) H(Ic(b.u()), "If change path is empty, we must have complete server data"), Jc(b.u()) ? (e = Fc(b), d = d.sc(e instanceof P ? e : F)) : d = d.Ba(Fc(b)), f = a.V.za(b.O.j(), d, f);else {
            var m = J(c);if (".priority" == m) H(1 == Zd(c), "Can't have a priority with additional path components"), f = g.j(), k = b.u().j(), d = d.$c(c, f, k), f = null != d ? a.V.ga(f, d) : g.j();else {
                var l = D(c);Dc(g, m) ? (k = b.u().j(), d = d.$c(c, g.j(), k), d = null != d ? g.j().R(m).F(l, d) : g.j().R(m)) : d = d.rc(m, b.u());f = null != d ? a.V.F(g.j(), m, d, l, e, f) : g.j();
            }
        }return Ud(b, f, g.ea || c.e(), a.V.Qa());
    }function Qd(a, b, c, d, e, f, g, k) {
        var m = b.u();g = g ? a.V : a.V.Vb();if (c.e()) d = g.za(m.j(), d, null);else if (g.Qa() && !m.Tb) d = m.j().F(c, d), d = g.za(m.j(), d, null);else {
            var l = J(c);if (!Kc(m, c) && 1 < Zd(c)) return b;var u = D(c);d = m.j().R(l).F(u, d);d = ".priority" == l ? g.ga(m.j(), d) : g.F(m.j(), l, d, u, Bc, null);
        }m = m.ea || c.e();b = new Xd(b.O, new Ec(d, m, g.Qa()));return Wd(a, b, c, e, new Cc(e, b, f), k);
    }
    function Pd(a, b, c, d, e, f, g) {
        var k = b.O;e = new Cc(e, b, f);if (c.e()) g = a.V.za(b.O.j(), d, g), a = Ud(b, g, !0, a.V.Qa());else if (f = J(c), ".priority" === f) g = a.V.ga(b.O.j(), d), a = Ud(b, g, k.ea, k.Tb);else {
            c = D(c);var m = k.j().R(f);if (!c.e()) {
                var l = e.Xe(f);d = null != l ? ".priority" === $d(c) && l.Q(c.parent()).e() ? l : l.F(c, d) : F;
            }m.ca(d) ? a = b : (g = a.V.F(k.j(), f, d, c, e, g), a = Ud(b, g, k.ea, a.V.Qa()));
        }return a;
    }
    function Rd(a, b, c, d, e, f, g) {
        var k = b;ae(d, function (d, l) {
            var u = c.m(d);Dc(b.O, J(u)) && (k = Pd(a, k, u, l, e, f, g));
        });ae(d, function (d, l) {
            var u = c.m(d);Dc(b.O, J(u)) || (k = Pd(a, k, u, l, e, f, g));
        });return k;
    }function be(a, b) {
        ae(b, function (b, d) {
            a = a.F(b, d);
        });return a;
    }
    function Sd(a, b, c, d, e, f, g, k) {
        if (b.u().j().e() && !Ic(b.u())) return b;var m = b;c = c.e() ? d : ce(Q, c, d);var l = b.u().j();c.children.ia(function (c, d) {
            if (l.Fa(c)) {
                var G = b.u().j().R(c),
                    G = be(G, d);m = Qd(a, m, new L(c), G, e, f, g, k);
            }
        });c.children.ia(function (c, d) {
            var G = !Dc(b.u(), c) && null == d.value;l.Fa(c) || G || (G = b.u().j().R(c), G = be(G, d), m = Qd(a, m, new L(c), G, e, f, g, k));
        });return m;
    }
    function Vd(a, b, c, d, e, f, g) {
        if (null != e.mc(c)) return b;var k = Jc(b.u()),
            m = b.u();if (null != d.value) {
            if (c.e() && m.ea || Kc(m, c)) return Qd(a, b, c, m.j().Q(c), e, f, k, g);if (c.e()) {
                var l = Q;m.j().P(de, function (a, b) {
                    l = l.set(new L(a), b);
                });return Sd(a, b, c, l, e, f, k, g);
            }return b;
        }l = Q;ae(d, function (a) {
            var b = c.m(a);Kc(m, b) && (l = l.set(a, m.j().Q(b)));
        });return Sd(a, b, c, l, e, f, k, g);
    };function ee(a) {
        this.g = a;
    }h = ee.prototype;h.F = function (a, b, c, d, e, f) {
        H(a.zc(this.g), "A node must be indexed if only a child is updated");e = a.R(b);if (e.Q(d).ca(c.Q(d)) && e.e() == c.e()) return a;null != f && (c.e() ? a.Fa(b) ? Id(f, new I("child_removed", e, b)) : H(a.J(), "A child remove without an old child only makes sense on a leaf node") : e.e() ? Id(f, new I("child_added", c, b)) : Id(f, new I("child_changed", c, b, e)));return a.J() && c.e() ? a : a.U(b, c).ob(this.g);
    };
    h.za = function (a, b, c) {
        null != c && (a.J() || a.P(N, function (a, e) {
            b.Fa(a) || Id(c, new I("child_removed", e, a));
        }), b.J() || b.P(N, function (b, e) {
            if (a.Fa(b)) {
                var f = a.R(b);f.ca(e) || Id(c, new I("child_changed", e, b, f));
            } else Id(c, new I("child_added", e, b));
        }));return b.ob(this.g);
    };h.ga = function (a, b) {
        return a.e() ? F : a.ga(b);
    };h.Qa = function () {
        return !1;
    };h.Vb = function () {
        return this;
    };function fe(a) {
        this.he = new ee(a.g);this.g = a.g;var b;a.ka ? (b = ge(a), b = a.g.Fc(he(a), b)) : b = a.g.Ic();this.Uc = b;a.na ? (b = ie(a), a = a.g.Fc(je(a), b)) : a = a.g.Gc();this.wc = a;
    }h = fe.prototype;h.matches = function (a) {
        return 0 >= this.g.compare(this.Uc, a) && 0 >= this.g.compare(a, this.wc);
    };h.F = function (a, b, c, d, e, f) {
        this.matches(new K(b, c)) || (c = F);return this.he.F(a, b, c, d, e, f);
    };
    h.za = function (a, b, c) {
        b.J() && (b = F);var d = b.ob(this.g),
            d = d.ga(F),
            e = this;b.P(N, function (a, b) {
            e.matches(new K(a, b)) || (d = d.U(a, F));
        });return this.he.za(a, d, c);
    };h.ga = function (a) {
        return a;
    };h.Qa = function () {
        return !0;
    };h.Vb = function () {
        return this.he;
    };function ke(a) {
        this.sa = new fe(a);this.g = a.g;H(a.xa, "Only valid if limit has been set");this.oa = a.oa;this.Jb = !le(a);
    }h = ke.prototype;h.F = function (a, b, c, d, e, f) {
        this.sa.matches(new K(b, c)) || (c = F);return a.R(b).ca(c) ? a : a.Fb() < this.oa ? this.sa.Vb().F(a, b, c, d, e, f) : me(this, a, b, c, e, f);
    };
    h.za = function (a, b, c) {
        var d;if (b.J() || b.e()) d = F.ob(this.g);else if (2 * this.oa < b.Fb() && b.zc(this.g)) {
            d = F.ob(this.g);b = this.Jb ? b.$b(this.sa.wc, this.g) : b.Yb(this.sa.Uc, this.g);for (var e = 0; 0 < b.Sa.length && e < this.oa;) {
                var f = R(b),
                    g;if (g = this.Jb ? 0 >= this.g.compare(this.sa.Uc, f) : 0 >= this.g.compare(f, this.sa.wc)) d = d.U(f.name, f.S), e++;else break;
            }
        } else {
            d = b.ob(this.g);d = d.ga(F);var k, m, l;if (this.Jb) {
                b = d.$e(this.g);k = this.sa.wc;m = this.sa.Uc;var u = ne(this.g);l = function l(a, b) {
                    return u(b, a);
                };
            } else b = d.Xb(this.g), k = this.sa.Uc, m = this.sa.wc, l = ne(this.g);for (var e = 0, z = !1; 0 < b.Sa.length;) {
                f = R(b), !z && 0 >= l(k, f) && (z = !0), (g = z && e < this.oa && 0 >= l(f, m)) ? e++ : d = d.U(f.name, F);
            }
        }return this.sa.Vb().za(a, d, c);
    };h.ga = function (a) {
        return a;
    };h.Qa = function () {
        return !0;
    };h.Vb = function () {
        return this.sa.Vb();
    };
    function me(a, b, c, d, e, f) {
        var g;if (a.Jb) {
            var k = ne(a.g);g = function g(a, b) {
                return k(b, a);
            };
        } else g = ne(a.g);H(b.Fb() == a.oa, "");var m = new K(c, d),
            l = a.Jb ? oe(b, a.g) : pe(b, a.g),
            u = a.sa.matches(m);if (b.Fa(c)) {
            for (var z = b.R(c), l = e.fe(a.g, l, a.Jb); null != l && (l.name == c || b.Fa(l.name));) {
                l = e.fe(a.g, l, a.Jb);
            }e = null == l ? 1 : g(l, m);if (u && !d.e() && 0 <= e) return null != f && Id(f, new I("child_changed", d, c, z)), b.U(c, d);null != f && Id(f, new I("child_removed", z, c));b = b.U(c, F);return null != l && a.sa.matches(l) ? (null != f && Id(f, new I("child_added", l.S, l.name)), b.U(l.name, l.S)) : b;
        }return d.e() ? b : u && 0 <= g(l, m) ? (null != f && (Id(f, new I("child_removed", l.S, l.name)), Id(f, new I("child_added", d, c))), b.U(c, d).U(l.name, F)) : b;
    };function Vc(a, b) {
        this.B = a;H(p(this.B) && null !== this.B, "LeafNode shouldn't be created with null/undefined value.");this.aa = b || F;qe(this.aa);this.Eb = null;
    }var re = ["object", "boolean", "number", "string"];h = Vc.prototype;h.J = function () {
        return !0;
    };h.C = function () {
        return this.aa;
    };h.ga = function (a) {
        return new Vc(this.B, a);
    };h.R = function (a) {
        return ".priority" === a ? this.aa : F;
    };h.Q = function (a) {
        return a.e() ? this : ".priority" === J(a) ? this.aa : F;
    };h.Fa = function () {
        return !1;
    };h.Ze = function () {
        return null;
    };
    h.U = function (a, b) {
        return ".priority" === a ? this.ga(b) : b.e() && ".priority" !== a ? this : F.U(a, b).ga(this.aa);
    };h.F = function (a, b) {
        var c = J(a);if (null === c) return b;if (b.e() && ".priority" !== c) return this;H(".priority" !== c || 1 === Zd(a), ".priority must be the last token in a path");return this.U(c, F.F(D(a), b));
    };h.e = function () {
        return !1;
    };h.Fb = function () {
        return 0;
    };h.P = function () {
        return !1;
    };h.H = function (a) {
        return a && !this.C().e() ? { ".value": this.Ea(), ".priority": this.C().H() } : this.Ea();
    };
    h.hash = function () {
        if (null === this.Eb) {
            var a = "";this.aa.e() || (a += "priority:" + se(this.aa.H()) + ":");var b = _typeof(this.B),
                a = a + (b + ":"),
                a = "number" === b ? a + nd(this.B) : a + this.B;this.Eb = Zc(a);
        }return this.Eb;
    };h.Ea = function () {
        return this.B;
    };h.tc = function (a) {
        if (a === F) return 1;if (a instanceof P) return -1;H(a.J(), "Unknown node type");var b = _typeof(a.B),
            c = _typeof(this.B),
            d = Ia(re, b),
            e = Ia(re, c);H(0 <= d, "Unknown leaf type: " + b);H(0 <= e, "Unknown leaf type: " + c);return d === e ? "object" === c ? 0 : this.B < a.B ? -1 : this.B === a.B ? 0 : 1 : e - d;
    };
    h.ob = function () {
        return this;
    };h.zc = function () {
        return !0;
    };h.ca = function (a) {
        return a === this ? !0 : a.J() ? this.B === a.B && this.aa.ca(a.aa) : !1;
    };h.toString = function () {
        return B(this.H(!0));
    };function te() {}var ue = {};function ne(a) {
        return r(a.compare, a);
    }te.prototype.nd = function (a, b) {
        return 0 !== this.compare(new K("[MIN_NAME]", a), new K("[MIN_NAME]", b));
    };te.prototype.Ic = function () {
        return ve;
    };function we(a) {
        H(!a.e() && ".priority" !== J(a), "Can't create PathIndex with empty path or .priority key");this.cc = a;
    }ka(we, te);h = we.prototype;h.yc = function (a) {
        return !a.Q(this.cc).e();
    };h.compare = function (a, b) {
        var c = a.S.Q(this.cc),
            d = b.S.Q(this.cc),
            c = c.tc(d);return 0 === c ? Mc(a.name, b.name) : c;
    };
    h.Fc = function (a, b) {
        var c = M(a),
            c = F.F(this.cc, c);return new K(b, c);
    };h.Gc = function () {
        var a = F.F(this.cc, xe);return new K("[MAX_NAME]", a);
    };h.toString = function () {
        return this.cc.slice().join("/");
    };function ye() {}ka(ye, te);h = ye.prototype;h.compare = function (a, b) {
        var c = a.S.C(),
            d = b.S.C(),
            c = c.tc(d);return 0 === c ? Mc(a.name, b.name) : c;
    };h.yc = function (a) {
        return !a.C().e();
    };h.nd = function (a, b) {
        return !a.C().ca(b.C());
    };h.Ic = function () {
        return ve;
    };h.Gc = function () {
        return new K("[MAX_NAME]", new Vc("[PRIORITY-POST]", xe));
    };
    h.Fc = function (a, b) {
        var c = M(a);return new K(b, new Vc("[PRIORITY-POST]", c));
    };h.toString = function () {
        return ".priority";
    };var N = new ye();function ze() {}ka(ze, te);h = ze.prototype;h.compare = function (a, b) {
        return Mc(a.name, b.name);
    };h.yc = function () {
        throw Xc("KeyIndex.isDefinedOn not expected to be called.");
    };h.nd = function () {
        return !1;
    };h.Ic = function () {
        return ve;
    };h.Gc = function () {
        return new K("[MAX_NAME]", F);
    };h.Fc = function (a) {
        H(q(a), "KeyIndex indexValue must always be a string.");return new K(a, F);
    };h.toString = function () {
        return ".key";
    };
    var de = new ze();function Ae() {}ka(Ae, te);h = Ae.prototype;h.compare = function (a, b) {
        var c = a.S.tc(b.S);return 0 === c ? Mc(a.name, b.name) : c;
    };h.yc = function () {
        return !0;
    };h.nd = function (a, b) {
        return !a.ca(b);
    };h.Ic = function () {
        return ve;
    };h.Gc = function () {
        return Be;
    };h.Fc = function (a, b) {
        var c = M(a);return new K(b, c);
    };h.toString = function () {
        return ".value";
    };var Ce = new Ae();function De() {
        this.Sb = this.na = this.Lb = this.ka = this.xa = !1;this.oa = 0;this.oc = "";this.ec = null;this.Ab = "";this.bc = null;this.yb = "";this.g = N;
    }var Ee = new De();function le(a) {
        return "" === a.oc ? a.ka : "l" === a.oc;
    }function he(a) {
        H(a.ka, "Only valid if start has been set");return a.ec;
    }function ge(a) {
        H(a.ka, "Only valid if start has been set");return a.Lb ? a.Ab : "[MIN_NAME]";
    }function je(a) {
        H(a.na, "Only valid if end has been set");return a.bc;
    }
    function ie(a) {
        H(a.na, "Only valid if end has been set");return a.Sb ? a.yb : "[MAX_NAME]";
    }function Fe(a) {
        var b = new De();b.xa = a.xa;b.oa = a.oa;b.ka = a.ka;b.ec = a.ec;b.Lb = a.Lb;b.Ab = a.Ab;b.na = a.na;b.bc = a.bc;b.Sb = a.Sb;b.yb = a.yb;b.g = a.g;return b;
    }h = De.prototype;h.ne = function (a) {
        var b = Fe(this);b.xa = !0;b.oa = a;b.oc = "l";return b;
    };h.oe = function (a) {
        var b = Fe(this);b.xa = !0;b.oa = a;b.oc = "r";return b;
    };h.Nd = function (a, b) {
        var c = Fe(this);c.ka = !0;p(a) || (a = null);c.ec = a;null != b ? (c.Lb = !0, c.Ab = b) : (c.Lb = !1, c.Ab = "");return c;
    };
    h.fd = function (a, b) {
        var c = Fe(this);c.na = !0;p(a) || (a = null);c.bc = a;p(b) ? (c.Sb = !0, c.yb = b) : (c.Hg = !1, c.yb = "");return c;
    };function Ge(a, b) {
        var c = Fe(a);c.g = b;return c;
    }function He(a) {
        var b = {};a.ka && (b.sp = a.ec, a.Lb && (b.sn = a.Ab));a.na && (b.ep = a.bc, a.Sb && (b.en = a.yb));if (a.xa) {
            b.l = a.oa;var c = a.oc;"" === c && (c = le(a) ? "l" : "r");b.vf = c;
        }a.g !== N && (b.i = a.g.toString());return b;
    }function S(a) {
        return !(a.ka || a.na || a.xa);
    }function Cd(a) {
        return S(a) && a.g == N;
    }
    function Dd(a) {
        var b = {};if (Cd(a)) return b;var c;a.g === N ? c = "$priority" : a.g === Ce ? c = "$value" : a.g === de ? c = "$key" : (H(a.g instanceof we, "Unrecognized index type!"), c = a.g.toString());b.orderBy = B(c);a.ka && (b.startAt = B(a.ec), a.Lb && (b.startAt += "," + B(a.Ab)));a.na && (b.endAt = B(a.bc), a.Sb && (b.endAt += "," + B(a.yb)));a.xa && (le(a) ? b.limitToFirst = a.oa : b.limitToLast = a.oa);return b;
    }h.toString = function () {
        return B(He(this));
    };function Ie(a, b) {
        this.od = a;this.dc = b;
    }Ie.prototype.get = function (a) {
        var b = x(this.od, a);if (!b) throw Error("No index defined for " + a);return b === ue ? null : b;
    };function Je(a, b, c) {
        var d = oa(a.od, function (d, f) {
            var g = x(a.dc, f);H(g, "Missing index implementation for " + f);if (d === ue) {
                if (g.yc(b.S)) {
                    for (var k = [], m = c.Xb(Oc), l = R(m); l;) {
                        l.name != b.name && k.push(l), l = R(m);
                    }k.push(b);return Ke(k, ne(g));
                }return ue;
            }g = c.get(b.name);k = d;g && (k = k.remove(new K(b.name, g)));return k.Ra(b, b.S);
        });return new Ie(d, a.dc);
    }
    function Le(a, b, c) {
        var d = oa(a.od, function (a) {
            if (a === ue) return a;var d = c.get(b.name);return d ? a.remove(new K(b.name, d)) : a;
        });return new Ie(d, a.dc);
    }var Me = new Ie({ ".priority": ue }, { ".priority": N });function Ne() {
        this.set = {};
    }h = Ne.prototype;h.add = function (a, b) {
        this.set[a] = null !== b ? b : !0;
    };h.contains = function (a) {
        return Bb(this.set, a);
    };h.get = function (a) {
        return this.contains(a) ? this.set[a] : void 0;
    };h.remove = function (a) {
        delete this.set[a];
    };h.clear = function () {
        this.set = {};
    };h.e = function () {
        return xa(this.set);
    };h.count = function () {
        return qa(this.set);
    };function Oe(a, b) {
        t(a.set, function (a, d) {
            b(d, a);
        });
    }h.keys = function () {
        var a = [];t(this.set, function (b, c) {
            a.push(c);
        });return a;
    };function Pe(a, b, c, d) {
        this.Zd = a;this.f = cd(a);this.kc = b;this.qb = this.rb = 0;this.Xa = pc(b);this.Bf = c;this.xc = !1;this.Db = d;this.Yc = function (a) {
            return ic(b, "long_polling", a);
        };
    }var Qe, Re;
    Pe.prototype.open = function (a, b) {
        this.Qe = 0;this.ja = b;this.ff = new Rb(a);this.Bb = !1;var c = this;this.tb = setTimeout(function () {
            c.f("Timed out trying to connect.");c.fb();c.tb = null;
        }, Math.floor(3E4));hd(function () {
            if (!c.Bb) {
                c.Wa = new Se(function (a, b, d, k, m) {
                    Te(c, arguments);if (c.Wa) if (c.tb && (clearTimeout(c.tb), c.tb = null), c.xc = !0, "start" == a) c.id = b, c.mf = d;else if ("close" === a) b ? (c.Wa.Kd = !1, Sb(c.ff, b, function () {
                        c.fb();
                    })) : c.fb();else throw Error("Unrecognized command received: " + a);
                }, function (a, b) {
                    Te(c, arguments);
                    Tb(c.ff, a, b);
                }, function () {
                    c.fb();
                }, c.Yc);var a = { start: "t" };a.ser = Math.floor(1E8 * Math.random());c.Wa.Qd && (a.cb = c.Wa.Qd);a.v = "5";c.Bf && (a.s = c.Bf);c.Db && (a.ls = c.Db);"undefined" !== typeof location && location.href && -1 !== location.href.indexOf("firebaseio.com") && (a.r = "f");a = c.Yc(a);c.f("Connecting via long-poll to " + a);Ue(c.Wa, a, function () {});
            }
        });
    };
    Pe.prototype.start = function () {
        var a = this.Wa,
            b = this.mf;a.fg = this.id;a.gg = b;for (a.Ud = !0; Ve(a);) {}a = this.id;b = this.mf;this.gc = document.createElement("iframe");var c = { dframe: "t" };c.id = a;c.pw = b;this.gc.src = this.Yc(c);this.gc.style.display = "none";document.body.appendChild(this.gc);
    };
    Pe.isAvailable = function () {
        return Qe || !Re && "undefined" !== typeof document && null != document.createElement && !("object" === (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.chrome && window.chrome.extension && !/^chrome/.test(window.location.href)) && !("object" === (typeof Windows === "undefined" ? "undefined" : _typeof(Windows)) && "object" === _typeof(Windows.Dg)) && !0;
    };h = Pe.prototype;h.sd = function () {};h.Tc = function () {
        this.Bb = !0;this.Wa && (this.Wa.close(), this.Wa = null);this.gc && (document.body.removeChild(this.gc), this.gc = null);this.tb && (clearTimeout(this.tb), this.tb = null);
    };
    h.fb = function () {
        this.Bb || (this.f("Longpoll is closing itself"), this.Tc(), this.ja && (this.ja(this.xc), this.ja = null));
    };h.close = function () {
        this.Bb || (this.f("Longpoll is being closed."), this.Tc());
    };h.send = function (a) {
        a = B(a);this.rb += a.length;mc(this.Xa, "bytes_sent", a.length);a = Mb(a);a = ab(a, !0);a = ld(a, 1840);for (var b = 0; b < a.length; b++) {
            var c = this.Wa;c.Qc.push({ ug: this.Qe, Bg: a.length, Se: a[b] });c.Ud && Ve(c);this.Qe++;
        }
    };function Te(a, b) {
        var c = B(b).length;a.qb += c;mc(a.Xa, "bytes_received", c);
    }
    function Se(a, b, c, d) {
        this.Yc = d;this.kb = c;this.ve = new Ne();this.Qc = [];this.$d = Math.floor(1E8 * Math.random());this.Kd = !0;this.Qd = Wc();window["pLPCommand" + this.Qd] = a;window["pRTLPCB" + this.Qd] = b;a = document.createElement("iframe");a.style.display = "none";if (document.body) {
            document.body.appendChild(a);try {
                a.contentWindow.document || E("No IE domain setting required");
            } catch (e) {
                a.src = "javascript:void((function(){document.open();document.domain='" + document.domain + "';document.close();})())";
            }
        } else throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
        a.contentDocument ? a.ib = a.contentDocument : a.contentWindow ? a.ib = a.contentWindow.document : a.document && (a.ib = a.document);this.Ga = a;a = "";this.Ga.src && "javascript:" === this.Ga.src.substr(0, 11) && (a = '<script>document.domain="' + document.domain + '";\x3c/script>');a = "<html><body>" + a + "</body></html>";try {
            this.Ga.ib.open(), this.Ga.ib.write(a), this.Ga.ib.close();
        } catch (f) {
            E("frame writing exception"), f.stack && E(f.stack), E(f);
        }
    }
    Se.prototype.close = function () {
        this.Ud = !1;if (this.Ga) {
            this.Ga.ib.body.innerHTML = "";var a = this;setTimeout(function () {
                null !== a.Ga && (document.body.removeChild(a.Ga), a.Ga = null);
            }, Math.floor(0));
        }var b = this.kb;b && (this.kb = null, b());
    };
    function Ve(a) {
        if (a.Ud && a.Kd && a.ve.count() < (0 < a.Qc.length ? 2 : 1)) {
            a.$d++;var b = {};b.id = a.fg;b.pw = a.gg;b.ser = a.$d;for (var b = a.Yc(b), c = "", d = 0; 0 < a.Qc.length;) {
                if (1870 >= a.Qc[0].Se.length + 30 + c.length) {
                    var e = a.Qc.shift(),
                        c = c + "&seg" + d + "=" + e.ug + "&ts" + d + "=" + e.Bg + "&d" + d + "=" + e.Se;d++;
                } else break;
            }We(a, b + c, a.$d);return !0;
        }return !1;
    }function We(a, b, c) {
        function d() {
            a.ve.remove(c);Ve(a);
        }a.ve.add(c, 1);var e = setTimeout(d, Math.floor(25E3));Ue(a, b, function () {
            clearTimeout(e);d();
        });
    }
    function Ue(a, b, c) {
        setTimeout(function () {
            try {
                if (a.Kd) {
                    var d = a.Ga.ib.createElement("script");d.type = "text/javascript";d.async = !0;d.src = b;d.onload = d.onreadystatechange = function () {
                        var a = d.readyState;a && "loaded" !== a && "complete" !== a || (d.onload = d.onreadystatechange = null, d.parentNode && d.parentNode.removeChild(d), c());
                    };d.onerror = function () {
                        E("Long-poll script failed to load: " + b);a.Kd = !1;a.close();
                    };a.Ga.ib.body.appendChild(d);
                }
            } catch (e) {}
        }, Math.floor(1));
    };function Xe(a) {
        Ye(this, a);
    }var Ze = [Pe, vd];function Ye(a, b) {
        var c = vd && vd.isAvailable(),
            d = c && !(Yb.cf || !0 === Yb.get("previous_websocket_failure"));b.Cg && (c || O("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."), d = !0);if (d) a.Wc = [vd];else {
            var e = a.Wc = [];md(Ze, function (a, b) {
                b && b.isAvailable() && e.push(b);
            });
        }
    }function $e(a) {
        if (0 < a.Wc.length) return a.Wc[0];throw Error("No transports available");
    };function af(a, b, c, d, e, f, g) {
        this.id = a;this.f = cd("c:" + this.id + ":");this.te = c;this.Mc = d;this.ja = e;this.se = f;this.M = b;this.Ad = [];this.Oe = 0;this.Af = new Xe(b);this.L = 0;this.Db = g;this.f("Connection created");bf(this);
    }
    function bf(a) {
        var b = $e(a.Af);a.I = new b("c:" + a.id + ":" + a.Oe++, a.M, void 0, a.Db);a.xe = b.responsesRequiredToBeHealthy || 0;var c = cf(a, a.I),
            d = df(a, a.I);a.Xc = a.I;a.Rc = a.I;a.D = null;a.Cb = !1;setTimeout(function () {
            a.I && a.I.open(c, d);
        }, Math.floor(0));b = b.healthyTimeout || 0;0 < b && (a.md = setTimeout(function () {
            a.md = null;a.Cb || (a.I && 102400 < a.I.qb ? (a.f("Connection exceeded healthy timeout but has received " + a.I.qb + " bytes.  Marking connection healthy."), a.Cb = !0, a.I.sd()) : a.I && 10240 < a.I.rb ? a.f("Connection exceeded healthy timeout but has sent " + a.I.rb + " bytes.  Leaving connection alive.") : (a.f("Closing unhealthy connection after timeout."), a.close()));
        }, Math.floor(b)));
    }function df(a, b) {
        return function (c) {
            b === a.I ? (a.I = null, c || 0 !== a.L ? 1 === a.L && a.f("Realtime connection lost.") : (a.f("Realtime connection failed."), "s-" === a.M.bb.substr(0, 2) && (Yb.remove("host:" + a.M.host), a.M.bb = a.M.host)), a.close()) : b === a.D ? (a.f("Secondary connection lost."), c = a.D, a.D = null, a.Xc !== c && a.Rc !== c || a.close()) : a.f("closing an old connection");
        };
    }
    function cf(a, b) {
        return function (c) {
            if (2 != a.L) if (b === a.Rc) {
                var d = jd("t", c);c = jd("d", c);if ("c" == d) {
                    if (d = jd("t", c), "d" in c) if (c = c.d, "h" === d) {
                        var d = c.ts,
                            e = c.v,
                            f = c.h;a.yf = c.s;hc(a.M, f);0 == a.L && (a.I.start(), ef(a, a.I, d), "5" !== e && O("Protocol version mismatch detected"), c = a.Af, (c = 1 < c.Wc.length ? c.Wc[1] : null) && ff(a, c));
                    } else if ("n" === d) {
                        a.f("recvd end transmission on primary");a.Rc = a.D;for (c = 0; c < a.Ad.length; ++c) {
                            a.wd(a.Ad[c]);
                        }a.Ad = [];gf(a);
                    } else "s" === d ? (a.f("Connection shutdown command received. Shutting down..."), a.se && (a.se(c), a.se = null), a.ja = null, a.close()) : "r" === d ? (a.f("Reset packet received.  New host: " + c), hc(a.M, c), 1 === a.L ? a.close() : (hf(a), bf(a))) : "e" === d ? dd("Server Error: " + c) : "o" === d ? (a.f("got pong on primary."), jf(a), kf(a)) : dd("Unknown control packet command: " + d);
                } else "d" == d && a.wd(c);
            } else if (b === a.D) {
                if (d = jd("t", c), c = jd("d", c), "c" == d) "t" in c && (c = c.t, "a" === c ? lf(a) : "r" === c ? (a.f("Got a reset on secondary, closing it"), a.D.close(), a.Xc !== a.D && a.Rc !== a.D || a.close()) : "o" === c && (a.f("got pong on secondary."), a.xf--, lf(a)));else if ("d" == d) a.Ad.push(c);else throw Error("Unknown protocol layer: " + d);
            } else a.f("message on old connection");
        };
    }af.prototype.ua = function (a) {
        mf(this, { t: "d", d: a });
    };function gf(a) {
        a.Xc === a.D && a.Rc === a.D && (a.f("cleaning up and promoting a connection: " + a.D.Zd), a.I = a.D, a.D = null);
    }
    function lf(a) {
        0 >= a.xf ? (a.f("Secondary connection is healthy."), a.Cb = !0, a.D.sd(), a.D.start(), a.f("sending client ack on secondary"), a.D.send({ t: "c", d: { t: "a", d: {} } }), a.f("Ending transmission on primary"), a.I.send({ t: "c", d: { t: "n", d: {} } }), a.Xc = a.D, gf(a)) : (a.f("sending ping on secondary."), a.D.send({ t: "c", d: { t: "p", d: {} } }));
    }af.prototype.wd = function (a) {
        jf(this);this.te(a);
    };function jf(a) {
        a.Cb || (a.xe--, 0 >= a.xe && (a.f("Primary connection is healthy."), a.Cb = !0, a.I.sd()));
    }
    function ff(a, b) {
        a.D = new b("c:" + a.id + ":" + a.Oe++, a.M, a.yf);a.xf = b.responsesRequiredToBeHealthy || 0;a.D.open(cf(a, a.D), df(a, a.D));setTimeout(function () {
            a.D && (a.f("Timed out trying to upgrade."), a.D.close());
        }, Math.floor(6E4));
    }function ef(a, b, c) {
        a.f("Realtime connection established.");a.I = b;a.L = 1;a.Mc && (a.Mc(c, a.yf), a.Mc = null);0 === a.xe ? (a.f("Primary connection is healthy."), a.Cb = !0) : setTimeout(function () {
            kf(a);
        }, Math.floor(5E3));
    }
    function kf(a) {
        a.Cb || 1 !== a.L || (a.f("sending ping on primary."), mf(a, { t: "c", d: { t: "p", d: {} } }));
    }function mf(a, b) {
        if (1 !== a.L) throw "Connection is not connected";a.Xc.send(b);
    }af.prototype.close = function () {
        2 !== this.L && (this.f("Closing realtime connection."), this.L = 2, hf(this), this.ja && (this.ja(), this.ja = null));
    };function hf(a) {
        a.f("Shutting down all connections");a.I && (a.I.close(), a.I = null);a.D && (a.D.close(), a.D = null);a.md && (clearTimeout(a.md), a.md = null);
    };function L(a, b) {
        if (1 == arguments.length) {
            this.o = a.split("/");for (var c = 0, d = 0; d < this.o.length; d++) {
                0 < this.o[d].length && (this.o[c] = this.o[d], c++);
            }this.o.length = c;this.Z = 0;
        } else this.o = a, this.Z = b;
    }function T(a, b) {
        var c = J(a);if (null === c) return b;if (c === J(b)) return T(D(a), D(b));throw Error("INTERNAL ERROR: innerPath (" + b + ") is not within outerPath (" + a + ")");
    }
    function nf(a, b) {
        for (var c = a.slice(), d = b.slice(), e = 0; e < c.length && e < d.length; e++) {
            var f = Mc(c[e], d[e]);if (0 !== f) return f;
        }return c.length === d.length ? 0 : c.length < d.length ? -1 : 1;
    }function J(a) {
        return a.Z >= a.o.length ? null : a.o[a.Z];
    }function Zd(a) {
        return a.o.length - a.Z;
    }function D(a) {
        var b = a.Z;b < a.o.length && b++;return new L(a.o, b);
    }function $d(a) {
        return a.Z < a.o.length ? a.o[a.o.length - 1] : null;
    }h = L.prototype;
    h.toString = function () {
        for (var a = "", b = this.Z; b < this.o.length; b++) {
            "" !== this.o[b] && (a += "/" + this.o[b]);
        }return a || "/";
    };h.slice = function (a) {
        return this.o.slice(this.Z + (a || 0));
    };h.parent = function () {
        if (this.Z >= this.o.length) return null;for (var a = [], b = this.Z; b < this.o.length - 1; b++) {
            a.push(this.o[b]);
        }return new L(a, 0);
    };
    h.m = function (a) {
        for (var b = [], c = this.Z; c < this.o.length; c++) {
            b.push(this.o[c]);
        }if (a instanceof L) for (c = a.Z; c < a.o.length; c++) {
            b.push(a.o[c]);
        } else for (a = a.split("/"), c = 0; c < a.length; c++) {
            0 < a[c].length && b.push(a[c]);
        }return new L(b, 0);
    };h.e = function () {
        return this.Z >= this.o.length;
    };h.ca = function (a) {
        if (Zd(this) !== Zd(a)) return !1;for (var b = this.Z, c = a.Z; b <= this.o.length; b++, c++) {
            if (this.o[b] !== a.o[c]) return !1;
        }return !0;
    };
    h.contains = function (a) {
        var b = this.Z,
            c = a.Z;if (Zd(this) > Zd(a)) return !1;for (; b < this.o.length;) {
            if (this.o[b] !== a.o[c]) return !1;++b;++c;
        }return !0;
    };var C = new L("");function of(a, b) {
        this.Ta = a.slice();this.Ka = Math.max(1, this.Ta.length);this.Te = b;for (var c = 0; c < this.Ta.length; c++) {
            this.Ka += Nb(this.Ta[c]);
        }pf(this);
    }of.prototype.push = function (a) {
        0 < this.Ta.length && (this.Ka += 1);this.Ta.push(a);this.Ka += Nb(a);pf(this);
    };of.prototype.pop = function () {
        var a = this.Ta.pop();this.Ka -= Nb(a);0 < this.Ta.length && --this.Ka;
    };
    function pf(a) {
        if (768 < a.Ka) throw Error(a.Te + "has a key path longer than 768 bytes (" + a.Ka + ").");if (32 < a.Ta.length) throw Error(a.Te + "path specified exceeds the maximum depth that can be written (32) or object contains a cycle " + qf(a));
    }function qf(a) {
        return 0 == a.Ta.length ? "" : "in property '" + a.Ta.join(".") + "'";
    };function rf(a) {
        a instanceof sf || ed("Don't call new Database() directly - please use firebase.database().");this.ta = a;this.ba = new U(a, C);this.INTERNAL = new tf(this);
    }var uf = { TIMESTAMP: { ".sv": "timestamp" } };h = rf.prototype;h.app = null;h.pf = function (a) {
        vf(this, "ref");y("database.ref", 0, 1, arguments.length);return p(a) ? this.ba.m(a) : this.ba;
    };
    h.rg = function (a) {
        vf(this, "database.refFromURL");y("database.refFromURL", 1, 1, arguments.length);var b = fd(a);wf("database.refFromURL", b);var c = b.kc;c.host !== this.ta.M.host && ed("database.refFromURL: Host name does not match the current database: (found " + c.host + " but expected " + this.ta.M.host + ")");return this.pf(b.path.toString());
    };function vf(a, b) {
        null === a.ta && ed("Cannot call " + b + " on a deleted database.");
    }h.$f = function () {
        y("database.goOffline", 0, 0, arguments.length);vf(this, "goOffline");this.ta.eb();
    };
    h.ag = function () {
        y("database.goOnline", 0, 0, arguments.length);vf(this, "goOnline");this.ta.lc();
    };Object.defineProperty(rf.prototype, "app", { get: function get() {
            return this.ta.app;
        } });function tf(a) {
        this.$a = a;
    }tf.prototype.delete = function () {
        vf(this.$a, "delete");var a = xf.Wb(),
            b = this.$a.ta;x(a.nb, b.app.name) !== b && ed("Database " + b.app.name + " has already been deleted.");b.eb();delete a.nb[b.app.name];this.$a.ta = null;this.$a.ba = null;this.$a = this.$a.INTERNAL = null;return firebase.Promise.resolve();
    };
    rf.prototype.ref = rf.prototype.pf;rf.prototype.refFromURL = rf.prototype.rg;rf.prototype.goOnline = rf.prototype.ag;rf.prototype.goOffline = rf.prototype.$f;tf.prototype["delete"] = tf.prototype.delete;function Rc() {
        this.k = this.B = null;
    }Rc.prototype.find = function (a) {
        if (null != this.B) return this.B.Q(a);if (a.e() || null == this.k) return null;var b = J(a);a = D(a);return this.k.contains(b) ? this.k.get(b).find(a) : null;
    };function Tc(a, b, c) {
        if (b.e()) a.B = c, a.k = null;else if (null !== a.B) a.B = a.B.F(b, c);else {
            null == a.k && (a.k = new Ne());var d = J(b);a.k.contains(d) || a.k.add(d, new Rc());a = a.k.get(d);b = D(b);Tc(a, b, c);
        }
    }
    function yf(a, b) {
        if (b.e()) return a.B = null, a.k = null, !0;if (null !== a.B) {
            if (a.B.J()) return !1;var c = a.B;a.B = null;c.P(N, function (b, c) {
                Tc(a, new L(b), c);
            });return yf(a, b);
        }return null !== a.k ? (c = J(b), b = D(b), a.k.contains(c) && yf(a.k.get(c), b) && a.k.remove(c), a.k.e() ? (a.k = null, !0) : !1) : !0;
    }function Sc(a, b, c) {
        null !== a.B ? c(b, a.B) : a.P(function (a, e) {
            var f = new L(b.toString() + "/" + a);Sc(e, f, c);
        });
    }Rc.prototype.P = function (a) {
        null !== this.k && Oe(this.k, function (b, c) {
            a(b, c);
        });
    };var zf = /[\[\].#$\/\u0000-\u001F\u007F]/,
        Af = /[\[\].#$\u0000-\u001F\u007F]/;function Bf(a) {
        return q(a) && 0 !== a.length && !zf.test(a);
    }function Cf(a) {
        return null === a || q(a) || fa(a) && !gd(a) || ha(a) && Bb(a, ".sv");
    }function Df(a, b, c, d) {
        d && !p(b) || Ef(Db(a, 1, d), b, c);
    }
    function Ef(a, b, c) {
        c instanceof L && (c = new of(c, a));if (!p(b)) throw Error(a + "contains undefined " + qf(c));if (ga(b)) throw Error(a + "contains a function " + qf(c) + " with contents: " + b.toString());if (gd(b)) throw Error(a + "contains " + b.toString() + " " + qf(c));if (q(b) && b.length > 10485760 / 3 && 10485760 < Nb(b)) throw Error(a + "contains a string greater than 10485760 utf8 bytes " + qf(c) + " ('" + b.substring(0, 50) + "...')");if (ha(b)) {
            var d = !1,
                e = !1;Cb(b, function (b, g) {
                if (".value" === b) d = !0;else if (".priority" !== b && ".sv" !== b && (e = !0, !Bf(b))) throw Error(a + " contains an invalid key (" + b + ") " + qf(c) + '.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Ef(a, g, c);c.pop();
            });if (d && e) throw Error(a + ' contains ".value" child ' + qf(c) + " in addition to actual children.");
        }
    }
    function Ff(a, b) {
        var c, d;for (c = 0; c < b.length; c++) {
            d = b[c];for (var e = d.slice(), f = 0; f < e.length; f++) {
                if ((".priority" !== e[f] || f !== e.length - 1) && !Bf(e[f])) throw Error(a + "contains an invalid key (" + e[f] + ") in path " + d.toString() + '. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }b.sort(nf);e = null;for (c = 0; c < b.length; c++) {
            d = b[c];if (null !== e && e.contains(d)) throw Error(a + "contains a path " + e.toString() + " that is ancestor of another path " + d.toString());e = d;
        }
    }
    function Gf(a, b, c) {
        var d = Db(a, 1, !1);if (!ha(b) || da(b)) throw Error(d + " must be an object containing the children to replace.");var e = [];Cb(b, function (a, b) {
            var k = new L(a);Ef(d, b, c.m(k));if (".priority" === $d(k) && !Cf(b)) throw Error(d + "contains an invalid value for '" + k.toString() + "', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k);
        });Ff(d, e);
    }
    function Hf(a, b, c) {
        if (gd(c)) throw Error(Db(a, b, !1) + "is " + c.toString() + ", but must be a valid Firebase priority (a string, finite number, server value, or null).");if (!Cf(c)) throw Error(Db(a, b, !1) + "must be a valid Firebase priority (a string, finite number, server value, or null).");
    }
    function If(a, b, c) {
        if (!c || p(b)) switch (b) {case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":
                break;default:
                throw Error(Db(a, 1, c) + 'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}
    }function Jf(a, b) {
        if (p(b) && !Bf(b)) throw Error(Db(a, 2, !0) + 'was an invalid key: "' + b + '".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');
    }
    function Kf(a, b) {
        if (!q(b) || 0 === b.length || Af.test(b)) throw Error(Db(a, 1, !1) + 'was an invalid path: "' + b + '". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');
    }function Lf(a, b) {
        if (".info" === J(b)) throw Error(a + " failed: Can't modify data under /.info/");
    }
    function wf(a, b) {
        var c = b.path.toString(),
            d;!(d = !q(b.kc.host) || 0 === b.kc.host.length || !Bf(b.kc.pe)) && (d = 0 !== c.length) && (c && (c = c.replace(/^\/*\.info(\/|$)/, "/")), d = !(q(c) && 0 !== c.length && !Af.test(c)));if (d) throw Error(Db(a, 1, !1) + 'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');
    };function V(a, b) {
        this.ta = a;this.qa = b;
    }V.prototype.cancel = function (a) {
        y("Firebase.onDisconnect().cancel", 0, 1, arguments.length);A("Firebase.onDisconnect().cancel", 1, a, !0);var b = new Hb();this.ta.xd(this.qa, Ib(b, a));return b.ra;
    };V.prototype.cancel = V.prototype.cancel;V.prototype.remove = function (a) {
        y("Firebase.onDisconnect().remove", 0, 1, arguments.length);Lf("Firebase.onDisconnect().remove", this.qa);A("Firebase.onDisconnect().remove", 1, a, !0);var b = new Hb();Mf(this.ta, this.qa, null, Ib(b, a));return b.ra;
    };
    V.prototype.remove = V.prototype.remove;V.prototype.set = function (a, b) {
        y("Firebase.onDisconnect().set", 1, 2, arguments.length);Lf("Firebase.onDisconnect().set", this.qa);Df("Firebase.onDisconnect().set", a, this.qa, !1);A("Firebase.onDisconnect().set", 2, b, !0);var c = new Hb();Mf(this.ta, this.qa, a, Ib(c, b));return c.ra;
    };V.prototype.set = V.prototype.set;
    V.prototype.Kb = function (a, b, c) {
        y("Firebase.onDisconnect().setWithPriority", 2, 3, arguments.length);Lf("Firebase.onDisconnect().setWithPriority", this.qa);Df("Firebase.onDisconnect().setWithPriority", a, this.qa, !1);Hf("Firebase.onDisconnect().setWithPriority", 2, b);A("Firebase.onDisconnect().setWithPriority", 3, c, !0);var d = new Hb();Nf(this.ta, this.qa, a, b, Ib(d, c));return d.ra;
    };V.prototype.setWithPriority = V.prototype.Kb;
    V.prototype.update = function (a, b) {
        y("Firebase.onDisconnect().update", 1, 2, arguments.length);Lf("Firebase.onDisconnect().update", this.qa);if (da(a)) {
            for (var c = {}, d = 0; d < a.length; ++d) {
                c["" + d] = a[d];
            }a = c;O("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }Gf("Firebase.onDisconnect().update", a, this.qa);A("Firebase.onDisconnect().update", 2, b, !0);
        c = new Hb();Of(this.ta, this.qa, a, Ib(c, b));return c.ra;
    };V.prototype.update = V.prototype.update;function Pf(a) {
        H(da(a) && 0 < a.length, "Requires a non-empty array");this.Kf = a;this.Ec = {};
    }Pf.prototype.Ge = function (a, b) {
        var c;c = this.Ec[a] || [];var d = c.length;if (0 < d) {
            for (var e = Array(d), f = 0; f < d; f++) {
                e[f] = c[f];
            }c = e;
        } else c = [];for (d = 0; d < c.length; d++) {
            c[d].Ke.apply(c[d].Pa, Array.prototype.slice.call(arguments, 1));
        }
    };Pf.prototype.hc = function (a, b, c) {
        Qf(this, a);this.Ec[a] = this.Ec[a] || [];this.Ec[a].push({ Ke: b, Pa: c });(a = this.Ye(a)) && b.apply(c, a);
    };
    Pf.prototype.Jc = function (a, b, c) {
        Qf(this, a);a = this.Ec[a] || [];for (var d = 0; d < a.length; d++) {
            if (a[d].Ke === b && (!c || c === a[d].Pa)) {
                a.splice(d, 1);break;
            }
        }
    };function Qf(a, b) {
        H(Oa(a.Kf, function (a) {
            return a === b;
        }), "Unknown event: " + b);
    };function Rf() {
        Pf.call(this, ["online"]);this.ic = !0;if ("undefined" !== typeof window && "undefined" !== typeof window.addEventListener && !Qb()) {
            var a = this;window.addEventListener("online", function () {
                a.ic || (a.ic = !0, a.Ge("online", !0));
            }, !1);window.addEventListener("offline", function () {
                a.ic && (a.ic = !1, a.Ge("online", !1));
            }, !1);
        }
    }ka(Rf, Pf);Rf.prototype.Ye = function (a) {
        H("online" === a, "Unknown event type: " + a);return [this.ic];
    };ba(Rf);function Sf() {
        Pf.call(this, ["visible"]);var a, b;"undefined" !== typeof document && "undefined" !== typeof document.addEventListener && ("undefined" !== typeof document.hidden ? (b = "visibilitychange", a = "hidden") : "undefined" !== typeof document.mozHidden ? (b = "mozvisibilitychange", a = "mozHidden") : "undefined" !== typeof document.msHidden ? (b = "msvisibilitychange", a = "msHidden") : "undefined" !== typeof document.webkitHidden && (b = "webkitvisibilitychange", a = "webkitHidden"));this.Nb = !0;if (b) {
            var c = this;document.addEventListener(b, function () {
                var b = !document[a];b !== c.Nb && (c.Nb = b, c.Ge("visible", b));
            }, !1);
        }
    }ka(Sf, Pf);Sf.prototype.Ye = function (a) {
        H("visible" === a, "Unknown event type: " + a);return [this.Nb];
    };ba(Sf);var Tf = function () {
        var a = 0,
            b = [];return function (c) {
            var d = c === a;a = c;for (var e = Array(8), f = 7; 0 <= f; f--) {
                e[f] = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c % 64), c = Math.floor(c / 64);
            }H(0 === c, "Cannot push at time == 0");c = e.join("");if (d) {
                for (f = 11; 0 <= f && 63 === b[f]; f--) {
                    b[f] = 0;
                }b[f]++;
            } else for (f = 0; 12 > f; f++) {
                b[f] = Math.floor(64 * Math.random());
            }for (f = 0; 12 > f; f++) {
                c += "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);
            }H(20 === c.length, "nextPushId: Length should be 20.");
            return c;
        };
    }();function Uf(a, b) {
        this.Oa = a;this.ba = b ? b : Vf;
    }h = Uf.prototype;h.Ra = function (a, b) {
        return new Uf(this.Oa, this.ba.Ra(a, b, this.Oa).Y(null, null, !1, null, null));
    };h.remove = function (a) {
        return new Uf(this.Oa, this.ba.remove(a, this.Oa).Y(null, null, !1, null, null));
    };h.get = function (a) {
        for (var b, c = this.ba; !c.e();) {
            b = this.Oa(a, c.key);if (0 === b) return c.value;0 > b ? c = c.left : 0 < b && (c = c.right);
        }return null;
    };
    function Wf(a, b) {
        for (var c, d = a.ba, e = null; !d.e();) {
            c = a.Oa(b, d.key);if (0 === c) {
                if (d.left.e()) return e ? e.key : null;for (d = d.left; !d.right.e();) {
                    d = d.right;
                }return d.key;
            }0 > c ? d = d.left : 0 < c && (e = d, d = d.right);
        }throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
    }h.e = function () {
        return this.ba.e();
    };h.count = function () {
        return this.ba.count();
    };h.Hc = function () {
        return this.ba.Hc();
    };h.fc = function () {
        return this.ba.fc();
    };h.ia = function (a) {
        return this.ba.ia(a);
    };
    h.Xb = function (a) {
        return new Xf(this.ba, null, this.Oa, !1, a);
    };h.Yb = function (a, b) {
        return new Xf(this.ba, a, this.Oa, !1, b);
    };h.$b = function (a, b) {
        return new Xf(this.ba, a, this.Oa, !0, b);
    };h.$e = function (a) {
        return new Xf(this.ba, null, this.Oa, !0, a);
    };function Xf(a, b, c, d, e) {
        this.Hd = e || null;this.le = d;this.Sa = [];for (e = 1; !a.e();) {
            if (e = b ? c(a.key, b) : 1, d && (e *= -1), 0 > e) a = this.le ? a.left : a.right;else if (0 === e) {
                this.Sa.push(a);break;
            } else this.Sa.push(a), a = this.le ? a.right : a.left;
        }
    }
    function R(a) {
        if (0 === a.Sa.length) return null;var b = a.Sa.pop(),
            c;c = a.Hd ? a.Hd(b.key, b.value) : { key: b.key, value: b.value };if (a.le) for (b = b.left; !b.e();) {
            a.Sa.push(b), b = b.right;
        } else for (b = b.right; !b.e();) {
            a.Sa.push(b), b = b.left;
        }return c;
    }function Yf(a) {
        if (0 === a.Sa.length) return null;var b;b = a.Sa;b = b[b.length - 1];return a.Hd ? a.Hd(b.key, b.value) : { key: b.key, value: b.value };
    }function Zf(a, b, c, d, e) {
        this.key = a;this.value = b;this.color = null != c ? c : !0;this.left = null != d ? d : Vf;this.right = null != e ? e : Vf;
    }h = Zf.prototype;
    h.Y = function (a, b, c, d, e) {
        return new Zf(null != a ? a : this.key, null != b ? b : this.value, null != c ? c : this.color, null != d ? d : this.left, null != e ? e : this.right);
    };h.count = function () {
        return this.left.count() + 1 + this.right.count();
    };h.e = function () {
        return !1;
    };h.ia = function (a) {
        return this.left.ia(a) || a(this.key, this.value) || this.right.ia(a);
    };function $f(a) {
        return a.left.e() ? a : $f(a.left);
    }h.Hc = function () {
        return $f(this).key;
    };h.fc = function () {
        return this.right.e() ? this.key : this.right.fc();
    };
    h.Ra = function (a, b, c) {
        var d, e;e = this;d = c(a, e.key);e = 0 > d ? e.Y(null, null, null, e.left.Ra(a, b, c), null) : 0 === d ? e.Y(null, b, null, null, null) : e.Y(null, null, null, null, e.right.Ra(a, b, c));return ag(e);
    };function bg(a) {
        if (a.left.e()) return Vf;a.left.fa() || a.left.left.fa() || (a = cg(a));a = a.Y(null, null, null, bg(a.left), null);return ag(a);
    }
    h.remove = function (a, b) {
        var c, d;c = this;if (0 > b(a, c.key)) c.left.e() || c.left.fa() || c.left.left.fa() || (c = cg(c)), c = c.Y(null, null, null, c.left.remove(a, b), null);else {
            c.left.fa() && (c = dg(c));c.right.e() || c.right.fa() || c.right.left.fa() || (c = eg(c), c.left.left.fa() && (c = dg(c), c = eg(c)));if (0 === b(a, c.key)) {
                if (c.right.e()) return Vf;d = $f(c.right);c = c.Y(d.key, d.value, null, null, bg(c.right));
            }c = c.Y(null, null, null, null, c.right.remove(a, b));
        }return ag(c);
    };h.fa = function () {
        return this.color;
    };
    function ag(a) {
        a.right.fa() && !a.left.fa() && (a = fg(a));a.left.fa() && a.left.left.fa() && (a = dg(a));a.left.fa() && a.right.fa() && (a = eg(a));return a;
    }function cg(a) {
        a = eg(a);a.right.left.fa() && (a = a.Y(null, null, null, null, dg(a.right)), a = fg(a), a = eg(a));return a;
    }function fg(a) {
        return a.right.Y(null, null, a.color, a.Y(null, null, !0, null, a.right.left), null);
    }function dg(a) {
        return a.left.Y(null, null, a.color, null, a.Y(null, null, !0, a.left.right, null));
    }
    function eg(a) {
        return a.Y(null, null, !a.color, a.left.Y(null, null, !a.left.color, null, null), a.right.Y(null, null, !a.right.color, null, null));
    }function gg() {}h = gg.prototype;h.Y = function () {
        return this;
    };h.Ra = function (a, b) {
        return new Zf(a, b, null);
    };h.remove = function () {
        return this;
    };h.count = function () {
        return 0;
    };h.e = function () {
        return !0;
    };h.ia = function () {
        return !1;
    };h.Hc = function () {
        return null;
    };h.fc = function () {
        return null;
    };h.fa = function () {
        return !1;
    };var Vf = new gg();function P(a, b, c) {
        this.k = a;(this.aa = b) && qe(this.aa);a.e() && H(!this.aa || this.aa.e(), "An empty node cannot have a priority");this.zb = c;this.Eb = null;
    }h = P.prototype;h.J = function () {
        return !1;
    };h.C = function () {
        return this.aa || F;
    };h.ga = function (a) {
        return this.k.e() ? this : new P(this.k, a, this.zb);
    };h.R = function (a) {
        if (".priority" === a) return this.C();a = this.k.get(a);return null === a ? F : a;
    };h.Q = function (a) {
        var b = J(a);return null === b ? this : this.R(b).Q(D(a));
    };h.Fa = function (a) {
        return null !== this.k.get(a);
    };
    h.U = function (a, b) {
        H(b, "We should always be passing snapshot nodes");if (".priority" === a) return this.ga(b);var c = new K(a, b),
            d,
            e;b.e() ? (d = this.k.remove(a), c = Le(this.zb, c, this.k)) : (d = this.k.Ra(a, b), c = Je(this.zb, c, this.k));e = d.e() ? F : this.aa;return new P(d, e, c);
    };h.F = function (a, b) {
        var c = J(a);if (null === c) return b;H(".priority" !== J(a) || 1 === Zd(a), ".priority must be the last token in a path");var d = this.R(c).F(D(a), b);return this.U(c, d);
    };h.e = function () {
        return this.k.e();
    };h.Fb = function () {
        return this.k.count();
    };
    var hg = /^(0|[1-9]\d*)$/;h = P.prototype;h.H = function (a) {
        if (this.e()) return null;var b = {},
            c = 0,
            d = 0,
            e = !0;this.P(N, function (f, g) {
            b[f] = g.H(a);c++;e && hg.test(f) ? d = Math.max(d, Number(f)) : e = !1;
        });if (!a && e && d < 2 * c) {
            var f = [],
                g;for (g in b) {
                f[g] = b[g];
            }return f;
        }a && !this.C().e() && (b[".priority"] = this.C().H());return b;
    };h.hash = function () {
        if (null === this.Eb) {
            var a = "";this.C().e() || (a += "priority:" + se(this.C().H()) + ":");this.P(N, function (b, c) {
                var d = c.hash();"" !== d && (a += ":" + b + ":" + d);
            });this.Eb = "" === a ? "" : Zc(a);
        }return this.Eb;
    };
    h.Ze = function (a, b, c) {
        return (c = ig(this, c)) ? (a = Wf(c, new K(a, b))) ? a.name : null : Wf(this.k, a);
    };function oe(a, b) {
        var c;c = (c = ig(a, b)) ? (c = c.Hc()) && c.name : a.k.Hc();return c ? new K(c, a.k.get(c)) : null;
    }function pe(a, b) {
        var c;c = (c = ig(a, b)) ? (c = c.fc()) && c.name : a.k.fc();return c ? new K(c, a.k.get(c)) : null;
    }h.P = function (a, b) {
        var c = ig(this, a);return c ? c.ia(function (a) {
            return b(a.name, a.S);
        }) : this.k.ia(b);
    };h.Xb = function (a) {
        return this.Yb(a.Ic(), a);
    };
    h.Yb = function (a, b) {
        var c = ig(this, b);if (c) return c.Yb(a, function (a) {
            return a;
        });for (var c = this.k.Yb(a.name, Oc), d = Yf(c); null != d && 0 > b.compare(d, a);) {
            R(c), d = Yf(c);
        }return c;
    };h.$e = function (a) {
        return this.$b(a.Gc(), a);
    };h.$b = function (a, b) {
        var c = ig(this, b);if (c) return c.$b(a, function (a) {
            return a;
        });for (var c = this.k.$b(a.name, Oc), d = Yf(c); null != d && 0 < b.compare(d, a);) {
            R(c), d = Yf(c);
        }return c;
    };h.tc = function (a) {
        return this.e() ? a.e() ? 0 : -1 : a.J() || a.e() ? 1 : a === xe ? -1 : 0;
    };
    h.ob = function (a) {
        if (a === de || ua(this.zb.dc, a.toString())) return this;var b = this.zb,
            c = this.k;H(a !== de, "KeyIndex always exists and isn't meant to be added to the IndexMap.");for (var d = [], e = !1, c = c.Xb(Oc), f = R(c); f;) {
            e = e || a.yc(f.S), d.push(f), f = R(c);
        }d = e ? Ke(d, ne(a)) : ue;e = a.toString();c = ya(b.dc);c[e] = a;a = ya(b.od);a[e] = d;return new P(this.k, this.aa, new Ie(a, c));
    };h.zc = function (a) {
        return a === de || ua(this.zb.dc, a.toString());
    };
    h.ca = function (a) {
        if (a === this) return !0;if (a.J()) return !1;if (this.C().ca(a.C()) && this.k.count() === a.k.count()) {
            var b = this.Xb(N);a = a.Xb(N);for (var c = R(b), d = R(a); c && d;) {
                if (c.name !== d.name || !c.S.ca(d.S)) return !1;c = R(b);d = R(a);
            }return null === c && null === d;
        }return !1;
    };function ig(a, b) {
        return b === de ? null : a.zb.get(b.toString());
    }h.toString = function () {
        return B(this.H(!0));
    };function M(a, b) {
        if (null === a) return F;var c = null;"object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && ".priority" in a ? c = a[".priority"] : "undefined" !== typeof b && (c = b);H(null === c || "string" === typeof c || "number" === typeof c || "object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && ".sv" in c, "Invalid priority type found: " + (typeof c === "undefined" ? "undefined" : _typeof(c)));"object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && ".value" in a && null !== a[".value"] && (a = a[".value"]);if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || ".sv" in a) return new Vc(a, M(c));if (a instanceof Array) {
            var d = F,
                e = a;t(e, function (a, b) {
                if (Bb(e, b) && "." !== b.substring(0, 1)) {
                    var c = M(a);if (c.J() || !c.e()) d = d.U(b, c);
                }
            });return d.ga(M(c));
        }var f = [],
            g = !1,
            k = a;Cb(k, function (a) {
            if ("string" !== typeof a || "." !== a.substring(0, 1)) {
                var b = M(k[a]);b.e() || (g = g || !b.C().e(), f.push(new K(a, b)));
            }
        });if (0 == f.length) return F;var m = Ke(f, Lc, function (a) {
            return a.name;
        }, Nc);if (g) {
            var l = Ke(f, ne(N));return new P(m, M(c), new Ie({ ".priority": l }, { ".priority": N }));
        }return new P(m, M(c), Me);
    }var jg = Math.log(2);
    function kg(a) {
        this.count = parseInt(Math.log(a + 1) / jg, 10);this.Re = this.count - 1;this.Lf = a + 1 & parseInt(Array(this.count + 1).join("1"), 2);
    }function lg(a) {
        var b = !(a.Lf & 1 << a.Re);a.Re--;return b;
    }
    function Ke(a, b, c, d) {
        function e(b, d) {
            var f = d - b;if (0 == f) return null;if (1 == f) {
                var l = a[b],
                    u = c ? c(l) : l;return new Zf(u, l.S, !1, null, null);
            }var l = parseInt(f / 2, 10) + b,
                f = e(b, l),
                z = e(l + 1, d),
                l = a[l],
                u = c ? c(l) : l;return new Zf(u, l.S, !1, f, z);
        }a.sort(b);var f = function (b) {
            function d(b, g) {
                var k = u - b,
                    z = u;u -= b;var z = e(k + 1, z),
                    k = a[k],
                    G = c ? c(k) : k,
                    z = new Zf(G, k.S, g, null, z);f ? f.left = z : l = z;f = z;
            }for (var f = null, l = null, u = a.length, z = 0; z < b.count; ++z) {
                var G = lg(b),
                    td = Math.pow(2, b.count - (z + 1));G ? d(td, !1) : (d(td, !1), d(td, !0));
            }return l;
        }(new kg(a.length));
        return null !== f ? new Uf(d || b, f) : new Uf(d || b);
    }function se(a) {
        return "number" === typeof a ? "number:" + nd(a) : "string:" + a;
    }function qe(a) {
        if (a.J()) {
            var b = a.H();H("string" === typeof b || "number" === typeof b || "object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && Bb(b, ".sv"), "Priority must be a string or number.");
        } else H(a === xe || a.e(), "priority of unexpected type.");H(a === xe || a.C().e(), "Priority nodes can't have a priority of their own.");
    }var F = new P(new Uf(Nc), null, Me);function mg() {
        P.call(this, new Uf(Nc), F, Me);
    }ka(mg, P);h = mg.prototype;
    h.tc = function (a) {
        return a === this ? 0 : 1;
    };h.ca = function (a) {
        return a === this;
    };h.C = function () {
        return this;
    };h.R = function () {
        return F;
    };h.e = function () {
        return !1;
    };var xe = new mg(),
        ve = new K("[MIN_NAME]", F),
        Be = new K("[MAX_NAME]", xe);function W(a, b, c) {
        this.A = a;this.W = b;this.g = c;
    }W.prototype.H = function () {
        y("Firebase.DataSnapshot.val", 0, 0, arguments.length);return this.A.H();
    };W.prototype.val = W.prototype.H;W.prototype.Ue = function () {
        y("Firebase.DataSnapshot.exportVal", 0, 0, arguments.length);return this.A.H(!0);
    };W.prototype.exportVal = W.prototype.Ue;W.prototype.Vf = function () {
        y("Firebase.DataSnapshot.exists", 0, 0, arguments.length);return !this.A.e();
    };W.prototype.exists = W.prototype.Vf;
    W.prototype.m = function (a) {
        y("Firebase.DataSnapshot.child", 0, 1, arguments.length);fa(a) && (a = String(a));Kf("Firebase.DataSnapshot.child", a);var b = new L(a),
            c = this.W.m(b);return new W(this.A.Q(b), c, N);
    };W.prototype.child = W.prototype.m;W.prototype.Fa = function (a) {
        y("Firebase.DataSnapshot.hasChild", 1, 1, arguments.length);Kf("Firebase.DataSnapshot.hasChild", a);var b = new L(a);return !this.A.Q(b).e();
    };W.prototype.hasChild = W.prototype.Fa;
    W.prototype.C = function () {
        y("Firebase.DataSnapshot.getPriority", 0, 0, arguments.length);return this.A.C().H();
    };W.prototype.getPriority = W.prototype.C;W.prototype.forEach = function (a) {
        y("Firebase.DataSnapshot.forEach", 1, 1, arguments.length);A("Firebase.DataSnapshot.forEach", 1, a, !1);if (this.A.J()) return !1;var b = this;return !!this.A.P(this.g, function (c, d) {
            return a(new W(d, b.W.m(c), N));
        });
    };W.prototype.forEach = W.prototype.forEach;
    W.prototype.kd = function () {
        y("Firebase.DataSnapshot.hasChildren", 0, 0, arguments.length);return this.A.J() ? !1 : !this.A.e();
    };W.prototype.hasChildren = W.prototype.kd;W.prototype.getKey = function () {
        y("Firebase.DataSnapshot.key", 0, 0, arguments.length);return this.W.getKey();
    };pd(W.prototype, "key", W.prototype.getKey);W.prototype.Fb = function () {
        y("Firebase.DataSnapshot.numChildren", 0, 0, arguments.length);return this.A.Fb();
    };W.prototype.numChildren = W.prototype.Fb;
    W.prototype.xb = function () {
        y("Firebase.DataSnapshot.ref", 0, 0, arguments.length);return this.W;
    };pd(W.prototype, "ref", W.prototype.xb);function Xd(a, b) {
        this.O = a;this.Ld = b;
    }function Ud(a, b, c, d) {
        return new Xd(new Ec(b, c, d), a.Ld);
    }function Yd(a) {
        return a.O.ea ? a.O.j() : null;
    }Xd.prototype.u = function () {
        return this.Ld;
    };function Fc(a) {
        return a.Ld.ea ? a.Ld.j() : null;
    };function ng(a, b) {
        this.W = a;var c = a.n,
            d = new ee(c.g),
            c = S(c) ? new ee(c.g) : c.xa ? new ke(c) : new fe(c);this.of = new Od(c);var e = b.u(),
            f = b.O,
            g = d.za(F, e.j(), null),
            k = c.za(F, f.j(), null);this.Na = new Xd(new Ec(k, f.ea, c.Qa()), new Ec(g, e.ea, d.Qa()));this.ab = [];this.Sf = new Jd(a);
    }function og(a) {
        return a.W;
    }h = ng.prototype;h.u = function () {
        return this.Na.u().j();
    };h.jb = function (a) {
        var b = Fc(this.Na);return b && (S(this.W.n) || !a.e() && !b.R(J(a)).e()) ? b.Q(a) : null;
    };h.e = function () {
        return 0 === this.ab.length;
    };h.Ob = function (a) {
        this.ab.push(a);
    };
    h.mb = function (a, b) {
        var c = [];if (b) {
            H(null == a, "A cancel should cancel all event registrations.");var d = this.W.path;Ja(this.ab, function (a) {
                (a = a.Pe(b, d)) && c.push(a);
            });
        }if (a) {
            for (var e = [], f = 0; f < this.ab.length; ++f) {
                var g = this.ab[f];if (!g.matches(a)) e.push(g);else if (a.af()) {
                    e = e.concat(this.ab.slice(f + 1));break;
                }
            }this.ab = e;
        } else this.ab = [];return c;
    };
    h.gb = function (a, b, c) {
        a.type === Gd && null !== a.source.Ib && (H(Fc(this.Na), "We should always have a full cache before handling merges"), H(Yd(this.Na), "Missing event cache, even though we have a server cache"));var d = this.Na;a = this.of.gb(d, a, b, c);b = this.of;c = a.Sd;H(c.O.j().zc(b.V.g), "Event snap not indexed");H(c.u().j().zc(b.V.g), "Server snap not indexed");H(Ic(a.Sd.u()) || !Ic(d.u()), "Once a server snap is complete, it should never go back");this.Na = a.Sd;return pg(this, a.Mf, a.Sd.O.j(), null);
    };
    function qg(a, b) {
        var c = a.Na.O,
            d = [];c.j().J() || c.j().P(N, function (a, b) {
            d.push(new I("child_added", b, a));
        });c.ea && d.push(Gc(c.j()));return pg(a, d, c.j(), b);
    }function pg(a, b, c, d) {
        return Kd(a.Sf, b, c, d ? [d] : a.ab);
    };function rg(a, b, c) {
        this.Qb = a;this.sb = b;this.ub = c || null;
    }h = rg.prototype;h.tf = function (a) {
        return "value" === a;
    };h.createEvent = function (a, b) {
        var c = b.n.g;return new yc("value", this, new W(a.Ma, b.xb(), c));
    };h.Ub = function (a) {
        var b = this.ub;if ("cancel" === a.ge()) {
            H(this.sb, "Raising a cancel event on a listener with no cancel callback");var c = this.sb;return function () {
                c.call(b, a.error);
            };
        }var d = this.Qb;return function () {
            d.call(b, a.Md);
        };
    };h.Pe = function (a, b) {
        return this.sb ? new zc(this, a, b) : null;
    };
    h.matches = function (a) {
        return a instanceof rg ? a.Qb && this.Qb ? a.Qb === this.Qb && a.ub === this.ub : !0 : !1;
    };h.af = function () {
        return null !== this.Qb;
    };function sg(a, b, c) {
        this.ha = a;this.sb = b;this.ub = c;
    }h = sg.prototype;h.tf = function (a) {
        a = "children_added" === a ? "child_added" : a;return ("children_removed" === a ? "child_removed" : a) in this.ha;
    };h.Pe = function (a, b) {
        return this.sb ? new zc(this, a, b) : null;
    };
    h.createEvent = function (a, b) {
        H(null != a.Za, "Child events should have a childName.");var c = b.xb().m(a.Za);return new yc(a.type, this, new W(a.Ma, c, b.n.g), a.Dd);
    };h.Ub = function (a) {
        var b = this.ub;if ("cancel" === a.ge()) {
            H(this.sb, "Raising a cancel event on a listener with no cancel callback");var c = this.sb;return function () {
                c.call(b, a.error);
            };
        }var d = this.ha[a.gd];return function () {
            d.call(b, a.Md, a.Dd);
        };
    };
    h.matches = function (a) {
        if (a instanceof sg) {
            if (!this.ha || !a.ha) return !0;if (this.ub === a.ub) {
                var b = qa(a.ha);if (b === qa(this.ha)) {
                    if (1 === b) {
                        var b = ra(a.ha),
                            c = ra(this.ha);return c === b && (!a.ha[b] || !this.ha[c] || a.ha[b] === this.ha[c]);
                    }return pa(this.ha, function (b, c) {
                        return a.ha[c] === b;
                    });
                }
            }
        }return !1;
    };h.af = function () {
        return null !== this.ha;
    };function X(a, b, c, d) {
        this.w = a;this.path = b;this.n = c;this.Oc = d;
    }
    function tg(a) {
        var b = null,
            c = null;a.ka && (b = he(a));a.na && (c = je(a));if (a.g === de) {
            if (a.ka) {
                if ("[MIN_NAME]" != ge(a)) throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if ("string" !== typeof b) throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");
            }if (a.na) {
                if ("[MAX_NAME]" != ie(a)) throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if ("string" !== typeof c) throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");
            }
        } else if (a.g === N) {
            if (null != b && !Cf(b) || null != c && !Cf(c)) throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");
        } else if (H(a.g instanceof we || a.g === Ce, "unknown index type."), null != b && "object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) || null != c && "object" === (typeof c === "undefined" ? "undefined" : _typeof(c))) throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
    }function ug(a) {
        if (a.ka && a.na && a.xa && (!a.xa || "" === a.oc)) throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
    }function vg(a, b) {
        if (!0 === a.Oc) throw Error(b + ": You can't combine multiple orderBy calls.");
    }h = X.prototype;h.xb = function () {
        y("Query.ref", 0, 0, arguments.length);return new U(this.w, this.path);
    };
    h.hc = function (a, b, c, d) {
        y("Query.on", 2, 4, arguments.length);If("Query.on", a, !1);A("Query.on", 2, b, !1);var e = wg("Query.on", c, d);if ("value" === a) xg(this.w, this, new rg(b, e.cancel || null, e.Pa || null));else {
            var f = {};f[a] = b;xg(this.w, this, new sg(f, e.cancel, e.Pa));
        }return b;
    };
    h.Jc = function (a, b, c) {
        y("Query.off", 0, 3, arguments.length);If("Query.off", a, !0);A("Query.off", 2, b, !0);Eb("Query.off", 3, c);var d = null,
            e = null;"value" === a ? d = new rg(b || null, null, c || null) : a && (b && (e = {}, e[a] = b), d = new sg(e, null, c || null));e = this.w;d = ".info" === J(this.path) ? e.pd.mb(this, d) : e.K.mb(this, d);uc(e.da, this.path, d);
    };
    h.kg = function (a, b) {
        function c(k) {
            f && (f = !1, e.Jc(a, c), b && b.call(d.Pa, k), g.resolve(k));
        }y("Query.once", 1, 4, arguments.length);If("Query.once", a, !1);A("Query.once", 2, b, !0);var d = wg("Query.once", arguments[2], arguments[3]),
            e = this,
            f = !0,
            g = new Hb();Jb(g.ra);this.hc(a, c, function (b) {
            e.Jc(a, c);d.cancel && d.cancel.call(d.Pa, b);g.reject(b);
        });return g.ra;
    };
    h.ne = function (a) {
        y("Query.limitToFirst", 1, 1, arguments.length);if (!fa(a) || Math.floor(a) !== a || 0 >= a) throw Error("Query.limitToFirst: First argument must be a positive integer.");if (this.n.xa) throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.w, this.path, this.n.ne(a), this.Oc);
    };
    h.oe = function (a) {
        y("Query.limitToLast", 1, 1, arguments.length);if (!fa(a) || Math.floor(a) !== a || 0 >= a) throw Error("Query.limitToLast: First argument must be a positive integer.");if (this.n.xa) throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.w, this.path, this.n.oe(a), this.Oc);
    };
    h.lg = function (a) {
        y("Query.orderByChild", 1, 1, arguments.length);if ("$key" === a) throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if ("$priority" === a) throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if ("$value" === a) throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Kf("Query.orderByChild", a);vg(this, "Query.orderByChild");var b = new L(a);if (b.e()) throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
        b = new we(b);b = Ge(this.n, b);tg(b);return new X(this.w, this.path, b, !0);
    };h.mg = function () {
        y("Query.orderByKey", 0, 0, arguments.length);vg(this, "Query.orderByKey");var a = Ge(this.n, de);tg(a);return new X(this.w, this.path, a, !0);
    };h.ng = function () {
        y("Query.orderByPriority", 0, 0, arguments.length);vg(this, "Query.orderByPriority");var a = Ge(this.n, N);tg(a);return new X(this.w, this.path, a, !0);
    };
    h.og = function () {
        y("Query.orderByValue", 0, 0, arguments.length);vg(this, "Query.orderByValue");var a = Ge(this.n, Ce);tg(a);return new X(this.w, this.path, a, !0);
    };h.Nd = function (a, b) {
        y("Query.startAt", 0, 2, arguments.length);Df("Query.startAt", a, this.path, !0);Jf("Query.startAt", b);var c = this.n.Nd(a, b);ug(c);tg(c);if (this.n.ka) throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");p(a) || (b = a = null);return new X(this.w, this.path, c, this.Oc);
    };
    h.fd = function (a, b) {
        y("Query.endAt", 0, 2, arguments.length);Df("Query.endAt", a, this.path, !0);Jf("Query.endAt", b);var c = this.n.fd(a, b);ug(c);tg(c);if (this.n.na) throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.w, this.path, c, this.Oc);
    };
    h.Rf = function (a, b) {
        y("Query.equalTo", 1, 2, arguments.length);Df("Query.equalTo", a, this.path, !1);Jf("Query.equalTo", b);if (this.n.ka) throw Error("Query.equalTo: Starting point was already set (by another call to endAt or equalTo).");if (this.n.na) throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a, b).fd(a, b);
    };
    h.toString = function () {
        y("Query.toString", 0, 0, arguments.length);for (var a = this.path, b = "", c = a.Z; c < a.o.length; c++) {
            "" !== a.o[c] && (b += "/" + encodeURIComponent(String(a.o[c])));
        }return this.w.toString() + (b || "/");
    };h.ya = function () {
        var a = kd(He(this.n));return "{}" === a ? "default" : a;
    };
    function wg(a, b, c) {
        var d = { cancel: null, Pa: null };if (b && c) d.cancel = b, A(a, 3, d.cancel, !0), d.Pa = c, Eb(a, 4, d.Pa);else if (b) if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) d.Pa = b;else if ("function" === typeof b) d.cancel = b;else throw Error(Db(a, 3, !0) + " must either be a cancel callback or a context object.");return d;
    }X.prototype.on = X.prototype.hc;X.prototype.off = X.prototype.Jc;X.prototype.once = X.prototype.kg;X.prototype.limitToFirst = X.prototype.ne;X.prototype.limitToLast = X.prototype.oe;X.prototype.orderByChild = X.prototype.lg;
    X.prototype.orderByKey = X.prototype.mg;X.prototype.orderByPriority = X.prototype.ng;X.prototype.orderByValue = X.prototype.og;X.prototype.startAt = X.prototype.Nd;X.prototype.endAt = X.prototype.fd;X.prototype.equalTo = X.prototype.Rf;X.prototype.toString = X.prototype.toString;pd(X.prototype, "ref", X.prototype.xb);function yg(a, b) {
        this.value = a;this.children = b || zg;
    }var zg = new Uf(function (a, b) {
        return a === b ? 0 : a < b ? -1 : 1;
    });function Ag(a) {
        var b = Q;t(a, function (a, d) {
            b = b.set(new L(d), a);
        });return b;
    }h = yg.prototype;h.e = function () {
        return null === this.value && this.children.e();
    };function Bg(a, b, c) {
        if (null != a.value && c(a.value)) return { path: C, value: a.value };if (b.e()) return null;var d = J(b);a = a.children.get(d);return null !== a ? (b = Bg(a, D(b), c), null != b ? { path: new L(d).m(b.path), value: b.value } : null) : null;
    }
    function Cg(a, b) {
        return Bg(a, b, function () {
            return !0;
        });
    }h.subtree = function (a) {
        if (a.e()) return this;var b = this.children.get(J(a));return null !== b ? b.subtree(D(a)) : Q;
    };h.set = function (a, b) {
        if (a.e()) return new yg(b, this.children);var c = J(a),
            d = (this.children.get(c) || Q).set(D(a), b),
            c = this.children.Ra(c, d);return new yg(this.value, c);
    };
    h.remove = function (a) {
        if (a.e()) return this.children.e() ? Q : new yg(null, this.children);var b = J(a),
            c = this.children.get(b);return c ? (a = c.remove(D(a)), b = a.e() ? this.children.remove(b) : this.children.Ra(b, a), null === this.value && b.e() ? Q : new yg(this.value, b)) : this;
    };h.get = function (a) {
        if (a.e()) return this.value;var b = this.children.get(J(a));return b ? b.get(D(a)) : null;
    };
    function ce(a, b, c) {
        if (b.e()) return c;var d = J(b);b = ce(a.children.get(d) || Q, D(b), c);d = b.e() ? a.children.remove(d) : a.children.Ra(d, b);return new yg(a.value, d);
    }function Dg(a, b) {
        return Eg(a, C, b);
    }function Eg(a, b, c) {
        var d = {};a.children.ia(function (a, f) {
            d[a] = Eg(f, b.m(a), c);
        });return c(b, a.value, d);
    }function Fg(a, b, c) {
        return Gg(a, b, C, c);
    }function Gg(a, b, c, d) {
        var e = a.value ? d(c, a.value) : !1;if (e) return e;if (b.e()) return null;e = J(b);return (a = a.children.get(e)) ? Gg(a, D(b), c.m(e), d) : null;
    }
    function Hg(a, b, c) {
        Ig(a, b, C, c);
    }function Ig(a, b, c, d) {
        if (b.e()) return a;a.value && d(c, a.value);var e = J(b);return (a = a.children.get(e)) ? Ig(a, D(b), c.m(e), d) : Q;
    }function ae(a, b) {
        Jg(a, C, b);
    }function Jg(a, b, c) {
        a.children.ia(function (a, e) {
            Jg(e, b.m(a), c);
        });a.value && c(b, a.value);
    }function Kg(a, b) {
        a.children.ia(function (a, d) {
            d.value && b(a, d.value);
        });
    }var Q = new yg(null);yg.prototype.toString = function () {
        var a = {};ae(this, function (b, c) {
            a[b.toString()] = c.toString();
        });return B(a);
    };function Lg(a, b, c) {
        this.type = Td;this.source = Mg;this.path = a;this.Pb = b;this.Id = c;
    }Lg.prototype.Nc = function (a) {
        if (this.path.e()) {
            if (null != this.Pb.value) return H(this.Pb.children.e(), "affectedTree should not have overlapping affected paths."), this;a = this.Pb.subtree(new L(a));return new Lg(C, a, this.Id);
        }H(J(this.path) === a, "operationForChild called for unrelated child.");return new Lg(D(this.path), this.Pb, this.Id);
    };
    Lg.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " ack write revert=" + this.Id + " affectedTree=" + this.Pb + ")";
    };var ac = 0,
        Gd = 1,
        Td = 2,
        cc = 3;function Ng(a, b, c, d) {
        this.ee = a;this.We = b;this.Ib = c;this.Ee = d;H(!d || b, "Tagged queries must be from server.");
    }var Mg = new Ng(!0, !1, null, !1),
        Og = new Ng(!1, !0, null, !1);Ng.prototype.toString = function () {
        return this.ee ? "user" : this.Ee ? "server(queryID=" + this.Ib + ")" : "server";
    };function Pg(a) {
        this.X = a;
    }var Qg = new Pg(new yg(null));function Rg(a, b, c) {
        if (b.e()) return new Pg(new yg(c));var d = Cg(a.X, b);if (null != d) {
            var e = d.path,
                d = d.value;b = T(e, b);d = d.F(b, c);return new Pg(a.X.set(e, d));
        }a = ce(a.X, b, new yg(c));return new Pg(a);
    }function Sg(a, b, c) {
        var d = a;Cb(c, function (a, c) {
            d = Rg(d, b.m(a), c);
        });return d;
    }Pg.prototype.Ed = function (a) {
        if (a.e()) return Qg;a = ce(this.X, a, Q);return new Pg(a);
    };function Tg(a, b) {
        var c = Cg(a.X, b);return null != c ? a.X.get(c.path).Q(T(c.path, b)) : null;
    }
    function Ug(a) {
        var b = [],
            c = a.X.value;null != c ? c.J() || c.P(N, function (a, c) {
            b.push(new K(a, c));
        }) : a.X.children.ia(function (a, c) {
            null != c.value && b.push(new K(a, c.value));
        });return b;
    }function Vg(a, b) {
        if (b.e()) return a;var c = Tg(a, b);return null != c ? new Pg(new yg(c)) : new Pg(a.X.subtree(b));
    }Pg.prototype.e = function () {
        return this.X.e();
    };Pg.prototype.apply = function (a) {
        return Wg(C, this.X, a);
    };
    function Wg(a, b, c) {
        if (null != b.value) return c.F(a, b.value);var d = null;b.children.ia(function (b, f) {
            ".priority" === b ? (H(null !== f.value, "Priority writes must always be leaf nodes"), d = f.value) : c = Wg(a.m(b), f, c);
        });c.Q(a).e() || null === d || (c = c.F(a.m(".priority"), d));return c;
    };function Xg() {
        this.Aa = {};
    }h = Xg.prototype;h.e = function () {
        return xa(this.Aa);
    };h.gb = function (a, b, c) {
        var d = a.source.Ib;if (null !== d) return d = x(this.Aa, d), H(null != d, "SyncTree gave us an op for an invalid query."), d.gb(a, b, c);var e = [];t(this.Aa, function (d) {
            e = e.concat(d.gb(a, b, c));
        });return e;
    };h.Ob = function (a, b, c, d, e) {
        var f = a.ya(),
            g = x(this.Aa, f);if (!g) {
            var g = c.Ba(e ? d : null),
                k = !1;g ? k = !0 : (g = d instanceof P ? c.sc(d) : F, k = !1);g = new ng(a, new Xd(new Ec(g, k, !1), new Ec(d, e, !1)));this.Aa[f] = g;
        }g.Ob(b);return qg(g, b);
    };
    h.mb = function (a, b, c) {
        var d = a.ya(),
            e = [],
            f = [],
            g = null != Yg(this);if ("default" === d) {
            var k = this;t(this.Aa, function (a, d) {
                f = f.concat(a.mb(b, c));a.e() && (delete k.Aa[d], S(a.W.n) || e.push(a.W));
            });
        } else {
            var m = x(this.Aa, d);m && (f = f.concat(m.mb(b, c)), m.e() && (delete this.Aa[d], S(m.W.n) || e.push(m.W)));
        }g && null == Yg(this) && e.push(new U(a.w, a.path));return { sg: e, Tf: f };
    };function Zg(a) {
        return Ka(sa(a.Aa), function (a) {
            return !S(a.W.n);
        });
    }h.jb = function (a) {
        var b = null;t(this.Aa, function (c) {
            b = b || c.jb(a);
        });return b;
    };
    function $g(a, b) {
        if (S(b.n)) return Yg(a);var c = b.ya();return x(a.Aa, c);
    }function Yg(a) {
        return wa(a.Aa, function (a) {
            return S(a.W.n);
        }) || null;
    };function ah() {
        this.T = Qg;this.la = [];this.Cc = -1;
    }function bh(a, b) {
        for (var c = 0; c < a.la.length; c++) {
            var d = a.la[c];if (d.Zc === b) return d;
        }return null;
    }h = ah.prototype;
    h.Ed = function (a) {
        var b = Pa(this.la, function (b) {
            return b.Zc === a;
        });H(0 <= b, "removeWrite called with nonexistent writeId.");var c = this.la[b];this.la.splice(b, 1);for (var d = c.visible, e = !1, f = this.la.length - 1; d && 0 <= f;) {
            var g = this.la[f];g.visible && (f >= b && ch(g, c.path) ? d = !1 : c.path.contains(g.path) && (e = !0));f--;
        }if (d) {
            if (e) this.T = dh(this.la, eh, C), this.Cc = 0 < this.la.length ? this.la[this.la.length - 1].Zc : -1;else if (c.Ja) this.T = this.T.Ed(c.path);else {
                var k = this;t(c.children, function (a, b) {
                    k.T = k.T.Ed(c.path.m(b));
                });
            }return !0;
        }return !1;
    };
    h.Ba = function (a, b, c, d) {
        if (c || d) {
            var e = Vg(this.T, a);return !d && e.e() ? b : d || null != b || null != Tg(e, C) ? (e = dh(this.la, function (b) {
                return (b.visible || d) && (!c || !(0 <= Ia(c, b.Zc))) && (b.path.contains(a) || a.contains(b.path));
            }, a), b = b || F, e.apply(b)) : null;
        }e = Tg(this.T, a);if (null != e) return e;e = Vg(this.T, a);return e.e() ? b : null != b || null != Tg(e, C) ? (b = b || F, e.apply(b)) : null;
    };
    h.sc = function (a, b) {
        var c = F,
            d = Tg(this.T, a);if (d) d.J() || d.P(N, function (a, b) {
            c = c.U(a, b);
        });else if (b) {
            var e = Vg(this.T, a);b.P(N, function (a, b) {
                var d = Vg(e, new L(a)).apply(b);c = c.U(a, d);
            });Ja(Ug(e), function (a) {
                c = c.U(a.name, a.S);
            });
        } else e = Vg(this.T, a), Ja(Ug(e), function (a) {
            c = c.U(a.name, a.S);
        });return c;
    };h.$c = function (a, b, c, d) {
        H(c || d, "Either existingEventSnap or existingServerSnap must exist");a = a.m(b);if (null != Tg(this.T, a)) return null;a = Vg(this.T, a);return a.e() ? d.Q(b) : a.apply(d.Q(b));
    };
    h.rc = function (a, b, c) {
        a = a.m(b);var d = Tg(this.T, a);return null != d ? d : Dc(c, b) ? Vg(this.T, a).apply(c.j().R(b)) : null;
    };h.mc = function (a) {
        return Tg(this.T, a);
    };h.Xd = function (a, b, c, d, e, f) {
        var g;a = Vg(this.T, a);g = Tg(a, C);if (null == g) if (null != b) g = a.apply(b);else return [];g = g.ob(f);if (g.e() || g.J()) return [];b = [];a = ne(f);e = e ? g.$b(c, f) : g.Yb(c, f);for (f = R(e); f && b.length < d;) {
            0 !== a(f, c) && b.push(f), f = R(e);
        }return b;
    };
    function ch(a, b) {
        return a.Ja ? a.path.contains(b) : !!va(a.children, function (c, d) {
            return a.path.m(d).contains(b);
        });
    }function eh(a) {
        return a.visible;
    }
    function dh(a, b, c) {
        for (var d = Qg, e = 0; e < a.length; ++e) {
            var f = a[e];if (b(f)) {
                var g = f.path;if (f.Ja) c.contains(g) ? (g = T(c, g), d = Rg(d, g, f.Ja)) : g.contains(c) && (g = T(g, c), d = Rg(d, C, f.Ja.Q(g)));else if (f.children) {
                    if (c.contains(g)) g = T(c, g), d = Sg(d, g, f.children);else {
                        if (g.contains(c)) if (g = T(g, c), g.e()) d = Sg(d, C, f.children);else if (f = x(f.children, J(g))) f = f.Q(D(g)), d = Rg(d, C, f);
                    }
                } else throw Xc("WriteRecord should have .snap or .children");
            }
        }return d;
    }function fh(a, b) {
        this.Mb = a;this.X = b;
    }h = fh.prototype;
    h.Ba = function (a, b, c) {
        return this.X.Ba(this.Mb, a, b, c);
    };h.sc = function (a) {
        return this.X.sc(this.Mb, a);
    };h.$c = function (a, b, c) {
        return this.X.$c(this.Mb, a, b, c);
    };h.mc = function (a) {
        return this.X.mc(this.Mb.m(a));
    };h.Xd = function (a, b, c, d, e) {
        return this.X.Xd(this.Mb, a, b, c, d, e);
    };h.rc = function (a, b) {
        return this.X.rc(this.Mb, a, b);
    };h.m = function (a) {
        return new fh(this.Mb.m(a), this.X);
    };function gh() {
        this.children = {};this.ad = 0;this.value = null;
    }function hh(a, b, c) {
        this.ud = a ? a : "";this.Ha = b ? b : null;this.A = c ? c : new gh();
    }function ih(a, b) {
        for (var c = b instanceof L ? b : new L(b), d = a, e; null !== (e = J(c));) {
            d = new hh(e, d, x(d.A.children, e) || new gh()), c = D(c);
        }return d;
    }h = hh.prototype;h.Ea = function () {
        return this.A.value;
    };function jh(a, b) {
        H("undefined" !== typeof b, "Cannot set value to undefined");a.A.value = b;kh(a);
    }h.clear = function () {
        this.A.value = null;this.A.children = {};this.A.ad = 0;kh(this);
    };
    h.kd = function () {
        return 0 < this.A.ad;
    };h.e = function () {
        return null === this.Ea() && !this.kd();
    };h.P = function (a) {
        var b = this;t(this.A.children, function (c, d) {
            a(new hh(d, b, c));
        });
    };function lh(a, b, c, d) {
        c && !d && b(a);a.P(function (a) {
            lh(a, b, !0, d);
        });c && d && b(a);
    }function mh(a, b) {
        for (var c = a.parent(); null !== c && !b(c);) {
            c = c.parent();
        }
    }h.path = function () {
        return new L(null === this.Ha ? this.ud : this.Ha.path() + "/" + this.ud);
    };h.name = function () {
        return this.ud;
    };h.parent = function () {
        return this.Ha;
    };
    function kh(a) {
        if (null !== a.Ha) {
            var b = a.Ha,
                c = a.ud,
                d = a.e(),
                e = Bb(b.A.children, c);d && e ? (delete b.A.children[c], b.A.ad--, kh(b)) : d || e || (b.A.children[c] = a.A, b.A.ad++, kh(b));
        }
    };function nh(a, b, c, d, e, f) {
        this.id = oh++;this.f = cd("p:" + this.id + ":");this.qd = {};this.$ = {};this.pa = [];this.Pc = 0;this.Lc = [];this.ma = !1;this.Va = 1E3;this.td = 3E5;this.Hb = b;this.Kc = c;this.ue = d;this.M = a;this.pb = this.Ia = this.Db = this.ze = null;this.Vd = e;this.de = !1;this.ke = 0;if (f) throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Je = f || null;this.vb = null;this.Nb = !1;this.Gd = {};this.tg = 0;this.Ve = !0;this.Bc = this.me = null;ph(this, 0);Sf.Wb().hc("visible", this.jg, this);-1 === a.host.indexOf("fblocal") && Rf.Wb().hc("online", this.ig, this);
    }var oh = 0,
        qh = 0;h = nh.prototype;h.ua = function (a, b, c) {
        var d = ++this.tg;a = { r: d, a: a, b: b };this.f(B(a));H(this.ma, "sendRequest call when we're not connected not allowed.");this.Ia.ua(a);c && (this.Gd[d] = c);
    };
    h.df = function (a, b, c, d) {
        var e = a.ya(),
            f = a.path.toString();this.f("Listen called for " + f + " " + e);this.$[f] = this.$[f] || {};H(Cd(a.n) || !S(a.n), "listen() called for non-default but complete query");H(!this.$[f][e], "listen() called twice for same path/queryId.");a = { G: d, ld: b, pg: a, tag: c };this.$[f][e] = a;this.ma && rh(this, a);
    };
    function rh(a, b) {
        var c = b.pg,
            d = c.path.toString(),
            e = c.ya();a.f("Listen on " + d + " for " + e);var f = { p: d };b.tag && (f.q = He(c.n), f.t = b.tag);f.h = b.ld();a.ua("q", f, function (f) {
            var k = f.d,
                m = f.s;if (k && "object" === (typeof k === "undefined" ? "undefined" : _typeof(k)) && Bb(k, "w")) {
                var l = x(k, "w");da(l) && 0 <= Ia(l, "no_index") && O("Using an unspecified index. Consider adding " + ('".indexOn": "' + c.n.g.toString() + '"') + " at " + c.path.toString() + " to your security rules for better performance");
            }(a.$[d] && a.$[d][e]) === b && (a.f("listen response", f), "ok" !== m && sh(a, d, e), b.G && b.G(m, k));
        });
    }h.qf = function (a) {
        this.pb = a;this.f("Auth token refreshed");this.pb ? th(this) : this.ma && this.ua("unauth", {}, function () {});if (a && 40 === a.length || sd(a)) this.f("Admin auth credential detected.  Reducing max reconnect time."), this.td = 3E4;
    };function th(a) {
        if (a.ma && a.pb) {
            var b = a.pb,
                c = rd(b) ? "auth" : "gauth",
                d = { cred: b };a.Je && (d.authvar = a.Je);a.ua(c, d, function (c) {
                var d = c.s;c = c.d || "error";a.pb === b && ("ok" === d ? this.ke = 0 : uh(a, d, c));
            });
        }
    }
    h.Ef = function (a, b) {
        var c = a.path.toString(),
            d = a.ya();this.f("Unlisten called for " + c + " " + d);H(Cd(a.n) || !S(a.n), "unlisten() called for non-default but complete query");if (sh(this, c, d) && this.ma) {
            var e = He(a.n);this.f("Unlisten on " + c + " for " + d);c = { p: c };b && (c.q = e, c.t = b);this.ua("n", c);
        }
    };h.re = function (a, b, c) {
        this.ma ? vh(this, "o", a, b, c) : this.Lc.push({ we: a, action: "o", data: b, G: c });
    };h.gf = function (a, b, c) {
        this.ma ? vh(this, "om", a, b, c) : this.Lc.push({ we: a, action: "om", data: b, G: c });
    };
    h.xd = function (a, b) {
        this.ma ? vh(this, "oc", a, null, b) : this.Lc.push({ we: a, action: "oc", data: null, G: b });
    };function vh(a, b, c, d, e) {
        c = { p: c, d: d };a.f("onDisconnect " + b, c);a.ua(b, c, function (a) {
            e && setTimeout(function () {
                e(a.s, a.d);
            }, Math.floor(0));
        });
    }h.put = function (a, b, c, d) {
        wh(this, "p", a, b, c, d);
    };h.ef = function (a, b, c, d) {
        wh(this, "m", a, b, c, d);
    };function wh(a, b, c, d, e, f) {
        d = { p: c, d: d };p(f) && (d.h = f);a.pa.push({ action: b, sf: d, G: e });a.Pc++;b = a.pa.length - 1;a.ma ? xh(a, b) : a.f("Buffering put: " + c);
    }
    function xh(a, b) {
        var c = a.pa[b].action,
            d = a.pa[b].sf,
            e = a.pa[b].G;a.pa[b].qg = a.ma;a.ua(c, d, function (d) {
            a.f(c + " response", d);delete a.pa[b];a.Pc--;0 === a.Pc && (a.pa = []);e && e(d.s, d.d);
        });
    }h.ye = function (a) {
        this.ma && (a = { c: a }, this.f("reportStats", a), this.ua("s", a, function (a) {
            "ok" !== a.s && this.f("reportStats", "Error sending stats: " + a.d);
        }));
    };
    h.wd = function (a) {
        if ("r" in a) {
            this.f("from server: " + B(a));var b = a.r,
                c = this.Gd[b];c && (delete this.Gd[b], c(a.b));
        } else {
            if ("error" in a) throw "A server-side error has occurred: " + a.error;"a" in a && (b = a.a, a = a.b, this.f("handleServerMessage", b, a), "d" === b ? this.Hb(a.p, a.d, !1, a.t) : "m" === b ? this.Hb(a.p, a.d, !0, a.t) : "c" === b ? yh(this, a.p, a.q) : "ac" === b ? uh(this, a.s, a.d) : "sd" === b ? this.ze ? this.ze(a) : "msg" in a && "undefined" !== typeof console && console.log("FIREBASE: " + a.msg.replace("\n", "\nFIREBASE: ")) : dd("Unrecognized action received from server: " + B(b) + "\nAre you using the latest client?"));
        }
    };h.Mc = function (a, b) {
        this.f("connection ready");this.ma = !0;this.Bc = new Date().getTime();this.ue({ serverTimeOffset: a - new Date().getTime() });this.Db = b;if (this.Ve) {
            var c = {};c["sdk.js." + firebase.SDK_VERSION.replace(/\./g, "-")] = 1;Qb() ? c["framework.cordova"] = 1 : "object" === (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) && "ReactNative" === navigator.product && (c["framework.reactnative"] = 1);this.ye(c);
        }zh(this);this.Ve = !1;this.Kc(!0);
    };
    function ph(a, b) {
        H(!a.Ia, "Scheduling a connect when we're already connected/ing?");a.vb && clearTimeout(a.vb);a.vb = setTimeout(function () {
            a.vb = null;Ah(a);
        }, Math.floor(b));
    }h.jg = function (a) {
        a && !this.Nb && this.Va === this.td && (this.f("Window became visible.  Reducing delay."), this.Va = 1E3, this.Ia || ph(this, 0));this.Nb = a;
    };h.ig = function (a) {
        a ? (this.f("Browser went online."), this.Va = 1E3, this.Ia || ph(this, 0)) : (this.f("Browser went offline.  Killing connection."), this.Ia && this.Ia.close());
    };
    h.jf = function () {
        this.f("data client disconnected");this.ma = !1;this.Ia = null;for (var a = 0; a < this.pa.length; a++) {
            var b = this.pa[a];b && "h" in b.sf && b.qg && (b.G && b.G("disconnect"), delete this.pa[a], this.Pc--);
        }0 === this.Pc && (this.pa = []);this.Gd = {};Bh(this) && (this.Nb ? this.Bc && (3E4 < new Date().getTime() - this.Bc && (this.Va = 1E3), this.Bc = null) : (this.f("Window isn't visible.  Delaying reconnect."), this.Va = this.td, this.me = new Date().getTime()), a = Math.max(0, this.Va - (new Date().getTime() - this.me)), a *= Math.random(), this.f("Trying to reconnect in " + a + "ms"), ph(this, a), this.Va = Math.min(this.td, 1.3 * this.Va));this.Kc(!1);
    };
    function Ah(a) {
        if (Bh(a)) {
            a.f("Making a connection attempt");a.me = new Date().getTime();a.Bc = null;var b = r(a.wd, a),
                c = r(a.Mc, a),
                d = r(a.jf, a),
                e = a.id + ":" + qh++,
                f = a.Db,
                g = !1,
                k = null,
                m = function m() {
                k ? k.close() : (g = !0, d());
            };a.Ia = { close: m, ua: function ua(a) {
                    H(k, "sendRequest call when we're not connected not allowed.");k.ua(a);
                } };var l = a.de;a.de = !1;a.Vd.getToken(l).then(function (l) {
                g ? E("getToken() completed but was canceled") : (E("getToken() completed. Creating connection."), a.pb = l && l.accessToken, k = new af(e, a.M, b, c, d, function (b) {
                    O(b + " (" + a.M.toString() + ")");a.eb("server_kill");
                }, f));
            }).then(null, function (b) {
                a.f("Failed to get token: " + b);g || m();
            });
        }
    }h.eb = function (a) {
        E("Interrupting connection for reason: " + a);this.qd[a] = !0;this.Ia ? this.Ia.close() : (this.vb && (clearTimeout(this.vb), this.vb = null), this.ma && this.jf());
    };h.lc = function (a) {
        E("Resuming connection for reason: " + a);delete this.qd[a];xa(this.qd) && (this.Va = 1E3, this.Ia || ph(this, 0));
    };
    function yh(a, b, c) {
        c = c ? La(c, function (a) {
            return kd(a);
        }).join("$") : "default";(a = sh(a, b, c)) && a.G && a.G("permission_denied");
    }function sh(a, b, c) {
        b = new L(b).toString();var d;p(a.$[b]) ? (d = a.$[b][c], delete a.$[b][c], 0 === qa(a.$[b]) && delete a.$[b]) : d = void 0;return d;
    }
    function uh(a, b, c) {
        E("Auth token revoked: " + b + "/" + c);a.pb = null;a.de = !0;a.Ia.close();"invalid_token" === b && (a.ke++, 3 <= a.ke && (a.Va = 3E4, O("Provided authentication credentials are invalid. This usually indicates your FirebaseApp instance was not initialized correctly. Make sure your apiKey and databaseURL match the values provided for your app at https://console.firebase.google.com/, or if you're using a service account, make sure it's authorized to access the specified databaseURL and is from the correct project.")));
    }
    function zh(a) {
        th(a);t(a.$, function (b) {
            t(b, function (b) {
                rh(a, b);
            });
        });for (var b = 0; b < a.pa.length; b++) {
            a.pa[b] && xh(a, b);
        }for (; a.Lc.length;) {
            b = a.Lc.shift(), vh(a, b.action, b.we, b.data, b.G);
        }
    }function Bh(a) {
        var b;b = Rf.Wb().ic;return xa(a.qd) && b;
    };var Y = { Xf: function Xf() {
            Qe = wd = !0;
        } };Y.forceLongPolling = Y.Xf;Y.Yf = function () {
        Re = !0;
    };Y.forceWebSockets = Y.Yf;Y.dg = function () {
        return vd.isAvailable();
    };Y.isWebSocketsAvailable = Y.dg;Y.wg = function (a, b) {
        a.w.Ua.ze = b;
    };Y.setSecurityDebugCallback = Y.wg;Y.Be = function (a, b) {
        a.w.Be(b);
    };Y.stats = Y.Be;Y.Ce = function (a, b) {
        a.w.Ce(b);
    };Y.statsIncrementCounter = Y.Ce;Y.ed = function (a) {
        return a.w.ed;
    };Y.dataUpdateCount = Y.ed;Y.cg = function (a, b) {
        a.w.je = b;
    };Y.interceptServerData = Y.cg;function Ch(a) {
        this.wa = Q;this.lb = new ah();this.De = {};this.jc = {};this.Dc = a;
    }function Dh(a, b, c, d, e) {
        var f = a.lb,
            g = e;H(d > f.Cc, "Stacking an older write on top of newer ones");p(g) || (g = !0);f.la.push({ path: b, Ja: c, Zc: d, visible: g });g && (f.T = Rg(f.T, b, c));f.Cc = d;return e ? Eh(a, new $b(Mg, b, c)) : [];
    }function Fh(a, b, c, d) {
        var e = a.lb;H(d > e.Cc, "Stacking an older merge on top of newer ones");e.la.push({ path: b, children: c, Zc: d, visible: !0 });e.T = Sg(e.T, b, c);e.Cc = d;c = Ag(c);return Eh(a, new Fd(Mg, b, c));
    }
    function Gh(a, b, c) {
        c = c || !1;var d = bh(a.lb, b);if (a.lb.Ed(b)) {
            var e = Q;null != d.Ja ? e = e.set(C, !0) : Cb(d.children, function (a, b) {
                e = e.set(new L(a), b);
            });return Eh(a, new Lg(d.path, e, c));
        }return [];
    }function Hh(a, b, c) {
        c = Ag(c);return Eh(a, new Fd(Og, b, c));
    }function Ih(a, b, c, d) {
        d = Jh(a, d);if (null != d) {
            var e = Kh(d);d = e.path;e = e.Ib;b = T(d, b);c = new $b(new Ng(!1, !0, e, !0), b, c);return Lh(a, d, c);
        }return [];
    }
    function Mh(a, b, c, d) {
        if (d = Jh(a, d)) {
            var e = Kh(d);d = e.path;e = e.Ib;b = T(d, b);c = Ag(c);c = new Fd(new Ng(!1, !0, e, !0), b, c);return Lh(a, d, c);
        }return [];
    }
    Ch.prototype.Ob = function (a, b) {
        var c = a.path,
            d = null,
            e = !1;Hg(this.wa, c, function (a, b) {
            var f = T(a, c);d = d || b.jb(f);e = e || null != Yg(b);
        });var f = this.wa.get(c);f ? (e = e || null != Yg(f), d = d || f.jb(C)) : (f = new Xg(), this.wa = this.wa.set(c, f));var g;null != d ? g = !0 : (g = !1, d = F, Kg(this.wa.subtree(c), function (a, b) {
            var c = b.jb(C);c && (d = d.U(a, c));
        }));var k = null != $g(f, a);if (!k && !S(a.n)) {
            var m = Nh(a);H(!(m in this.jc), "View does not exist, but we have a tag");var l = Oh++;this.jc[m] = l;this.De["_" + l] = m;
        }g = f.Ob(a, b, new fh(c, this.lb), d, g);k || e || (f = $g(f, a), g = g.concat(Ph(this, a, f)));return g;
    };
    Ch.prototype.mb = function (a, b, c) {
        var d = a.path,
            e = this.wa.get(d),
            f = [];if (e && ("default" === a.ya() || null != $g(e, a))) {
            f = e.mb(a, b, c);e.e() && (this.wa = this.wa.remove(d));e = f.sg;f = f.Tf;b = -1 !== Pa(e, function (a) {
                return S(a.n);
            });var g = Fg(this.wa, d, function (a, b) {
                return null != Yg(b);
            });if (b && !g && (d = this.wa.subtree(d), !d.e())) for (var d = Qh(d), k = 0; k < d.length; ++k) {
                var m = d[k],
                    l = m.W,
                    m = Rh(this, m);this.Dc.Ae(Sh(l), Th(this, l), m.ld, m.G);
            }if (!g && 0 < e.length && !c) if (b) this.Dc.Od(Sh(a), null);else {
                var u = this;Ja(e, function (a) {
                    a.ya();
                    var b = u.jc[Nh(a)];u.Dc.Od(Sh(a), b);
                });
            }Uh(this, e);
        }return f;
    };Ch.prototype.Ba = function (a, b) {
        var c = this.lb,
            d = Fg(this.wa, a, function (b, c) {
            var d = T(b, a);if (d = c.jb(d)) return d;
        });return c.Ba(a, d, b, !0);
    };function Qh(a) {
        return Dg(a, function (a, c, d) {
            if (c && null != Yg(c)) return [Yg(c)];var e = [];c && (e = Zg(c));t(d, function (a) {
                e = e.concat(a);
            });return e;
        });
    }function Uh(a, b) {
        for (var c = 0; c < b.length; ++c) {
            var d = b[c];if (!S(d.n)) {
                var d = Nh(d),
                    e = a.jc[d];delete a.jc[d];delete a.De["_" + e];
            }
        }
    }
    function Sh(a) {
        return S(a.n) && !Cd(a.n) ? a.xb() : a;
    }function Ph(a, b, c) {
        var d = b.path,
            e = Th(a, b);c = Rh(a, c);b = a.Dc.Ae(Sh(b), e, c.ld, c.G);d = a.wa.subtree(d);if (e) H(null == Yg(d.value), "If we're adding a query, it shouldn't be shadowed");else for (e = Dg(d, function (a, b, c) {
            if (!a.e() && b && null != Yg(b)) return [og(Yg(b))];var d = [];b && (d = d.concat(La(Zg(b), function (a) {
                return a.W;
            })));t(c, function (a) {
                d = d.concat(a);
            });return d;
        }), d = 0; d < e.length; ++d) {
            c = e[d], a.Dc.Od(Sh(c), Th(a, c));
        }return b;
    }
    function Rh(a, b) {
        var c = b.W,
            d = Th(a, c);return {
            ld: function ld() {
                return (b.u() || F).hash();
            }, G: function G(b) {
                if ("ok" === b) {
                    if (d) {
                        var f = c.path;if (b = Jh(a, d)) {
                            var g = Kh(b);b = g.path;g = g.Ib;f = T(b, f);f = new bc(new Ng(!1, !0, g, !0), f);b = Lh(a, b, f);
                        } else b = [];
                    } else b = Eh(a, new bc(Og, c.path));return b;
                }f = "Unknown Error";"too_big" === b ? f = "The data requested exceeds the maximum size that can be accessed with a single request." : "permission_denied" == b ? f = "Client doesn't have permission to access the desired data." : "unavailable" == b && (f = "The service is unavailable");f = Error(b + " at " + c.path.toString() + ": " + f);f.code = b.toUpperCase();return a.mb(c, null, f);
            }
        };
    }function Nh(a) {
        return a.path.toString() + "$" + a.ya();
    }function Kh(a) {
        var b = a.indexOf("$");H(-1 !== b && b < a.length - 1, "Bad queryKey.");return { Ib: a.substr(b + 1), path: new L(a.substr(0, b)) };
    }function Jh(a, b) {
        var c = a.De,
            d = "_" + b;return d in c ? c[d] : void 0;
    }function Th(a, b) {
        var c = Nh(b);return x(a.jc, c);
    }var Oh = 1;
    function Lh(a, b, c) {
        var d = a.wa.get(b);H(d, "Missing sync point for query tag that we're tracking");return d.gb(c, new fh(b, a.lb), null);
    }function Eh(a, b) {
        return Vh(a, b, a.wa, null, new fh(C, a.lb));
    }function Vh(a, b, c, d, e) {
        if (b.path.e()) return Wh(a, b, c, d, e);var f = c.get(C);null == d && null != f && (d = f.jb(C));var g = [],
            k = J(b.path),
            m = b.Nc(k);if ((c = c.children.get(k)) && m) var l = d ? d.R(k) : null,
            k = e.m(k),
            g = g.concat(Vh(a, m, c, l, k));f && (g = g.concat(f.gb(b, e, d)));return g;
    }
    function Wh(a, b, c, d, e) {
        var f = c.get(C);null == d && null != f && (d = f.jb(C));var g = [];c.children.ia(function (c, f) {
            var l = d ? d.R(c) : null,
                u = e.m(c),
                z = b.Nc(c);z && (g = g.concat(Wh(a, z, f, l, u)));
        });f && (g = g.concat(f.gb(b, e, d)));return g;
    };function sf(a, b, c) {
        this.app = c;var d = new dc(c);this.M = a;this.Xa = pc(a);this.Vc = null;this.da = new rc();this.vd = 1;this.Ua = null;if (b || 0 <= ("object" === (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.navigator && window.navigator.userAgent || "").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i)) this.va = new Ad(this.M, r(this.Hb, this), d), setTimeout(r(this.Kc, this, !0), 0);else {
            b = c.options.databaseAuthVariableOverride || null;if (null !== b) {
                if ("object" !== ca(b)) throw Error("Only objects are supported for option databaseAuthVariableOverride");
                try {
                    B(b);
                } catch (e) {
                    throw Error("Invalid authOverride provided: " + e);
                }
            }this.va = this.Ua = new nh(this.M, r(this.Hb, this), r(this.Kc, this), r(this.ue, this), d, b);
        }var f = this;ec(d, function (a) {
            f.va.qf(a);
        });this.zg = qc(a, r(function () {
            return new jc(this.Xa, this.va);
        }, this));this.nc = new hh();this.ie = new fc();this.pd = new Ch({ Ae: function Ae(a, b, c, d) {
                b = [];c = f.ie.j(a.path);c.e() || (b = Eh(f.pd, new $b(Og, a.path, c)), setTimeout(function () {
                    d("ok");
                }, 0));return b;
            }, Od: aa });Xh(this, "connected", !1);this.ja = new Rc();this.$a = new rf(this);this.ed = 0;this.je = null;this.K = new Ch({ Ae: function Ae(a, b, c, d) {
                f.va.df(a, c, b, function (b, c) {
                    var e = d(b, c);wc(f.da, a.path, e);
                });return [];
            }, Od: function Od(a, b) {
                f.va.Ef(a, b);
            } });
    }h = sf.prototype;h.toString = function () {
        return (this.M.Sc ? "https://" : "http://") + this.M.host;
    };h.name = function () {
        return this.M.pe;
    };function Yh(a) {
        a = a.ie.j(new L(".info/serverTimeOffset")).H() || 0;return new Date().getTime() + a;
    }function Zh(a) {
        a = a = { timestamp: Yh(a) };a.timestamp = a.timestamp || new Date().getTime();return a;
    }
    h.Hb = function (a, b, c, d) {
        this.ed++;var e = new L(a);b = this.je ? this.je(a, b) : b;a = [];d ? c ? (b = oa(b, function (a) {
            return M(a);
        }), a = Mh(this.K, e, b, d)) : (b = M(b), a = Ih(this.K, e, b, d)) : c ? (d = oa(b, function (a) {
            return M(a);
        }), a = Hh(this.K, e, d)) : (d = M(b), a = Eh(this.K, new $b(Og, e, d)));d = e;0 < a.length && (d = $h(this, e));wc(this.da, d, a);
    };h.Kc = function (a) {
        Xh(this, "connected", a);!1 === a && ai(this);
    };h.ue = function (a) {
        var b = this;md(a, function (a, d) {
            Xh(b, d, a);
        });
    };
    function Xh(a, b, c) {
        b = new L("/.info/" + b);c = M(c);var d = a.ie;d.Jd = d.Jd.F(b, c);c = Eh(a.pd, new $b(Og, b, c));wc(a.da, b, c);
    }h.Kb = function (a, b, c, d) {
        this.f("set", { path: a.toString(), value: b, Gg: c });var e = Zh(this);b = M(b, c);var e = Uc(b, e),
            f = this.vd++,
            e = Dh(this.K, a, e, f, !0);sc(this.da, e);var g = this;this.va.put(a.toString(), b.H(!0), function (b, c) {
            var e = "ok" === b;e || O("set at " + a + " failed: " + b);e = Gh(g.K, f, !e);wc(g.da, a, e);bi(d, b, c);
        });e = ci(this, a);$h(this, e);wc(this.da, e, []);
    };
    h.update = function (a, b, c) {
        this.f("update", { path: a.toString(), value: b });var d = !0,
            e = Zh(this),
            f = {};t(b, function (a, b) {
            d = !1;var c = M(a);f[b] = Uc(c, e);
        });if (d) E("update() called with empty data.  Don't do anything."), bi(c, "ok");else {
            var g = this.vd++,
                k = Fh(this.K, a, f, g);sc(this.da, k);var m = this;this.va.ef(a.toString(), b, function (b, d) {
                var e = "ok" === b;e || O("update at " + a + " failed: " + b);var e = Gh(m.K, g, !e),
                    f = a;0 < e.length && (f = $h(m, a));wc(m.da, f, e);bi(c, b, d);
            });b = ci(this, a);$h(this, b);wc(this.da, a, []);
        }
    };
    function ai(a) {
        a.f("onDisconnectEvents");var b = Zh(a),
            c = [];Sc(Qc(a.ja, b), C, function (b, e) {
            c = c.concat(Eh(a.K, new $b(Og, b, e)));var f = ci(a, b);$h(a, f);
        });a.ja = new Rc();wc(a.da, C, c);
    }h.xd = function (a, b) {
        var c = this;this.va.xd(a.toString(), function (d, e) {
            "ok" === d && yf(c.ja, a);bi(b, d, e);
        });
    };function Mf(a, b, c, d) {
        var e = M(c);a.va.re(b.toString(), e.H(!0), function (c, g) {
            "ok" === c && Tc(a.ja, b, e);bi(d, c, g);
        });
    }function Nf(a, b, c, d, e) {
        var f = M(c, d);a.va.re(b.toString(), f.H(!0), function (c, d) {
            "ok" === c && Tc(a.ja, b, f);bi(e, c, d);
        });
    }
    function Of(a, b, c, d) {
        var e = !0,
            f;for (f in c) {
            e = !1;
        }e ? (E("onDisconnect().update() called with empty data.  Don't do anything."), bi(d, "ok")) : a.va.gf(b.toString(), c, function (e, f) {
            if ("ok" === e) for (var m in c) {
                var l = M(c[m]);Tc(a.ja, b.m(m), l);
            }bi(d, e, f);
        });
    }function xg(a, b, c) {
        c = ".info" === J(b.path) ? a.pd.Ob(b, c) : a.K.Ob(b, c);uc(a.da, b.path, c);
    }h.eb = function () {
        this.Ua && this.Ua.eb("repo_interrupt");
    };h.lc = function () {
        this.Ua && this.Ua.lc("repo_interrupt");
    };
    h.Be = function (a) {
        if ("undefined" !== typeof console) {
            a ? (this.Vc || (this.Vc = new kc(this.Xa)), a = this.Vc.get()) : a = this.Xa.get();var b = Ma(ta(a), function (a, b) {
                return Math.max(b.length, a);
            }, 0),
                c;for (c in a) {
                for (var d = a[c], e = c.length; e < b + 2; e++) {
                    c += " ";
                }console.log(c + d);
            }
        }
    };h.Ce = function (a) {
        mc(this.Xa, a);this.zg.zf[a] = !0;
    };h.f = function (a) {
        var b = "";this.Ua && (b = this.Ua.id + ":");E(b, arguments);
    };
    function bi(a, b, c) {
        a && Ub(function () {
            if ("ok" == b) a(null);else {
                var d = (b || "error").toUpperCase(),
                    e = d;c && (e += ": " + c);e = Error(e);e.code = d;a(e);
            }
        });
    };function di(a, b, c, d, e) {
        function f() {}a.f("transaction on " + b);var g = new U(a, b);g.hc("value", f);c = { path: b, update: c, G: d, status: null, lf: Wc(), Ie: e, wf: 0, Rd: function Rd() {
                g.Jc("value", f);
            }, Td: null, Da: null, bd: null, cd: null, dd: null };d = a.K.Ba(b, void 0) || F;c.bd = d;d = c.update(d.H());if (p(d)) {
            Ef("transaction failed: Data returned ", d, c.path);c.status = 1;e = ih(a.nc, b);var k = e.Ea() || [];k.push(c);jh(e, k);"object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d && Bb(d, ".priority") ? (k = x(d, ".priority"), H(Cf(k), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")) : k = (a.K.Ba(b) || F).C().H();e = Zh(a);d = M(d, k);e = Uc(d, e);c.cd = d;c.dd = e;c.Da = a.vd++;c = Dh(a.K, b, e, c.Da, c.Ie);wc(a.da, b, c);ei(a);
        } else c.Rd(), c.cd = null, c.dd = null, c.G && (a = new W(c.bd, new U(a, c.path), N), c.G(null, !1, a));
    }function ei(a, b) {
        var c = b || a.nc;b || fi(a, c);if (null !== c.Ea()) {
            var d = gi(a, c);H(0 < d.length, "Sending zero length transaction queue");Na(d, function (a) {
                return 1 === a.status;
            }) && hi(a, c.path(), d);
        } else c.kd() && c.P(function (b) {
            ei(a, b);
        });
    }
    function hi(a, b, c) {
        for (var d = La(c, function (a) {
            return a.Da;
        }), e = a.K.Ba(b, d) || F, d = e, e = e.hash(), f = 0; f < c.length; f++) {
            var g = c[f];H(1 === g.status, "tryToSendTransactionQueue_: items in queue should all be run.");g.status = 2;g.wf++;var k = T(b, g.path),
                d = d.F(k, g.cd);
        }d = d.H(!0);a.va.put(b.toString(), d, function (d) {
            a.f("transaction put response", { path: b.toString(), status: d });var e = [];if ("ok" === d) {
                d = [];for (f = 0; f < c.length; f++) {
                    c[f].status = 3;e = e.concat(Gh(a.K, c[f].Da));if (c[f].G) {
                        var g = c[f].dd,
                            k = new U(a, c[f].path);d.push(r(c[f].G, null, null, !0, new W(g, k, N)));
                    }c[f].Rd();
                }fi(a, ih(a.nc, b));ei(a);wc(a.da, b, e);for (f = 0; f < d.length; f++) {
                    Ub(d[f]);
                }
            } else {
                if ("datastale" === d) for (f = 0; f < c.length; f++) {
                    c[f].status = 4 === c[f].status ? 5 : 1;
                } else for (O("transaction at " + b.toString() + " failed: " + d), f = 0; f < c.length; f++) {
                    c[f].status = 5, c[f].Td = d;
                }$h(a, b);
            }
        }, e);
    }function $h(a, b) {
        var c = ii(a, b),
            d = c.path(),
            c = gi(a, c);ji(a, c, d);return d;
    }
    function ji(a, b, c) {
        if (0 !== b.length) {
            for (var d = [], e = [], f = Ka(b, function (a) {
                return 1 === a.status;
            }), f = La(f, function (a) {
                return a.Da;
            }), g = 0; g < b.length; g++) {
                var k = b[g],
                    m = T(c, k.path),
                    l = !1,
                    u;H(null !== m, "rerunTransactionsUnderNode_: relativePath should not be null.");if (5 === k.status) l = !0, u = k.Td, e = e.concat(Gh(a.K, k.Da, !0));else if (1 === k.status) if (25 <= k.wf) l = !0, u = "maxretry", e = e.concat(Gh(a.K, k.Da, !0));else {
                    var z = a.K.Ba(k.path, f) || F;k.bd = z;var G = b[g].update(z.H());p(G) ? (Ef("transaction failed: Data returned ", G, k.path), m = M(G), "object" === (typeof G === "undefined" ? "undefined" : _typeof(G)) && null != G && Bb(G, ".priority") || (m = m.ga(z.C())), z = k.Da, G = Zh(a), G = Uc(m, G), k.cd = m, k.dd = G, k.Da = a.vd++, Qa(f, z), e = e.concat(Dh(a.K, k.path, G, k.Da, k.Ie)), e = e.concat(Gh(a.K, z, !0))) : (l = !0, u = "nodata", e = e.concat(Gh(a.K, k.Da, !0)));
                }wc(a.da, c, e);e = [];l && (b[g].status = 3, setTimeout(b[g].Rd, Math.floor(0)), b[g].G && ("nodata" === u ? (k = new U(a, b[g].path), d.push(r(b[g].G, null, null, !1, new W(b[g].bd, k, N)))) : d.push(r(b[g].G, null, Error(u), !1, null))));
            }fi(a, a.nc);for (g = 0; g < d.length; g++) {
                Ub(d[g]);
            }ei(a);
        }
    }
    function ii(a, b) {
        for (var c, d = a.nc; null !== (c = J(b)) && null === d.Ea();) {
            d = ih(d, c), b = D(b);
        }return d;
    }function gi(a, b) {
        var c = [];ki(a, b, c);c.sort(function (a, b) {
            return a.lf - b.lf;
        });return c;
    }function ki(a, b, c) {
        var d = b.Ea();if (null !== d) for (var e = 0; e < d.length; e++) {
            c.push(d[e]);
        }b.P(function (b) {
            ki(a, b, c);
        });
    }function fi(a, b) {
        var c = b.Ea();if (c) {
            for (var d = 0, e = 0; e < c.length; e++) {
                3 !== c[e].status && (c[d] = c[e], d++);
            }c.length = d;jh(b, 0 < c.length ? c : null);
        }b.P(function (b) {
            fi(a, b);
        });
    }
    function ci(a, b) {
        var c = ii(a, b).path(),
            d = ih(a.nc, b);mh(d, function (b) {
            li(a, b);
        });li(a, d);lh(d, function (b) {
            li(a, b);
        });return c;
    }
    function li(a, b) {
        var c = b.Ea();if (null !== c) {
            for (var d = [], e = [], f = -1, g = 0; g < c.length; g++) {
                4 !== c[g].status && (2 === c[g].status ? (H(f === g - 1, "All SENT items should be at beginning of queue."), f = g, c[g].status = 4, c[g].Td = "set") : (H(1 === c[g].status, "Unexpected transaction status in abort"), c[g].Rd(), e = e.concat(Gh(a.K, c[g].Da, !0)), c[g].G && d.push(r(c[g].G, null, Error("set"), !1, null))));
            }-1 === f ? jh(b, null) : c.length = f + 1;wc(a.da, b.path(), e);for (g = 0; g < d.length; g++) {
                Ub(d[g]);
            }
        }
    };function xf() {
        this.nb = {};this.Ff = !1;
    }xf.prototype.eb = function () {
        for (var a in this.nb) {
            this.nb[a].eb();
        }
    };xf.prototype.lc = function () {
        for (var a in this.nb) {
            this.nb[a].lc();
        }
    };xf.prototype.ce = function (a) {
        this.Ff = a;
    };ba(xf);xf.prototype.interrupt = xf.prototype.eb;xf.prototype.resume = xf.prototype.lc;var Z = {};Z.pc = nh;Z.DataConnection = Z.pc;nh.prototype.yg = function (a, b) {
        this.ua("q", { p: a }, b);
    };Z.pc.prototype.simpleListen = Z.pc.prototype.yg;nh.prototype.Qf = function (a, b) {
        this.ua("echo", { d: a }, b);
    };Z.pc.prototype.echo = Z.pc.prototype.Qf;nh.prototype.interrupt = nh.prototype.eb;Z.If = af;Z.RealTimeConnection = Z.If;af.prototype.sendRequest = af.prototype.ua;af.prototype.close = af.prototype.close;
    Z.bg = function (a) {
        var b = nh.prototype.put;nh.prototype.put = function (c, d, e, f) {
            p(f) && (f = a());b.call(this, c, d, e, f);
        };return function () {
            nh.prototype.put = b;
        };
    };Z.hijackHash = Z.bg;Z.Hf = gc;Z.ConnectionTarget = Z.Hf;Z.ya = function (a) {
        return a.ya();
    };Z.queryIdentifier = Z.ya;Z.eg = function (a) {
        return a.w.Ua.$;
    };Z.listens = Z.eg;Z.ce = function (a) {
        xf.Wb().ce(a);
    };Z.forceRestClient = Z.ce;Z.Context = xf;function U(a, b) {
        if (!(a instanceof sf)) throw Error("new Firebase() no longer supported - use app.database().");X.call(this, a, b, Ee, !1);this.then = void 0;this["catch"] = void 0;
    }ka(U, X);h = U.prototype;h.getKey = function () {
        y("Firebase.key", 0, 0, arguments.length);return this.path.e() ? null : $d(this.path);
    };
    h.m = function (a) {
        y("Firebase.child", 1, 1, arguments.length);if (fa(a)) a = String(a);else if (!(a instanceof L)) if (null === J(this.path)) {
            var b = a;b && (b = b.replace(/^\/*\.info(\/|$)/, "/"));Kf("Firebase.child", b);
        } else Kf("Firebase.child", a);return new U(this.w, this.path.m(a));
    };h.getParent = function () {
        y("Firebase.parent", 0, 0, arguments.length);var a = this.path.parent();return null === a ? null : new U(this.w, a);
    };
    h.Zf = function () {
        y("Firebase.ref", 0, 0, arguments.length);for (var a = this; null !== a.getParent();) {
            a = a.getParent();
        }return a;
    };h.Pf = function () {
        return this.w.$a;
    };h.set = function (a, b) {
        y("Firebase.set", 1, 2, arguments.length);Lf("Firebase.set", this.path);Df("Firebase.set", a, this.path, !1);A("Firebase.set", 2, b, !0);var c = new Hb();this.w.Kb(this.path, a, null, Ib(c, b));return c.ra;
    };
    h.update = function (a, b) {
        y("Firebase.update", 1, 2, arguments.length);Lf("Firebase.update", this.path);if (da(a)) {
            for (var c = {}, d = 0; d < a.length; ++d) {
                c["" + d] = a[d];
            }a = c;O("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }Gf("Firebase.update", a, this.path);A("Firebase.update", 2, b, !0);c = new Hb();this.w.update(this.path, a, Ib(c, b));return c.ra;
    };
    h.Kb = function (a, b, c) {
        y("Firebase.setWithPriority", 2, 3, arguments.length);Lf("Firebase.setWithPriority", this.path);Df("Firebase.setWithPriority", a, this.path, !1);Hf("Firebase.setWithPriority", 2, b);A("Firebase.setWithPriority", 3, c, !0);if (".length" === this.getKey() || ".keys" === this.getKey()) throw "Firebase.setWithPriority failed: " + this.getKey() + " is a read-only object.";var d = new Hb();this.w.Kb(this.path, a, b, Ib(d, c));return d.ra;
    };
    h.remove = function (a) {
        y("Firebase.remove", 0, 1, arguments.length);Lf("Firebase.remove", this.path);A("Firebase.remove", 1, a, !0);return this.set(null, a);
    };
    h.transaction = function (a, b, c) {
        y("Firebase.transaction", 1, 3, arguments.length);Lf("Firebase.transaction", this.path);A("Firebase.transaction", 1, a, !1);A("Firebase.transaction", 2, b, !0);if (p(c) && "boolean" != typeof c) throw Error(Db("Firebase.transaction", 3, !0) + "must be a boolean.");if (".length" === this.getKey() || ".keys" === this.getKey()) throw "Firebase.transaction failed: " + this.getKey() + " is a read-only object.";"undefined" === typeof c && (c = !0);var d = new Hb();ga(b) && Jb(d.ra);di(this.w, this.path, a, function (a, c, g) {
            a ? d.reject(a) : d.resolve(new Pb(c, g));ga(b) && b(a, c, g);
        }, c);return d.ra;
    };h.vg = function (a, b) {
        y("Firebase.setPriority", 1, 2, arguments.length);Lf("Firebase.setPriority", this.path);Hf("Firebase.setPriority", 1, a);A("Firebase.setPriority", 2, b, !0);var c = new Hb();this.w.Kb(this.path.m(".priority"), a, null, Ib(c, b));return c.ra;
    };
    h.push = function (a, b) {
        y("Firebase.push", 0, 2, arguments.length);Lf("Firebase.push", this.path);Df("Firebase.push", a, this.path, !0);A("Firebase.push", 2, b, !0);var c = Yh(this.w),
            d = Tf(c),
            c = this.m(d);if (null != a) {
            var e = this,
                f = c.set(a, b).then(function () {
                return e.m(d);
            });c.then = r(f.then, f);c["catch"] = r(f.then, f, void 0);ga(b) && Jb(f);
        }return c;
    };h.kb = function () {
        Lf("Firebase.onDisconnect", this.path);return new V(this.w, this.path);
    };U.prototype.child = U.prototype.m;U.prototype.set = U.prototype.set;U.prototype.update = U.prototype.update;
    U.prototype.setWithPriority = U.prototype.Kb;U.prototype.remove = U.prototype.remove;U.prototype.transaction = U.prototype.transaction;U.prototype.setPriority = U.prototype.vg;U.prototype.push = U.prototype.push;U.prototype.onDisconnect = U.prototype.kb;pd(U.prototype, "database", U.prototype.Pf);pd(U.prototype, "key", U.prototype.getKey);pd(U.prototype, "parent", U.prototype.getParent);pd(U.prototype, "root", U.prototype.Zf);if ("undefined" === typeof firebase) throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
    try {
        firebase.INTERNAL.registerService("database", function (a) {
            var b = xf.Wb(),
                c = a.options.databaseURL;p(c) || ed("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d = fd(c),
                c = d.kc;wf("Invalid Firebase Database URL", d);d.path.e() || ed("Database URL must point to the root of a Firebase Database (not including a child path).");(d = x(b.nb, a.name)) && ed("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d = new sf(c, b.Ff, a);b.nb[a.name] = d;return d.$a;
        }, { Reference: U, Query: X, Database: rf, enableLogging: bd, INTERNAL: Y, TEST_ACCESS: Z, ServerValue: uf });
    } catch (mi) {
        ed("Failed to register the Firebase Database Service (" + mi + ")");
    };
})();

(function () {
    var k,
        aa = aa || {},
        m = this,
        n = function n(a) {
        return void 0 !== a;
    },
        ba = function ba() {},
        p = function p(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    },
        ca = function ca(a) {
        var b = p(a);return "array" == b || "object" == b && "number" == typeof a.length;
    },
        q = function q(a) {
        return "string" == typeof a;
    },
        r = function r(a) {
        return "function" == p(a);
    },
        da = function da(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && null != a || "function" == b;
    },
        ea = "closure_uid_" + (1E9 * Math.random() >>> 0),
        fa = 0,
        ga = function ga(a, b, c) {
        return a.call.apply(a.bind, arguments);
    },
        ha = function ha(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    },
        _t = function t(a, b, c) {
        _t = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ga : ha;return _t.apply(null, arguments);
    },
        ia = Date.now || function () {
        return +new Date();
    },
        u = function u(a, b) {
        function c() {}
        c.prototype = b.prototype;a.I = b.prototype;a.prototype = new c();a.La = function (a, c, f) {
            for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) {
                g[h - 2] = arguments[h];
            }return b.prototype[c].apply(a, g);
        };
    };var ja = function ja(a, b, c) {
        function d() {
            ya || (ya = !0, b.apply(null, arguments));
        }function e(b) {
            l = setTimeout(function () {
                l = null;a(f, 2 === N);
            }, b);
        }function f(a, b) {
            if (!ya) if (a) d.apply(null, arguments);else if (2 === N || F) d.apply(null, arguments);else {
                64 > h && (h *= 2);var c;1 === N ? (N = 2, c = 0) : c = 1E3 * (h + Math.random());e(c);
            }
        }function g(a) {
            cc || (cc = !0, ya || (null !== l ? (a || (N = 2), clearTimeout(l), e(0)) : a || (N = 1)));
        }var h = 1,
            l = null,
            F = !1,
            N = 0,
            ya = !1,
            cc = !1;e(0);setTimeout(function () {
            F = !0;g(!0);
        }, c);return g;
    };var ka = "https://firebasestorage.googleapis.com";var v = function v(a, b) {
        this.code = "storage/" + a;this.message = "Firebase Storage: " + b;this.serverResponse = null;this.name = "FirebaseError";
    };u(v, Error);
    var la = function la() {
        return new v("unknown", "An unknown error occurred, please check the error payload for server response.");
    },
        ma = function ma() {
        return new v("canceled", "User canceled the upload/download.");
    },
        na = function na() {
        return new v("cannot-slice-blob", "Cannot slice blob for upload. Please retry the upload.");
    },
        oa = function oa(a, b, c) {
        return new v("invalid-argument", "Invalid argument in `" + b + "` at index " + a + ": " + c);
    },
        pa = function pa() {
        return new v("app-deleted", "The Firebase app was deleted.");
    },
        qa = function qa(a, b) {
        return new v("invalid-format", "String does not match format '" + a + "': " + b);
    };var ra = function ra(a, b) {
        for (var c in a) {
            Object.prototype.hasOwnProperty.call(a, c) && b(c, a[c]);
        }
    },
        sa = function sa(a) {
        var b = {};ra(a, function (a, d) {
            b[a] = d;
        });return b;
    };var w = function w(a, b, c, d) {
        this.l = a;this.f = {};this.i = b;this.b = {};this.c = "";this.M = c;this.g = this.a = null;this.h = [200];this.j = d;
    };var ta = { STATE_CHANGED: "state_changed" },
        ua = { RUNNING: "running", PAUSED: "paused", SUCCESS: "success", CANCELED: "canceled", ERROR: "error" },
        va = function va(a) {
        switch (a) {case "running":case "pausing":case "canceling":
                return "running";case "paused":
                return "paused";case "success":
                return "success";case "canceled":
                return "canceled";case "error":
                return "error";default:
                return "error";}
    };var x = function x(a) {
        return n(a) && null !== a;
    },
        wa = function wa(a) {
        return "string" === typeof a || a instanceof String;
    },
        xa = function xa() {
        return "undefined" !== typeof Blob;
    };var za = function za(a, b, c) {
        this.f = c;this.c = a;this.g = b;this.b = 0;this.a = null;
    };za.prototype.get = function () {
        var a;0 < this.b ? (this.b--, a = this.a, this.a = a.next, a.next = null) : a = this.c();return a;
    };var Aa = function Aa(a, b) {
        a.g(b);a.b < a.f && (a.b++, b.next = a.a, a.a = b);
    };var Ba = function Ba(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, Ba);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    };u(Ba, Error);Ba.prototype.name = "CustomError";var Ca = function Ca(a, b, c, d, e) {
        this.reset(a, b, c, d, e);
    };Ca.prototype.a = null;var Da = 0;Ca.prototype.reset = function (a, b, c, d, e) {
        "number" == typeof e || Da++;d || ia();this.b = b;delete this.a;
    };var Ea = function Ea(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = a[d];
        }return b;
    },
        Fa = function Fa(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = d;
        }return b;
    },
        Ga = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
        Ha = function Ha(a, b) {
        for (var c, d, e = 1; e < arguments.length; e++) {
            d = arguments[e];for (c in d) {
                a[c] = d[c];
            }for (var f = 0; f < Ga.length; f++) {
                c = Ga[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
            }
        }
    };var Ia = function Ia(a) {
        a.prototype.then = a.prototype.then;a.prototype.$goog_Thenable = !0;
    },
        Ja = function Ja(a) {
        if (!a) return !1;try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    };var Ka = function Ka(a) {
        Ka[" "](a);return a;
    };Ka[" "] = ba;var Ma = function Ma(a, b) {
        var c = La;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    };var Na = function Na(a, b) {
        for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
            d += c.shift() + e.shift();
        }return d + c.join("%s");
    },
        Oa = String.prototype.trim ? function (a) {
        return a.trim();
    } : function (a) {
        return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
    },
        Pa = function Pa(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    };var Qa = function Qa(a, b) {
        this.a = a;this.b = b;
    };var y = function y(a, b) {
        this.bucket = a;this.path = b;
    },
        Ra = function Ra(a) {
        var b = encodeURIComponent;return "/b/" + b(a.bucket) + "/o/" + b(a.path);
    },
        Sa = function Sa(a) {
        for (var b = null, c = [{ ia: /^gs:\/\/([A-Za-z0-9.\-]+)(\/(.*))?$/i, ba: { bucket: 1, path: 3 }, ha: function ha(a) {
                "/" === a.path.charAt(a.path.length - 1) && (a.path = a.path.slice(0, -1));
            } }, { ia: /^https?:\/\/firebasestorage\.googleapis\.com\/v[A-Za-z0-9_]+\/b\/([A-Za-z0-9.\-]+)\/o(\/([^?#]*).*)?$/i, ba: { bucket: 1, path: 3 }, ha: function ha(a) {
                a.path = decodeURIComponent(a.path);
            } }], d = 0; d < c.length; d++) {
            var e = c[d],
                f = e.ia.exec(a);if (f) {
                b = f[e.ba.bucket];(f = f[e.ba.path]) || (f = "");b = new y(b, f);e.ha(b);break;
            }
        }if (null == b) throw new v("invalid-url", "Invalid URL '" + a + "'.");return b;
    };var Ta = function Ta(a, b, c) {
        r(a) || x(b) || x(c) ? (this.next = a, this.a = b || null, this.b = c || null) : (this.next = a.next || null, this.a = a.error || null, this.b = a.complete || null);
    };var Ua = { RAW: "raw", BASE64: "base64", BASE64URL: "base64url", DATA_URL: "data_url" },
        Va = function Va(a) {
        switch (a) {case "raw":case "base64":case "base64url":case "data_url":
                break;default:
                throw "Expected one of the event types: [raw, base64, base64url, data_url].";}
    },
        Wa = function Wa(a, b) {
        this.data = a;this.a = b || null;
    },
        $a = function $a(a, b) {
        switch (a) {case "raw":
                return new Wa(Xa(b));case "base64":case "base64url":
                return new Wa(Ya(a, b));case "data_url":
                return a = new Za(b), a = a.a ? Ya("base64", a.c) : Xa(a.c), new Wa(a, new Za(b).b);}throw la();
    },
        Xa = function Xa(a) {
        for (var b = [], c = 0; c < a.length; c++) {
            var d = a.charCodeAt(c);if (127 >= d) b.push(d);else if (2047 >= d) b.push(192 | d >> 6, 128 | d & 63);else if (55296 == (d & 64512)) {
                if (c < a.length - 1 && 56320 == (a.charCodeAt(c + 1) & 64512)) {
                    var e = a.charCodeAt(++c),
                        d = 65536 | (d & 1023) << 10 | e & 1023;b.push(240 | d >> 18, 128 | d >> 12 & 63, 128 | d >> 6 & 63, 128 | d & 63);
                } else b.push(239, 191, 189);
            } else 56320 == (d & 64512) ? b.push(239, 191, 189) : b.push(224 | d >> 12, 128 | d >> 6 & 63, 128 | d & 63);
        }return new Uint8Array(b);
    },
        Ya = function Ya(a, b) {
        switch (a) {
            case "base64":
                var c = -1 !== b.indexOf("-"),
                    d = -1 !== b.indexOf("_");if (c || d) throw qa(a, "Invalid character '" + (c ? "-" : "_") + "' found: is it base64url encoded?");break;case "base64url":
                c = -1 !== b.indexOf("+");d = -1 !== b.indexOf("/");if (c || d) throw qa(a, "Invalid character '" + (c ? "+" : "/") + "' found: is it base64 encoded?");b = b.replace(/-/g, "+").replace(/_/g, "/");
        }var e;try {
            e = atob(b);
        } catch (f) {
            throw qa(a, "Invalid character found");
        }a = new Uint8Array(e.length);for (b = 0; b < e.length; b++) {
            a[b] = e.charCodeAt(b);
        }return a;
    },
        Za = function Za(a) {
        var b = a.match(/^data:([^,]+)?,/);
        if (null === b) throw qa("data_url", "Must be formatted 'data:[<mediatype>][;base64],<data>");b = b[1] || null;this.a = !1;this.b = null;if (null != b) {
            var c = b.length - 7;this.b = (this.a = 0 <= c && b.indexOf(";base64", c) == c) ? b.substring(0, b.length - 7) : b;
        }this.c = a.substring(a.indexOf(",") + 1);
    };var bb = function bb(a) {
        var b = encodeURIComponent,
            c = "?";ra(a, function (a, e) {
            a = b(a) + "=" + b(e);c = c + a + "&";
        });return c = c.slice(0, -1);
    };var z = function z(a, b, c, d, e, f) {
        this.b = a;this.h = b;this.f = c;this.a = d;this.g = e;this.c = f;
    };k = z.prototype;k.oa = function () {
        return this.b;
    };k.Ka = function () {
        return this.h;
    };k.Ha = function () {
        return this.f;
    };k.Ca = function () {
        return this.a;
    };k.qa = function () {
        if (x(this.a)) {
            var a = this.a.downloadURLs;return x(a) && x(a[0]) ? a[0] : null;
        }return null;
    };k.Ja = function () {
        return this.g;
    };k.Fa = function () {
        return this.c;
    };var cb = function cb(a, b) {
        b.unshift(a);Ba.call(this, Na.apply(null, b));b.shift();
    };u(cb, Ba);cb.prototype.name = "AssertionError";
    var db = function db(a, b, c, d) {
        var e = "Assertion failed";if (c) var e = e + (": " + c),
            f = d;else a && (e += ": " + a, f = b);throw new cb("" + e, f || []);
    },
        A = function A(a, b, c) {
        a || db("", null, b, Array.prototype.slice.call(arguments, 2));
    },
        eb = function eb(a, b) {
        throw new cb("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    },
        fb = function fb(a, b, c) {
        r(a) || db("Expected function but got %s: %s.", [p(a), a], b, Array.prototype.slice.call(arguments, 2));
    };var B = function B() {
        this.g = this.g;this.o = this.o;
    };B.prototype.g = !1;B.prototype.ea = function () {
        this.g || (this.g = !0, this.C());
    };B.prototype.C = function () {
        if (this.o) for (; this.o.length;) {
            this.o.shift()();
        }
    };var gb = "closure_listenable_" + (1E6 * Math.random() | 0),
        hb = 0;var ib;a: {
        var jb = m.navigator;if (jb) {
            var kb = jb.userAgent;if (kb) {
                ib = kb;break a;
            }
        }ib = "";
    }var C = function C(a) {
        return -1 != ib.indexOf(a);
    };var lb = function lb() {};lb.prototype.a = null;var nb = function nb(a) {
        var b;(b = a.a) || (b = {}, mb(a) && (b[0] = !0, b[1] = !0), b = a.a = b);return b;
    };var ob = Array.prototype.indexOf ? function (a, b, c) {
        A(null != a.length);return Array.prototype.indexOf.call(a, b, c);
    } : function (a, b, c) {
        c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (q(a)) return q(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
            if (c in a && a[c] === b) return c;
        }return -1;
    },
        pb = Array.prototype.forEach ? function (a, b, c) {
        A(null != a.length);Array.prototype.forEach.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            f in e && b.call(c, e[f], f, a);
        }
    },
        qb = Array.prototype.filter ? function (a, b, c) {
        A(null != a.length);return Array.prototype.filter.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = [], f = 0, g = q(a) ? a.split("") : a, h = 0; h < d; h++) {
            if (h in g) {
                var l = g[h];b.call(c, l, h, a) && (e[f++] = l);
            }
        }return e;
    },
        rb = Array.prototype.map ? function (a, b, c) {
        A(null != a.length);return Array.prototype.map.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = Array(d), f = q(a) ? a.split("") : a, g = 0; g < d; g++) {
            g in f && (e[g] = b.call(c, f[g], g, a));
        }return e;
    },
        sb = Array.prototype.some ? function (a, b, c) {
        A(null != a.length);return Array.prototype.some.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && b.call(c, e[f], f, a)) return !0;
        }return !1;
    },
        ub = function ub(a) {
        var b;a: {
            b = tb;for (var c = a.length, d = q(a) ? a.split("") : a, e = 0; e < c; e++) {
                if (e in d && b.call(void 0, d[e], e, a)) {
                    b = e;break a;
                }
            }b = -1;
        }return 0 > b ? null : q(a) ? a.charAt(b) : a[b];
    },
        vb = function vb(a) {
        if ("array" != p(a)) for (var b = a.length - 1; 0 <= b; b--) {
            delete a[b];
        }a.length = 0;
    },
        wb = function wb(a, b) {
        b = ob(a, b);var c;if (c = 0 <= b) A(null != a.length), Array.prototype.splice.call(a, b, 1);return c;
    },
        xb = function xb(a) {
        var b = a.length;if (0 < b) {
            for (var c = Array(b), d = 0; d < b; d++) {
                c[d] = a[d];
            }return c;
        }return [];
    };var zb = new za(function () {
        return new yb();
    }, function (a) {
        a.reset();
    }, 100),
        Bb = function Bb() {
        var a = Ab,
            b = null;a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);return b;
    },
        yb = function yb() {
        this.next = this.b = this.a = null;
    };yb.prototype.set = function (a, b) {
        this.a = a;this.b = b;this.next = null;
    };yb.prototype.reset = function () {
        this.next = this.b = this.a = null;
    };var Cb = function Cb(a, b) {
        this.type = a;this.a = this.target = b;this.ja = !0;
    };Cb.prototype.b = function () {
        this.ja = !1;
    };var Db = function Db(a, b, c, d, e) {
        this.listener = a;this.a = null;this.src = b;this.type = c;this.V = !!d;this.M = e;++hb;this.N = this.U = !1;
    },
        Eb = function Eb(a) {
        a.N = !0;a.listener = null;a.a = null;a.src = null;a.M = null;
    };var Fb = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;var Gb = function Gb(a, b) {
        b = qb(b.split("/"), function (a) {
            return 0 < a.length;
        }).join("/");return 0 === a.length ? b : a + "/" + b;
    },
        Hb = function Hb(a) {
        var b = a.lastIndexOf("/", a.length - 2);return -1 === b ? a : a.slice(b + 1);
    };var Ib = function Ib(a) {
        this.src = a;this.a = {};this.b = 0;
    },
        Kb = function Kb(a, b, c, d, e, f) {
        var g = b.toString();b = a.a[g];b || (b = a.a[g] = [], a.b++);var h = Jb(b, c, e, f);-1 < h ? (a = b[h], d || (a.U = !1)) : (a = new Db(c, a.src, g, !!e, f), a.U = d, b.push(a));return a;
    },
        Lb = function Lb(a, b) {
        var c = b.type;c in a.a && wb(a.a[c], b) && (Eb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    },
        Jb = function Jb(a, b, c, d) {
        for (var e = 0; e < a.length; ++e) {
            var f = a[e];if (!f.N && f.listener == b && f.V == !!c && f.M == d) return e;
        }return -1;
    };var Mb,
        Nb = function Nb() {};u(Nb, lb);var Ob = function Ob(a) {
        return (a = mb(a)) ? new ActiveXObject(a) : new XMLHttpRequest();
    },
        mb = function mb(a) {
        if (!a.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
                var d = b[c];try {
                    return new ActiveXObject(d), a.b = d;
                } catch (e) {}
            }throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }return a.b;
    };Mb = new Nb();var Pb = function Pb(a) {
        this.a = [];if (a) a: {
            var b;if (a instanceof Pb) {
                if (b = a.H(), a = a.A(), 0 >= this.b()) {
                    for (var c = this.a, d = 0; d < b.length; d++) {
                        c.push(new Qa(b[d], a[d]));
                    }break a;
                }
            } else b = Fa(a), a = Ea(a);for (d = 0; d < b.length; d++) {
                Qb(this, b[d], a[d]);
            }
        }
    },
        Qb = function Qb(a, b, c) {
        var d = a.a;d.push(new Qa(b, c));b = d.length - 1;a = a.a;for (c = a[b]; 0 < b;) {
            if (d = b - 1 >> 1, a[d].a > c.a) a[b] = a[d], b = d;else break;
        }a[b] = c;
    };Pb.prototype.A = function () {
        for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
            b.push(a[d].b);
        }return b;
    };
    Pb.prototype.H = function () {
        for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
            b.push(a[d].a);
        }return b;
    };Pb.prototype.b = function () {
        return this.a.length;
    };var Rb = function Rb() {
        this.c = [];this.a = [];
    },
        Sb = function Sb(a) {
        0 == a.c.length && (a.c = a.a, a.c.reverse(), a.a = []);return a.c.pop();
    };Rb.prototype.b = function () {
        return this.c.length + this.a.length;
    };Rb.prototype.A = function () {
        for (var a = [], b = this.c.length - 1; 0 <= b; --b) {
            a.push(this.c[b]);
        }for (var c = this.a.length, b = 0; b < c; ++b) {
            a.push(this.a[b]);
        }return a;
    };var Tb = function Tb(a) {
        if (a.A && "function" == typeof a.A) return a.A();if (q(a)) return a.split("");if (ca(a)) {
            for (var b = [], c = a.length, d = 0; d < c; d++) {
                b.push(a[d]);
            }return b;
        }return Ea(a);
    },
        Ub = function Ub(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ca(a) || q(a)) pb(a, b, void 0);else {
            var c;if (a.H && "function" == typeof a.H) c = a.H();else if (a.A && "function" == typeof a.A) c = void 0;else if (ca(a) || q(a)) {
                c = [];for (var d = a.length, e = 0; e < d; e++) {
                    c.push(e);
                }
            } else c = Fa(a);for (var d = Tb(a), e = d.length, f = 0; f < e; f++) {
                b.call(void 0, d[f], c && c[f], a);
            }
        }
    };var Vb = function Vb(a) {
        m.setTimeout(function () {
            throw a;
        }, 0);
    },
        Wb,
        Xb = function Xb() {
        var a = m.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !C("Presto") && (a = function a() {
            var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = _t(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && !C("Trident") && !C("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (n(c.next)) {
                    c = c.next;var a = c.da;c.da = null;a();
                }
            };return function (a) {
                d.next = { da: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
            var b = document.createElement("SCRIPT");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            m.setTimeout(a, 0);
        };
    };var Yb = "StopIteration" in m ? m.StopIteration : { message: "StopIteration", stack: "" },
        Zb = function Zb() {};Zb.prototype.next = function () {
        throw Yb;
    };Zb.prototype.h = function () {
        return this;
    };var $b = function $b() {
        Pb.call(this);
    };u($b, Pb);var ac = C("Opera"),
        D = C("Trident") || C("MSIE"),
        bc = C("Edge"),
        dc = C("Gecko") && !(-1 != ib.toLowerCase().indexOf("webkit") && !C("Edge")) && !(C("Trident") || C("MSIE")) && !C("Edge"),
        ec = -1 != ib.toLowerCase().indexOf("webkit") && !C("Edge"),
        fc = function fc() {
        var a = m.document;return a ? a.documentMode : void 0;
    },
        gc;
    a: {
        var hc = "",
            ic = function () {
            var a = ib;if (dc) return (/rv\:([^\);]+)(\)|;)/.exec(a)
            );if (bc) return (/Edge\/([\d\.]+)/.exec(a)
            );if (D) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
            );if (ec) return (/WebKit\/(\S+)/.exec(a)
            );if (ac) return (/(?:Version)[ \/]?(\S+)/.exec(a)
            );
        }();ic && (hc = ic ? ic[1] : "");if (D) {
            var jc = fc();if (null != jc && jc > parseFloat(hc)) {
                gc = String(jc);break a;
            }
        }gc = hc;
    }
    var kc = gc,
        La = {},
        E = function E(a) {
        return Ma(a, function () {
            for (var b = 0, c = Oa(String(kc)).split("."), d = Oa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
                var g = c[f] || "",
                    h = d[f] || "";do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];if (0 == g[0].length && 0 == h[0].length) break;b = Pa(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || Pa(0 == g[2].length, 0 == h[2].length) || Pa(g[2], h[2]);g = g[3];h = h[3];
                } while (0 == b);
            }return 0 <= b;
        });
    },
        lc = m.document,
        mc = lc && D ? fc() || ("CSS1Compat" == lc.compatMode ? parseInt(kc, 10) : 5) : void 0;var qc = function qc(a, b) {
        nc || oc();pc || (nc(), pc = !0);var c = Ab,
            d = zb.get();d.set(a, b);c.b ? c.b.next = d : (A(!c.a), c.a = d);c.b = d;
    },
        nc,
        oc = function oc() {
        if (m.Promise && m.Promise.resolve) {
            var a = m.Promise.resolve(void 0);nc = function nc() {
                a.then(rc);
            };
        } else nc = function nc() {
            var a = rc;!r(m.setImmediate) || m.Window && m.Window.prototype && !C("Edge") && m.Window.prototype.setImmediate == m.setImmediate ? (Wb || (Wb = Xb()), Wb(a)) : m.setImmediate(a);
        };
    },
        pc = !1,
        Ab = new function () {
        this.b = this.a = null;
    }(),
        rc = function rc() {
        for (var a; a = Bb();) {
            try {
                a.a.call(a.b);
            } catch (b) {
                Vb(b);
            }Aa(zb, a);
        }pc = !1;
    };var sc;(sc = !D) || (sc = 9 <= Number(mc));var tc = sc,
        uc = D && !E("9");!ec || E("528");dc && E("1.9b") || D && E("8") || ac && E("9.5") || ec && E("528");dc && !E("8") || D && E("9");var G = function G(a, b) {
        this.c = {};this.a = [];this.g = this.f = 0;var c = arguments.length;if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
                this.set(arguments[d], arguments[d + 1]);
            }
        } else if (a) {
            a instanceof G ? (c = a.H(), d = a.A()) : (c = Fa(a), d = Ea(a));for (var e = 0; e < c.length; e++) {
                this.set(c[e], d[e]);
            }
        }
    };G.prototype.b = function () {
        return this.f;
    };G.prototype.A = function () {
        vc(this);for (var a = [], b = 0; b < this.a.length; b++) {
            a.push(this.c[this.a[b]]);
        }return a;
    };G.prototype.H = function () {
        vc(this);return this.a.concat();
    };
    var wc = function wc(a, b) {
        return Object.prototype.hasOwnProperty.call(a.c, b) ? (delete a.c[b], a.f--, a.g++, a.a.length > 2 * a.f && vc(a), !0) : !1;
    },
        vc = function vc(a) {
        if (a.f != a.a.length) {
            for (var b = 0, c = 0; b < a.a.length;) {
                var d = a.a[b];Object.prototype.hasOwnProperty.call(a.c, d) && (a.a[c++] = d);b++;
            }a.a.length = c;
        }if (a.f != a.a.length) {
            for (var e = {}, c = b = 0; b < a.a.length;) {
                d = a.a[b], Object.prototype.hasOwnProperty.call(e, d) || (a.a[c++] = d, e[d] = 1), b++;
            }a.a.length = c;
        }
    };
    G.prototype.get = function (a, b) {
        return Object.prototype.hasOwnProperty.call(this.c, a) ? this.c[a] : b;
    };G.prototype.set = function (a, b) {
        Object.prototype.hasOwnProperty.call(this.c, a) || (this.f++, this.a.push(a), this.g++);this.c[a] = b;
    };G.prototype.forEach = function (a, b) {
        for (var c = this.H(), d = 0; d < c.length; d++) {
            var e = c[d],
                f = this.get(e);a.call(b, f, e, this);
        }
    };
    G.prototype.h = function (a) {
        vc(this);var b = 0,
            c = this.g,
            d = this,
            e = new Zb();e.next = function () {
            if (c != d.g) throw Error("The map has changed since the iterator was created");if (b >= d.a.length) throw Yb;var e = d.a[b++];return a ? e : d.c[e];
        };return e;
    };var xc = function xc(a, b) {
        Cb.call(this, a ? a.type : "");this.c = this.a = this.target = null;if (a) {
            this.type = a.type;this.target = a.target || a.srcElement;this.a = b;if ((b = a.relatedTarget) && dc) try {
                Ka(b.nodeName);
            } catch (c) {}this.c = a;a.defaultPrevented && this.b();
        }
    };u(xc, Cb);xc.prototype.b = function () {
        xc.I.b.call(this);var a = this.c;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, uc) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };var H = function H(a, b) {
        this.a = 0;this.i = void 0;this.c = this.b = this.f = null;this.g = this.h = !1;if (a != ba) try {
            var c = this;a.call(b, function (a) {
                yc(c, 2, a);
            }, function (a) {
                try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}yc(c, 3, a);
            });
        } catch (d) {
            yc(this, 3, d);
        }
    },
        zc = function zc() {
        this.next = this.f = this.c = this.a = this.b = null;this.g = !1;
    };zc.prototype.reset = function () {
        this.f = this.c = this.a = this.b = null;this.g = !1;
    };
    var Ac = new za(function () {
        return new zc();
    }, function (a) {
        a.reset();
    }, 100),
        Bc = function Bc(a, b, c) {
        var d = Ac.get();d.a = a;d.c = b;d.f = c;return d;
    },
        Cc = function Cc(a) {
        if (a instanceof H) return a;var b = new H(ba);yc(b, 2, a);return b;
    },
        Dc = function Dc(a) {
        return new H(function (b, c) {
            c(a);
        });
    };
    H.prototype.then = function (a, b, c) {
        null != a && fb(a, "opt_onFulfilled should be a function.");null != b && fb(b, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return Ec(this, r(a) ? a : null, r(b) ? b : null, c);
    };Ia(H);H.prototype.l = function (a, b) {
        return Ec(this, null, a, b);
    };
    var Gc = function Gc(a, b) {
        a.b || 2 != a.a && 3 != a.a || Fc(a);A(null != b.a);a.c ? a.c.next = b : a.b = b;a.c = b;
    },
        Ec = function Ec(a, b, c, d) {
        var e = Bc(null, null, null);e.b = new H(function (a, g) {
            e.a = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (F) {
                    g(F);
                }
            } : a;e.c = c ? function (b) {
                try {
                    var e = c.call(d, b);a(e);
                } catch (F) {
                    g(F);
                }
            } : g;
        });e.b.f = a;Gc(a, e);return e.b;
    };H.prototype.o = function (a) {
        A(1 == this.a);this.a = 0;yc(this, 2, a);
    };H.prototype.m = function (a) {
        A(1 == this.a);this.a = 0;yc(this, 3, a);
    };
    var yc = function yc(a, b, c) {
        if (0 == a.a) {
            a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself"));a.a = 1;var d;a: {
                var e = c,
                    f = a.o,
                    g = a.m;if (e instanceof H) null != f && fb(f, "opt_onFulfilled should be a function."), null != g && fb(g, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"), Gc(e, Bc(f || ba, g || null, a)), d = !0;else if (Ja(e)) e.then(f, g, a), d = !0;else {
                    if (da(e)) try {
                        var h = e.then;if (r(h)) {
                            Hc(e, h, f, g, a);d = !0;break a;
                        }
                    } catch (l) {
                        g.call(a, l);d = !0;break a;
                    }d = !1;
                }
            }d || (a.i = c, a.a = b, a.f = null, Fc(a), 3 != b || Ic(a, c));
        }
    },
        Hc = function Hc(a, b, c, d, e) {
        var f = !1,
            g = function g(a) {
            f || (f = !0, c.call(e, a));
        },
            h = function h(a) {
            f || (f = !0, d.call(e, a));
        };try {
            b.call(a, g, h);
        } catch (l) {
            h(l);
        }
    },
        Fc = function Fc(a) {
        a.h || (a.h = !0, qc(a.j, a));
    },
        Jc = function Jc(a) {
        var b = null;a.b && (b = a.b, a.b = b.next, b.next = null);a.b || (a.c = null);null != b && A(null != b.a);return b;
    };
    H.prototype.j = function () {
        for (var a; a = Jc(this);) {
            var b = this.a,
                c = this.i;if (3 == b && a.c && !a.g) {
                var d;for (d = this; d && d.g; d = d.f) {
                    d.g = !1;
                }
            }if (a.b) a.b.f = null, Kc(a, b, c);else try {
                a.g ? a.a.call(a.f) : Kc(a, b, c);
            } catch (e) {
                Lc.call(null, e);
            }Aa(Ac, a);
        }this.h = !1;
    };var Kc = function Kc(a, b, c) {
        2 == b ? a.a.call(a.f, c) : a.c && a.c.call(a.f, c);
    },
        Ic = function Ic(a, b) {
        a.g = !0;qc(function () {
            a.g && Lc.call(null, b);
        });
    },
        Lc = Vb;var Nc = function Nc(a) {
        this.a = new G();if (a) {
            a = Tb(a);for (var b = a.length, c = 0; c < b; c++) {
                var d = a[c];this.a.set(Mc(d), d);
            }
        }
    },
        Mc = function Mc(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && a || "function" == b ? "o" + (a[ea] || (a[ea] = ++fa)) : b.substr(0, 1) + a;
    };Nc.prototype.b = function () {
        return this.a.b();
    };Nc.prototype.A = function () {
        return this.a.A();
    };Nc.prototype.h = function () {
        return this.a.h(!1);
    };var Oc = function Oc(a) {
        return function () {
            var b = [];Array.prototype.push.apply(b, arguments);Cc(!0).then(function () {
                a.apply(null, b);
            });
        };
    };var Pc = "closure_lm_" + (1E6 * Math.random() | 0),
        Qc = {},
        Rc = 0,
        Sc = function Sc(a, b, c, d, e) {
        if ("array" == p(b)) {
            for (var f = 0; f < b.length; f++) {
                Sc(a, b[f], c, d, e);
            }return null;
        }c = Tc(c);a && a[gb] ? (Uc(a), a = Kb(a.b, String(b), c, !1, d, e)) : a = Vc(a, b, c, !1, d, e);return a;
    },
        Vc = function Vc(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");var g = !!e,
            h = Wc(a);h || (a[Pc] = h = new Ib(a));c = Kb(h, b, c, d, e, f);if (c.a) return c;d = Xc();c.a = d;d.src = a;d.listener = c;if (a.addEventListener) a.addEventListener(b.toString(), d, g);else if (a.attachEvent) a.attachEvent(Yc(b.toString()), d);else throw Error("addEventListener and attachEvent are unavailable.");Rc++;return c;
    },
        Xc = function Xc() {
        var a = Zc,
            b = tc ? function (c) {
            return a.call(b.src, b.listener, c);
        } : function (c) {
            c = a.call(b.src, b.listener, c);if (!c) return c;
        };return b;
    },
        $c = function $c(a, b, c, d, e) {
        if ("array" == p(b)) for (var f = 0; f < b.length; f++) {
            $c(a, b[f], c, d, e);
        } else c = Tc(c), a && a[gb] ? Kb(a.b, String(b), c, !0, d, e) : Vc(a, b, c, !0, d, e);
    },
        ad = function ad(a, b, c, d, e) {
        if ("array" == p(b)) for (var f = 0; f < b.length; f++) {
            ad(a, b[f], c, d, e);
        } else (c = Tc(c), a && a[gb]) ? (a = a.b, b = String(b).toString(), b in a.a && (f = a.a[b], c = Jb(f, c, d, e), -1 < c && (Eb(f[c]), A(null != f.length), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = Wc(a)) && (b = a.a[b.toString()], a = -1, b && (a = Jb(b, c, !!d, e)), (c = -1 < a ? b[a] : null) && bd(c));
    },
        bd = function bd(a) {
        if ("number" != typeof a && a && !a.N) {
            var b = a.src;if (b && b[gb]) Lb(b.b, a);else {
                var c = a.type,
                    d = a.a;b.removeEventListener ? b.removeEventListener(c, d, a.V) : b.detachEvent && b.detachEvent(Yc(c), d);Rc--;(c = Wc(b)) ? (Lb(c, a), 0 == c.b && (c.src = null, b[Pc] = null)) : Eb(a);
            }
        }
    },
        Yc = function Yc(a) {
        return a in Qc ? Qc[a] : Qc[a] = "on" + a;
    },
        dd = function dd(a, b, c, d) {
        var e = !0;if (a = Wc(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
            var f = b[a];f && f.V == c && !f.N && (f = cd(f, d), e = e && !1 !== f);
        }return e;
    },
        cd = function cd(a, b) {
        var c = a.listener,
            d = a.M || a.src;a.U && bd(a);return c.call(d, b);
    },
        Zc = function Zc(a, b) {
        if (a.N) return !0;if (!tc) {
            if (!b) a: {
                b = ["window", "event"];for (var c = m, d; d = b.shift();) {
                    if (null != c[d]) c = c[d];else {
                        b = null;break a;
                    }
                }b = c;
            }d = b;b = new xc(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;if (0 == d.keyCode) try {
                        d.keyCode = -1;break a;
                    } catch (g) {
                        e = !0;
                    }if (e || void 0 == d.returnValue) d.returnValue = !0;
                }d = [];for (e = b.a; e; e = e.parentNode) {
                    d.push(e);
                }a = a.type;for (e = d.length - 1; 0 <= e; e--) {
                    b.a = d[e];var f = dd(d[e], a, !0, b),
                        c = c && f;
                }for (e = 0; e < d.length; e++) {
                    b.a = d[e], f = dd(d[e], a, !1, b), c = c && f;
                }
            }return c;
        }return cd(a, new xc(b, this));
    },
        Wc = function Wc(a) {
        a = a[Pc];return a instanceof Ib ? a : null;
    },
        ed = "__closure_events_fn_" + (1E9 * Math.random() >>> 0),
        Tc = function Tc(a) {
        A(a, "Listener can not be null.");if (r(a)) return a;A(a.handleEvent, "An object listener must have handleEvent method.");
        a[ed] || (a[ed] = function (b) {
            return a.handleEvent(b);
        });return a[ed];
    };var I = function I(a, b) {
        B.call(this);this.m = a || 0;this.f = b || 10;if (this.m > this.f) throw Error("[goog.structs.Pool] Min can not be greater than max");this.a = new Rb();this.c = new Nc();this.j = null;this.T();
    };u(I, B);I.prototype.X = function () {
        var a = ia();if (!(null != this.j && 0 > a - this.j)) {
            for (var b; 0 < this.a.b() && (b = Sb(this.a), !this.l(b));) {
                this.T();
            }!b && this.b() < this.f && (b = this.i());b && (this.j = a, this.c.a.set(Mc(b), b));return b;
        }
    };var gd = function gd(a) {
        var b = fd;wc(b.c.a, Mc(a)) && b.$(a);
    };
    I.prototype.$ = function (a) {
        wc(this.c.a, Mc(a));this.l(a) && this.b() < this.f ? this.a.a.push(a) : hd(a);
    };I.prototype.T = function () {
        for (var a = this.a; this.b() < this.m;) {
            var b = this.i();a.a.push(b);
        }for (; this.b() > this.f && 0 < this.a.b();) {
            hd(Sb(a));
        }
    };I.prototype.i = function () {
        return {};
    };var hd = function hd(a) {
        if ("function" == typeof a.ea) a.ea();else for (var b in a) {
            a[b] = null;
        }
    };I.prototype.l = function (a) {
        return "function" == typeof a.pa ? a.pa() : !0;
    };I.prototype.b = function () {
        return this.a.b() + this.c.b();
    };
    I.prototype.C = function () {
        I.I.C.call(this);if (0 < this.c.b()) throw Error("[goog.structs.Pool] Objects not released");delete this.c;for (var a = this.a; 0 != a.c.length || 0 != a.a.length;) {
            hd(Sb(a));
        }delete this.a;
    }; /*
       Portions of this code are from MochiKit, received by
       The Closure Authors under the MIT license. All other code is Copyright
       2005-2009 The Closure Authors. All Rights Reserved.
       */
    var id = function id(a, b) {
        this.c = [];this.m = b || null;this.a = this.h = !1;this.b = void 0;this.j = this.g = !1;this.f = 0;this.i = null;this.o = 0;
    };id.prototype.l = function (a, b) {
        this.g = !1;this.h = !0;this.b = b;this.a = !a;jd(this);
    };var kd = function kd(a, b, c) {
        A(!a.j, "Blocking Deferreds can not be re-used");a.c.push([b, c, void 0]);a.h && jd(a);
    };id.prototype.then = function (a, b, c) {
        var d,
            e,
            f = new H(function (a, b) {
            d = a;e = b;
        });kd(this, d, function (a) {
            e(a);
        });return f.then(a, b, c);
    };Ia(id);
    var ld = function ld(a) {
        return sb(a.c, function (a) {
            return r(a[1]);
        });
    },
        jd = function jd(a) {
        if (a.f && a.h && ld(a)) {
            var b = a.f,
                c = md[b];c && (m.clearTimeout(c.a), delete md[b]);a.f = 0;
        }a.i && (a.i.o--, delete a.i);for (var b = a.b, d = c = !1; a.c.length && !a.g;) {
            var e = a.c.shift(),
                f = e[0],
                g = e[1],
                e = e[2];if (f = a.a ? g : f) try {
                var h = f.call(e || a.m, b);n(h) && (a.a = a.a && (h == b || h instanceof Error), a.b = b = h);if (Ja(b) || "function" === typeof m.Promise && b instanceof m.Promise) d = !0, a.g = !0;
            } catch (l) {
                b = l, a.a = !0, ld(a) || (c = !0);
            }
        }a.b = b;d && (h = _t(a.l, a, !0), d = _t(a.l, a, !1), b instanceof id ? (kd(b, h, d), b.j = !0) : b.then(h, d));c && (b = new nd(b), md[b.a] = b, a.f = b.a);
    },
        nd = function nd(a) {
        this.a = m.setTimeout(_t(this.c, this), 0);this.b = a;
    };nd.prototype.c = function () {
        A(md[this.a], "Cannot throw an error that is not scheduled.");delete md[this.a];throw this.b;
    };var md = {};var od = function od(a) {
        this.f = a;this.b = this.c = this.a = null;
    },
        pd = function pd(a, b) {
        this.name = a;this.value = b;
    };pd.prototype.toString = function () {
        return this.name;
    };var qd = new pd("SEVERE", 1E3),
        rd = new pd("CONFIG", 700),
        sd = new pd("FINE", 500),
        td = function td(a) {
        if (a.c) return a.c;if (a.a) return td(a.a);eb("Root logger has no level set.");return null;
    };
    od.prototype.log = function (a, b, c) {
        if (a.value >= td(this).value) for (r(b) && (b = b()), a = new Ca(a, String(b), this.f), c && (a.a = c), c = "log:" + a.b, m.console && (m.console.timeStamp ? m.console.timeStamp(c) : m.console.markTimeline && m.console.markTimeline(c)), m.msWriteProfilerMark && m.msWriteProfilerMark(c), c = this; c;) {
            c = c.a;
        }
    };
    var ud = {},
        vd = null,
        wd = function wd(a) {
        vd || (vd = new od(""), ud[""] = vd, vd.c = rd);var b;if (!(b = ud[a])) {
            b = new od(a);var c = a.lastIndexOf("."),
                d = a.substr(c + 1),
                c = wd(a.substr(0, c));c.b || (c.b = {});c.b[d] = b;b.a = c;ud[a] = b;
        }return b;
    };var xd = function xd() {
        B.call(this);this.b = new Ib(this);this.Z = this;this.G = null;
    };u(xd, B);xd.prototype[gb] = !0;xd.prototype.removeEventListener = function (a, b, c, d) {
        ad(this, a, b, c, d);
    };
    var J = function J(a, b) {
        Uc(a);var c,
            d = a.G;if (d) {
            c = [];for (var e = 1; d; d = d.G) {
                c.push(d), A(1E3 > ++e, "infinite loop");
            }
        }a = a.Z;d = b.type || b;q(b) ? b = new Cb(b, a) : b instanceof Cb ? b.target = b.target || a : (e = b, b = new Cb(d, a), Ha(b, e));var e = !0,
            f;if (c) for (var g = c.length - 1; 0 <= g; g--) {
            f = b.a = c[g], e = yd(f, d, !0, b) && e;
        }f = b.a = a;e = yd(f, d, !0, b) && e;e = yd(f, d, !1, b) && e;if (c) for (g = 0; g < c.length; g++) {
            f = b.a = c[g], e = yd(f, d, !1, b) && e;
        }
    };
    xd.prototype.C = function () {
        xd.I.C.call(this);if (this.b) {
            var a = this.b,
                b = 0,
                c;for (c in a.a) {
                for (var d = a.a[c], e = 0; e < d.length; e++) {
                    ++b, Eb(d[e]);
                }delete a.a[c];a.b--;
            }
        }this.G = null;
    };var yd = function yd(a, b, c, d) {
        b = a.b.a[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
            var g = b[f];if (g && !g.N && g.V == c) {
                var h = g.listener,
                    l = g.M || g.src;g.U && Lb(a.b, g);e = !1 !== h.call(l, d) && e;
            }
        }return e && 0 != d.ja;
    },
        Uc = function Uc(a) {
        A(a.b, "Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?");
    };var K = function K(a, b) {
        this.h = new $b();I.call(this, a, b);
    };u(K, I);k = K.prototype;k.X = function (a, b) {
        if (!a) return K.I.X.call(this);Qb(this.h, n(b) ? b : 100, a);this.aa();
    };k.aa = function () {
        for (var a = this.h; 0 < a.b();) {
            var b = this.X();if (b) {
                var c;var d = a,
                    e = d.a,
                    f = e.length;c = e[0];if (0 >= f) c = void 0;else {
                    if (1 == f) vb(e);else {
                        e[0] = e.pop();for (var e = 0, d = d.a, f = d.length, g = d[e]; e < f >> 1;) {
                            var h = 2 * e + 1,
                                l = 2 * e + 2,
                                h = l < f && d[l].a < d[h].a ? l : h;if (d[h].a > g.a) break;d[e] = d[h];e = h;
                        }d[e] = g;
                    }c = c.b;
                }c.apply(this, [b]);
            } else break;
        }
    };
    k.$ = function (a) {
        K.I.$.call(this, a);this.aa();
    };k.T = function () {
        K.I.T.call(this);this.aa();
    };k.C = function () {
        K.I.C.call(this);m.clearTimeout(void 0);vb(this.h.a);this.h = null;
    };var L = function L(a, b) {
        a && a.log(sd, b, void 0);
    };var zd = function zd(a, b, c) {
        if (r(a)) c && (a = _t(a, c));else if (a && "function" == typeof a.handleEvent) a = _t(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : m.setTimeout(a, b || 0);
    };var M = function M(a) {
        xd.call(this);this.K = new G();this.B = a || null;this.c = !1;this.w = this.a = null;this.O = this.l = "";this.J = 0;this.h = "";this.f = this.F = this.j = this.D = !1;this.i = 0;this.m = null;this.S = "";this.u = this.ca = this.Y = !1;
    };u(M, xd);var Ad = M.prototype,
        Bd = wd("goog.net.XhrIo");Ad.v = Bd;var Cd = /^https?$/i,
        Dd = ["POST", "PUT"];
    M.prototype.send = function (a, b, c, d) {
        if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.l + "; newUri=" + a);b = b ? b.toUpperCase() : "GET";this.l = a;this.h = "";this.J = 0;this.O = b;this.D = !1;this.c = !0;this.a = this.B ? Ob(this.B) : Ob(Mb);this.w = this.B ? nb(this.B) : nb(Mb);this.a.onreadystatechange = _t(this.R, this);this.ca && "onprogress" in this.a && (this.a.onprogress = _t(function (a) {
            this.P(a, !0);
        }, this), this.a.upload && (this.a.upload.onprogress = _t(this.P, this)));try {
            L(this.v, O(this, "Opening Xhr")), this.F = !0, this.a.open(b, String(a), !0), this.F = !1;
        } catch (f) {
            L(this.v, O(this, "Error opening Xhr: " + f.message));Ed(this, f);return;
        }a = c || "";var e = new G(this.K);d && Ub(d, function (a, b) {
            e.set(b, a);
        });d = ub(e.H());c = m.FormData && a instanceof m.FormData;!(0 <= ob(Dd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");e.forEach(function (a, b) {
            this.a.setRequestHeader(b, a);
        }, this);this.S && (this.a.responseType = this.S);"withCredentials" in this.a && this.a.withCredentials !== this.Y && (this.a.withCredentials = this.Y);try {
            Fd(this), 0 < this.i && (this.u = Gd(this.a), L(this.v, O(this, "Will abort after " + this.i + "ms if incomplete, xhr2 " + this.u)), this.u ? (this.a.timeout = this.i, this.a.ontimeout = _t(this.L, this)) : this.m = zd(this.L, this.i, this)), L(this.v, O(this, "Sending request")), this.j = !0, this.a.send(a), this.j = !1;
        } catch (f) {
            L(this.v, O(this, "Send error: " + f.message)), Ed(this, f);
        }
    };var Gd = function Gd(a) {
        return D && E(9) && "number" == typeof a.timeout && n(a.ontimeout);
    },
        tb = function tb(a) {
        return "content-type" == a.toLowerCase();
    };
    M.prototype.L = function () {
        "undefined" != typeof aa && this.a && (this.h = "Timed out after " + this.i + "ms, aborting", this.J = 8, L(this.v, O(this, this.h)), J(this, "timeout"), Hd(this, 8));
    };var Ed = function Ed(a, b) {
        a.c = !1;a.a && (a.f = !0, a.a.abort(), a.f = !1);a.h = b;a.J = 5;Id(a);Kd(a);
    },
        Id = function Id(a) {
        a.D || (a.D = !0, J(a, "complete"), J(a, "error"));
    },
        Hd = function Hd(a, b) {
        a.a && a.c && (L(a.v, O(a, "Aborting")), a.c = !1, a.f = !0, a.a.abort(), a.f = !1, a.J = b || 7, J(a, "complete"), J(a, "abort"), Kd(a));
    };
    M.prototype.C = function () {
        this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), Kd(this, !0));M.I.C.call(this);
    };M.prototype.R = function () {
        this.g || (this.F || this.j || this.f ? Ld(this) : this.la());
    };M.prototype.la = function () {
        Ld(this);
    };
    var Ld = function Ld(a) {
        if (a.c && "undefined" != typeof aa) if (a.w[1] && 4 == Md(a) && 2 == P(a)) L(a.v, O(a, "Local request error detected and ignored"));else if (a.j && 4 == Md(a)) zd(a.R, 0, a);else if (J(a, "readystatechange"), 4 == Md(a)) {
            L(a.v, O(a, "Request complete"));a.c = !1;try {
                if (Nd(a)) J(a, "complete"), J(a, "success");else {
                    a.J = 6;var b;try {
                        b = 2 < Md(a) ? a.a.statusText : "";
                    } catch (c) {
                        L(a.v, "Can not get status: " + c.message), b = "";
                    }a.h = b + " [" + P(a) + "]";Id(a);
                }
            } finally {
                Kd(a);
            }
        }
    };
    M.prototype.P = function (a, b) {
        A("progress" === a.type, "goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");J(this, Od(a, "progress"));J(this, Od(a, b ? "downloadprogress" : "uploadprogress"));
    };
    var Od = function Od(a, b) {
        return { type: b, lengthComputable: a.lengthComputable, loaded: a.loaded, total: a.total };
    },
        Kd = function Kd(a, b) {
        if (a.a) {
            Fd(a);var c = a.a,
                d = a.w[0] ? ba : null;a.a = null;a.w = null;b || J(a, "ready");try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.v) && a.log(qd, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    },
        Fd = function Fd(a) {
        a.a && a.u && (a.a.ontimeout = null);"number" == typeof a.m && (m.clearTimeout(a.m), a.m = null);
    },
        Nd = function Nd(a) {
        var b = P(a),
            c;a: switch (b) {
            case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
                c = !0;break a;default:
                c = !1;
        }if (!c) {
            if (b = 0 === b) a = String(a.l).match(Fb)[1] || null, !a && m.self && m.self.location && (a = m.self.location.protocol, a = a.substr(0, a.length - 1)), b = !Cd.test(a ? a.toLowerCase() : "");c = b;
        }return c;
    },
        Md = function Md(a) {
        return a.a ? a.a.readyState : 0;
    },
        P = function P(a) {
        try {
            return 2 < Md(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    },
        Pd = function Pd(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return L(a.v, "Can not get responseText: " + b.message), "";
        }
    },
        Qd = function Qd(a, b) {
        return a.a && 4 == Md(a) ? a.a.getResponseHeader(b) : void 0;
    },
        O = function O(a, b) {
        return b + " [" + a.O + " " + a.l + " " + P(a) + "]";
    };var Rd = function Rd(a, b, c, d) {
        this.u = a;this.w = !!d;K.call(this, b, c);
    };u(Rd, K);Rd.prototype.i = function () {
        var a = new M(),
            b = this.u;b && b.forEach(function (b, d) {
            a.K.set(d, b);
        });this.w && (a.Y = !0);return a;
    };Rd.prototype.l = function (a) {
        return !a.g && !a.a;
    };var fd = new Rd();var Td = function Td(a, b, c, d, e, f, g, h, l, F) {
        this.K = a;this.F = b;this.w = c;this.m = d;this.G = e.slice();this.l = this.o = this.f = this.c = null;this.h = this.i = !1;this.u = f;this.j = g;this.g = l;this.L = F;this.D = h;var N = this;this.B = new H(function (a, b) {
            N.o = a;N.l = b;Sd(N);
        });
    },
        Ud = function Ud(a, b, c) {
        this.b = a;this.c = b;this.a = !!c;
    },
        Sd = function Sd(a) {
        function b(a, b) {
            b ? a(!1, new Ud(!1, null, !0)) : fd.X(function (b) {
                b.Y = d.L;d.c = b;var c = null;null !== d.g && (b.ca = !0, c = Sc(b, "uploadprogress", function (a) {
                    d.g(a.loaded, a.lengthComputable ? a.total : -1);
                }), b.ca = null !== d.g);b.send(d.K, d.F, d.m, d.w);$c(b, "complete", function (b) {
                    null !== c && bd(c);d.c = null;b = b.target;var f = 6 === b.J && 100 <= P(b),
                        f = Nd(b) || f,
                        g = P(b);!f || 500 <= g && 600 > g || 429 === g ? (f = 7 === b.J, gd(b), a(!1, new Ud(!1, null, f))) : (f = 0 <= ob(d.G, g), a(!0, new Ud(f, b)));
                });
            });
        }function c(a, b) {
            var c = d.o;a = d.l;var h = b.c;if (b.b) try {
                var l = d.u(h, Pd(h));n(l) ? c(l) : c();
            } catch (F) {
                a(F);
            } else null !== h ? (b = la(), l = Pd(h), b.serverResponse = l, d.j ? a(d.j(h, b)) : a(b)) : (b = b.a ? d.h ? pa() : ma() : new v("retry-limit-exceeded", "Max retry time for operation exceeded, please try again."), a(b));gd(h);
        }var d = a;a.i ? c(0, new Ud(!1, null, !0)) : a.f = ja(b, c, a.D);
    };Td.prototype.a = function () {
        return this.B;
    };Td.prototype.b = function (a) {
        this.i = !0;this.h = a || !1;null !== this.f && (0, this.f)(!1);null !== this.c && Hd(this.c);
    };var Vd = function Vd(a, b, c) {
        var d = bb(a.f),
            d = a.l + d,
            e = a.b ? sa(a.b) : {};null !== b && 0 < b.length && (e.Authorization = "Firebase " + b);e["X-Firebase-Storage-Version"] = "webjs/" + ("undefined" !== typeof firebase ? firebase.SDK_VERSION : "AppManager");return new Td(d, a.i, e, a.c, a.h, a.M, a.a, a.j, a.g, c);
    };var Wd = function Wd(a) {
        var b = m.BlobBuilder || m.WebKitBlobBuilder;if (n(b)) {
            for (var b = new b(), c = 0; c < arguments.length; c++) {
                b.append(arguments[c]);
            }return b.getBlob();
        }b = xb(arguments);c = m.BlobBuilder || m.WebKitBlobBuilder;if (n(c)) {
            for (var c = new c(), d = 0; d < b.length; d++) {
                c.append(b[d], void 0);
            }b = c.getBlob(void 0);
        } else if (n(m.Blob)) b = new Blob(b, {});else throw Error("This browser doesn't seem to support creating Blobs");return b;
    },
        Xd = function Xd(a, b, c) {
        n(c) || (c = a.size);return a.webkitSlice ? a.webkitSlice(b, c) : a.mozSlice ? a.mozSlice(b, c) : a.slice ? dc && !E("13.0") || ec && !E("537.1") ? (0 > b && (b += a.size), 0 > b && (b = 0), 0 > c && (c += a.size), c < b && (c = b), a.slice(b, c - b)) : a.slice(b, c) : null;
    };var Q = function Q(a, b) {
        xa() && a instanceof Blob ? (this.s = a, b = a.size, a = a.type) : (a instanceof ArrayBuffer ? (b ? this.s = new Uint8Array(a) : (this.s = new Uint8Array(a.byteLength), this.s.set(new Uint8Array(a))), b = this.s.length) : (b ? this.s = a : (this.s = new Uint8Array(a.length), this.s.set(a)), b = a.length), a = "");this.a = b;this.b = a;
    };Q.prototype.type = function () {
        return this.b;
    };
    Q.prototype.slice = function (a, b) {
        if (xa() && this.s instanceof Blob) return a = Xd(this.s, a, b), null === a ? null : new Q(a);a = new Uint8Array(this.s.buffer, a, b - a);return new Q(a, !0);
    };
    var Yd = function Yd(a) {
        var b = [];Array.prototype.push.apply(b, arguments);if (xa()) return b = rb(b, function (a) {
            return a instanceof Q ? a.s : a;
        }), new Q(Wd.apply(null, b));var b = rb(b, function (a) {
            return wa(a) ? $a("raw", a).data.buffer : a.s.buffer;
        }),
            c = 0;pb(b, function (a) {
            c += a.byteLength;
        });var d = new Uint8Array(c),
            e = 0;pb(b, function (a) {
            a = new Uint8Array(a);for (var b = 0; b < a.length; b++) {
                d[e++] = a[b];
            }
        });return new Q(d, !0);
    };var Zd = function Zd(a) {
        this.c = Dc(a);
    };Zd.prototype.a = function () {
        return this.c;
    };Zd.prototype.b = function () {};var $d = function $d() {
        this.a = {};this.b = Number.MIN_SAFE_INTEGER;
    },
        ae = function ae(a, b) {
        function c() {
            delete e.a[d];
        }var d = a.b;a.b++;a.a[d] = b;var e = a;b.a().then(c, c);
    },
        be = function be(a) {
        ra(a.a, function (a, c) {
            c && c.b(!0);
        });a.a = {};
    };var ce = function ce(a, b, c, d) {
        this.a = a;this.g = null;if (null !== this.a && (a = this.a.options, x(a))) {
            a = a.storageBucket || null;if (null == a) a = null;else {
                var e = null;try {
                    e = Sa(a);
                } catch (f) {}if (null !== e) {
                    if ("" !== e.path) throw new v("invalid-default-bucket", "Invalid default bucket '" + a + "'.");a = e.bucket;
                }
            }this.g = a;
        }this.l = b;this.j = c;this.i = d;this.c = 12E4;this.b = 6E4;this.h = new $d();this.f = !1;
    },
        de = function de(a) {
        return null !== a.a && x(a.a.INTERNAL) && x(a.a.INTERNAL.getToken) ? a.a.INTERNAL.getToken().then(function (a) {
            return x(a) ? a.accessToken : null;
        }, function () {
            return null;
        }) : Cc(null);
    };ce.prototype.bucket = function () {
        if (this.f) throw pa();return this.g;
    };var R = function R(a, b, c) {
        if (a.f) return new Zd(pa());b = a.j(b, c, null === a.a);ae(a.h, b);return b;
    };var ee = function ee(a, b) {
        return b;
    },
        S = function S(a, b, c, d) {
        this.c = a;this.b = b || a;this.f = !!c;this.a = d || ee;
    },
        fe = null,
        ge = function ge() {
        if (fe) return fe;var a = [];a.push(new S("bucket"));a.push(new S("generation"));a.push(new S("metageneration"));a.push(new S("name", "fullPath", !0));var b = new S("name");b.a = function (a, b) {
            return !wa(b) || 2 > b.length ? b : Hb(b);
        };a.push(b);b = new S("size");b.a = function (a, b) {
            return x(b) ? +b : b;
        };a.push(b);a.push(new S("timeCreated"));a.push(new S("updated"));a.push(new S("md5Hash", null, !0));a.push(new S("cacheControl", null, !0));a.push(new S("contentDisposition", null, !0));a.push(new S("contentEncoding", null, !0));a.push(new S("contentLanguage", null, !0));a.push(new S("contentType", null, !0));a.push(new S("metadata", "customMetadata", !0));a.push(new S("downloadTokens", "downloadURLs", !1, function (a, b) {
            if (!(wa(b) && 0 < b.length)) return [];var e = encodeURIComponent;return rb(b.split(","), function (b) {
                var d = a.fullPath,
                    d = "https://firebasestorage.googleapis.com/v0" + ("/b/" + e(a.bucket) + "/o/" + e(d));b = bb({ alt: "media", token: b });return d + b;
            });
        }));return fe = a;
    },
        he = function he(a, b) {
        Object.defineProperty(a, "ref", { get: function get() {
                return b.l(b, new y(a.bucket, a.fullPath));
            } });
    },
        ie = function ie(a, b) {
        for (var c = {}, d = b.length, e = 0; e < d; e++) {
            var f = b[e];f.f && (c[f.c] = a[f.b]);
        }return JSON.stringify(c);
    },
        je = function je(a) {
        if (!a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) throw "Expected Metadata object.";for (var b in a) {
            var c = a[b];if ("customMetadata" === b && "object" !== (typeof c === "undefined" ? "undefined" : _typeof(c))) throw "Expected object for 'customMetadata' mapping.";
        }
    };var T = function T(a, b, c) {
        for (var d = b.length, e = b.length, f = 0; f < b.length; f++) {
            if (b[f].b) {
                d = f;break;
            }
        }if (!(d <= c.length && c.length <= e)) throw d === e ? (b = d, d = 1 === d ? "argument" : "arguments") : (b = "between " + d + " and " + e, d = "arguments"), new v("invalid-argument-count", "Invalid argument count in `" + a + "`: Expected " + b + " " + d + ", received " + c.length + ".");for (f = 0; f < c.length; f++) {
            try {
                b[f].a(c[f]);
            } catch (g) {
                if (g instanceof Error) throw oa(f, a, g.message);throw oa(f, a, g);
            }
        }
    },
        U = function U(a, b) {
        var c = this;this.a = function (b) {
            c.b && !n(b) || a(b);
        };
        this.b = !!b;
    },
        ke = function ke(a, b) {
        return function (c) {
            a(c);b(c);
        };
    },
        le = function le(a, b) {
        function c(a) {
            if (!("string" === typeof a || a instanceof String)) throw "Expected string.";
        }var d;a ? d = ke(c, a) : d = c;return new U(d, b);
    },
        me = function me() {
        return new U(function (a) {
            if (!(a instanceof Uint8Array || a instanceof ArrayBuffer || xa() && a instanceof Blob)) throw "Expected Blob or File.";
        });
    },
        ne = function ne() {
        return new U(function (a) {
            if (!(("number" === typeof a || a instanceof Number) && 0 <= a)) throw "Expected a number 0 or greater.";
        });
    },
        oe = function oe(a, b) {
        return new U(function (b) {
            if (!(null === b || x(b) && b instanceof Object)) throw "Expected an Object.";x(a) && a(b);
        }, b);
    },
        pe = function pe() {
        return new U(function (a) {
            if (null !== a && !r(a)) throw "Expected a Function.";
        }, !0);
    };var qe = function qe(a) {
        if (!a) throw la();
    },
        re = function re(a, b) {
        return function (c, d) {
            a: {
                var e;try {
                    e = JSON.parse(d);
                } catch (h) {
                    c = null;break a;
                }c = da(e) ? e : null;
            }if (null === c) c = null;else {
                d = { type: "file" };e = b.length;for (var f = 0; f < e; f++) {
                    var g = b[f];d[g.b] = g.a(d, c[g.c]);
                }he(d, a);c = d;
            }qe(null !== c);return c;
        };
    },
        se = function se(a) {
        return function (b, c) {
            b = 401 === P(b) ? new v("unauthenticated", "User is not authenticated, please authenticate using Firebase Authentication and try again.") : 402 === P(b) ? new v("quota-exceeded", "Quota for bucket '" + a.bucket + "' exceeded, please view quota on https://firebase.google.com/pricing/.") : 403 === P(b) ? new v("unauthorized", "User does not have permission to access '" + a.path + "'.") : c;b.serverResponse = c.serverResponse;return b;
        };
    },
        te = function te(a) {
        var b = se(a);return function (c, d) {
            var e = b(c, d);404 === P(c) && (e = new v("object-not-found", "Object '" + a.path + "' does not exist."));e.serverResponse = d.serverResponse;return e;
        };
    },
        ue = function ue(a, b, c) {
        var d = Ra(b);a = new w(ka + "/v0" + d, "GET", re(a, c), a.c);a.a = te(b);return a;
    },
        ve = function ve(a, b) {
        var c = Ra(b);a = new w(ka + "/v0" + c, "DELETE", function () {}, a.c);a.h = [200, 204];a.a = te(b);return a;
    },
        we = function we(a, b, c) {
        c = c ? sa(c) : {};c.fullPath = a.path;c.size = b.a;c.contentType || (a = b && b.type() || "application/octet-stream", c.contentType = a);return c;
    },
        xe = function xe(a, b, c, d, e) {
        var f = "/b/" + encodeURIComponent(b.bucket) + "/o",
            g = { "X-Goog-Upload-Protocol": "multipart" },
            h;h = "";for (var l = 0; 2 > l; l++) {
            h += Math.random().toString().slice(2);
        }g["Content-Type"] = "multipart/related; boundary=" + h;e = we(b, d, e);l = ie(e, c);d = Yd("--" + h + "\r\nContent-Type: application/json; charset=utf-8\r\n\r\n" + l + "\r\n--" + h + "\r\nContent-Type: " + e.contentType + "\r\n\r\n", d, "\r\n--" + h + "--");if (null === d) throw na();a = new w(ka + "/v0" + f, "POST", re(a, c), a.b);a.f = { name: e.fullPath };a.b = g;a.c = d.s;a.a = se(b);return a;
    },
        ye = function ye(a, b, c, d) {
        this.a = a;this.total = b;this.b = !!c;this.c = d || null;
    },
        ze = function ze(a, b) {
        var c;try {
            c = Qd(a, "X-Goog-Upload-Status");
        } catch (d) {
            qe(!1);
        }a = 0 <= ob(b || ["active"], c);qe(a);return c;
    },
        Ae = function Ae(a, b, c, d, e) {
        var f = "/b/" + encodeURIComponent(b.bucket) + "/o",
            g = we(b, d, e);e = { name: g.fullPath };f = ka + "/v0" + f;d = {
            "X-Goog-Upload-Protocol": "resumable",
            "X-Goog-Upload-Command": "start", "X-Goog-Upload-Header-Content-Length": d.a, "X-Goog-Upload-Header-Content-Type": g.contentType, "Content-Type": "application/json; charset=utf-8"
        };c = ie(g, c);a = new w(f, "POST", function (a) {
            ze(a);var b;try {
                b = Qd(a, "X-Goog-Upload-URL");
            } catch (c) {
                qe(!1);
            }qe(wa(b));return b;
        }, a.b);a.f = e;a.b = d;a.c = c;a.a = se(b);return a;
    },
        Be = function Be(a, b, c, d) {
        a = new w(c, "POST", function (a) {
            var b = ze(a, ["active", "final"]),
                c;try {
                c = Qd(a, "X-Goog-Upload-Size-Received");
            } catch (h) {
                qe(!1);
            }a = c;isFinite(a) && (a = String(a));
            a = q(a) ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;qe(!isNaN(a));return new ye(a, d.a, "final" === b);
        }, a.b);a.b = { "X-Goog-Upload-Command": "query" };a.a = se(b);return a;
    },
        Ce = function Ce(a, b, c, d, e, f) {
        var g = new ye(0, 0);f ? (g.a = f.a, g.total = f.total) : (g.a = 0, g.total = d.a);if (d.a !== g.total) throw new v("server-file-wrong-size", "Server recorded incorrect upload file size, please retry the upload.");var h = f = g.total - g.a,
            h = Math.min(h, 262144),
            l = g.a;f = { "X-Goog-Upload-Command": h === f ? "upload, finalize" : "upload", "X-Goog-Upload-Offset": g.a };
        l = d.slice(l, l + h);if (null === l) throw na();c = new w(c, "POST", function (a, c) {
            var f = ze(a, ["active", "final"]),
                l = g.a + h,
                Jd = d.a,
                ab;"final" === f ? ab = re(b, e)(a, c) : ab = null;return new ye(l, Jd, "final" === f, ab);
        }, b.b);c.b = f;c.c = l.s;c.g = null;c.a = se(a);return c;
    };var W = function W(a, b, c, d, e, f) {
        this.K = a;this.c = b;this.i = c;this.f = e;this.h = f || null;this.o = d;this.j = 0;this.G = this.m = !1;this.B = [];this.Z = 262144 < this.f.a;this.b = "running";this.a = this.u = this.g = null;var g = this;this.W = function (a) {
            g.a = null;"storage/canceled" === a.code ? (g.m = !0, De(g)) : (g.g = a, V(g, "error"));
        };this.S = function (a) {
            g.a = null;"storage/canceled" === a.code ? De(g) : (g.g = a, V(g, "error"));
        };this.w = this.l = null;this.F = new H(function (a, b) {
            g.l = a;g.w = b;Ee(g);
        });this.F.then(null, function () {});
    },
        Ee = function Ee(a) {
        "running" === a.b && null === a.a && (a.Z ? null === a.u ? Fe(a) : a.m ? Ge(a) : a.G ? He(a) : Ie(a) : Je(a));
    },
        Ke = function Ke(a, b) {
        de(a.c).then(function (c) {
            switch (a.b) {case "running":
                    b(c);break;case "canceling":
                    V(a, "canceled");break;case "pausing":
                    V(a, "paused");}
        });
    },
        Fe = function Fe(a) {
        Ke(a, function (b) {
            var c = Ae(a.c, a.i, a.o, a.f, a.h);a.a = R(a.c, c, b);a.a.a().then(function (b) {
                a.a = null;a.u = b;a.m = !1;De(a);
            }, this.W);
        });
    },
        Ge = function Ge(a) {
        var b = a.u;Ke(a, function (c) {
            var d = Be(a.c, a.i, b, a.f);a.a = R(a.c, d, c);a.a.a().then(function (b) {
                a.a = null;Le(a, b.a);a.m = !1;b.b && (a.G = !0);De(a);
            }, a.W);
        });
    },
        Ie = function Ie(a) {
        var b = new ye(a.j, a.f.a),
            c = a.u;Ke(a, function (d) {
            var e;try {
                e = Ce(a.i, a.c, c, a.f, a.o, b);
            } catch (f) {
                a.g = f;V(a, "error");return;
            }a.a = R(a.c, e, d);a.a.a().then(function (b) {
                a.a = null;Le(a, b.a);b.b ? (a.h = b.c, V(a, "success")) : De(a);
            }, a.W);
        });
    },
        He = function He(a) {
        Ke(a, function (b) {
            var c = ue(a.c, a.i, a.o);a.a = R(a.c, c, b);a.a.a().then(function (b) {
                a.a = null;a.h = b;V(a, "success");
            }, a.S);
        });
    },
        Je = function Je(a) {
        Ke(a, function (b) {
            var c = xe(a.c, a.i, a.o, a.f, a.h);a.a = R(a.c, c, b);a.a.a().then(function (b) {
                a.a = null;
                a.h = b;Le(a, a.f.a);V(a, "success");
            }, a.W);
        });
    },
        Le = function Le(a, b) {
        var c = a.j;a.j = b;a.j > c && Me(a);
    },
        V = function V(a, b) {
        if (a.b !== b) switch (b) {case "canceling":
                a.b = b;null !== a.a && a.a.b();break;case "pausing":
                a.b = b;null !== a.a && a.a.b();break;case "running":
                var c = "paused" === a.b;a.b = b;c && (Me(a), Ee(a));break;case "paused":
                a.b = b;Me(a);break;case "canceled":
                a.g = ma();a.b = b;Me(a);break;case "error":
                a.b = b;Me(a);break;case "success":
                a.b = b, Me(a);}
    },
        De = function De(a) {
        switch (a.b) {
            case "pausing":
                V(a, "paused");break;case "canceling":
                V(a, "canceled");break;case "running":
                Ee(a);
        }
    };W.prototype.D = function () {
        return new z(this.j, this.f.a, va(this.b), this.h, this, this.K);
    };
    W.prototype.O = function (a, b, c, d) {
        function e(a) {
            try {
                g(a);return;
            } catch (b) {}try {
                if (h(a), !(n(a.next) || n(a.error) || n(a.complete))) throw "";
            } catch (b) {
                throw "Expected a function or an Object with one of `next`, `error`, `complete` properties.";
            }
        }function f(a) {
            return function (b, c, d) {
                null !== a && T("on", a, arguments);var e = new Ta(b, c, d);Ne(l, e);return function () {
                    wb(l.B, e);
                };
            };
        }var g = pe().a,
            h = oe(null, !0).a;T("on", [le(function () {
            if ("state_changed" !== a) throw "Expected one of the event types: [state_changed].";
        }), oe(e, !0), pe(), pe()], arguments);var l = this,
            F = [oe(function (a) {
            if (null === a) throw "Expected a function or an Object with one of `next`, `error`, `complete` properties.";e(a);
        }), pe(), pe()];return n(b) || n(c) || n(d) ? f(null)(b, c, d) : f(F);
    };W.prototype.then = function (a, b) {
        return this.F.then(a, b);
    };
    var Ne = function Ne(a, b) {
        a.B.push(b);Oe(a, b);
    },
        Me = function Me(a) {
        Pe(a);var b = xb(a.B);pb(b, function (b) {
            Oe(a, b);
        });
    },
        Pe = function Pe(a) {
        if (null !== a.l) {
            var b = !0;switch (va(a.b)) {case "success":
                    Oc(a.l.bind(null, a.D()))();break;case "canceled":case "error":
                    Oc(a.w.bind(null, a.g))();break;default:
                    b = !1;}b && (a.l = null, a.w = null);
        }
    },
        Oe = function Oe(a, b) {
        switch (va(a.b)) {
            case "running":case "paused":
                null !== b.next && Oc(b.next.bind(b, a.D()))();break;case "success":
                null !== b.b && Oc(b.b.bind(b))();break;case "canceled":case "error":
                null !== b.a && Oc(b.a.bind(b, a.g))();break;default:
                null !== b.a && Oc(b.a.bind(b, a.g))();
        }
    };W.prototype.R = function () {
        T("resume", [], arguments);var a = "paused" === this.b || "pausing" === this.b;a && V(this, "running");return a;
    };W.prototype.P = function () {
        T("pause", [], arguments);var a = "running" === this.b;a && V(this, "pausing");return a;
    };W.prototype.L = function () {
        T("cancel", [], arguments);var a = "running" === this.b || "pausing" === this.b;a && V(this, "canceling");return a;
    };var X = function X(a, b) {
        this.b = a;if (b) this.a = b instanceof y ? b : Sa(b);else if (a = a.bucket(), null !== a) this.a = new y(a, "");else throw new v("no-default-bucket", "No default bucket found. Did you set the 'storageBucket' property when initializing the app?");
    };X.prototype.toString = function () {
        T("toString", [], arguments);return "gs://" + this.a.bucket + "/" + this.a.path;
    };var Qe = function Qe(a, b) {
        return new X(a, b);
    };k = X.prototype;
    k.fa = function (a) {
        T("child", [le()], arguments);var b = Gb(this.a.path, a);return Qe(this.b, new y(this.a.bucket, b));
    };k.Ea = function () {
        var a;a = this.a.path;if (0 == a.length) a = null;else {
            var b = a.lastIndexOf("/");a = -1 === b ? "" : a.slice(0, b);
        }return null === a ? null : Qe(this.b, new y(this.a.bucket, a));
    };k.Ga = function () {
        return Qe(this.b, new y(this.a.bucket, ""));
    };k.na = function () {
        return this.a.bucket;
    };k.za = function () {
        return this.a.path;
    };k.Da = function () {
        return Hb(this.a.path);
    };k.Ia = function () {
        return this.b.i;
    };
    k.sa = function (a, b) {
        T("put", [me(), new U(je, !0)], arguments);Re(this, "put");return new W(this, this.b, this.a, ge(), new Q(a), b);
    };k.ta = function (a, b, c) {
        T("putString", [le(), le(Va, !0), new U(je, !0)], arguments);Re(this, "putString");var d = $a(x(b) ? b : "raw", a),
            e = c ? sa(c) : {};e.contentType = d.a;return new W(this, this.b, this.a, ge(), new Q(d.data, !0), e);
    };k.delete = function () {
        T("delete", [], arguments);Re(this, "delete");var a = this;return de(this.b).then(function (b) {
            var c = ve(a.b, a.a);return R(a.b, c, b).a();
        });
    };
    k.ga = function () {
        T("getMetadata", [], arguments);Re(this, "getMetadata");var a = this;return de(this.b).then(function (b) {
            var c = ue(a.b, a.a, ge());return R(a.b, c, b).a();
        });
    };k.ua = function (a) {
        T("updateMetadata", [new U(je, void 0)], arguments);Re(this, "updateMetadata");var b = this;return de(this.b).then(function (c) {
            var d = b.b,
                e = b.a,
                f = a,
                g = ge(),
                h = Ra(e),
                h = ka + "/v0" + h,
                f = ie(f, g),
                d = new w(h, "PATCH", re(d, g), d.c);d.b = { "Content-Type": "application/json; charset=utf-8" };d.c = f;d.a = te(e);return R(b.b, d, c).a();
        });
    };
    k.ra = function () {
        T("getDownloadURL", [], arguments);Re(this, "getDownloadURL");return this.ga().then(function (a) {
            a = a.downloadURLs[0];if (x(a)) return a;throw new v("no-download-url", "The given file does not have any download URLs.");
        });
    };var Re = function Re(a, b) {
        if ("" === a.a.path) throw new v("invalid-root-operation", "The operation '" + b + "' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");
    };var Y = function Y(a) {
        this.a = new ce(a, function (a, c) {
            return new X(a, c);
        }, Vd, this);this.b = a;this.c = new Se(this);
    };k = Y.prototype;k.va = function (a) {
        T("ref", [le(function (a) {
            if (/^[A-Za-z]+:\/\//.test(a)) throw "Expected child path but got a URL, use refFromURL instead.";
        }, !0)], arguments);var b = new X(this.a);return n(a) ? b.fa(a) : b;
    };
    k.wa = function (a) {
        T("refFromURL", [le(function (a) {
            if (!/^[A-Za-z]+:\/\//.test(a)) throw "Expected full URL but got a child path, use ref instead.";try {
                Sa(a);
            } catch (c) {
                throw "Expected valid full URL but got an invalid one.";
            }
        }, !1)], arguments);return new X(this.a, a);
    };k.Ba = function () {
        return this.a.b;
    };k.ya = function (a) {
        T("setMaxUploadRetryTime", [ne()], arguments);this.a.b = a;
    };k.Aa = function () {
        return this.a.c;
    };k.xa = function (a) {
        T("setMaxOperationRetryTime", [ne()], arguments);this.a.c = a;
    };k.ma = function () {
        return this.b;
    };
    k.ka = function () {
        return this.c;
    };var Se = function Se(a) {
        this.a = a;
    };Se.prototype.delete = function () {
        var a = this.a.a;a.f = !0;a.a = null;be(a.h);
    };var Z = function Z(a, b, c) {
        Object.defineProperty(a, b, { get: c });
    };X.prototype.toString = X.prototype.toString;X.prototype.child = X.prototype.fa;X.prototype.put = X.prototype.sa;X.prototype.putString = X.prototype.ta;X.prototype["delete"] = X.prototype.delete;X.prototype.getMetadata = X.prototype.ga;X.prototype.updateMetadata = X.prototype.ua;X.prototype.getDownloadURL = X.prototype.ra;Z(X.prototype, "parent", X.prototype.Ea);Z(X.prototype, "root", X.prototype.Ga);Z(X.prototype, "bucket", X.prototype.na);
    Z(X.prototype, "fullPath", X.prototype.za);Z(X.prototype, "name", X.prototype.Da);Z(X.prototype, "storage", X.prototype.Ia);Y.prototype.ref = Y.prototype.va;Y.prototype.refFromURL = Y.prototype.wa;Z(Y.prototype, "maxOperationRetryTime", Y.prototype.Aa);Y.prototype.setMaxOperationRetryTime = Y.prototype.xa;Z(Y.prototype, "maxUploadRetryTime", Y.prototype.Ba);Y.prototype.setMaxUploadRetryTime = Y.prototype.ya;Z(Y.prototype, "app", Y.prototype.ma);Z(Y.prototype, "INTERNAL", Y.prototype.ka);Se.prototype["delete"] = Se.prototype.delete;
    Y.prototype.capi_ = function (a) {
        ka = a;
    };W.prototype.on = W.prototype.O;W.prototype.resume = W.prototype.R;W.prototype.pause = W.prototype.P;W.prototype.cancel = W.prototype.L;Z(W.prototype, "snapshot", W.prototype.D);Z(z.prototype, "bytesTransferred", z.prototype.oa);Z(z.prototype, "totalBytes", z.prototype.Ka);Z(z.prototype, "state", z.prototype.Ha);Z(z.prototype, "metadata", z.prototype.Ca);Z(z.prototype, "downloadURL", z.prototype.qa);Z(z.prototype, "task", z.prototype.Ja);Z(z.prototype, "ref", z.prototype.Fa);
    ta.STATE_CHANGED = "state_changed";ua.RUNNING = "running";ua.PAUSED = "paused";ua.SUCCESS = "success";ua.CANCELED = "canceled";ua.ERROR = "error";Ua.RAW = "raw";Ua.BASE64 = "base64";Ua.BASE64URL = "base64url";Ua.DATA_URL = "data_url";H.prototype["catch"] = H.prototype.l;H.prototype.then = H.prototype.then;
    (function () {
        function a(a) {
            return new Y(a);
        }var b = { TaskState: ua, TaskEvent: ta, StringFormat: Ua, Storage: Y, Reference: X };if (window.firebase && firebase.INTERNAL && firebase.INTERNAL.registerService) firebase.INTERNAL.registerService("storage", a, b);else throw Error("Cannot install Firebase Storage - be sure to load firebase-app.js first.");
    })();
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loader)?_c('div',{staticClass:"loader"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.isSnakebar)?_c('snackbar',{attrs:{"message":_vm.message,"backgroundColor":_vm.backgroundColor}}):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-div"},[_c('div',{staticClass:"main-loader-div"},[_c('img',{staticClass:"loader-image",attrs:{"src":__webpack_require__(16),"alt":"loader"}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px","text-align":"center"}},[_vm._v("Please wait a moment...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(29);



var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
    return originalPush.call(this, location).catch(function (err) {
        return err;
    });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* routes */],
    mode: 'history'
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationFailureType */
/* unused harmony export RouterLink */
/* unused harmony export RouterView */
/* unused harmony export START_LOCATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueRouter$1; });
/* unused harmony export isNavigationFailure */
/* unused harmony export version */
/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/(?:\s*\/)+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'}\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1$1.ensureURL();
      this$1$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1$1.ready) {
        this$1$1.ready = true;
        this$1$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1$1.ready = true;
          this$1$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1$1.errorCbs.length) {
        this$1$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1$1.replace(to);
          } else {
            this$1$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1$1.pending = null;
      onComplete(route);
      if (this$1$1.router.app) {
        this$1$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1$1.base);
      if (this$1$1.current === START && location === this$1$1._startLocation) {
        return
      }

      this$1$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index + 1).concat(route);
        this$1$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1$1.current;
        this$1$1.index = targetIndex;
        this$1$1.updateRoute(route);
        this$1$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1$1.apps.indexOf(app);
    if (index > -1) { this$1$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1$1.app === app) { this$1$1.app = this$1$1.apps[0] || null; }

    if (!this$1$1.app) { this$1$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

var VueRouter$1 = VueRouter;

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

// We cannot remove this as it would be a breaking change
VueRouter.install = install;
VueRouter.version = '3.6.5';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

var version = '3.6.5';




/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
var mypackChild = [{
    path: "",
    component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 67));
    },
    name: "manage"
}, {
    path: "renew",
    component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 68));
    },
    name: "renew"
}];
var myprofileChild = [{
    path: "",
    component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 69));
    },
    name: "details"
}, {
    path: "kyc",
    component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 70));
    },
    name: "kyc"
}, {
    path: "transactions",
    component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 71));
    },
    name: "transactions"
}];
var helpChild = [{
    path: "",
    component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 72));
    },
    name: "faq"
}, {
    path: "customersupport",
    component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 73));
    },
    name: "customersupport"
}];
var menuChildren = [{
    path: "",
    component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 74));
    },
    name: "mynxtdigital"
}, {
    path: "mypacks",
    component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 75));
    },
    name: "manage",
    children: mypackChild
}, {
    path: "addpacks",
    component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 76));
    },
    name: "addpacks"
}, {
    path: "myprofile",
    component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 77));
    },
    name: "details",
    children: myprofileChild
}, {
    path: "help",
    component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 78));
    },
    name: "help",
    children: helpChild
}, {
    path: "alert",
    component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 79));
    },
    name: "alert"
}, {
    path: "contactus",
    component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 80));
    },
    name: "contactus"
}, {
    path: "/checkout",
    component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 81));
    },
    name: "checkout"
},
// {
//   path: "transactionhistory",
//   component: () =>
//     import(
//       /* webpackChunkName: 'nxt-transactionhistory */ "@/components/transactionHistory/TransactionHistory.vue"
//     ),
//   name: "transactionhistory"
// },
{
    path: "description",
    component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 82));
    },
    name: "description"
}, {
    path: "logout",
    component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 83));
    },
    name: "logout"
},
// {
//   path: "/myaccountchild/:link",
//   component: () =>
//     import(
//       /* webpackChunkName: 'imcl-myaccountchild */ "@/components/myaccount/myAccount.vue"
//     ),
//   name: "myaccountchild"
// },
{
    path: "topup",
    component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 84));
    },
    name: "topup"
}];
var routes = [{
    path: "/",
    name: "login",
    component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 85));
    }
}, {
    path: "/ottquickpay",
    name: "ottquickpay",
    component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 86));
    }
}, {
    path: "/instantpayment",
    name: "instantpayment",
    component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 87));
    }
}, {
    path: "/qrscan/:id",
    name: "qrscan",
    component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 88));
    }
}, {
    path: "/hdupgrade",
    name: "hdupgrade",
    component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 89));
    }
}, {
    path: "/instantpaymentconfirm/:id",
    name: "instantpaymentconfirm",
    component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 90));
    }
}, {
    path: "/maintenance",
    name: "maintenance",
    component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 91));
    }
}, {
    path: "/maintenancelogin",
    name: "maintenancelogin",
    component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 92));
    }
}, {
    path: "/nxtselfcareportal",
    component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 93));
    },
    children: menuChildren,
    name: "home"
}, {
    path: "/surveyquestions",
    component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 94));
    },
    name: "surveyquestions"
}, {
    path: "/paymentstatuscheck",
    name: "paymentstatuscheck",
    component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 95));
    }
}];

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "baseUrl", function() { return baseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMode", function() { return getMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getServer", function() { return getServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImage", function() { return getImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserInfo", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemsInfoCart", function() { return getItemsInfoCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSurveyQuestions", function() { return getSurveyQuestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSurveyPageNum", function() { return getSurveyPageNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCartDataDetails", function() { return getCartDataDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCTAImages", function() { return getCTAImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCartDetails", function() { return getCartDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBBDetails", function() { return getBBDetails; });
var baseUrl = function baseUrl(state) {
  return state.baseUrl;
};
var getMode = function getMode(state) {
  return state.mode;
};
var getServer = function getServer(state) {
  return state.server;
};
var getImage = function getImage(state) {
  console.log("getters js ", state);
  return state.docImage;
};
var getUserInfo = function getUserInfo(state) {
  console.log("getter ", state);
  return state.userInfo;
};
var getItemsInfoCart = function getItemsInfoCart(state) {
  return state.getCartDetails;
};
var getSurveyQuestions = function getSurveyQuestions(state) {
  return state.surveyQuestions;
};
var getSurveyPageNum = function getSurveyPageNum(state) {
  return state.pageNum;
};
var getCartDataDetails = function getCartDataDetails(state) {
  return state.cartData;
};
var getCTAImages = function getCTAImages(state) {
  return state.CTAImages;
};
var getCartDetails = function getCartDetails(state) {
  return state.CartDetails;
};
var getBBDetails = function getBBDetails(state) {
  return state.bbDetails;
};

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserInfo", function() { return setUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStbNumber", function() { return setStbNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemsInfoCart", function() { return setItemsInfoCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSurveyPageNum", function() { return setSurveyPageNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSurveyQuestions", function() { return setSurveyQuestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setImage", function() { return setImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCartDataDetails", function() { return setCartDataDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCTAImages", function() { return setCTAImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCartDetails", function() { return setCartDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBBDetails", function() { return setBBDetails; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var setUserInfo = function setUserInfo(state, data) {
  state.userInfo = data;
};
var setStbNumber = function setStbNumber(state, data) {
  state.boxNumber = data;
};
var setItemsInfoCart = function setItemsInfoCart(state, data) {
  state.getCartDetails = data;
};
var setSurveyPageNum = function setSurveyPageNum(state, page) {
  state.pageNum = page;
};
var setSurveyQuestions = function setSurveyQuestions(state, question) {
  if (question && question.length) {
    state.surveyQuestions = [].concat(_toConsumableArray(state.surveyQuestions), _toConsumableArray(question));
  } else {
    state.surveyQuestions = [];
  }
};
var setImage = function setImage(state, data) {
  console.log("setImage", data);
  state.docImage = data;
};
var setCartDataDetails = function setCartDataDetails(state, data) {
  state.cartData = data;
};
var setCTAImages = function setCTAImages(state, data) {
  state.CTAImages = data;
};
var setCartDetails = function setCartDetails(state, data) {
  state.CartDetails = data;
};
var setBBDetails = function setBBDetails(state, data) {
  state.bbDetails = data;
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actGetUserInfo", function() { return actGetUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);


var actGetUserInfo = function actGetUserInfo(context, payload) {
  return new Promise(function (resolve, reject) {
    fetch(context.state.baseUrl + "/subscriber/v1/subscriber").then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
      return response.json();
    }).then(function (data) {
      resolve(data);
    }).catch(function (error) {
      reject(error);
    });
  });
};

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var actions = {
  actPostResetPassword: function actPostResetPassword(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      console.log("payload", payload);
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/passwordreset", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var actions = {
  actGetLogin: function actGetLogin(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/login" + data, {
        method: "GET"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveAgreementDetail: function saveAgreementDetail(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/termsandcondition", {
        method: "POST"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ success: 26312908 });
          return;
        }
        reject(error);
      });
    });
  },
  checkPortalMaintenance: function checkPortalMaintenance(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + "/subscriber/v1/maintenance", {
        method: "GET"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve({
            "maintenance": "OFF",
            "header": "Portal Maintenance",
            "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
            "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
            "style": ""
          });
          return;
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({
            "maintenance": "OFF",
            "header": "Portal Maintenance",
            "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
            "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
            "style": ""
          });
          return;
        }
        reject(error);
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);


var state = {
  stbData: undefined,
  smcData: undefined,
  accountDetails: undefined,
  tempData: undefined,
  typeSelected: undefined,
  boxNumber: undefined
};
var getters = {
  getStbData: function getStbData(state) {
    return state.stbData;
  },
  getSmcData: function getSmcData(state) {
    return state.smcData;
  },
  getChangePassword: function getChangePassword(state) {
    return state.changePassword;
  },
  getAccountDetails: function getAccountDetails(state) {
    return state.accountDetails;
  },
  getTempData: function getTempData(state) {
    return state.tempData;
  },
  getTypeSelected: function getTypeSelected(state) {
    return state.typeSelected;
  },
  getBoxNumber: function getBoxNumber(state) {
    return state.boxNumber;
  }
};
var mutations = {
  setStbData: function setStbData(state, data) {
    state.stbData = data;
    console.log("setStbData", data);
  },
  setSmcData: function setSmcData(state, data) {
    state.smcData = data;
  },
  setAccountDetails: function setAccountDetails(state, data) {
    state.accountDetails = data;
  },
  setChangePassword: function setChangePassword(state, data) {
    state.changeNumber = data;
  },
  setTempData: function setTempData(state, data) {
    state.tempData = data;
  },
  setTypeSelected: function setTypeSelected(state, data) {
    state.typeSelected = data;
  },
  setBoxNumber: function setBoxNumber(state, data) {
    state.boxNumber = data;
  }
};
var actions = {
  actGetSubscriberValidate: function actGetSubscriberValidate(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/validate", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changeUserAccountDetails: function changeUserAccountDetails(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/childdetails", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changeToParentDetails: function changeToParentDetails(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/deletechilddetails", {
        method: "POST"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  actPostSubscriberDetails: function actPostSubscriberDetails(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      delete payload.changeNumber;
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  actregionRegister: function actregionRegister(context, payload) {
    var key = '';
    if (context.getters.getServer == "test") {
      key = 'key=AAAASuKqmzg:APA91bEg3-eFiXPNucqTCR1FM2D0f8bs0Kf6RKpR5lAmVsglcwgtT6p8A3Qp6x6FLVFA8eFFtKpn1Mjhy6h0lYhDDJUubEqAMc8oB7-DnmjSbWj9P85a_xNtHzSYwfv7YCYv3P-TLUO1';
    } else {
      key = 'key=AAAAVDulBSI:APA91bHZZDfrIh5rO5fYpup8pTvEDtdfghg9MD5RaJ4LNBGNJe-sTl1G9YATovZbQ4rn0UlRoYMQx3bUnwbm3VCfRD0O46uxUkdlqOUUTSWWDF9kCdz9JyluqPwE9GZ-zJ-Wnwn4W5Ik';
    }
    return new Promise(function (resolve, reject) {
      fetch('https://iid.googleapis.com/iid/v1/' + payload.token + '/rel/topics/' + payload.region, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': key
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);


var state = {
  otpData: undefined
};
var getters = {
  getOtpData: function getOtpData(state) {
    console.log("otp getter ", state.otpData);
    return state.otpData;
  }
};
var mutations = {
  setOtpData: function setOtpData(state, data) {
    state.otpData = data;
    console.log("otp setter ", state.otpData);
  }
};
var actions = {
  actPostGenerateOtp: function actPostGenerateOtp(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/generateotp", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  actPostVerifyOtp: function actPostVerifyOtp(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/otpverify", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  actPostReGenerateOtp: function actPostReGenerateOtp(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/regenotp", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  lazyPayReGenerateOtp: function lazyPayReGenerateOtp(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/lazypay/resendotp", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  lazyPayVerifyOtp: function lazyPayVerifyOtp(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/lazypay/pay", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  lazyPaymentConfirm: function lazyPaymentConfirm(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = payload;
      fetch(context.getters.baseUrl + "/subscriber/paymentconfirm", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  cancelLazypayPayment: function cancelLazypayPayment(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/lazypay/updateCanclePayment", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }

};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions,
  state: state,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var state = {
  name: 'abcs'
};
var actions = {
  getCustomerSupport: function getCustomerSupport(context, filterData) {
    var url = '/subscriber/v1/ticket';
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
          return;
        }
        reject(error);
      });
    });
  },
  actCloseTicket: function actCloseTicket(context, filterData) {
    var url = '/subscriber/v1/ticket/';
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + url + filterData, {
        method: 'PUT'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("phase 2");
        if (context.getters.getMode == "development") {
          resolve({ "success": "3939244" });
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ "success": "3939244" });
          return;
        }
        reject(error);
      });
    });
  },
  getTicketCategory: function getTicketCategory(context) {
    var url = '/subscriber/v1/ticket/category';
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("phase 2");
        if (context.getters.getMode == "development") {
          resolve([{ "idcategory": "BIL01", "description": "BILLING", "subcategory": [{ "idcategory": "BIL01001", "description": "Bill Not Received" }, { "idcategory": "BIL01011", "description": "Wrong Rentals charged for Set Top Box" }, { "idcategory": "BIL01012", "description": "Wrong or Excess Bill received" }] }, { "idcategory": "HWR01", "description": "HARDWARE", "subcategory": [{ "idcategory": "HWR01001", "description": "Remote Not Functioning" }, { "idcategory": "HWR01002", "description": "STB Hang " }, { "idcategory": "HWR01003", "description": "Smartcard Inserted Up-side Down or Smartcard Communication Error" }, { "idcategory": "HWR01004", "description": "STB Dead (Green Light Not Glowing)" }, { "idcategory": "HWR01005", "description": "Channels not getting Auto Scanned" }, { "idcategory": "HWR01006", "description": "No Audio in All Channels" }, { "idcategory": "HWR01007", "description": "No Video in All Channels (All Channels Blank) " }, { "idcategory": "HWR01008", "description": "Negative Video" }] }, { "idcategory": "MOD", "description": "MODIFICATION", "subcategory": [{ "idcategory": "MOD01001", "description": "Customer Name Wrong or Mismatch" }, { "idcategory": "MOD01002", "description": "Change in Address \/ Wrong Address" }, { "idcategory": "MOD01003", "description": "Change in Contact Nos. \/ New Contact Nos." }, { "idcategory": "MOD01004", "description": "Hardware Mismatch" }] }, { "idcategory": "ORD01", "description": "ORDER", "subcategory": [{ "idcategory": "ORD01001", "description": "Addition of Channels \/ Changes in A La Carte" }, { "idcategory": "ORD01002", "description": "Additional Set Top Box required" }, { "idcategory": "ORD01003", "description": "New Set Top Box required" }, { "idcategory": "ORD01004", "description": "New Connection required" }, { "idcategory": "ORD01005", "description": "Shifting to New Premises" }, { "idcategory": "ORD01006", "description": "Addition of Package \/ Changes in Package" }, { "idcategory": "ORD01007", "description": "New Activation Request" }, { "idcategory": "ORD01008", "description": "Temporary Deactivation Request" }, { "idcategory": "ORD01009", "description": "Permanent Deactivation Request" }, { "idcategory": "ORD01010", "description": "Reconnection Request" }] }, { "idcategory": "SER01", "description": "SERVICE", "subcategory": [{ "idcategory": "SER01001", "description": "Access Denied or Channel Not Subscribed" }, { "idcategory": "SER01003", "description": "Channels Freezing (Channels get Stuck)" }, { "idcategory": "SER01005", "description": "Less Channels Available" }, { "idcategory": "SER01007", "description": "No Audio in One or Few Channels" }, { "idcategory": "SER01008", "description": "No Signal in One or Few Channels" }, { "idcategory": "SER01009", "description": "No Video in One or Few Channels" }, { "idcategory": "SER01010", "description": "No Signal in All Channels" }, { "idcategory": "SER01011", "description": "Cracking (Disturbance ) in Audio" }, { "idcategory": "SER01012", "description": "Reconnection \/ Disconnection" }, { "idcategory": "SER01013", "description": "Fiber cut" }, { "idcategory": "SER01014", "description": "Low signal strength" }, { "idcategory": "SER01015", "description": "Error-1" }, { "idcategory": "SER01016", "description": "Error-5" }] }]);
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          // resolve([{"idcategory":"BIL01","description":"BILLING","subcategory":[{"idcategory":"BIL01001","description":"Bill Not Received"},{"idcategory":"BIL01011","description":"Wrong Rentals charged for Set Top Box"},{"idcategory":"BIL01012","description":"Wrong or Excess Bill received"}]},{"idcategory":"HWR01","description":"HARDWARE","subcategory":[{"idcategory":"HWR01001","description":"Remote Not Functioning"},{"idcategory":"HWR01002","description":"STB Hang "},{"idcategory":"HWR01003","description":"Smartcard Inserted Up-side Down or Smartcard Communication Error"},{"idcategory":"HWR01004","description":"STB Dead (Green Light Not Glowing)"},{"idcategory":"HWR01005","description":"Channels not getting Auto Scanned"},{"idcategory":"HWR01006","description":"No Audio in All Channels"},{"idcategory":"HWR01007","description":"No Video in All Channels (All Channels Blank) "},{"idcategory":"HWR01008","description":"Negative Video"}]},{"idcategory":"MOD","description":"MODIFICATION","subcategory":[{"idcategory":"MOD01001","description":"Customer Name Wrong or Mismatch"},{"idcategory":"MOD01002","description":"Change in Address \/ Wrong Address"},{"idcategory":"MOD01003","description":"Change in Contact Nos. \/ New Contact Nos."},{"idcategory":"MOD01004","description":"Hardware Mismatch"}]},{"idcategory":"ORD01","description":"ORDER","subcategory":[{"idcategory":"ORD01001","description":"Addition of Channels \/ Changes in A La Carte"},{"idcategory":"ORD01002","description":"Additional Set Top Box required"},{"idcategory":"ORD01003","description":"New Set Top Box required"},{"idcategory":"ORD01004","description":"New Connection required"},{"idcategory":"ORD01005","description":"Shifting to New Premises"},{"idcategory":"ORD01006","description":"Addition of Package \/ Changes in Package"},{"idcategory":"ORD01007","description":"New Activation Request"},{"idcategory":"ORD01008","description":"Temporary Deactivation Request"},{"idcategory":"ORD01009","description":"Permanent Deactivation Request"},{"idcategory":"ORD01010","description":"Reconnection Request"}]},{"idcategory":"SER01","description":"SERVICE","subcategory":[{"idcategory":"SER01001","description":"Access Denied or Channel Not Subscribed"},{"idcategory":"SER01003","description":"Channels Freezing (Channels get Stuck)"},{"idcategory":"SER01005","description":"Less Channels Available"},{"idcategory":"SER01007","description":"No Audio in One or Few Channels"},{"idcategory":"SER01008","description":"No Signal in One or Few Channels"},{"idcategory":"SER01009","description":"No Video in One or Few Channels"},{"idcategory":"SER01010","description":"No Signal in All Channels"},{"idcategory":"SER01011","description":"Cracking (Disturbance ) in Audio"},{"idcategory":"SER01012","description":"Reconnection \/ Disconnection"},{"idcategory":"SER01013","description":"Fiber cut"},{"idcategory":"SER01014","description":"Low signal strength"},{"idcategory":"SER01015","description":"Error-1"},{"idcategory":"SER01016","description":"Error-5"}]}])
          return;
        }
        reject(error);
      });
    });
  },
  addCreateTicket: function addCreateTicket(context, payload) {
    console.log(payload);
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(payload);
      console.log(data);
      fetch(context.getters.baseUrl + "/subscriber/v1/ticket", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("phase 2");
        if (context.getters.getMode == "development") {
          resolve({ "ticketid": "3939244" });
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ "ticketid": "3939244" });
          return;
        }
        reject(error);
      });
    });
  },
  getContactMethod: function getContactMethod(context) {
    var url = '/subscriber/v1/ticket.php/contactmethods';
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("phase 2");
        if (context.getters.getMode == "development") {
          resolve([{ "contactmethod": "S", "contactmethodname": "SMS", "description": "SMS", "status": true }, { "contactmethod": "P", "contactmethodname": "Phone", "description": "Phone", "status": true }, { "contactmethod": "O", "contactmethodname": "OSD", "description": "On Screen Display Message", "status": true }, { "contactmethod": "E", "contactmethodname": "Email", "description": "Emial", "status": true }, { "contactmethod": "B", "contactmethodname": "Bmail", "description": "Broadcast Mail Message", "status": true }]);
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve([{ "contactmethod": "S", "contactmethodname": "SMS", "description": "SMS", "status": true }, { "contactmethod": "P", "contactmethodname": "Phone", "description": "Phone", "status": true }, { "contactmethod": "O", "contactmethodname": "OSD", "description": "On Screen Display Message", "status": true }, { "contactmethod": "E", "contactmethodname": "Email", "description": "Emial", "status": true }, { "contactmethod": "B", "contactmethodname": "Bmail", "description": "Broadcast Mail Message", "status": true }]);
          return;
        }
        reject(error);
      });
    });
  }
};
/*const getters = {
  getCus: (state) => {
   console.log("state.baseUrl ===========>",state)
    return state.baseUrl;
  }
}*/
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, actions: actions
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var actions = {
  // actPostRetrack: (context, payload) => {
  //   return new Promise((resolve, reject) => {
  //     if (!payload) {
  //       reject({ error: "payload not found" });
  //     }
  //     let data = makeQueryFormDataDyn(payload);
  //     fetch(context.getters.baseUrl + "/subscriber/v1/retrack", {
  //       method: "POST",
  //       body: data
  //     })
  //       .then(errorServeiceHandler)
  //       .then(response => {
  //           return response.json();
  //       })
  //       .then(data => {
  //         if (context.getters.getMode == "development") {
  //           resolve({ success: 26312908 });
  //         } else {
  //             resolve(data);
  //         }
  //       })
  //       .catch(error => {
  //         console.log("error", error);
  //         reject(error);
  //       });
  //   });
  // },
  sendfaqError: function sendfaqError(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/supporterror", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        }
        console.log("error", error);
        reject(error);
      });
    });
  },
  retrackFaq: function retrackFaq(context) {
    return new Promise(function (resolve, reject) {

      fetch(context.getters.baseUrl + "/subscriber/v1/retrack", {
        method: "POST"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ success: 26467977 });
        }
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var state = {
  editDetails: undefined
};

var getters = {
  getEditDetails: function getEditDetails(state) {
    return state.editDetails;
  }
};

var mutations = {
  setEditDetails: function setEditDetails(state, data) {
    state.editDetails = data;
  }
};

var actions = {
  getHardwareAndLco: function getHardwareAndLco(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/cpe", {
        method: "GET"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
        }
        console.log("error", error);
        reject(error);
      });
    });
  },
  actPutProfileDetails: function actPutProfileDetails(context, payload) {
    return new Promise(function (resolve, reject) {

      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      var object = {};
      data.forEach(function (value, key) {
        object[key] = value;
      });
      data = JSON.stringify(object);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber", {
        method: "PUT",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
        }
        console.log("error", error);
        reject(error);
      });
    });
  },
  actPostChangePassword: function actPostChangePassword(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/changepassword", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
        }
        console.log("error", error);
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions, state: state, getters: getters, mutations: mutations
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var actions = {
  actPostFileUpload: function actPostFileUpload(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/fileupload", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
        }
        console.log("error", error);
        reject(error);
      });
    });
  },
  actPutKYC: function actPutKYC(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      var object = {};
      data.forEach(function (value, key) {
        object[key] = value;
      });
      data = JSON.stringify(object);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber", {
        method: "PUT",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
        }
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 41 */
/***/ (function(module, exports) {



/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var actions = {
  actGetLogout: function actGetLogout(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + "/subscriber/v1/logout", {
        method: "GET"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var actions = {
  getManagePacksDetail: function getManagePacksDetail(context, filterData) {
    //let url = 'subscriber/v1/product/active.php'
    var url = '/subscriber/v1/subscriber/services';
    return new Promise(function (resolve, reject) {
      //let queryStr = ''
      //queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
          return;
        }
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var actions = {
    getRenewPacksDetail: function getRenewPacksDetail(context, filterData) {
        var url = '/subscriber/v1/plan/active';
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            if (filterData.productstatus) {
                queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
            }
            fetch(context.getters.baseUrl + url + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },

    payDPCustomer: function payDPCustomer(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log("payload ", payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(payload);

            fetch(context.getters.baseUrl + "/subscriber/v1/plan/plannew", {
                method: "POST",
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                console.log("error", error);
                reject(error);
            });
        });
    }

};

/* harmony default export */ __webpack_exports__["a"] = ({
    actions: actions
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var actions = {
  getPacksDetail: function getPacksDetail(context, filterData) {
    var url = filterData.url;
    delete filterData.url;
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  sendBroadbandDetails: function sendBroadbandDetails(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      console.log("payload", payload);
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(payload);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/broadbanddetails", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ success: 26312908 });
          return;
        }
        console.log("error", error);
        reject(error);
      });
    });
  },
  disconnectForRefund: function disconnectForRefund(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/disconnectpackdetails", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ success: 26312908 });
          return;
        }
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var state = {};
var getters = {};
var mutations = {};

var actions = {
    addPacksInCart: function addPacksInCart(context, data) {
        console.log("before call api", data);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/subscriber/v1/cart', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    removePackFromCart: function removePackFromCart(context, data) {
        var queryStr = '';
        queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(data);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/subscriber/v1/cart/remove' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getCartData: function getCartData(context) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/subscriber/v1/cart', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getPaymentStatus: function getPaymentStatus(context, dataObj) {
        return new Promise(function (resolve, reject) {
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(dataObj);
            console.log(queryStr);
            fetch(context.getters.baseUrl + '/subscriber/paymentstatuscheck' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                resolve({ "status": true, "msg": { "name_on_card": "NA", "bank_ref_num": "959405", "udf3": "", "hash": "853e78415d6423db5af35d81f36f3a2621cf20fe32d3714351bd001e828c840a4c4aa89169673b45ccd2c6b906e3df0fdae109a716a750a5832f0815315adbce", "firstname": "indigitial", "net_amount_debit": "10.0", "payment_source": "Easebuzz", "surl": "https:\/\/imclselfcaretest.mobiotics.com\/subscriber\/paymentconfirm", "error_Message": "PGS10001-Success", "issuing_bank": "NA", "cardCategory": "NA", "phone": "9999999999", "easepayid": "TBCPTAVIQT", "cardnum": "NA", "key": "2PBP7IABZ2", "udf8": "", "unmappedstatus": "NA", "PG_TYPE": "NA", "addedon": "2022-12-27 11:14:21", "cash_back_percentage": "50.0", "status": "success", "card_type": "Debit Card", "merchant_logo": "NA", "udf6": "", "udf10": "", "txnid": "7151948DP", "productinfo": "NXT SELFCARE RECHARGE", "furl": "https:\/\/imclselfcaretest.mobiotics.com\/subscriber\/paymentconfirm", "udf1": "12350940", "amount": "10.0", "udf2": "", "udf5": "", "mode": "DC", "udf7": "", "error": "PGS10001-Success", "udf9": "", "bankcode": "NA", "deduction_percentage": "2.3", "email": "test@test.com", "udf4": "" } });
                reject(error);
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var state = {
    rechargeAmount: undefined
};
var getters = {
    getRechargeAmount: function getRechargeAmount(state) {
        return state.rechargeAmount;
    }
};
var mutations = {
    setRechargeAmount: function setRechargeAmount(state, data) {
        state.rechargeAmount = data;
    }
};

var actions = {
    actGetBanner: function actGetBanner(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            console.log('url', context.getters.baseUrl + "subscriber/v1/promo" + data);
            fetch(context.getters.baseUrl + "/subscriber/v1/promo" + data, {
                method: "GET"
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    actions: actions, state: state, getters: getters, mutations: mutations
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var actions = {
  getChannelListsDetail: function getChannelListsDetail(context, filterData) {
    var url = '/subscriber/v1/plan/channel';
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("phase 2");
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
          return;
        }
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var actions = {
  actGetChannelList: function actGetChannelList(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/plan/channel" + data, {
        method: "GET"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);



var actions = {
  actGetBannerImage: function actGetBannerImage(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/promo" + data, {
        method: "GET"
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var actions = {
  payDPOCustomer: function payDPOCustomer(context) {
    var url = '/subscriber/v1/cart/checkout';
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + url, {
        method: 'POST'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.text();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
          return;
        }
        reject(error);
      });
    });
  },
  payLCOCustomer: function payLCOCustomer(context, formData) {
    var url = '/subscriber/v1/payment/init';
    return new Promise(function (resolve, reject) {
      var queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formData);
      fetch(context.getters.baseUrl + url, {
        method: 'POST',
        body: queryStr
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve();
          return;
        }
        reject(error);
      });
    });
  },
  payBillCloudCustomer: function payBillCloudCustomer(context, formData) {
    var url = 'https://v3-uat.billcloud.in:9999/me-imcl/external/initiatePayment';
    return new Promise(function (resolve, reject) {
      var queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formData);
      fetch(url, {
        method: 'POST',
        body: queryStr
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  payRenewLCOCustomer: function payRenewLCOCustomer(context, formData) {
    var url = '/subscriber/v1/billgenerate/init';
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + url, {
        method: 'POST',
        body: formData
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);


var state = {};
var getters = {};
var mutations = {};
var actions = {
  actPostInit: function actPostInit(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/payment/init", {
        method: "POST",
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  actPayMobikwik: function actPayMobikwik(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + '/subscriber/v1/payment/wallet', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  actPayLazyPay: function actPayLazyPay(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      console.log(payload);
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      fetch(context.getters.baseUrl + '/subscriber/v1/lazypay/eligibility', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPackDetails: function getPackDetails(context, filterData) {
    var url = '/subscriber/v1/subscriber/ldrprice';
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({
            "chargeperiod": 1,
            "monthlyprice": 871.77,
            "quarterlyprice": 2615.32,
            "halfyearlyprice": 4794.75,
            "yearlyprice": 9589.49
          });
          return;
        }
        reject(error);
      });
    });
  }

};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions, state: state, getters: getters, mutations: mutations
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(0);


var state = {};
var getters = {};
var mutations = {};
var actions = {
  getAlertMessage: function getAlertMessage(context, dataObj) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
      fetch(context.getters.baseUrl + '/subscriber/v1/alertmessage' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var state = {
  name: 'abcs'
};
var actions = {
  getTransactions: function getTransactions(context, filterData) {
    var url = '/subscriber/v1/subscriber/transactionhistory';
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve([{ "created": "6th August 2020", "description1": "NXTB Local Channels Pack", "description2": "Subscription start date: 06\/08\/20", "transactiontype": "Subscription Charges", "amount": "0.00" }, { "created": "6th August 2020", "description1": "Online Recharge - NXTDIGITAL - Customer Payment to LCO", "description2": "", "transactiontype": "Account Recharge", "amount": "0.00" }, { "created": "18th July 2020", "description1": "Foundation + Hindi Popular Pack 3M", "description2": "Subscription start date: 18\/07\/20", "transactiontype": "Subscription Charges", "amount": "390.00" }, { "created": "18th July 2020", "description1": "Foundation + Hindi Popular Pack 3M", "description2": "Subscription start date: 18\/07\/20", "transactiontype": "Subscription Charges", "amount": "509.25" }, { "created": "18th July 2020", "description1": "Online Recharge - NXTDIGITAL - Customer Payment to LCO", "description2": "", "transactiontype": "Account Recharge", "amount": "899.25" }]);
          return;
        }
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, actions: actions
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var state = {};
var getters = {};
var mutations = {};
var actions = {
  getInstantCustomerDetails: function getInstantCustomerDetails(context, filterData) {
    var url = '/subscriber/v1/subscriber/instantpayment';
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ "subscribername": "Neena Aidasani", "email": "", "mobileno": 9987505831, "susbcriberstatus": "A", "accountno": 23397361, "region": "MUM", "currentbalance": -223, "frcode": "DP0001", "customertype": "DP", "customeridentity": null });
          return;
        }
        reject(error);
      });
    });
  },
  getQRCustomer: function getQRCustomer(context, filterData) {
    var url = '/subscriber/v1/subscriber/qrcustomer';
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ "subscribername": "Neena Aidasani", "email": "", "mobileno": 9987505831, "susbcriberstatus": "A", "accountno": 23397361, "region": "MUM", "currentbalance": -223, "frcode": "DP0001", "customertype": "DP", "customeridentity": null });
          return;
        }
        reject(error);
      });
    });
  },
  getInstantPackDetails: function getInstantPackDetails(context, filterData) {
    var url = '/subscriber/v1/subscriber/ldrprice';
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ "basepacktariff": 1, "monthlyprice": "351.94", "quarterlyprice": "1055.82", "halfyearlyprice": "1935.67", "yearlyprice": "3871.34" });
          return;
        }
        reject(error);
      });
    });
  },
  getOffersDetails: function getOffersDetails(context, filterData) {
    var url = '/subscriber/v1/promo';
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions, state: state, getters: getters, mutations: mutations
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(0);

var state = {};
var getters = {};
var mutations = {};
var actions = {
    getInstantCustomerDetailsOTT: function getInstantCustomerDetailsOTT(context, filterData) {
        console.log("called customer details");
        var url = '/subscriber/v1/subscriber/ottquickpay';
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
            fetch(context.getters.baseUrl + url + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "subscribername": "Neena Aidasani", "email": "", "mobileno": 9987505831, "susbcriberstatus": "A", "accountno": 23397361, "region": "MUM", "currentbalance": -223, "frcode": "DP0001", "customertype": "DP", "customeridentity": null });
                    return;
                }
                reject(error);
            });
        });
    },
    getQRCustomerPlans: function getQRCustomerPlans(context, filterData) {
        var url = '/subscriber/v1/qrplan/listplan';
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
            fetch(context.getters.baseUrl + url + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getOttPacks: function getOttPacks(context, filterData) {
        console.log("called customer details");
        var url = "/subscriber/v1/subscriber/ottquickpay";
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
            fetch(context.getters.baseUrl + url + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "subscribername": "Neena Aidasani", "email": "", "mobileno": 9987505831, "susbcriberstatus": "A", "accountno": 23397361, "region": "MUM", "currentbalance": -223, "frcode": "DP0001", "customertype": "DP", "customeridentity": null });
                    return;
                }
                reject(error);
            });
        });
    },
    submitOttQuickpay: function submitOttQuickpay(context, formData) {
        var url = '/subscriber/v1/payment/init';
        return new Promise(function (resolve, reject) {
            var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formData);
            fetch(context.getters.baseUrl + url, {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    actions: actions,
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(58);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("7dc8347e", content, true, {});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports
exports.i(__webpack_require__(59), "");

// module
exports.push([module.i, "body{overflow:hidden;margin:0;padding:0;font-family:Red Hat Text,sans-serif}*{box-sizing:border-box}p{margin:0}input::-webkit-inner-spin-button,input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.error{text-align:left;color:red;font-size:12px}::placeholder{color:#a0a0a0!important;font-size:10px}.container-checkbox{display:block;position:relative;font-size:22px;margin-left:31%}@media only screen and (max-width:760px){.container-checkbox{margin-left:0;margin-bottom:10%}}.container-checkbox input{position:absolute;opacity:0;height:0;width:0}.checkmark{position:absolute;top:0;left:0;cursor:pointer;height:14px;width:14px;border-radius:4px;background-color:#fff;border:2px solid #c5cee0}.container-checkbox:hover input~.checkmark{opacity:1}.container-checkbox input:checked~.checkmark{background-color:#b10070;border:none}.checkmark:after{content:\"\";position:absolute;display:none;border:none}.container input:checked~.checkmark:after{display:block}.container-checkbox .checkmark:after{left:5px;top:2px;width:5px;height:10px;border:solid #fff;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.checkmark-radio{position:absolute;top:40%;left:38%;cursor:pointer;height:16px;width:16px;background-color:#fff;border:3px solid #c5cee0;border-radius:50%}@media only screen and (max-width:767px){.checkmark-radio{top:42%;left:30%}}@media only screen and (min-width:768px) and (max-width:1024px){.checkmark-radio{top:33%;left:33%}}.container-radio:hover input~.checkmark-radio{opacity:1}.container-radio input:checked~.checkmark-radio{background-color:#b10070;border:none}.checkmark-radio:after{content:\"\";position:absolute;display:none}.container-radio input:checked~.checkmark-radio:after{display:block}.container-radio .checkmark-radio:after{top:5px;left:5px;width:6px;height:6px;border-radius:50%;background:#fff}.display-main{width:90%;display:flex;padding-left:10%}.static-row{width:65%;padding:1.5% 0;letter-spacing:.5px;line-height:20px;color:#6f6f6f}@media only screen and (min-width:320px){.display-row,.static-row{font-size:12px}}@media only screen and (min-width:768px){.display-row,.static-row{font-size:17px}}.display-row{width:30%;padding:1.5% 0;color:#000;font-weight:500;line-height:20px;letter-spacing:.5px}button{border:none;border-radius:10px;color:#fff;font-size:20px;font-weight:500;background:linear-gradient(180deg,#b10070,#7d0466 52.59%,#4d0a53)}button:focus{outline:none}button:hover{background:#b10070}.selection-ball{box-shadow:0 0 3px .4px rgba(0,0,0,.16);padding-top:5px;background-color:#fff;color:#000}.selection-ball,.selection-ball-active{float:left;margin-left:5%;height:25px;width:25px;border-radius:50%;text-align:center;font-size:13px;cursor:pointer}.selection-ball-active{box-shadow:1px 1px 1px rgba(0,0,0,.1);padding-top:4px;background-color:#b10070;color:#eee}::-webkit-scrollbar{width:7px}::-webkit-scrollbar-track{box-shadow:inset 0 0 5px grey;border-radius:10px}::-webkit-scrollbar-thumb{background:#b10070;border-radius:10px}::-webkit-scrollbar-thumb:hover{background:#b10070}.ball{float:left;height:60px;width:60px;border-radius:50%;-webkit-box-shadow:-1px 1px 0 1px #b71e7f;-moz-box-shadow:-1px 1px 0 1px #b71e7f;box-shadow:-1px 1px 0 1px #b71e7f;padding-top:20px;font-weight:700;text-align:center;background-color:#fff;color:#000;font-size:16px;cursor:pointer;position:absolute}.svg-div-container{text-align:center;z-index:1}.svg-image{cursor:pointer}@media only screen and (max-width:900px){.svg-image{width:70%}}.bg-modal{width:100%;height:100%;background-color:rgba(0,0,0,.3);position:fixed;top:0;left:0;z-index:3;overflow:auto}.page-link{color:#b10070!important}.page-link:hover{cursor:pointer}.page-item.active .page-link,.page-link:hover{background-color:#b10070!important;border-color:#fff!important;color:#fff!important}.page-link:focus{box-shadow:none!important}.page-item.disabled .page-link{border-color:#dee2e6!important;color:#6c757d!important}.disabled{color:#6c757d!important;border-color:#fff!important}.mx-calendar-content .cell.actived{background-color:#b10070!important}", ""]);

// exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".red-hat-bold{font-weight:700}.red-hat-medium{font-weight:500}.red-hat-regular{font-weight:400}", ""]);

// exports


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_messaging__ = __webpack_require__(63);


console.log("firebase ", __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a);
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('./sw.js').then(function (success) {
        console.log("sw register successfully");
        callFirebase();
    }, function (error) {
        console.log(" not register successfully");
    });
} else {
    console.log("not present");
}
// import { configFirebase } from "@/store/config/firebaseConfig";
// firebase.initializeApp(configFirebase);

__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp({
    // production
    apiKey: "AIzaSyCmyYTOZlJeEV4riZSvw7qRciWMQ-buKFQ",
    authDomain: "imcl-selfcare.firebaseapp.com",
    databaseURL: "https://imcl-selfcare.firebaseio.com",
    projectId: "imcl-selfcare",
    storageBucket: "imcl-selfcare.appspot.com",
    messagingSenderId: "361777923362",
    appId: "1:361777923362:web:c60692e610f5db931c117b",
    measurementId: "G-XX8NXVHT2J"
});

function callFirebase() {
    console.log('callFirebase');
    var tokengen = "";
    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.messaging().requestPermission().then(function () {
        return __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.messaging().getToken();
    }).then(function (token) {
        console.log("token", token);
        localStorage.setItem("token", token);
        tokengen = token;
    }).catch(function (error) {
        console.log('[App | initAWSMA | Notification | requestPermission | error ]', error);
    });
    var messageNotification = "";
    var createdDate = "";
    var image = "";
    navigator.serviceWorker.addEventListener("message", function (message) {
        navigator.serviceWorker.ready.then(function (registration) {
            console.log(message);

            console.log("message data ", message);
            messageNotification = message.data['firebase-messaging-msg-data'].data.message;
            createdDate = message.data['firebase-messaging-msg-data'].data.createddates;
            image = message.data['firebase-messaging-msg-data'].data.icon;

            var notificationTitle = message.data['firebase-messaging-msg-data'].data.title;
            var notificationOptions = {
                body: messageNotification,
                image: image
            };

            if (localStorage.getItem("fcm-data")) {
                var getLocalFcm = JSON.parse(localStorage.getItem("fcm-data"));
                console.log(getLocalFcm);
                getLocalFcm.push({ 'message': messageNotification, 'createddate': createdDate, "image": image });
                localStorage.setItem("fcm-data", JSON.stringify(getLocalFcm));
            } else {
                var localfcm = [{ 'message': messageNotification }];
                localStorage.setItem("fcm-data", JSON.stringify(localfcm));
            }

            registration.showNotification(notificationTitle, notificationOptions);
        });
    });
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var firebase = __webpack_require__(6);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var firebase__default = /*#__PURE__*/_interopDefaultLegacy(firebase);

var name = "firebase";
var version = "7.24.0";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase__default['default'].registerVersion(name, version, 'app');

module.exports = firebase__default['default'];
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserLogHandler", function() { return setUserLogHandler; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
var levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
var ConsoleMethod = (_a = {},
    _a[LogLevel.DEBUG] = 'log',
    _a[LogLevel.VERBOSE] = 'log',
    _a[LogLevel.INFO] = 'info',
    _a[LogLevel.WARN] = 'warn',
    _a[LogLevel.ERROR] = 'error',
    _a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    var method = ConsoleMethod[logType];
    if (method) {
        console[method].apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
    }
    else {
        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError("Invalid value \"" + val + "\" assigned to `logLevel`");
            }
            this._logLevel = val;
        },
        enumerable: false,
        configurable: true
    });
    // Workaround for setter/getter having to be the same type.
    Logger.prototype.setLogLevel = function (val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    };
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function () {
            return this._userLogHandler;
        },
        set: function (val) {
            this._userLogHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
    };
    return Logger;
}());
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    var _loop_1 = function (instance) {
        var customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = function (instance, level) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                var message = args
                    .map(function (arg) {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(function (arg) { return arg; })
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message: message,
                        args: args,
                        type: instance.name
                    });
                }
            };
        }
    };
    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_messaging__ = __webpack_require__(64);

//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_installations__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_app__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__firebase_app__);







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_MAP = (_a = {},
    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
    _a["only-available-in-window" /* AVAILABLE_IN_WINDOW */] = 'This method is available in a Window context.',
    _a["only-available-in-sw" /* AVAILABLE_IN_SW */] = 'This method is available in a service worker context.',
    _a["permission-default" /* PERMISSION_DEFAULT */] = 'The notification permission was not granted and dismissed instead.',
    _a["permission-blocked" /* PERMISSION_BLOCKED */] = 'The notification permission was not granted and blocked instead.',
    _a["unsupported-browser" /* UNSUPPORTED_BROWSER */] = "This browser doesn't support the API's required to use the firebase SDK.",
    _a["failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */] = 'We are unable to register the default service worker. {$browserErrorMessage}',
    _a["token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */] = 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    _a["token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */] = 'FCM returned no token when subscribing the user to push.',
    _a["token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */] = 'A problem occurred while unsubscribing the ' +
        'user from FCM: {$errorInfo}',
    _a["token-update-failed" /* TOKEN_UPDATE_FAILED */] = 'A problem occurred while updating the user from FCM: {$errorInfo}',
    _a["token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */] = 'FCM returned no token when updating the user to push.',
    _a["use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */] = 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.',
    _a["invalid-sw-registration" /* INVALID_SW_REGISTRATION */] = 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    _a["invalid-bg-handler" /* INVALID_BG_HANDLER */] = 'The input to setBackgroundMessageHandler() must be a function.',
    _a["invalid-vapid-key" /* INVALID_VAPID_KEY */] = 'The public VAPID key must be a string.',
    _a["use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */] = 'The usePublicVapidKey() method may only be called once and must be ' +
        'called before calling getToken() to ensure your VAPID key is used.',
    _a);
var ERROR_FACTORY = new __WEBPACK_IMPORTED_MODULE_2__firebase_util__["ErrorFactory"]('messaging', 'Messaging', ERROR_MAP);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
var DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
var ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
/** Key of FCM Payload in Notification's data field. */
var FCM_MSG = 'FCM_MSG';
var CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
var CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
var CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */
var CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
var TAG = 'FirebaseMessaging: ';

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var MessageType;
(function (MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function arrayToBase64(array) {
    var uint8Array = new Uint8Array(array);
    var base64String = btoa(String.fromCharCode.apply(String, Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__spread"])(uint8Array)));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64ToArray(base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */
var OLD_DB_VERSION = 5;
var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
function migrateOldDatabase(senderId) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var databases, dbNames, tokenDetails, db;
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!('databases' in indexedDB)) return [3 /*break*/, 2];
                    return [4 /*yield*/, indexedDB.databases()];
                case 1:
                    databases = _a.sent();
                    dbNames = databases.map(function (db) { return db.name; });
                    if (!dbNames.includes(OLD_DB_NAME)) {
                        // old DB didn't exist, no need to open.
                        return [2 /*return*/, null];
                    }
                    _a.label = 2;
                case 2:
                    tokenDetails = null;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["openDb"])(OLD_DB_NAME, OLD_DB_VERSION, function (db) { return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(_this, void 0, void 0, function () {
                            var objectStore, value, oldDetails, oldDetails, oldDetails;
                            var _a;
                            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (db.oldVersion < 2) {
                                            // Database too old, skip migration.
                                            return [2 /*return*/];
                                        }
                                        if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
                                            // Database did not exist. Nothing to do.
                                            return [2 /*return*/];
                                        }
                                        objectStore = db.transaction.objectStore(OLD_OBJECT_STORE_NAME);
                                        return [4 /*yield*/, objectStore.index('fcmSenderId').get(senderId)];
                                    case 1:
                                        value = _b.sent();
                                        return [4 /*yield*/, objectStore.clear()];
                                    case 2:
                                        _b.sent();
                                        if (!value) {
                                            // No entry in the database, nothing to migrate.
                                            return [2 /*return*/];
                                        }
                                        if (db.oldVersion === 2) {
                                            oldDetails = value;
                                            if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
                                                return [2 /*return*/];
                                            }
                                            tokenDetails = {
                                                token: oldDetails.fcmToken,
                                                createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                                                subscriptionOptions: {
                                                    auth: oldDetails.auth,
                                                    p256dh: oldDetails.p256dh,
                                                    endpoint: oldDetails.endpoint,
                                                    swScope: oldDetails.swScope,
                                                    vapidKey: typeof oldDetails.vapidKey === 'string'
                                                        ? oldDetails.vapidKey
                                                        : arrayToBase64(oldDetails.vapidKey)
                                                }
                                            };
                                        }
                                        else if (db.oldVersion === 3) {
                                            oldDetails = value;
                                            tokenDetails = {
                                                token: oldDetails.fcmToken,
                                                createTime: oldDetails.createTime,
                                                subscriptionOptions: {
                                                    auth: arrayToBase64(oldDetails.auth),
                                                    p256dh: arrayToBase64(oldDetails.p256dh),
                                                    endpoint: oldDetails.endpoint,
                                                    swScope: oldDetails.swScope,
                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
                                                }
                                            };
                                        }
                                        else if (db.oldVersion === 4) {
                                            oldDetails = value;
                                            tokenDetails = {
                                                token: oldDetails.fcmToken,
                                                createTime: oldDetails.createTime,
                                                subscriptionOptions: {
                                                    auth: arrayToBase64(oldDetails.auth),
                                                    p256dh: arrayToBase64(oldDetails.p256dh),
                                                    endpoint: oldDetails.endpoint,
                                                    swScope: oldDetails.swScope,
                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
                                                }
                                            };
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 3:
                    db = _a.sent();
                    db.close();
                    // Delete all old databases.
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["deleteDb"])(OLD_DB_NAME)];
                case 4:
                    // Delete all old databases.
                    _a.sent();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["deleteDb"])('fcm_vapid_details_db')];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["deleteDb"])('undefined')];
                case 6:
                    _a.sent();
                    return [2 /*return*/, checkTokenDetails(tokenDetails) ? tokenDetails : null];
            }
        });
    });
}
function checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) {
        return false;
    }
    var subscriptionOptions = tokenDetails.subscriptionOptions;
    return (typeof tokenDetails.createTime === 'number' &&
        tokenDetails.createTime > 0 &&
        typeof tokenDetails.token === 'string' &&
        tokenDetails.token.length > 0 &&
        typeof subscriptionOptions.auth === 'string' &&
        subscriptionOptions.auth.length > 0 &&
        typeof subscriptionOptions.p256dh === 'string' &&
        subscriptionOptions.p256dh.length > 0 &&
        typeof subscriptionOptions.endpoint === 'string' &&
        subscriptionOptions.endpoint.length > 0 &&
        typeof subscriptionOptions.swScope === 'string' &&
        subscriptionOptions.swScope.length > 0 &&
        typeof subscriptionOptions.vapidKey === 'string' &&
        subscriptionOptions.vapidKey.length > 0);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Exported for tests.
var DATABASE_NAME = 'firebase-messaging-database';
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = 'firebase-messaging-store';
var dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = Object(__WEBPACK_IMPORTED_MODULE_4_idb__["openDb"])(DATABASE_NAME, DATABASE_VERSION, function (upgradeDb) {
            // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
            // because if there are multiple versions between the old version and the current version, we
            // want ALL the migrations that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (upgradeDb.oldVersion) {
                case 0:
                    upgradeDb.createObjectStore(OBJECT_STORE_NAME);
            }
        });
    }
    return dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */
function dbGet(firebaseDependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tokenDetails, oldTokenDetails;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(firebaseDependencies);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    return [4 /*yield*/, db
                            .transaction(OBJECT_STORE_NAME)
                            .objectStore(OBJECT_STORE_NAME)
                            .get(key)];
                case 2:
                    tokenDetails = _a.sent();
                    if (!tokenDetails) return [3 /*break*/, 3];
                    return [2 /*return*/, tokenDetails];
                case 3: return [4 /*yield*/, migrateOldDatabase(firebaseDependencies.appConfig.senderId)];
                case 4:
                    oldTokenDetails = _a.sent();
                    if (!oldTokenDetails) return [3 /*break*/, 6];
                    return [4 /*yield*/, dbSet(firebaseDependencies, oldTokenDetails)];
                case 5:
                    _a.sent();
                    return [2 /*return*/, oldTokenDetails];
                case 6: return [2 /*return*/];
            }
        });
    });
}
/** Assigns or overwrites the record for the given key with the given value. */
function dbSet(firebaseDependencies, tokenDetails) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(firebaseDependencies);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/, tokenDetails];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */
function dbRemove(firebaseDependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(firebaseDependencies);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function getKey(_a) {
    var appConfig = _a.appConfig;
    return appConfig.appId;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function requestGetToken(firebaseDependencies, subscriptionOptions) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var headers, body, subscribeOptions, responseData, response, err_1, message;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
                case 1:
                    headers = _a.sent();
                    body = getBody(subscriptionOptions);
                    subscribeOptions = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions)];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    responseData = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                        errorInfo: err_1
                    });
                case 6:
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                            errorInfo: message
                        });
                    }
                    if (!responseData.token) {
                        throw ERROR_FACTORY.create("token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */);
                    }
                    return [2 /*return*/, responseData.token];
            }
        });
    });
}
function requestUpdateToken(firebaseDependencies, tokenDetails) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var headers, body, updateOptions, responseData, response, err_2, message;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
                case 1:
                    headers = _a.sent();
                    body = getBody(tokenDetails.subscriptionOptions);
                    updateOptions = {
                        method: 'PATCH',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + tokenDetails.token, updateOptions)];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    responseData = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_2 = _a.sent();
                    throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                        errorInfo: err_2
                    });
                case 6:
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                            errorInfo: message
                        });
                    }
                    if (!responseData.token) {
                        throw ERROR_FACTORY.create("token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */);
                    }
                    return [2 /*return*/, responseData.token];
            }
        });
    });
}
function requestDeleteToken(firebaseDependencies, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var headers, unsubscribeOptions, response, responseData, message, err_3;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
                case 1:
                    headers = _a.sent();
                    unsubscribeOptions = {
                        method: 'DELETE',
                        headers: headers
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + token, unsubscribeOptions)];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    responseData = _a.sent();
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                            errorInfo: message
                        });
                    }
                    return [3 /*break*/, 6];
                case 5:
                    err_3 = _a.sent();
                    throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                        errorInfo: err_3
                    });
                case 6: return [2 /*return*/];
            }
        });
    });
}
function getEndpoint(_a) {
    var projectId = _a.projectId;
    return ENDPOINT + "/projects/" + projectId + "/registrations";
}
function getHeaders(_a) {
    var appConfig = _a.appConfig, installations = _a.installations;
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var authToken;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, installations.getToken()];
                case 1:
                    authToken = _b.sent();
                    return [2 /*return*/, new Headers({
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'x-goog-api-key': appConfig.apiKey,
                            'x-goog-firebase-installations-auth': "FIS " + authToken
                        })];
            }
        });
    });
}
function getBody(_a) {
    var p256dh = _a.p256dh, auth = _a.auth, endpoint = _a.endpoint, vapidKey = _a.vapidKey;
    var body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== DEFAULT_VAPID_KEY) {
        body.web.applicationPubKey = vapidKey;
    }
    return body;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** UpdateRegistration will be called once every week. */
var TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
function getToken(firebaseDependencies, swRegistration, vapidKey) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var pushSubscription, tokenDetails, subscriptionOptions, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (Notification.permission !== 'granted') {
                        throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
                    }
                    return [4 /*yield*/, getPushSubscription(swRegistration, vapidKey)];
                case 1:
                    pushSubscription = _a.sent();
                    return [4 /*yield*/, dbGet(firebaseDependencies)];
                case 2:
                    tokenDetails = _a.sent();
                    subscriptionOptions = {
                        vapidKey: vapidKey,
                        swScope: swRegistration.scope,
                        endpoint: pushSubscription.endpoint,
                        auth: arrayToBase64(pushSubscription.getKey('auth')),
                        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
                    };
                    if (!!tokenDetails) return [3 /*break*/, 3];
                    // No token, get a new one.
                    return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
                case 3:
                    if (!!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) return [3 /*break*/, 8];
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    // Suppress errors because of #2364
                    console.warn(e_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
                case 8:
                    if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
                        // Weekly token refresh
                        return [2 /*return*/, updateToken({
                                token: tokenDetails.token,
                                createTime: Date.now(),
                                subscriptionOptions: subscriptionOptions
                            }, firebaseDependencies, swRegistration)];
                    }
                    else {
                        // Valid token, nothing to do.
                        return [2 /*return*/, tokenDetails.token];
                    }
                case 9: return [2 /*return*/];
            }
        });
    });
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */
function deleteToken(firebaseDependencies, swRegistration) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var tokenDetails, pushSubscription;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dbGet(firebaseDependencies)];
                case 1:
                    tokenDetails = _a.sent();
                    if (!tokenDetails) return [3 /*break*/, 4];
                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dbRemove(firebaseDependencies)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
                case 5:
                    pushSubscription = _a.sent();
                    if (pushSubscription) {
                        return [2 /*return*/, pushSubscription.unsubscribe()];
                    }
                    // If there's no SW, consider it a success.
                    return [2 /*return*/, true];
            }
        });
    });
}
function updateToken(tokenDetails, firebaseDependencies, swRegistration) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var updatedToken, updatedTokenDetails, e_2;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 5]);
                    return [4 /*yield*/, requestUpdateToken(firebaseDependencies, tokenDetails)];
                case 1:
                    updatedToken = _a.sent();
                    updatedTokenDetails = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__assign"])({}, tokenDetails), { token: updatedToken, createTime: Date.now() });
                    return [4 /*yield*/, dbSet(firebaseDependencies, updatedTokenDetails)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, updatedToken];
                case 3:
                    e_2 = _a.sent();
                    return [4 /*yield*/, deleteToken(firebaseDependencies, swRegistration)];
                case 4:
                    _a.sent();
                    throw e_2;
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getNewToken(firebaseDependencies, subscriptionOptions) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var token, tokenDetails;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestGetToken(firebaseDependencies, subscriptionOptions)];
                case 1:
                    token = _a.sent();
                    tokenDetails = {
                        token: token,
                        createTime: Date.now(),
                        subscriptionOptions: subscriptionOptions
                    };
                    return [4 /*yield*/, dbSet(firebaseDependencies, tokenDetails)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, tokenDetails.token];
            }
        });
    });
}
/**
 * Gets a PushSubscription for the current user.
 */
function getPushSubscription(swRegistration, vapidKey) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var subscription;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
                case 1:
                    subscription = _a.sent();
                    if (subscription) {
                        return [2 /*return*/, subscription];
                    }
                    return [2 /*return*/, swRegistration.pushManager.subscribe({
                            userVisibleOnly: true,
                            // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
                            // submitted to pushManager#subscribe must be of type Uint8Array.
                            applicationServerKey: base64ToArray(vapidKey)
                        })];
            }
        });
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */
function isTokenValid(dbOptions, currentOptions) {
    var isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    var isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    var isAuthEqual = currentOptions.auth === dbOptions.auth;
    var isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function externalizePayload(internalPayload) {
    var payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key
    };
    propagateNotificationPayload(payload, internalPayload);
    propagateDataPayload(payload, internalPayload);
    propagateFcmOptions(payload, internalPayload);
    return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) {
        return;
    }
    payload.notification = {};
    var title = messagePayloadInternal.notification.title;
    if (!!title) {
        payload.notification.title = title;
    }
    var body = messagePayloadInternal.notification.body;
    if (!!body) {
        payload.notification.body = body;
    }
    var image = messagePayloadInternal.notification.image;
    if (!!image) {
        payload.notification.image = image;
    }
}
function propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) {
        return;
    }
    payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.fcmOptions) {
        return;
    }
    payload.fcmOptions = {};
    var link = messagePayloadInternal.fcmOptions.link;
    if (!!link) {
        payload.fcmOptions.link = link;
    }
    // eslint-disable-next-line camelcase
    var analyticsLabel = messagePayloadInternal.fcmOptions.analytics_label;
    if (!!analyticsLabel) {
        payload.fcmOptions.analyticsLabel = analyticsLabel;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SwController = /** @class */ (function () {
    function SwController(firebaseDependencies) {
        var _this = this;
        this.firebaseDependencies = firebaseDependencies;
        // A boolean flag to determine wether an app is using onBackgroundMessage or
        // setBackgroundMessageHandler. onBackgroundMessage will receive a MessagePayload regardless of if
        // a notification is displayed. Whereas, setBackgroundMessageHandler will swallow the
        // MessagePayload if a NotificationPayload is included.
        this.isOnBackgroundMessageUsed = null;
        this.vapidKey = null;
        this.bgMessageHandler = null;
        self.addEventListener('push', function (e) {
            e.waitUntil(_this.onPush(e));
        });
        self.addEventListener('pushsubscriptionchange', function (e) {
            e.waitUntil(_this.onSubChange(e));
        });
        self.addEventListener('notificationclick', function (e) {
            e.waitUntil(_this.onNotificationClick(e));
        });
    }
    Object.defineProperty(SwController.prototype, "app", {
        get: function () {
            return this.firebaseDependencies.app;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @deprecated. Use onBackgroundMessage(nextOrObserver: NextFn<object> | Observer<object>):
     * Unsubscribe instead.
     *
     * Calling setBackgroundMessageHandler will opt in to some specific behaviors.
     *
     * 1.) If a notification doesn't need to be shown due to a window already being visible, then push
     * messages will be sent to the page. 2.) If a notification needs to be shown, and the message
     * contains no notification data this method will be called and the promise it returns will be
     * passed to event.waitUntil. If you do not set this callback then all push messages will let and
     * the developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received and a notification
     * must be shown. The callback will be given the data from the push message.
     */
    SwController.prototype.setBackgroundMessageHandler = function (callback) {
        this.isOnBackgroundMessageUsed = false;
        if (!callback || typeof callback !== 'function') {
            throw ERROR_FACTORY.create("invalid-bg-handler" /* INVALID_BG_HANDLER */);
        }
        this.bgMessageHandler = callback;
    };
    SwController.prototype.onBackgroundMessage = function (nextOrObserver) {
        var _this = this;
        this.isOnBackgroundMessageUsed = true;
        this.bgMessageHandler = nextOrObserver;
        return function () {
            _this.bgMessageHandler = null;
        };
    };
    // TODO: Remove getToken from SW Controller. Calling this from an old SW can cause all kinds of
    // trouble.
    SwController.prototype.getToken = function () {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.vapidKey) return [3 /*break*/, 2];
                        return [4 /*yield*/, dbGet(this.firebaseDependencies)];
                    case 1:
                        tokenDetails = _c.sent();
                        this.vapidKey = (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : DEFAULT_VAPID_KEY;
                        _c.label = 2;
                    case 2: return [2 /*return*/, getToken(this.firebaseDependencies, self.registration, this.vapidKey)];
                }
            });
        });
    };
    // TODO: Remove deleteToken from SW Controller. Calling this from an old SW can cause all kinds of
    // trouble.
    SwController.prototype.deleteToken = function () {
        return deleteToken(this.firebaseDependencies, self.registration);
    };
    SwController.prototype.requestPermission = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    // TODO: Remove this together with getToken from SW Controller.
    SwController.prototype.usePublicVapidKey = function (vapidKey) {
        if (this.vapidKey !== null) {
            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
        }
        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
        }
        this.vapidKey = vapidKey;
    };
    SwController.prototype.useServiceWorker = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    SwController.prototype.onMessage = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    SwController.prototype.onTokenRefresh = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    /**
     * A handler for push events that shows notifications based on the content of the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The value of the
     * `notification` property will be used as the NotificationOptions object passed to
     * showNotification. Additionally, the `title` property of the notification object will be used as
     * the title.
     *
     * If there is no notification data in the payload then no notification will be shown.
     */
    SwController.prototype.onPush = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var internalPayload, clientList, isNotificationShown, payload;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalPayload = getMessagePayloadInternal(event);
                        if (!internalPayload) {
                            console.debug(TAG +
                                'failed to get parsed MessagePayload from the PushEvent. Skip handling the push.');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        if (hasVisibleClients(clientList)) {
                            return [2 /*return*/, sendMessagePayloadInternalToWindows(clientList, internalPayload)];
                        }
                        isNotificationShown = false;
                        if (!!!internalPayload.notification) return [3 /*break*/, 3];
                        return [4 /*yield*/, showNotification(wrapInternalPayload(internalPayload))];
                    case 2:
                        _a.sent();
                        isNotificationShown = true;
                        _a.label = 3;
                    case 3:
                        // MessagePayload is only passed to `onBackgroundMessage`. Skip passing MessagePayload for
                        // the legacy `setBackgroundMessageHandler` to preserve the SDK behaviors.
                        if (isNotificationShown === true &&
                            this.isOnBackgroundMessageUsed === false) {
                            return [2 /*return*/];
                        }
                        if (!!this.bgMessageHandler) {
                            payload = externalizePayload(internalPayload);
                            if (typeof this.bgMessageHandler === 'function') {
                                this.bgMessageHandler(payload);
                            }
                            else {
                                this.bgMessageHandler.next(payload);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onSubChange = function (event) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var newSubscription, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        newSubscription = event.newSubscription;
                        if (!!newSubscription) return [3 /*break*/, 2];
                        // Subscription revoked, delete token
                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
                    case 1:
                        // Subscription revoked, delete token
                        _c.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, dbGet(this.firebaseDependencies)];
                    case 3:
                        tokenDetails = _c.sent();
                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
                    case 4:
                        _c.sent();
                        return [4 /*yield*/, getToken(this.firebaseDependencies, self.registration, (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : DEFAULT_VAPID_KEY)];
                    case 5:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onNotificationClick = function (event) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var internalPayload, link, url, originUrl, client;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        internalPayload = (_b = (_a = event.notification) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[FCM_MSG];
                        if (!internalPayload) {
                            return [2 /*return*/];
                        }
                        else if (event.action) {
                            // User clicked on an action button. This will allow developers to act on action button clicks
                            // by using a custom onNotificationClick listener that they define.
                            return [2 /*return*/];
                        }
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        link = getLink(internalPayload);
                        if (!link) {
                            return [2 /*return*/];
                        }
                        url = new URL(link, self.location.href);
                        originUrl = new URL(self.location.origin);
                        if (url.host !== originUrl.host) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getWindowClient(url)];
                    case 1:
                        client = _c.sent();
                        if (!!client) return [3 /*break*/, 4];
                        return [4 /*yield*/, self.clients.openWindow(link)];
                    case 2:
                        client = _c.sent();
                        // Wait three seconds for the client to initialize and set up the message handler so that it
                        // can receive the message.
                        return [4 /*yield*/, sleep(3000)];
                    case 3:
                        // Wait three seconds for the client to initialize and set up the message handler so that it
                        // can receive the message.
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, client.focus()];
                    case 5:
                        client = _c.sent();
                        _c.label = 6;
                    case 6:
                        if (!client) {
                            // Window Client will not be returned if it's for a third party origin.
                            return [2 /*return*/];
                        }
                        internalPayload.messageType = MessageType.NOTIFICATION_CLICKED;
                        internalPayload.isFirebaseMessaging = true;
                        return [2 /*return*/, client.postMessage(internalPayload)];
                }
            });
        });
    };
    return SwController;
}());
function wrapInternalPayload(internalPayload) {
    var _a;
    var wrappedInternalPayload = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__assign"])({}, internalPayload.notification);
    // Put the message payload under FCM_MSG name so we can identify the notification as being an FCM
    // notification vs a notification from somewhere else (i.e. normal web push or developer generated
    // notification).
    wrappedInternalPayload.data = (_a = {},
        _a[FCM_MSG] = internalPayload,
        _a);
    return wrappedInternalPayload;
}
function getMessagePayloadInternal(_a) {
    var data = _a.data;
    if (!data) {
        return null;
    }
    try {
        return data.json();
    }
    catch (err) {
        // Not JSON so not an FCM message.
        return null;
    }
}
/**
 * @param url The URL to look for when focusing a client.
 * @return Returns an existing window client or a newly opened WindowClient.
 */
function getWindowClient(url) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var clientList, clientList_1, clientList_1_1, client, clientUrl;
        var e_1, _a;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getClientList()];
                case 1:
                    clientList = _b.sent();
                    try {
                        for (clientList_1 = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__values"])(clientList), clientList_1_1 = clientList_1.next(); !clientList_1_1.done; clientList_1_1 = clientList_1.next()) {
                            client = clientList_1_1.value;
                            clientUrl = new URL(client.url, self.location.href);
                            if (url.host === clientUrl.host) {
                                return [2 /*return*/, client];
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (clientList_1_1 && !clientList_1_1.done && (_a = clientList_1.return)) _a.call(clientList_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [2 /*return*/, null];
            }
        });
    });
}
/**
 * @returns If there is currently a visible WindowClient, this method will resolve to true,
 * otherwise false.
 */
function hasVisibleClients(clientList) {
    return clientList.some(function (client) {
        return client.visibilityState === 'visible' &&
            // Ignore chrome-extension clients as that matches the background pages of extensions, which
            // are always considered visible for some reason.
            !client.url.startsWith('chrome-extension://');
    });
}
function sendMessagePayloadInternalToWindows(clientList, internalPayload) {
    var e_2, _a;
    internalPayload.isFirebaseMessaging = true;
    internalPayload.messageType = MessageType.PUSH_RECEIVED;
    try {
        for (var clientList_2 = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__values"])(clientList), clientList_2_1 = clientList_2.next(); !clientList_2_1.done; clientList_2_1 = clientList_2.next()) {
            var client = clientList_2_1.value;
            client.postMessage(internalPayload);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (clientList_2_1 && !clientList_2_1.done && (_a = clientList_2.return)) _a.call(clientList_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
function getClientList() {
    return self.clients.matchAll({
        type: 'window',
        includeUncontrolled: true
        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
    });
}
function showNotification(notificationPayloadInternal) {
    var _a;
    // Note: Firefox does not support the maxActions property.
    // https://developer.mozilla.org/en-US/docs/Web/API/notification/maxActions
    var actions = notificationPayloadInternal.actions;
    var maxActions = Notification.maxActions;
    if (actions && maxActions && actions.length > maxActions) {
        console.warn("This browser only supports " + maxActions + " actions. The remaining actions will not be displayed.");
    }
    return self.registration.showNotification((_a = 
    /* title= */ notificationPayloadInternal.title) !== null && _a !== void 0 ? _a : '', notificationPayloadInternal);
}
function getLink(payload) {
    var _a, _b, _c;
    // eslint-disable-next-line camelcase
    var link = (_b = (_a = payload.fcmOptions) === null || _a === void 0 ? void 0 : _a.link) !== null && _b !== void 0 ? _b : (_c = payload.notification) === null || _c === void 0 ? void 0 : _c.click_action;
    if (link) {
        return link;
    }
    if (isConsoleMessage(payload.data)) {
        // Notification created in the Firebase Console. Redirect to origin.
        return self.location.origin;
    }
    else {
        return null;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = /** @class */ (function () {
    function WindowController(firebaseDependencies) {
        var _this = this;
        this.firebaseDependencies = firebaseDependencies;
        this.vapidKey = null;
        this.onMessageCallback = null;
        navigator.serviceWorker.addEventListener('message', function (e) {
            return _this.messageEventListener(e);
        });
    }
    Object.defineProperty(WindowController.prototype, "app", {
        get: function () {
            return this.firebaseDependencies.app;
        },
        enumerable: false,
        configurable: true
    });
    WindowController.prototype.messageEventListener = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var internalPayload, dataPayload;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalPayload = event.data;
                        if (!internalPayload.isFirebaseMessaging) {
                            return [2 /*return*/];
                        }
                        // onMessageCallback is either a function or observer/subscriber.
                        // TODO: in the modularization release, have onMessage handle type MessagePayload as supposed to
                        // the legacy payload where some fields are in snake cases.
                        if (this.onMessageCallback &&
                            internalPayload.messageType === MessageType.PUSH_RECEIVED) {
                            if (typeof this.onMessageCallback === 'function') {
                                this.onMessageCallback(stripInternalFields(Object.assign({}, internalPayload)));
                            }
                            else {
                                this.onMessageCallback.next(Object.assign({}, internalPayload));
                            }
                        }
                        dataPayload = internalPayload.data;
                        if (!(isConsoleMessage(dataPayload) &&
                            dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.logEvent(internalPayload.messageType, dataPayload)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    WindowController.prototype.getVapidKey = function () {
        return this.vapidKey;
    };
    WindowController.prototype.getSwReg = function () {
        return this.swRegistration;
    };
    WindowController.prototype.getToken = function (options) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(Notification.permission === 'default')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (Notification.permission !== 'granted') {
                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
                        }
                        return [4 /*yield*/, this.updateVapidKey(options === null || options === void 0 ? void 0 : options.vapidKey)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.updateSwReg(options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, getToken(this.firebaseDependencies, this.swRegistration, this.vapidKey)];
                }
            });
        });
    };
    WindowController.prototype.updateVapidKey = function (vapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                if (!!vapidKey) {
                    this.vapidKey = vapidKey;
                }
                else if (!this.vapidKey) {
                    this.vapidKey = DEFAULT_VAPID_KEY;
                }
                return [2 /*return*/];
            });
        });
    };
    WindowController.prototype.updateSwReg = function (swRegistration) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!swRegistration && !this.swRegistration)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.registerDefaultSw()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!swRegistration && !!this.swRegistration) {
                            return [2 /*return*/];
                        }
                        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
                            throw ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */);
                        }
                        this.swRegistration = swRegistration;
                        return [2 /*return*/];
                }
            });
        });
    };
    WindowController.prototype.registerDefaultSw = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var _a, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, navigator.serviceWorker.register(DEFAULT_SW_PATH, {
                                scope: DEFAULT_SW_SCOPE
                            })];
                    case 1:
                        _a.swRegistration = _b.sent();
                        // The timing when browser updates sw when sw has an update is unreliable by my experiment. It
                        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
                        // is stuck with the old version. For example,
                        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
                        // sw if there was an update.
                        this.swRegistration.update().catch(function () {
                            /* it is non blocking and we don't care if it failed */
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        throw ERROR_FACTORY.create("failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */, {
                            browserErrorMessage: e_1.message
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WindowController.prototype.deleteToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.swRegistration) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.registerDefaultSw()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, deleteToken(this.firebaseDependencies, this.swRegistration)];
                }
            });
        });
    };
    /**
     * Request permission if it is not currently granted.
     *
     * @return Resolves if the permission was granted, rejects otherwise.
     *
     * @deprecated Use Notification.requestPermission() instead.
     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
     */
    WindowController.prototype.requestPermission = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var permissionResult;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Notification.permission === 'granted') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        permissionResult = _a.sent();
                        if (permissionResult === 'granted') {
                            return [2 /*return*/];
                        }
                        else if (permissionResult === 'denied') {
                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
                        }
                        else {
                            throw ERROR_FACTORY.create("permission-default" /* PERMISSION_DEFAULT */);
                        }
                }
            });
        });
    };
    /**
     * @deprecated. Use getToken(options?: {vapidKey?: string; serviceWorkerRegistration?:
     * ServiceWorkerRegistration;}): Promise<string> instead.
     */
    WindowController.prototype.usePublicVapidKey = function (vapidKey) {
        if (this.vapidKey !== null) {
            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
        }
        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
        }
        this.vapidKey = vapidKey;
    };
    /**
     * @deprecated. Use getToken(options?: {vapidKey?: string; serviceWorkerRegistration?:
     * ServiceWorkerRegistration;}): Promise<string> instead.
     */
    WindowController.prototype.useServiceWorker = function (swRegistration) {
        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
            throw ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */);
        }
        if (this.swRegistration) {
            throw ERROR_FACTORY.create("use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */);
        }
        this.swRegistration = swRegistration;
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on message.
     *
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver) {
        var _this = this;
        this.onMessageCallback = nextOrObserver;
        return function () {
            _this.onMessageCallback = null;
        };
    };
    WindowController.prototype.setBackgroundMessageHandler = function () {
        throw ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
    };
    WindowController.prototype.onBackgroundMessage = function () {
        throw ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
    };
    /**
     * @deprecated No-op. It was initially designed with token rotation requests from server in mind.
     * However, the plan to implement such feature was abandoned.
     */
    WindowController.prototype.onTokenRefresh = function () {
        return function () { };
    };
    WindowController.prototype.logEvent = function (messageType, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var eventType, analytics;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventType = getEventType(messageType);
                        return [4 /*yield*/, this.firebaseDependencies.analyticsProvider.get()];
                    case 1:
                        analytics = _a.sent();
                        analytics.logEvent(eventType, {
                            /* eslint-disable camelcase */
                            message_id: data[CONSOLE_CAMPAIGN_ID],
                            message_name: data[CONSOLE_CAMPAIGN_NAME],
                            message_time: data[CONSOLE_CAMPAIGN_TIME],
                            message_device_time: Math.floor(Date.now() / 1000)
                            /* eslint-enable camelcase */
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return WindowController;
}());
function getEventType(messageType) {
    switch (messageType) {
        case MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}
function stripInternalFields(internalPayload) {
    delete internalPayload.messageType;
    delete internalPayload.isFirebaseMessaging;
    return internalPayload;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration Object');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    var configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    var options = app.options;
    try {
        for (var configKeys_1 = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__values"])(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
            var keyName = configKeys_1_1.value;
            if (!options[keyName]) {
                throw getMissingValueError(keyName);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
        valueName: valueName
    });
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MESSAGING_NAME = 'messaging';
function factoryMethod(container) {
    // Dependencies.
    var app = container.getProvider('app').getImmediate();
    var appConfig = extractAppConfig(app);
    var installations = container.getProvider('installations').getImmediate();
    var analyticsProvider = container.getProvider('analytics-internal');
    var firebaseDependencies = {
        app: app,
        appConfig: appConfig,
        installations: installations,
        analyticsProvider: analyticsProvider
    };
    if (!isSupported()) {
        throw ERROR_FACTORY.create("unsupported-browser" /* UNSUPPORTED_BROWSER */);
    }
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return new SwController(firebaseDependencies);
    }
    else {
        // Assume we are in the window context.
        return new WindowController(firebaseDependencies);
    }
}
var NAMESPACE_EXPORTS = {
    isSupported: isSupported
};
__WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.INTERNAL.registerComponent(new __WEBPACK_IMPORTED_MODULE_1__firebase_component__["Component"](MESSAGING_NAME, factoryMethod, "PUBLIC" /* PUBLIC */).setServiceProps(NAMESPACE_EXPORTS));
function isSupported() {
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return isSWControllerSupported();
    }
    else {
        // Assume we are in the window context.
        return isWindowControllerSupported();
    }
}
/**
 * Checks to see if the required APIs exist.
 */
function isWindowControllerSupported() {
    return ('indexedDB' in window &&
        indexedDB !== null &&
        navigator.cookieEnabled &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */
function isSWControllerSupported() {
    return ('indexedDB' in self &&
        indexedDB !== null &&
        'PushManager' in self &&
        'Notification' in self &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerInstallations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_util__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idb__);






var name = "@firebase/installations";
var version = "0.4.17";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PENDING_TIMEOUT_MS = 10000;
var PACKAGE_VERSION = "w:" + version;
var INTERNAL_AUTH_VERSION = 'FIS_v2';
var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
var SERVICE = 'installations';
var SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {},
    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
    _a["not-registered" /* NOT_REGISTERED */] = 'Firebase Installation is not registered.',
    _a["installation-not-found" /* INSTALLATION_NOT_FOUND */] = 'Firebase Installation not found.',
    _a["request-failed" /* REQUEST_FAILED */] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    _a["app-offline" /* APP_OFFLINE */] = 'Could not process request. Application offline.',
    _a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */] = "Can't delete installation while there is a pending registration request.",
    _a);
var ERROR_FACTORY = new __WEBPACK_IMPORTED_MODULE_3__firebase_util__["ErrorFactory"](SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof __WEBPACK_IMPORTED_MODULE_3__firebase_util__["FirebaseError"] &&
        error.code.includes("request-failed" /* REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint(_a) {
    var projectId = _a.projectId;
    return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function getErrorFromResponse(requestName, response) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var responseJson, errorData;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.json()];
                case 1:
                    responseJson = _a.sent();
                    errorData = responseJson.error;
                    return [2 /*return*/, ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })];
            }
        });
    });
}
function getHeaders(_a) {
    var apiKey = _a.apiKey;
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, _a) {
    var refreshToken = _a.refreshToken;
    var headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
function retryIfServerError(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var result;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fn()];
                case 1:
                    result = _a.sent();
                    if (result.status >= 500 && result.status < 600) {
                        // Internal Server Error. Retry request.
                        return [2 /*return*/, fn()];
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return INTERNAL_AUTH_VERSION + " " + refreshToken;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createInstallationRequest(appConfig, _a) {
    var fid = _a.fid;
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = getInstallationsEndpoint(appConfig);
                    headers = getHeaders(appConfig);
                    body = {
                        fid: fid,
                        authVersion: INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: PACKAGE_VERSION
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _b.sent();
                    registeredInstallationEntry = {
                        fid: responseValue.fid || fid,
                        registrationStatus: 2 /* COMPLETED */,
                        refreshToken: responseValue.refreshToken,
                        authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [2 /*return*/, registeredInstallationEntry];
                case 3: return [4 /*yield*/, getErrorFromResponse('Create Installation', response)];
                case 4: throw _b.sent();
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    var b64 = btoa(String.fromCharCode.apply(String, Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__spread"])(array)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto_1 = self.crypto || self.msCrypto;
        crypto_1.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + (fidByteArray[0] % 16);
        var fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    var b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return appConfig.appName + "!" + appConfig.appId;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    var key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    var key = getKey(appConfig);
    var callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    var key = getKey(appConfig);
    var callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    var e_1, _a;
    var callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    try {
        for (var callbacks_1 = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__values"])(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
            var callback = callbacks_1_1.value;
            callback(fid);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function broadcastFidChange(key, fid) {
    var channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key: key, fid: fid });
    }
    closeBroadcastChannel();
}
var broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = function (e) {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_NAME = 'firebase-installations-database';
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = 'firebase-installations-store';
var dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = Object(__WEBPACK_IMPORTED_MODULE_4_idb__["openDb"])(DATABASE_NAME, DATABASE_VERSION, function (upgradeDB) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (upgradeDB.oldVersion) {
                case 0:
                    upgradeDB.createObjectStore(OBJECT_STORE_NAME);
            }
        });
    }
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
function set(appConfig, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx, objectStore, oldValue;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    objectStore = tx.objectStore(OBJECT_STORE_NAME);
                    return [4 /*yield*/, objectStore.get(key)];
                case 2:
                    oldValue = _a.sent();
                    return [4 /*yield*/, objectStore.put(value, key)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 4:
                    _a.sent();
                    if (!oldValue || oldValue.fid !== value.fid) {
                        fidChanged(appConfig, value.fid);
                    }
                    return [2 /*return*/, value];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */
function remove(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
function update(appConfig, updateFn) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx, store, oldValue, newValue;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    store = tx.objectStore(OBJECT_STORE_NAME);
                    return [4 /*yield*/, store.get(key)];
                case 2:
                    oldValue = _a.sent();
                    newValue = updateFn(oldValue);
                    if (!(newValue === undefined)) return [3 /*break*/, 4];
                    return [4 /*yield*/, store.delete(key)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, store.put(newValue, key)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [4 /*yield*/, tx.complete];
                case 7:
                    _a.sent();
                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
                        fidChanged(appConfig, newValue.fid);
                    }
                    return [2 /*return*/, newValue];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
function getInstallationEntry(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var registrationPromise, installationEntry;
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
                        var installationEntry = updateOrCreateInstallationEntry(oldEntry);
                        var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry);
                        registrationPromise = entryWithPromise.registrationPromise;
                        return entryWithPromise.installationEntry;
                    })];
                case 1:
                    installationEntry = _b.sent();
                    if (!(installationEntry.fid === INVALID_FID)) return [3 /*break*/, 3];
                    _a = {};
                    return [4 /*yield*/, registrationPromise];
                case 2: 
                // FID generation failed. Waiting for the FID from the server.
                return [2 /*return*/, (_a.installationEntry = _b.sent(), _a)];
                case 3: return [2 /*return*/, {
                        installationEntry: installationEntry,
                        registrationPromise: registrationPromise
                    }];
            }
        });
    });
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(appConfig, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* IN_PROGRESS */,
            registrationTime: Date.now()
        };
        var registrationPromise = registerInstallation(appConfig, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
        return {
            installationEntry: installationEntry,
            registrationPromise: waitUntilFidRegistration(appConfig)
        };
    }
    else {
        return { installationEntry: installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
function registerInstallation(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var registeredInstallationEntry, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, createInstallationRequest(appConfig, installationEntry)];
                case 1:
                    registeredInstallationEntry = _a.sent();
                    return [2 /*return*/, set(appConfig, registeredInstallationEntry)];
                case 2:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && e_1.serverCode === 409)) return [3 /*break*/, 4];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(appConfig)];
                case 3:
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: 
                // Registration failed. Set FID as not registered.
                return [4 /*yield*/, set(appConfig, {
                        fid: installationEntry.fid,
                        registrationStatus: 0 /* NOT_STARTED */
                    })];
                case 5:
                    // Registration failed. Set FID as not registered.
                    _a.sent();
                    _a.label = 6;
                case 6: throw e_1;
                case 7: return [2 /*return*/];
            }
        });
    });
}
/** Call if FID registration is pending in another request. */
function waitUntilFidRegistration(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var entry, _a, installationEntry, registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 1:
                    entry = _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // createInstallation request still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // createInstallation request still in progress.
                    _b.sent();
                    return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 4:
                    entry = _b.sent();
                    return [3 /*break*/, 2];
                case 5:
                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */)) return [3 /*break*/, 7];
                    return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 6:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) {
                        return [2 /*return*/, registrationPromise];
                    }
                    else {
                        // if there is no registrationPromise, entry is registered.
                        return [2 /*return*/, installationEntry];
                    }
                case 7: return [2 /*return*/, entry];
            }
        });
    });
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function generateAuthTokenRequest(_a, installationEntry) {
    var appConfig = _a.appConfig, platformLoggerProvider = _a.platformLoggerProvider;
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    platformLogger = platformLoggerProvider.getImmediate({
                        optional: true
                    });
                    if (platformLogger) {
                        headers.append('x-firebase-client', platformLogger.getPlatformInfoString());
                    }
                    body = {
                        installation: {
                            sdkVersion: PACKAGE_VERSION
                        }
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _b.sent();
                    completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
                    return [2 /*return*/, completedAuthToken];
                case 3: return [4 /*yield*/, getErrorFromResponse('Generate Auth Token', response)];
                case 4: throw _b.sent();
            }
        });
    });
}
function getGenerateAuthTokenEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
function refreshAuthToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var tokenPromise, entry, authToken, _a;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, update(dependencies.appConfig, function (oldEntry) {
                        if (!isEntryRegistered(oldEntry)) {
                            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
                        }
                        var oldAuthToken = oldEntry.authToken;
                        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
                            // There is a valid token in the DB.
                            return oldEntry;
                        }
                        else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
                            // There already is a token request in progress.
                            tokenPromise = waitUntilAuthTokenRequest(dependencies, forceRefresh);
                            return oldEntry;
                        }
                        else {
                            // No token or token expired.
                            if (!navigator.onLine) {
                                throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                            }
                            var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
                            tokenPromise = fetchAuthTokenFromServer(dependencies, inProgressEntry);
                            return inProgressEntry;
                        }
                    })];
                case 1:
                    entry = _b.sent();
                    if (!tokenPromise) return [3 /*break*/, 3];
                    return [4 /*yield*/, tokenPromise];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = entry.authToken;
                    _b.label = 4;
                case 4:
                    authToken = _a;
                    return [2 /*return*/, authToken];
            }
        });
    });
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
function waitUntilAuthTokenRequest(dependencies, forceRefresh) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var entry, authToken;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
                case 1:
                    entry = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // generateAuthToken still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // generateAuthToken still in progress.
                    _a.sent();
                    return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
                case 4:
                    entry = _a.sent();
                    return [3 /*break*/, 2];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* NOT_STARTED */) {
                        // The request timed out or failed in a different call. Try again.
                        return [2 /*return*/, refreshAuthToken(dependencies, forceRefresh)];
                    }
                    else {
                        return [2 /*return*/, authToken];
                    }
            }
        });
    });
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
        }
        var oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, oldEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
function fetchAuthTokenFromServer(dependencies, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 8]);
                    return [4 /*yield*/, generateAuthTokenRequest(dependencies, installationEntry)];
                case 1:
                    authToken = _a.sent();
                    updatedInstallationEntry = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, installationEntry), { authToken: authToken });
                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, authToken];
                case 3:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [3 /*break*/, 5];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(dependencies.appConfig)];
                case 4:
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    updatedInstallationEntry = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, installationEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: throw e_1;
                case 8: return [2 /*return*/];
            }
        });
    });
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    var now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getId(dependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var _a, installationEntry, registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getInstallationEntry(dependencies.appConfig)];
                case 1:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) {
                        registrationPromise.catch(console.error);
                    }
                    else {
                        // If the installation is already registered, update the authentication
                        // token if needed.
                        refreshAuthToken(dependencies).catch(console.error);
                    }
                    return [2 /*return*/, installationEntry.fid];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var authToken;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, completeInstallationRegistration(dependencies.appConfig)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refreshAuthToken(dependencies, forceRefresh)];
                case 2:
                    authToken = _a.sent();
                    return [2 /*return*/, authToken.token];
            }
        });
    });
}
function completeInstallationRegistration(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 1:
                    registrationPromise = (_a.sent()).registrationPromise;
                    if (!registrationPromise) return [3 /*break*/, 3];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [4 /*yield*/, registrationPromise];
                case 2:
                    // A createInstallation request is in progress. Wait until it finishes.
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallationRequest(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var endpoint, headers, request, response;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = getDeleteEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: 'DELETE',
                        headers: headers
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, getErrorFromResponse('Delete Installation', response)];
                case 2: throw _a.sent();
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getDeleteEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallation(dependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var appConfig, entry;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appConfig = dependencies.appConfig;
                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
                                // Delete the unregistered entry without sending a deleteInstallation request.
                                return undefined;
                            }
                            return oldEntry;
                        })];
                case 1:
                    entry = _a.sent();
                    if (!entry) return [3 /*break*/, 6];
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 2];
                    // Can't delete while trying to register.
                    throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);
                case 2:
                    if (!(entry.registrationStatus === 2 /* COMPLETED */)) return [3 /*break*/, 6];
                    if (!!navigator.onLine) return [3 /*break*/, 3];
                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                case 3: return [4 /*yield*/, deleteInstallationRequest(appConfig, entry)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, remove(appConfig)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 */
function onIdChange(_a, callback) {
    var appConfig = _a.appConfig;
    addCallback(appConfig, callback);
    return function () {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    var configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    try {
        for (var configKeys_1 = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__values"])(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
            var keyName = configKeys_1_1.value;
            if (!app.options[keyName]) {
                throw getMissingValueError(keyName);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
        valueName: valueName
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerInstallations(instance) {
    var installationsName = 'installations';
    instance.INTERNAL.registerComponent(new __WEBPACK_IMPORTED_MODULE_1__firebase_component__["Component"](installationsName, function (container) {
        var app = container.getProvider('app').getImmediate();
        // Throws if app isn't configured properly.
        var appConfig = extractAppConfig(app);
        var platformLoggerProvider = container.getProvider('platform-logger');
        var dependencies = {
            appConfig: appConfig,
            platformLoggerProvider: platformLoggerProvider
        };
        var installations = {
            app: app,
            getId: function () { return getId(dependencies); },
            getToken: function (forceRefresh) {
                return getToken(dependencies, forceRefresh);
            },
            delete: function () { return deleteInstallation(dependencies); },
            onIdChange: function (callback) {
                return onIdChange(dependencies, callback);
            }
        };
        return installations;
    }, "PUBLIC" /* PUBLIC */));
    instance.registerVersion(name, version);
}
registerInstallations(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);


//# sourceMappingURL=index.esm.js.map


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build-38f03f3e11541238801c.js